export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Long: { input: number; output: number; }
};

export type AcceptAgentAlternativeRequest = {
  alternativeId: Scalars['ID']['input'];
  incidentId: Scalars['ID']['input'];
};

export type AcceptAgentAlternativeResponse = {
  __typename?: 'AcceptAgentAlternativeResponse';
  alternativeId: Scalars['ID']['output'];
};

export type AcceptAlternativeRequest = {
  alternativeFlights: Array<AlternativeFlight>;
  incidentId: Scalars['ID']['input'];
};

export type AcceptAlternativeResponse = {
  __typename?: 'AcceptAlternativeResponse';
  success: Scalars['Boolean']['output'];
};

export type AcceptMembershipRetentionOfferRequest = {
  feature?: InputMaybe<RetentionRuleFeatureType>;
  offerId?: InputMaybe<Scalars['ID']['input']>;
};

export type AcceptMembershipRetentionOfferResponse = {
  __typename?: 'AcceptMembershipRetentionOfferResponse';
  /** @deprecated Field no longer supported */
  code: RetentionRuleCodeType;
  success: Scalars['Boolean']['output'];
};

export type Accommodation = {
  __typename?: 'Accommodation';
  accommodationDeal: AccommodationDealInformation;
  accommodationFacilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  boardType?: Maybe<BoardType>;
  cancellationFreeAlternativeAvailable: Scalars['Boolean']['output'];
  contentKey?: Maybe<Scalars['String']['output']>;
  debugInfo?: Maybe<Scalars['String']['output']>;
  dedupId: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  defaultSortingPosition?: Maybe<Scalars['Int']['output']>;
  distanceFromCityCenter?: Maybe<Scalars['Float']['output']>;
  favorite: Scalars['Boolean']['output'];
  insideDestination?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  priceBreakdown?: Maybe<PriceBreakdown>;
  providerId?: Maybe<Scalars['String']['output']>;
  roomOffer: RoomOffer;
  roomsLeft?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  score: Scalars['Float']['output'];
  secretHotelId?: Maybe<Scalars['String']['output']>;
  sortingLogic: AccommodationSortingLogic;
  userReview?: Maybe<UserReview>;
};

export type AccommodationBooking = {
  __typename?: 'AccommodationBooking';
  accommodationCancelPolicy?: Maybe<Scalars['String']['output']>;
  accommodationDescription?: Maybe<Scalars['String']['output']>;
  accommodationName?: Maybe<Scalars['String']['output']>;
  /** @deprecated old data structure, use additionalInformationPolicy instead */
  additionalInformation?: Maybe<Scalars['String']['output']>;
  additionalInformationPolicy: Array<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  boardType?: Maybe<BoardType>;
  bookingCancelPolicy?: Maybe<Scalars['String']['output']>;
  bookingRooms: Array<BookingRoom>;
  bookingStatus?: Maybe<BookingStatus>;
  cancellationDate?: Maybe<Scalars['String']['output']>;
  cancellationInformation: CancellationInformation;
  cancellationPolicies: CancellationPolicies;
  category: AccommodationCategory;
  checkIn?: Maybe<Scalars['String']['output']>;
  checkInDate: Scalars['Long']['output'];
  checkInDateISO8601: Scalars['String']['output'];
  checkOut?: Maybe<Scalars['String']['output']>;
  checkOutDate: Scalars['Long']['output'];
  checkOutDateISO8601: Scalars['String']['output'];
  checkinInstructionPolicy: Array<Scalars['String']['output']>;
  /** @deprecated old data structure, use checkinInstructionPolicy instead */
  checkinInstructions?: Maybe<Scalars['String']['output']>;
  childrenAges?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  city: Scalars['String']['output'];
  coordinates: GeoCoordinates;
  countryCode: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated old data structure, use feesPolicy instead */
  fees?: Maybe<Scalars['String']['output']>;
  feesPolicy: Array<Scalars['String']['output']>;
  hotelImage?: Maybe<HotelImage>;
  id?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locator?: Maybe<Scalars['String']['output']>;
  numberOfAdults: Scalars['Int']['output'];
  numberOfChildren: Scalars['Int']['output'];
  numberOfInfants: Scalars['Int']['output'];
  numberOfRooms: Scalars['Int']['output'];
  payAtPropertyTax?: Maybe<PayAtDestinationTaxes>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  price?: Maybe<AccommodationPriceDetails>;
  promotions?: Maybe<Array<Promotion>>;
  providerCode?: Maybe<Scalars['String']['output']>;
  roomsDescription: Scalars['String']['output'];
  roomsGroupCancelPolicy?: Maybe<Scalars['String']['output']>;
  starRating?: Maybe<StarRating>;
};

export type AccommodationBuyer = {
  address?: InputMaybe<Scalars['String']['input']>;
  buyerIdentificationTypeName?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  dayOfBirth?: InputMaybe<Scalars['Int']['input']>;
  identification?: InputMaybe<Scalars['String']['input']>;
  lastNames?: InputMaybe<Scalars['String']['input']>;
  mail?: InputMaybe<Scalars['String']['input']>;
  monthOfBirth?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  typePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  yearOfBirth?: InputMaybe<Scalars['Int']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AccommodationCancellation = {
  __typename?: 'AccommodationCancellation';
  cancellationBasketId?: Maybe<Scalars['ID']['output']>;
  cancellationId?: Maybe<Scalars['ID']['output']>;
  cancellationOptionId?: Maybe<Scalars['ID']['output']>;
};

export type AccommodationCancellationOption = {
  __typename?: 'AccommodationCancellationOption';
  cancellationBasketId?: Maybe<Scalars['ID']['output']>;
  cancellationOptionId: Scalars['ID']['output'];
  refundAmount: Scalars['Float']['output'];
  refundCurrency: Scalars['String']['output'];
};

export enum AccommodationCategory {
  Stars_0 = 'STARS_0',
  Stars_0_5 = 'STARS_0_5',
  Stars_1 = 'STARS_1',
  Stars_1_5 = 'STARS_1_5',
  Stars_2 = 'STARS_2',
  Stars_2_5 = 'STARS_2_5',
  Stars_3 = 'STARS_3',
  Stars_3_5 = 'STARS_3_5',
  Stars_4 = 'STARS_4',
  Stars_4_5 = 'STARS_4_5',
  Stars_5 = 'STARS_5',
  Stars_6 = 'STARS_6',
  Stars_7 = 'STARS_7',
  Unknown = 'UNKNOWN'
}

export type AccommodationDeal = {
  __typename?: 'AccommodationDeal';
  accommodationInfo: AccommodationDetailsResponse;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  dedupId: Scalars['Int']['output'];
  destination: City;
  discount: Scalars['Float']['output'];
  discountAbsolute: Money;
  images: Array<AccommodationImages>;
  matchedFilters: Array<AccommodationDealFilterType>;
  price: Money;
  priceNonPrime: Money;
  requestedDestination?: Maybe<Scalars['Boolean']['output']>;
};

export type AccommodationDealByDestinationRequest = {
  checkInDateRange: DateRange;
  checkOutDateRange: DateRange;
  destination: GeoNodeId;
  durationDays?: InputMaybe<NumberRange>;
  filters?: InputMaybe<AccommodationDealFilters>;
  isAccommodationRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  roomRequest?: InputMaybe<RoomRequest>;
};

export enum AccommodationDealFilterType {
  MaxDistanceFromCenter = 'MAX_DISTANCE_FROM_CENTER',
  MinDiscount = 'MIN_DISCOUNT',
  MinScoring = 'MIN_SCORING',
  MinStars = 'MIN_STARS'
}

export type AccommodationDealFilters = {
  maxDistanceFromCenter?: InputMaybe<Scalars['Float']['input']>;
  minDiscount?: InputMaybe<Scalars['Float']['input']>;
  minStars?: InputMaybe<Scalars['Int']['input']>;
  minUserScore?: InputMaybe<Scalars['Float']['input']>;
};

export type AccommodationDealInformation = {
  __typename?: 'AccommodationDealInformation';
  address?: Maybe<Scalars['String']['output']>;
  cancellationFree: ThreeValuedLogic;
  cancellationPolicyDescription?: Maybe<Scalars['String']['output']>;
  category: AccommodationCategory;
  chain?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  coordinates: GeoCoordinates;
  description?: Maybe<Scalars['String']['output']>;
  hasMerchandisePrice: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  mainAccommodationImage?: Maybe<AccommodationImage>;
  name: Scalars['String']['output'];
  neighbourhood?: Maybe<Scalars['String']['output']>;
  paymentAtDestination: Scalars['Boolean']['output'];
  stars?: Maybe<Scalars['Int']['output']>;
  type: AccommodationType;
};

export type AccommodationDealRequest = {
  accommodationDestination?: InputMaybe<GeoAccommodationDestination>;
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use checkInDate instead */
  checkInDateRange?: InputMaybe<DateRange>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use checkOutDate instead */
  checkOutDateRange?: InputMaybe<DateRange>;
  /** @deprecated Use either itineraryDestination accommodationDestination or instead */
  destination?: InputMaybe<GeoDestination>;
  /** @deprecated Use destination instead */
  destinations?: InputMaybe<Array<InputMaybe<GeoNodeId>>>;
  /** @deprecated Field no longer supported */
  durationDays?: InputMaybe<NumberRange>;
  filters?: InputMaybe<AccommodationDealFilters>;
  itineraryDestination?: InputMaybe<GeoNode>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  roomRequest?: InputMaybe<RoomRequest>;
  searchPriority?: InputMaybe<DealsSearchPriority>;
};

export type AccommodationDealsResponse = {
  __typename?: 'AccommodationDealsResponse';
  deals: Array<AccommodationDeal>;
  dealsId?: Maybe<Scalars['String']['output']>;
  isAlternativeDates?: Maybe<Scalars['Boolean']['output']>;
};

export type AccommodationDetail = {
  __typename?: 'AccommodationDetail';
  accommodationDealInformation?: Maybe<AccommodationDealInformation>;
  accommodationFacilities: Array<Scalars['String']['output']>;
  accommodationReview?: Maybe<AccommodationReview>;
  accommodationRoomServices?: Maybe<Array<Maybe<AccommodationRoomService>>>;
  checkInPolicy?: Maybe<Scalars['String']['output']>;
  checkOutPolicy?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  creditCardTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  distanceFromCityCenter?: Maybe<Scalars['Float']['output']>;
  facilityGroups?: Maybe<Array<Maybe<FacilityGroups>>>;
  favorite: Scalars['Boolean']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  hotelPolicy?: Maybe<Scalars['String']['output']>;
  hotelType?: Maybe<AccommodationType>;
  images?: Maybe<Array<Maybe<AccommodationImages>>>;
  locationDescription?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  mapUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  numberOfRooms?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Array<Maybe<AccommodationPolicy>>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateProvince?: Maybe<Scalars['String']['output']>;
  surroundingAreaInfo?: Maybe<Scalars['String']['output']>;
  web?: Maybe<Scalars['String']['output']>;
};

export type AccommodationDetailRequest = {
  accommodationDealKey: Scalars['String']['input'];
  searchId: Scalars['Long']['input'];
};

export type AccommodationDetailResponse = {
  __typename?: 'AccommodationDetailResponse';
  accommodationDetail?: Maybe<AccommodationDetail>;
};

export type AccommodationDetailsRequest = {
  contentKey: Scalars['String']['input'];
  customerSearchGeoAccommodation?: InputMaybe<GeoAccommodationRequest>;
  dedupId?: InputMaybe<Scalars['Int']['input']>;
  searchId?: InputMaybe<Scalars['Long']['input']>;
};

export type AccommodationDetailsResponse = {
  __typename?: 'AccommodationDetailsResponse';
  accommodationDetail?: Maybe<AccommodationDetail>;
};

export type AccommodationFacilityGroup = {
  __typename?: 'AccommodationFacilityGroup';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type AccommodationFilterMetadata = {
  __typename?: 'AccommodationFilterMetadata';
  count?: Maybe<Scalars['Int']['output']>;
  filterName?: Maybe<Scalars['String']['output']>;
  filterType?: Maybe<Scalars['String']['output']>;
};

export type AccommodationImage = {
  __typename?: 'AccommodationImage';
  quality?: Maybe<AccommodationImageQuality>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccommodationImageType>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum AccommodationImageQuality {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Unknown = 'UNKNOWN'
}

export enum AccommodationImageType {
  AreaInformation = 'AREA_INFORMATION',
  Balcony = 'BALCONY',
  Bathroom = 'BATHROOM',
  Dining = 'DINING',
  Entertainment = 'ENTERTAINMENT',
  Exterior = 'EXTERIOR',
  Food = 'FOOD',
  General = 'GENERAL',
  Gym = 'GYM',
  Hotel = 'HOTEL',
  Interior = 'INTERIOR',
  LivingArea = 'LIVING_AREA',
  Nearby = 'NEARBY',
  Parking = 'PARKING',
  Pool = 'POOL',
  Rooftop = 'ROOFTOP',
  Room = 'ROOM',
  SpaSauna = 'SPA_SAUNA',
  Uknown = 'UKNOWN',
  Workspace = 'WORKSPACE'
}

export type AccommodationImages = {
  __typename?: 'AccommodationImages';
  quality?: Maybe<AccommodationImageQuality>;
  sources?: Maybe<Array<Maybe<AccommodationImage>>>;
};

export type AccommodationImagesRequest = {
  contentKey: Scalars['String']['input'];
};

export type AccommodationImagesResponse = {
  __typename?: 'AccommodationImagesResponse';
  accommodationImages: Array<AccommodationImage>;
};

export type AccommodationInfo = {
  __typename?: 'AccommodationInfo';
  cancellationFree: Scalars['Boolean']['output'];
  cityName: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  distanceFromCenter: Scalars['Float']['output'];
  priceBreakdown: PriceBreakdown;
  stars: Scalars['Int']['output'];
  starsRating?: Maybe<StarRating>;
  userReview: UserReview;
};

export type AccommodationInfoProduct = Product & {
  __typename?: 'AccommodationInfoProduct';
  id?: Maybe<ProductId>;
  possibleDuplicatedBookingDetected: Scalars['Boolean']['output'];
  price?: Maybe<Money>;
  productInfo?: Maybe<AccommodationSummaryResponse>;
};

export type AccommodationInsurance = {
  __typename?: 'AccommodationInsurance';
  companyName: AccommodationInsuranceCompanyName;
  offerId: Scalars['String']['output'];
  policyCode: Scalars['String']['output'];
  prices: Array<AccommodationInsurancePrice>;
  productId?: Maybe<Scalars['String']['output']>;
  selected: Scalars['Boolean']['output'];
  termsAndConditions: Array<AccommodationInsuranceTermsAndConditions>;
  type: AccommodationInsuranceProductType;
};

export enum AccommodationInsuranceCompanyName {
  Axa = 'AXA'
}

export type AccommodationInsurancePrice = {
  __typename?: 'AccommodationInsurancePrice';
  perception: PricePerception;
  type: AccommodationInsurancePriceType;
  value: Money;
};

export enum AccommodationInsurancePriceType {
  NonPrime = 'NON_PRIME',
  Prime = 'PRIME'
}

export enum AccommodationInsuranceProductType {
  AccommodationCancellation = 'ACCOMMODATION_CANCELLATION',
  AccommodationCancellationAndMedicalAssistance = 'ACCOMMODATION_CANCELLATION_AND_MEDICAL_ASSISTANCE'
}

export type AccommodationInsuranceTermsAndConditions = {
  __typename?: 'AccommodationInsuranceTermsAndConditions';
  type: AccommodationInsuranceTermsAndConditionsType;
  url: Scalars['String']['output'];
};

export enum AccommodationInsuranceTermsAndConditionsType {
  ImportantProductInformation = 'IMPORTANT_PRODUCT_INFORMATION',
  PreContractualInformation = 'PRE_CONTRACTUAL_INFORMATION',
  PreContractualInformationSummary = 'PRE_CONTRACTUAL_INFORMATION_SUMMARY',
  StatusDisclosureInformation = 'STATUS_DISCLOSURE_INFORMATION'
}

export type AccommodationInsuranceTripDetails = {
  __typename?: 'AccommodationInsuranceTripDetails';
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  hotelCity: Scalars['String']['output'];
  mainGuestName: Scalars['String']['output'];
  numberOfGuests: Scalars['Int']['output'];
  policyNumber: Scalars['Long']['output'];
};

export type AccommodationInsurancesRequest = {
  shoppingBasketId: Scalars['ID']['input'];
};

export type AccommodationInsurancesResponse = {
  __typename?: 'AccommodationInsurancesResponse';
  accommodationInsurances: Array<AccommodationInsurance>;
};

export type AccommodationInvoiceComponents = {
  __typename?: 'AccommodationInvoiceComponents';
  roomPrice: Scalars['Float']['output'];
};

export type AccommodationModificationOption = {
  __typename?: 'AccommodationModificationOption';
  id: Scalars['ID']['output'];
  modifiedProductId: Scalars['ID']['output'];
  prices: Array<AccommodationModificationPrice>;
  productDetails?: Maybe<AccommodationModificationProductDetails>;
  selectedCustomerPriceType: CustomerPriceType;
};

export type AccommodationModificationOptionsRequest = {
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};

export type AccommodationModificationOptionsResponse = {
  __typename?: 'AccommodationModificationOptionsResponse';
  accommodationModificationOptions: Array<AccommodationModificationOption>;
};

export type AccommodationModificationPrice = {
  __typename?: 'AccommodationModificationPrice';
  breakdown: AccommodationModificationPriceBreakdown;
  customerPriceType: CustomerPriceType;
  total: Money;
};

export type AccommodationModificationPriceBreakdown = {
  __typename?: 'AccommodationModificationPriceBreakdown';
  membershipFee?: Maybe<Money>;
  productPrice?: Maybe<Money>;
};

export type AccommodationModificationProductDetails = {
  __typename?: 'AccommodationModificationProductDetails';
  rooms: Array<AccommodationModificationRoom>;
};

export type AccommodationModificationRoom = {
  __typename?: 'AccommodationModificationRoom';
  description?: Maybe<Scalars['String']['output']>;
};

export type AccommodationPolicy = {
  __typename?: 'AccommodationPolicy';
  content: Array<Scalars['String']['output']>;
  type: AccommodationPolicyType;
};

export enum AccommodationPolicyType {
  AdditionalInformation = 'ADDITIONAL_INFORMATION',
  CheckInInstructions = 'CHECK_IN_INSTRUCTIONS',
  Fees = 'FEES'
}

export type AccommodationPostBookingSearchRequest = {
  bookingAuth: BookingAuth;
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  destination: LocationRequest;
  geoAccommodation?: InputMaybe<GeoAccommodationRequest>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  membershipFee?: InputMaybe<Scalars['Boolean']['input']>;
  onlyRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  roomRequests: Array<RoomRequest>;
};

export type AccommodationPostBookingUrlRequest = {
  bookingId: Scalars['Long']['input'];
  buyPath: Scalars['String']['input'];
  email: Scalars['String']['input'];
  parameters?: InputMaybe<Array<PostBookingParameter>>;
};

export type AccommodationPrice = {
  __typename?: 'AccommodationPrice';
  membershipDiscount?: Maybe<MembershipDiscount>;
  /** @deprecated old data field, use membershipDiscount */
  membershipFee?: Maybe<Money>;
  price?: Maybe<Money>;
  total: Money;
};

export type AccommodationPriceBreakDownItem = PriceBreakDownItem & {
  __typename?: 'AccommodationPriceBreakDownItem';
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountInfoOfferedInSearch: Array<DiscountInfo>;
  discountedPrice?: Maybe<Money>;
  discountedPriceOfferedInSearch?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  nonDiscountedPriceOfferedInSearch?: Maybe<Money>;
  nonDiscountedPricePerNight?: Maybe<Money>;
  nonDiscountedPricePerNightOfferedInSearch?: Maybe<Money>;
  payAtPropertyTax?: Maybe<PayAtDestinationTaxes>;
  /** @deprecated Field no longer supported */
  price: Money;
  pricePerNight?: Maybe<Money>;
  pricePerNightOfferedInSearch?: Maybe<Money>;
  providerId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  selectedCustomerPriceType?: Maybe<CustomerPriceType>;
  tax?: Maybe<Money>;
  taxOfferedInSearch?: Maybe<Money>;
  totalPrice: Money;
  totalPriceOfferedInSearch: Money;
  type: PriceBreakDownItemType;
};

export type AccommodationPriceBreakdown = {
  __typename?: 'AccommodationPriceBreakdown';
  accommodationPrice?: Maybe<AccommodationPrice>;
  customerPriceType?: Maybe<CustomerPriceType>;
  tax?: Maybe<Money>;
  total?: Maybe<Money>;
};

export type AccommodationPriceDetails = {
  __typename?: 'AccommodationPriceDetails';
  accommodationPrice: AccommodationPrice;
  priceApplied?: Maybe<CustomerPriceType>;
  priceBreakdown?: Maybe<Array<Maybe<AccommodationPriceBreakdown>>>;
  tax: Money;
  total: Money;
};

export type AccommodationPriceMetadata = {
  __typename?: 'AccommodationPriceMetadata';
  avgPrice?: Maybe<Scalars['Float']['output']>;
  avgPricePerNight?: Maybe<Scalars['Float']['output']>;
  histogramRange?: Maybe<Scalars['Float']['output']>;
  maxDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  maxPrice?: Maybe<Scalars['Float']['output']>;
  maxPricePerNight?: Maybe<Scalars['Float']['output']>;
  maxSavingAmount?: Maybe<Scalars['Float']['output']>;
  minPrice?: Maybe<Scalars['Float']['output']>;
  minPricePerNight?: Maybe<Scalars['Float']['output']>;
  pricePerNightRange?: Maybe<Scalars['Float']['output']>;
};

export type AccommodationPriceSummary = PriceSummary & {
  __typename?: 'AccommodationPriceSummary';
  /** @deprecated Field no longer supported */
  amount: Money;
  /** @deprecated This information will come in the corresponding items */
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedAmount?: Maybe<Money>;
  discountedAmountOfferedInSearch?: Maybe<Money>;
  discountedPrice?: Maybe<Money>;
  discountedPriceOfferedInSearch?: Maybe<Money>;
  nonDiscountedAmount?: Maybe<Money>;
  nonDiscountedAmountOfferedInSearch?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  nonDiscountedPriceOfferedInSearch?: Maybe<Money>;
  nonTaxesAmount?: Maybe<Money>;
  nonTaxesAmountOfferedInSearch?: Maybe<Money>;
  payAtPropertyTax?: Maybe<PayAtDestinationTaxes>;
  pricePerception: PricePerceptionConfig;
  providerId?: Maybe<Scalars['String']['output']>;
  showAdditionalCharges?: Maybe<Scalars['Boolean']['output']>;
  taxesAmount?: Maybe<Money>;
  taxesAmountOfferedInSearch?: Maybe<Money>;
  totalDiscountPercentage?: Maybe<Scalars['Int']['output']>;
  totalPrice: Money;
  totalPriceOfferedInSearch: Money;
};

export type AccommodationProduct = {
  __typename?: 'AccommodationProduct';
  address?: Maybe<Scalars['String']['output']>;
  checkIn?: Maybe<Scalars['String']['output']>;
  checkOut?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<ProductId>;
  images?: Maybe<Array<Maybe<AccommodationImages>>>;
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  rooms?: Maybe<Array<Maybe<AccommodationRoomProduct>>>;
};

export type AccommodationProductBooking = {
  __typename?: 'AccommodationProductBooking';
  cancellationPolicies: CancellationPolicies;
  price: AccommodationProductPrice;
  pricePerception?: Maybe<AccommodationProductPricePerception>;
  productId: Scalars['String']['output'];
  totalUnderage: Scalars['Int']['output'];
};

export type AccommodationProductPrice = {
  __typename?: 'AccommodationProductPrice';
  amount: Money;
  breakdown?: Maybe<AccommodationProductPriceBreakdown>;
};

export type AccommodationProductPriceBreakdown = {
  __typename?: 'AccommodationProductPriceBreakdown';
  items: Array<AccommodationProductPriceBreakdownItem>;
};

export type AccommodationProductPriceBreakdownItem = {
  __typename?: 'AccommodationProductPriceBreakdownItem';
  concept: AccommodationProductPriceConcept;
  percentage?: Maybe<Scalars['Int']['output']>;
  price: AccommodationProductPrice;
};

export enum AccommodationProductPriceConcept {
  CityTax = 'CITY_TAX',
  MembershipDiscount = 'MEMBERSHIP_DISCOUNT',
  Other = 'OTHER',
  PropertyFee = 'PROPERTY_FEE',
  ResortFee = 'RESORT_FEE',
  RoomPrice = 'ROOM_PRICE',
  Taxes = 'TAXES'
}

export type AccommodationProductPricePerception = {
  __typename?: 'AccommodationProductPricePerception';
  items: Array<AccommodationProductPricePerceptionItem>;
};

export type AccommodationProductPricePerceptionItem = {
  __typename?: 'AccommodationProductPricePerceptionItem';
  price: AccommodationProductPrice;
  type: AccommodationProductPricePerceptionType;
};

export enum AccommodationProductPricePerceptionType {
  NonPrime = 'NON_PRIME',
  PayAtDestination = 'PAY_AT_DESTINATION',
  PayAtDestinationCustomerCurrency = 'PAY_AT_DESTINATION_CUSTOMER_CURRENCY',
  Prime = 'PRIME'
}

export type AccommodationRecognisedUser = {
  __typename?: 'AccommodationRecognisedUser';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prime: Scalars['Boolean']['output'];
};

export type AccommodationRecommendation = {
  __typename?: 'AccommodationRecommendation';
  accommodationInfo: AccommodationDetailsResponse;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  dedupId: Scalars['Int']['output'];
  destination: City;
  /** @deprecated Field no longer supported */
  discount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Field no longer supported */
  discountAbsolute?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price?: Maybe<Money>;
  priceBreakdown: PriceBreakdown;
  /** @deprecated Field no longer supported */
  priceNonPrime?: Maybe<Money>;
};

export type AccommodationRecommendationByIataCodeRequest = {
  iataCode: Scalars['String']['input'];
};

export type AccommodationRecommendationByIataCodeResponse = {
  __typename?: 'AccommodationRecommendationByIataCodeResponse';
  propertyMappingIds: Array<PropertyMappingId>;
};

export type AccommodationRecommendationRequest = {
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  geoAccommodationRequest: GeoAccommodationRequest;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  roomRequest?: InputMaybe<RoomRequest>;
};

export type AccommodationRecommendationResponse = {
  __typename?: 'AccommodationRecommendationResponse';
  accommodationRecommendations: Array<AccommodationRecommendation>;
  searchId?: Maybe<Scalars['Long']['output']>;
};

export type AccommodationResponse = {
  __typename?: 'AccommodationResponse';
  accommodations: Array<Accommodation>;
  currency?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<AccommodationSearchMetadata>;
  providerIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AccommodationReview = {
  __typename?: 'AccommodationReview';
  dedupId?: Maybe<Scalars['Int']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerReviewId?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  totalReviews?: Maybe<Scalars['Int']['output']>;
};

export type AccommodationRoomProduct = {
  __typename?: 'AccommodationRoomProduct';
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type AccommodationRoomService = {
  __typename?: 'AccommodationRoomService';
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AccommodationSearchAsyncRequest = {
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  geoAccommodation: GeoAccommodationRequest;
  mainProduct?: InputMaybe<MainProduct>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  membershipFee?: InputMaybe<Scalars['Boolean']['input']>;
  roomRequests: Array<RoomRequest>;
  searchType: AccommodationSearchType;
  upsell?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccommodationSearchAsyncResponse = {
  __typename?: 'AccommodationSearchAsyncResponse';
  searchId: Scalars['Long']['output'];
};

export type AccommodationSearchByDedupIdRequest = {
  bookingAuth?: InputMaybe<BookingAuth>;
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  dedupIds: Array<Scalars['Int']['input']>;
  destination: LocationRequest;
  geoAccommodation?: InputMaybe<GeoAccommodationRequest>;
  mainProduct?: InputMaybe<MainProduct>;
  membershipFee?: InputMaybe<Scalars['Boolean']['input']>;
  roomRequests: Array<RoomRequest>;
  searchType?: InputMaybe<AccommodationSearchType>;
  upsell?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccommodationSearchBySearchIdRequest = {
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  searchId: Scalars['Long']['input'];
  sortCriteria?: AccommodationSortCriteria;
};

export type AccommodationSearchCriteria = {
  __typename?: 'AccommodationSearchCriteria';
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  destination: LocationSearchCriteria;
  isCurrentUserSearch?: Maybe<Scalars['Boolean']['output']>;
  roomRequests: Array<RoomSearchCriteria>;
  searchType?: Maybe<AccommodationSearchType>;
};

export type AccommodationSearchHistory = {
  __typename?: 'AccommodationSearchHistory';
  accommodationImage?: Maybe<AccommodationImage>;
  accommodationInfo?: Maybe<AccommodationInfo>;
  checkIn: Scalars['String']['output'];
  checkOut: Scalars['String']['output'];
  date: Scalars['String']['output'];
  geoAccommodation: GeoAccommodation;
  name: Scalars['String']['output'];
  rooms: Array<RoomRequested>;
  searchHistoryId: Scalars['String']['output'];
  searchId?: Maybe<Scalars['Long']['output']>;
  totalAdults: Scalars['Int']['output'];
  totalChildren?: Maybe<Scalars['Int']['output']>;
};

export type AccommodationSearchHistoryRequest = {
  maxResults?: InputMaybe<Scalars['Int']['input']>;
};

export type AccommodationSearchHistoryResponse = {
  __typename?: 'AccommodationSearchHistoryResponse';
  accommodationSearchHistories: Array<AccommodationSearchHistory>;
};

export type AccommodationSearchMetadata = {
  __typename?: 'AccommodationSearchMetadata';
  filtersMetadata?: Maybe<Array<Maybe<AccommodationFilterMetadata>>>;
  priceMetadata?: Maybe<AccommodationPriceMetadata>;
};

export type AccommodationSearchPriceAlertNewsletterRequest = {
  email: Scalars['String']['input'];
  geoAccommodationRequest?: InputMaybe<GeoAccommodationRequest>;
  searchId: Scalars['Long']['input'];
};

export type AccommodationSearchPriceAlertNewsletterResponse = {
  __typename?: 'AccommodationSearchPriceAlertNewsletterResponse';
  isSubscribed: Scalars['Boolean']['output'];
};

export type AccommodationSearchRequest = {
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  dealsRecommendedId?: InputMaybe<Scalars['String']['input']>;
  destination: LocationRequest;
  geoAccommodation?: InputMaybe<GeoAccommodationRequest>;
  mainProduct?: InputMaybe<MainProduct>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  membershipFee?: InputMaybe<Scalars['Boolean']['input']>;
  onlyRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  polygon?: InputMaybe<GeoAccommodationPolygonRequest>;
  roomRequests: Array<RoomRequest>;
  searchId?: InputMaybe<Scalars['Long']['input']>;
  searchType: AccommodationSearchType;
  sortCriteria?: AccommodationSortCriteria;
  upsell?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccommodationSearchResponse = {
  __typename?: 'AccommodationSearchResponse';
  /** @deprecated Field no longer supported */
  accommodationResponse: AccommodationResponse;
  accommodations: Array<Accommodation>;
  currency: Scalars['String']['output'];
  metadata: AccommodationSearchMetadata;
  numResults: Scalars['Int']['output'];
  providerIds: Array<Scalars['String']['output']>;
  searchId: Scalars['Long']['output'];
};

export type AccommodationSearchRoomUrlRequest = {
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  dedupId: Scalars['Long']['input'];
  destination: LocationRequest;
  roomRequests: Array<RoomRequest>;
};

export type AccommodationSearchRoomUrlResponse = {
  __typename?: 'AccommodationSearchRoomURLResponse';
  url: Scalars['String']['output'];
};

export enum AccommodationSearchType {
  Dynpack = 'DYNPACK',
  PostBooking = 'POST_BOOKING',
  Standalone = 'STANDALONE',
  Upsell = 'UPSELL'
}

export type AccommodationShoppingItem = {
  __typename?: 'AccommodationShoppingItem';
  accommodationDealInformation?: Maybe<AccommodationDealInformation>;
  id?: Maybe<Scalars['Long']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  roomDealLegend?: Maybe<Array<Maybe<RoomDeal>>>;
  roomGroupDeal?: Maybe<RoomGroupDeal>;
};

export enum AccommodationSortCriteria {
  HigherDiscount = 'HIGHER_DISCOUNT',
  HigherScore = 'HIGHER_SCORE'
}

export type AccommodationSortingLogic = {
  __typename?: 'AccommodationSortingLogic';
  defaultPosition: Scalars['Int']['output'];
  personalisationApplied: Scalars['Boolean']['output'];
};

export type AccommodationStaticContent = {
  __typename?: 'AccommodationStaticContent';
  accommodationDeal?: Maybe<AccommodationDealInformation>;
  contentKey?: Maybe<Scalars['String']['output']>;
};

export type AccommodationStaticContentRequest = {
  contentKeys: Array<Scalars['String']['input']>;
};

export type AccommodationStaticContentResponse = {
  __typename?: 'AccommodationStaticContentResponse';
  /** @deprecated The query accommodationStaticContent is no longer used */
  accommodationsStaticContent?: Maybe<Array<Maybe<AccommodationStaticContent>>>;
};

export type AccommodationStaticMapRequest = {
  apiKey?: InputMaybe<GoogleApiKey>;
  contentKey: Scalars['String']['input'];
  staticMapConfiguration: MapStaticConfiguration;
};

export enum AccommodationStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Processing = 'PROCESSING'
}

export type AccommodationSuggestionRequest = {
  accommodationSearchId: Scalars['Long']['input'];
  selectedAccommodationContentKey: Scalars['String']['input'];
};

export type AccommodationSuggestionResponse = {
  __typename?: 'AccommodationSuggestionResponse';
  accommodations: Array<Accommodation>;
  searchId: Scalars['Long']['output'];
};

export type AccommodationSummaryRequest = {
  bookingId?: InputMaybe<Scalars['Long']['input']>;
  shoppingId?: InputMaybe<Scalars['ID']['input']>;
  shoppingType?: InputMaybe<ShoppingType>;
};

export type AccommodationSummaryResponse = {
  __typename?: 'AccommodationSummaryResponse';
  accommodationDetail?: Maybe<AccommodationDetail>;
  accommodationReview?: Maybe<AccommodationReview>;
  cancelPenalties: Array<CancelPenalty>;
  checkInDate?: Maybe<Scalars['String']['output']>;
  checkOutDate?: Maybe<Scalars['String']['output']>;
  roomDeals?: Maybe<Array<Maybe<RoomDealSummary>>>;
  roomRequests: Array<RoomSearchCriteria>;
};

export type AccommodationTripSummary = {
  __typename?: 'AccommodationTripSummary';
  accommodationName: Scalars['String']['output'];
  bookingStatus: BookingStatus;
  category: AccommodationCategory;
  checkInDate: Scalars['Long']['output'];
  checkOutDate: Scalars['Long']['output'];
  hotelImage?: Maybe<HotelImage>;
  id: Scalars['ID']['output'];
  tdToken: Scalars['String']['output'];
};

export enum AccommodationType {
  Apartament = 'APARTAMENT',
  BedAndBreakfast = 'BED_AND_BREAKFAST',
  GuestHouse = 'GUEST_HOUSE',
  Hostel = 'HOSTEL',
  Hotel = 'HOTEL',
  Motel = 'MOTEL',
  Residence = 'RESIDENCE',
  Resort = 'RESORT',
  Ryokan = 'RYOKAN',
  Unknown = 'UNKNOWN'
}

export type ActivateTokenUserRequest = {
  activateToken: Scalars['String']['input'];
};

export type ActiveCampaignResponse = {
  __typename?: 'ActiveCampaignResponse';
  campaign?: Maybe<MarketingCampaign>;
};

export type AddBookingBuyerToShoppingBasketRequest = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};

export type AddContactDetailsToShoppingBasketRequest = {
  address?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  shoppingId: Scalars['String']['input'];
  typePhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AddContactDetailsToUniversalShoppingBasketRequest = {
  contactDetails: ContactDetailsToUniversalShoppingBasketRequest;
  shoppingBasketId: Scalars['ID']['input'];
};

export type AddFavoriteAccommodationRequest = {
  accommodationProviderId?: InputMaybe<Scalars['String']['input']>;
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  contentKey?: InputMaybe<Scalars['String']['input']>;
  geoNodeId?: InputMaybe<Scalars['Int']['input']>;
  propertyMappingId: Scalars['Long']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  roomRequests: Array<FavoriteRoomRequest>;
};

export type AddFavoriteAccommodationResponse = {
  __typename?: 'AddFavoriteAccommodationResponse';
  success: Scalars['Boolean']['output'];
};

export type AddItineraryModificationRequest = {
  bookingItemId: Scalars['Long']['input'];
  departureDate: Scalars['String']['input'];
  returnDate?: InputMaybe<Scalars['String']['input']>;
  tripDetailsToken: Scalars['String']['input'];
};

export type AddItineraryModificationResponse = {
  __typename?: 'AddItineraryModificationResponse';
  modificationId: Scalars['ID']['output'];
};

export type AddOutcomeRequest = {
  outcome: Array<InputParam>;
  userPaymentInteractionId: UserPaymentInteractionIdInput;
};

export type AddOutcomeResponse = {
  __typename?: 'AddOutcomeResponse';
  success: Scalars['Boolean']['output'];
};

export type AddPersonalInfoRequest = {
  buyer: BuyerInput;
  saveContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
  shoppingInfo: ShoppingInfo;
  travellers: Array<ShoppingTravellerInput>;
};

export type AddPersonalInfoResponse = {
  __typename?: 'AddPersonalInfoResponse';
  shoppingBundle: ShoppingBundle;
};

export type AddProductToShoppingBasketRequest = {
  product: ProductIdRequest;
  shoppingBasketId: Scalars['String']['input'];
  shoppingType?: InputMaybe<ShoppingType>;
  totalPrice?: InputMaybe<MoneyRequest>;
};

export type AddProductToUniversalShoppingBasketRequest = {
  product: UniversalShoppingBasketProductRequest;
  shoppingBasketId: Scalars['ID']['input'];
};

export type AddShoppingBasketPromoCodeRequest = {
  code: Scalars['String']['input'];
  shoppingBasketId: Scalars['ID']['input'];
};

export type AddShoppingBasketPromoCodeResponse = {
  __typename?: 'AddShoppingBasketPromoCodeResponse';
  shoppingBasketPromoCode: ShoppingBasketPromoCode;
};

export type AddUniversalShoppingBasketPromoCodeRequest = {
  code: Scalars['String']['input'];
  shoppingBasketId: Scalars['ID']['input'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type AirlineCampaignConfig = {
  __typename?: 'AirlineCampaignConfig';
  /** @deprecated Not used, will be removed in next iterations */
  hasAirlineCampaign: Scalars['Boolean']['output'];
};

export type AirlineChargesAmounts = {
  __typename?: 'AirlineChargesAmounts';
  airlineCode: Scalars['String']['output'];
  airlineName: Scalars['String']['output'];
  chargedAmount: Scalars['Float']['output'];
};

export type AirlineGroup = {
  __typename?: 'AirlineGroup';
  carriers: Array<Carrier>;
};

export type AirlineTracking = {
  __typename?: 'AirlineTracking';
  carrier: Scalars['String']['output'];
  preBoostingPosition?: Maybe<Array<TrackingPosition>>;
  sortingPosition: Array<TrackingPosition>;
};

export type Airport = {
  __typename?: 'Airport';
  boardingTime?: Maybe<Scalars['String']['output']>;
  datetime: Scalars['String']['output'];
  iata: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AlternativeFareItinerary = {
  __typename?: 'AlternativeFareItinerary';
  alternativeFareItineraryId: Scalars['ID']['output'];
  legs: Array<TripLeg>;
  price?: Maybe<ModificationPrice>;
};

export type AlternativeFlight = {
  arrivalAirport: Scalars['String']['input'];
  bookingClass?: InputMaybe<Scalars['String']['input']>;
  departureAirport: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
  flightNumber: Scalars['String']['input'];
};

export type AlternativeItinerary = {
  __typename?: 'AlternativeItinerary';
  cashback: Money;
  id: Scalars['ID']['output'];
};

export type AlternativeItineraryForIncident = {
  __typename?: 'AlternativeItineraryForIncident';
  alternativeItineraryId: Scalars['ID']['output'];
  legs: Array<TripLeg>;
};

export type AncillariesProduct = Product & {
  __typename?: 'AncillariesProduct';
  id?: Maybe<ProductId>;
  price?: Maybe<Money>;
  productInfo?: Maybe<AncillariesProductInfo>;
};

export type AncillariesProductInfo = {
  __typename?: 'AncillariesProductInfo';
  bagsSelections: Array<BaggageSelection>;
  cabinBagsSelections: Array<CabinBagsSelection>;
  seatsSelections: Array<SeatsSelection>;
};

export type AncillariesPurchaseStateResponse = {
  __typename?: 'AncillariesPurchaseStateResponse';
  bags: AncillaryPurchaseState;
  itineraryTravellers: Scalars['Long']['output'];
  seats: AncillaryPurchaseState;
};

export type AncillariesRetailingEvaluationNavigationTreeResponse = {
  __typename?: 'AncillariesRetailingEvaluationNavigationTreeResponse';
  evaluation: Evaluation;
};

export type AncillariesRetailingEvaluationRequest = {
  shoppingCartId: Scalars['ID']['input'];
};

export type AncillariesRetailingEvaluationResponse = {
  __typename?: 'AncillariesRetailingEvaluationResponse';
  ancillariesToSkip: Array<AncillariesRetailingType>;
};

export enum AncillariesRetailingType {
  /** @deprecated not used, will be removed in future iterations */
  CabinBag = 'CABIN_BAG',
  /** @deprecated not used, will be removed in future iterations */
  CancellationAndAssistanceInsurance = 'CANCELLATION_AND_ASSISTANCE_INSURANCE',
  /** @deprecated not used, will be removed in future iterations */
  CancellationInsurance = 'CANCELLATION_INSURANCE',
  CancelForAnyReason = 'CANCEL_FOR_ANY_REASON',
  /** @deprecated not used, will be removed in future iterations */
  CancelForAnyReasonGuarantee = 'CANCEL_FOR_ANY_REASON_GUARANTEE',
  /** @deprecated not used, will be removed in future iterations */
  CheckedBag = 'CHECKED_BAG',
  FarePlus = 'FARE_PLUS',
  /** @deprecated not used, will be removed in future iterations */
  FlexibleDatesInsurance = 'FLEXIBLE_DATES_INSURANCE',
  FlightCancellationAndFlightCancellationPlusMedicalAssistance = 'FLIGHT_CANCELLATION_AND_FLIGHT_CANCELLATION_PLUS_MEDICAL_ASSISTANCE',
  InstantDisruptionCompensation = 'INSTANT_DISRUPTION_COMPENSATION',
  /** @deprecated not used, will be removed in future iterations */
  Seat = 'SEAT',
  SupportPack = 'SUPPORT_PACK'
}

export type AncillariesSelectionRequest = {
  baggage?: InputMaybe<Array<BaggageRequest>>;
  cabinBags?: InputMaybe<Array<CabinBagsRequest>>;
  seats?: InputMaybe<Array<PassengerSeatsSelectionRequest>>;
};

export type AncillaryBundleItem = {
  __typename?: 'AncillaryBundleItem';
  descriptor: AncillaryBundleItemDescriptor;
  id: Scalars['ID']['output'];
};

export type AncillaryBundleItemBenefit = {
  __typename?: 'AncillaryBundleItemBenefit';
  reference: Scalars['String']['output'];
};

export type AncillaryBundleItemDescriptor = {
  __typename?: 'AncillaryBundleItemDescriptor';
  benefits: Array<AncillaryBundleItemBenefit>;
  type: AncillaryBundleItemType;
};

export enum AncillaryBundleItemType {
  FlightUpdateSms = 'FLIGHT_UPDATE_SMS',
  Insurance = 'INSURANCE'
}

export type AncillaryBundleOffer = {
  __typename?: 'AncillaryBundleOffer';
  bundleItems: Array<AncillaryBundleItemDescriptor>;
  id: Scalars['ID']['output'];
  prices: Array<AncillaryBundlePrice>;
  termsAndConditions: Array<AncillaryBundleTermsAndConditions>;
  type: Scalars['String']['output'];
};

export type AncillaryBundlePrice = {
  __typename?: 'AncillaryBundlePrice';
  breakdown?: Maybe<AncillaryBundlePriceBreakdown>;
  price: Price;
  type: AncillaryBundlePriceType;
};

export type AncillaryBundlePriceBreakdown = {
  __typename?: 'AncillaryBundlePriceBreakdown';
  items: Array<AncillaryBundlePriceBreakdownItem>;
};

export type AncillaryBundlePriceBreakdownItem = {
  __typename?: 'AncillaryBundlePriceBreakdownItem';
  concept: Scalars['String']['output'];
  price: Price;
};

export enum AncillaryBundlePriceType {
  NonPrime = 'NON_PRIME',
  Prime = 'PRIME'
}

export type AncillaryBundleProduct = {
  __typename?: 'AncillaryBundleProduct';
  id: Scalars['ID']['output'];
  items: Array<AncillaryBundleItem>;
  price: AncillaryBundlePrice;
  status: AncillaryBundleStatus;
  termsAndConditions: Array<AncillaryBundleTermsAndConditions>;
  type: Scalars['String']['output'];
};

export type AncillaryBundleProductRequest = {
  productId: Scalars['ID']['input'];
};

export enum AncillaryBundleRelatedProductIdType {
  Legacy = 'LEGACY'
}

export enum AncillaryBundleRelatedProductType {
  Itinerary = 'ITINERARY'
}

export type AncillaryBundleSelectionRequest = {
  customerPriceType: AncillaryBundlePriceType;
  offerId: Scalars['ID']['input'];
  shoppingBasketId: Scalars['ID']['input'];
};

export enum AncillaryBundleStatus {
  Aborted = 'ABORTED',
  Cancelled = 'CANCELLED',
  Contracted = 'CONTRACTED',
  Initialized = 'INITIALIZED'
}

export type AncillaryBundleTermsAndConditions = {
  __typename?: 'AncillaryBundleTermsAndConditions';
  url: Scalars['String']['output'];
};

export type AncillaryBundlesByRelatedTripProductRequest = {
  relatedProductIdType: AncillaryBundleRelatedProductIdType;
  relatedProductType: AncillaryBundleRelatedProductType;
  token: Scalars['String']['input'];
};

export type AncillaryBundlesByRelatedTripProductResponse = {
  __typename?: 'AncillaryBundlesByRelatedTripProductResponse';
  products: Array<AncillaryBundleProduct>;
};

export enum AncillaryFlowType {
  Online = 'ONLINE',
  PostBooking = 'POST_BOOKING'
}

export type AncillaryPrice = {
  __typename?: 'AncillaryPrice';
  amount: Money;
  breakdown?: Maybe<AncillaryPriceBreakdown>;
};

export type AncillaryPriceBreakdown = {
  __typename?: 'AncillaryPriceBreakdown';
  items: Array<AncillaryPriceBreakdownItem>;
};

export type AncillaryPriceBreakdownItem = {
  __typename?: 'AncillaryPriceBreakdownItem';
  concept: Scalars['String']['output'];
  price: AncillaryPrice;
};

export type AncillaryPriceItem = {
  __typename?: 'AncillaryPriceItem';
  price?: Maybe<AncillaryPrice>;
  type?: Maybe<AncillaryPriceType>;
};

export enum AncillaryPriceType {
  NonPrime = 'NON_PRIME',
  Prime = 'PRIME'
}

export type AncillaryProduct = {
  __typename?: 'AncillaryProduct';
  ancillaryType: AncillaryType;
  nextProductWhenAttached?: Maybe<AncillaryProduct>;
  nextProductWhenNotAttached?: Maybe<AncillaryProduct>;
};

export type AncillaryProductItem = {
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  providerPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  serviceFeeTaxes?: Maybe<Money>;
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export enum AncillaryProductStatus {
  Contract = 'CONTRACT',
  Didnotbuy = 'DIDNOTBUY',
  Init = 'INIT',
  Pending = 'PENDING',
  Request = 'REQUEST'
}

export enum AncillaryProductType {
  Bag = 'BAG',
  CabinBag = 'CABIN_BAG',
  Seat = 'SEAT'
}

export type AncillaryPurchaseState = {
  __typename?: 'AncillaryPurchaseState';
  anyOtherProductPurchasable: Scalars['Boolean']['output'];
  productType: ProductType;
  purchasedQuantity: PurchasedQuantity;
};

export type AncillaryResponse = {
  __typename?: 'AncillaryResponse';
  baggage: Array<Maybe<BaggageConditions>>;
  baggageOfferable: Scalars['Boolean']['output'];
  cabinBags: Array<Maybe<CabinBag>>;
  oneClickBagDeals: OneClickBagDeals;
  seats: Array<Maybe<SeatMapSegment>>;
  seatsOfferable: Scalars['Boolean']['output'];
  sitTogetherOffers: Array<SitTogetherOffer>;
};

export type AncillarySelectionResponse = {
  __typename?: 'AncillarySelectionResponse';
  productSelectionStatus: AncillaryProductStatus;
  productSelectionType: AncillaryProductType;
  products: Array<Maybe<AncillariesProduct>>;
  totalPrice: AncillaryPriceItem;
};

export enum AncillaryType {
  AutomaticCheckIn = 'AUTOMATIC_CHECK_IN',
  Bag = 'BAG',
  FarePlus = 'FARE_PLUS',
  InstantDisruptionCompensation = 'INSTANT_DISRUPTION_COMPENSATION',
  Insurance = 'INSURANCE',
  Seat = 'SEAT',
  SupportPack = 'SUPPORT_PACK'
}

export type ApparentPrice = {
  __typename?: 'ApparentPrice';
  id: Scalars['ID']['output'];
  price: Money;
};

export type ApplePayPaymentSession = {
  __typename?: 'ApplePayPaymentSession';
  sessionData: Scalars['String']['output'];
};

export type ApplePayPaymentSessionRequest = {
  displayName: Scalars['String']['input'];
  validationUrl: Scalars['String']['input'];
};

export type ApplicationConditionsFilter = {
  interfacesFilter?: InputMaybe<PromoCodeInterfaceConditionsFilter>;
  productTypesFilter?: InputMaybe<WalletElementProductTypeConditionsFilter>;
};

export type ApplyAccommodationModificationRequest = {
  modificationId: Scalars['ID']['input'];
};

export type ApplyCancellationOptionRequest = {
  bookingId: Scalars['Long']['input'];
  cancellationOptionId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type Arrival = {
  __typename?: 'Arrival';
  baggageClaim?: Maybe<Scalars['String']['output']>;
  gate?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
  timeDelay?: Maybe<Scalars['String']['output']>;
  timeISO8601?: Maybe<Scalars['String']['output']>;
  updatedTerminal?: Maybe<Scalars['String']['output']>;
};

export type Attributes = {
  __typename?: 'Attributes';
  autoCapitalize?: Maybe<Scalars['Boolean']['output']>;
  autoComplete?: Maybe<Scalars['Boolean']['output']>;
  autoCorrect?: Maybe<Scalars['Boolean']['output']>;
  validator?: Maybe<Validator>;
};

export type AuthenticationEmailRequest = {
  email: Scalars['String']['input'];
  landingPagePath?: InputMaybe<Scalars['String']['input']>;
  newsletterSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  recaptchaV2Response?: InputMaybe<Scalars['String']['input']>;
};

export type AuthenticationEmailResponse = {
  __typename?: 'AuthenticationEmailResponse';
  acknowledged: Scalars['Boolean']['output'];
  multiSessionToken?: Maybe<Scalars['String']['output']>;
};

export type AuthenticationEmailWithTripAroundTheWorldContestParticipationRequest = {
  email: Scalars['String']['input'];
  landingPagePath?: InputMaybe<Scalars['String']['input']>;
  recaptchaV2Response?: InputMaybe<Scalars['String']['input']>;
};

export type AutoCompleteSearchRequest = {
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoCompleteSearchRequestV2 = {
  locale?: InputMaybe<Locale>;
  searchTerm: Scalars['String']['input'];
  sizeAccommodation?: InputMaybe<Scalars['Int']['input']>;
  sizeRegion?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoCompleteSearchResponse = {
  __typename?: 'AutoCompleteSearchResponse';
  autoCompleteSearchSuggestions: Array<AutoCompleteSearchSuggestion>;
};

export type AutoCompleteSearchResponseV2 = {
  __typename?: 'AutoCompleteSearchResponseV2';
  autoCompleteSearchSuggestions: Array<Geo>;
};

export type AutoCompleteSearchSuggestion = {
  __typename?: 'AutoCompleteSearchSuggestion';
  city: Scalars['String']['output'];
  coordinates?: Maybe<GeoCoordinates>;
  country: Scalars['String']['output'];
  destinationType: DestinationType;
  geoNodeId: Scalars['Int']['output'];
  propertyMappingId: PropertyMappingId;
  value?: Maybe<Scalars['String']['output']>;
};

export enum AutoRenewalDeactivationCondition {
  DeactivationAllowedAfter_4ConsecutiveQuarterlyRenewals = 'DEACTIVATION_ALLOWED_AFTER_4_CONSECUTIVE_QUARTERLY_RENEWALS',
  DeactivationAllowedAfter_12ConsecutiveMonthlyRenewals = 'DEACTIVATION_ALLOWED_AFTER_12_CONSECUTIVE_MONTHLY_RENEWALS',
  Unknown = 'UNKNOWN'
}

export type AutoRenewalPolicy = {
  __typename?: 'AutoRenewalPolicy';
  deactivationConditions: Array<AutoRenewalDeactivationCondition>;
};

export type AvailableCollectionMethodsRequest = {
  shoppingId: Scalars['String']['input'];
  shoppingType?: InputMaybe<ShoppingType>;
};

export type AvailableCollectionMethodsResponse = {
  __typename?: 'AvailableCollectionMethodsResponse';
  collectionOptions: Array<CollectionMethod>;
  delayedCollectionOptions: Array<CollectionMethod>;
  priceLogic?: Maybe<PriceLogic>;
  selectableDelayedCollectionItems: Array<SelectableDelayedCollectionItem>;
};

export type AvailableMembershipPerk = LimitedAvailableMembershipPerk | UnlimitedAvailableMembershipPerk;

export type Award = {
  __typename?: 'Award';
  imageUrlLarge: Scalars['String']['output'];
  type: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export enum BaggageApplicationLevel {
  Itinerary = 'ITINERARY',
  Section = 'SECTION',
  Segment = 'SEGMENT'
}

export enum BaggageCondition {
  BasedOnAirline = 'BASED_ON_AIRLINE',
  CabinIncluded = 'CABIN_INCLUDED',
  CheckinIncluded = 'CHECKIN_INCLUDED'
}

export type BaggageConditions = {
  __typename?: 'BaggageConditions';
  baggageApplicationLevel?: Maybe<BaggageApplicationLevel>;
  baggageDescriptorIncludedInPrice?: Maybe<BaggageDescriptor>;
  baggageFeeIncludedInPrice?: Maybe<Money>;
  baggagePropensity?: Maybe<Scalars['Float']['output']>;
  segmentTypeIndex?: Maybe<SegmentTypeIndex>;
  selectableBaggageDescriptor?: Maybe<Array<SelectableBaggageDescriptor>>;
  travellerType: TravellerAgeType;
};

export type BaggageConditionsTraveller = {
  __typename?: 'BaggageConditionsTraveller';
  baggageConditions: Array<BaggageConditions>;
  numTraveller: Scalars['Int']['output'];
};

export type BaggageDescriptor = {
  __typename?: 'BaggageDescriptor';
  kilos?: Maybe<Scalars['Int']['output']>;
  pieces?: Maybe<Scalars['Int']['output']>;
};

export type BaggagePriceBreakDownItem = AncillaryProductItem & PriceBreakDownItem & {
  __typename?: 'BaggagePriceBreakDownItem';
  /** @deprecated Field no longer supported */
  baggageConditions: Array<BaggageConditionsTraveller>;
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  providerPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  serviceFeeTaxes?: Maybe<Money>;
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export type BaggageRequest = {
  displayedPrice?: InputMaybe<MoneyRequest>;
  kilos: Scalars['Int']['input'];
  numPassenger: Scalars['Int']['input'];
  pieces: Scalars['Int']['input'];
  segmentTypeIndex: SegmentTypeIndex;
};

export type BaggageSelection = {
  __typename?: 'BaggageSelection';
  allowanceChanged: Scalars['Boolean']['output'];
  baggageApplicationLevel?: Maybe<BaggageApplicationLevel>;
  baggageDescriptorIncludedInPrice?: Maybe<BaggageDescriptor>;
  numPassenger: Scalars['Int']['output'];
  segmentTypeIndex?: Maybe<SegmentTypeIndex>;
  selectedBaggageDescriptor?: Maybe<Array<SelectableBaggageDescriptor>>;
};

export type Bank = {
  address?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  bsb?: InputMaybe<Scalars['String']['input']>;
  ifsc?: InputMaybe<Scalars['String']['input']>;
  institutionNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type BankAccount = {
  bank?: InputMaybe<Bank>;
  country: Scalars['String']['input'];
  holder?: InputMaybe<BankAccountHolder>;
  iban?: InputMaybe<Scalars['String']['input']>;
  interbankCLABE?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  transitNumber?: InputMaybe<Scalars['String']['input']>;
};

export type BankAccountHolder = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['String']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BankTransferRequest = {
  bankAccount: BankAccount;
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};

export type BankTransferResponse = {
  __typename?: 'BankTransferResponse';
  successful: Scalars['Boolean']['output'];
};

export type BaseMembershipPerk = {
  type: MembershipPerkType;
};

export type BaseMembershipReward = {
  promoCodeRewards: Array<PromoCodeReward>;
  rewardType: RewardType;
};

export enum BoardType {
  Ai = 'AI',
  Bb = 'BB',
  Fb = 'FB',
  Hb = 'HB',
  Ro = 'RO',
  Sc = 'SC',
  Un = 'UN'
}

export type BoardingPass = {
  __typename?: 'BoardingPass';
  arrival: Airport;
  carrierName: Scalars['String']['output'];
  departure: Airport;
  flightCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  seat?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export enum BoardingPassFormat {
  Pdf = 'PDF',
  Wallet = 'WALLET'
}

export type BoardingPassMetadata = {
  __typename?: 'BoardingPassMetadata';
  seat?: Maybe<Scalars['String']['output']>;
};

export type BoardingPassResponseData = {
  __typename?: 'BoardingPassResponseData';
  bytes: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum BoardingPassStatus {
  Failed = 'FAILED',
  Missed = 'MISSED',
  Null = 'NULL',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Suspended = 'SUSPENDED',
  Unavailable = 'UNAVAILABLE',
  Unknown = 'UNKNOWN'
}

export type BoardingPassV2 = {
  __typename?: 'BoardingPassV2';
  format: BoardingPassFormat;
  metadata: BoardingPassMetadata;
  url: Scalars['String']['output'];
};

export type BoardingPassesResponse = {
  __typename?: 'BoardingPassesResponse';
  data: Array<BoardingPassResponseData>;
};

export type BoardingPreference = {
  __typename?: 'BoardingPreference';
  boardingType: Scalars['String']['output'];
  from: Location;
  sectionId: Scalars['String']['output'];
  to: Location;
};

export type Booking = {
  __typename?: 'Booking';
  /** @deprecated the display status has been moved to the product level */
  displayStatus: BookingDisplayStatus;
  id: Scalars['Long']['output'];
  token: Scalars['String']['output'];
};

export type BookingAuth = {
  bookingId: Scalars['Long']['input'];
  buyerEmail: Scalars['String']['input'];
};

export type BookingCancellationOption = {
  id: Scalars['ID']['output'];
};

export enum BookingDisplayStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export type BookingInfo = {
  __typename?: 'BookingInfo';
  feePerPassenger?: Maybe<Money>;
  totalFee?: Maybe<Money>;
};

export type BookingInvoicesRequest = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};

export enum BookingProductStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  PartiallyConfirmed = 'PARTIALLY_CONFIRMED',
  Pending = 'PENDING'
}

export type BookingRoom = {
  __typename?: 'BookingRoom';
  adultsNumber: Scalars['Int']['output'];
  cancelPolicy?: Maybe<Scalars['String']['output']>;
  childsNumber: Scalars['Int']['output'];
  infantsNumber: Scalars['Int']['output'];
  infoPolicy?: Maybe<Scalars['String']['output']>;
  roomDescription?: Maybe<Scalars['String']['output']>;
  roomNumber: Scalars['Int']['output'];
  taxesPolicy?: Maybe<Scalars['String']['output']>;
};

export enum BookingStatus {
  Contract = 'CONTRACT',
  Didnotbuy = 'DIDNOTBUY',
  FinalRet = 'FINAL_RET',
  Hold = 'HOLD',
  Pending = 'PENDING',
  Request = 'REQUEST',
  Retained = 'RETAINED',
  Unknown = 'UNKNOWN'
}

export type BookingStatusMessage = Message & {
  __typename?: 'BookingStatusMessage';
  bookingId: Scalars['Long']['output'];
  bookingStatus?: Maybe<RetailBookingStatus>;
  extraHeader: Scalars['Boolean']['output'];
  partialRebookUrl?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  semantic: MessageSemantic;
  status: MessageStatus;
  type: MessageType;
};

export type BookingV2 = {
  __typename?: 'BookingV2';
  id: Scalars['Long']['output'];
  token: Scalars['String']['output'];
};

export type BundleId = {
  id: Scalars['String']['input'];
};

export type Buyer = {
  __typename?: 'Buyer';
  address: Scalars['String']['output'];
  alternativePhoneNumber?: Maybe<Phone>;
  buyerIdentificationType?: Maybe<BuyerIdentificationType>;
  cityName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  idUser?: Maybe<Scalars['ID']['output']>;
  identification?: Maybe<Scalars['String']['output']>;
  lastNames?: Maybe<Scalars['String']['output']>;
  mail: Scalars['String']['output'];
  name: Scalars['String']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Phone>;
  stateName?: Maybe<Scalars['String']['output']>;
  userRegistered?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BuyerCheckoutDetails = {
  __typename?: 'BuyerCheckoutDetails';
  name?: Maybe<Scalars['String']['output']>;
};

export enum BuyerIdentificationType {
  BirthDate = 'BIRTH_DATE',
  Cif = 'CIF',
  NationalIdCard = 'NATIONAL_ID_CARD',
  Nie = 'NIE',
  Nif = 'NIF',
  Passport = 'PASSPORT'
}

export type BuyerInformationDescription = {
  __typename?: 'BuyerInformationDescription';
  identificationTypes?: Maybe<Array<BuyerIdentificationType>>;
  needsAddress: RequiredFieldType;
  needsAlternativePhoneNumber: RequiredFieldType;
  needsCityName: RequiredFieldType;
  needsCountryCode: RequiredFieldType;
  needsCpf: RequiredFieldType;
  needsDateOfBirth: RequiredFieldType;
  needsIdentification: RequiredFieldType;
  needsLastNames: RequiredFieldType;
  needsMail: RequiredFieldType;
  needsName: RequiredFieldType;
  needsNeighborhood: RequiredFieldType;
  needsPhoneNumber: RequiredFieldType;
  needsStateName: RequiredFieldType;
  needsZipCode: RequiredFieldType;
};

export type BuyerInput = {
  address: Scalars['String']['input'];
  alternativePhoneNumber?: InputMaybe<PhoneInput>;
  buyerIdentificationType?: InputMaybe<BuyerIdentificationType>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  idUser?: InputMaybe<Scalars['ID']['input']>;
  identification?: InputMaybe<Scalars['String']['input']>;
  lastNames?: InputMaybe<Scalars['String']['input']>;
  mail: Scalars['String']['input'];
  name: Scalars['String']['input'];
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<PhoneInput>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  storedTravellerId?: InputMaybe<Scalars['Long']['input']>;
  userRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum C4ArRedemptionType {
  Cash = 'CASH',
  Voucher = 'VOUCHER'
}

export type C4arCashRefundOption = {
  __typename?: 'C4arCashRefundOption';
  cancellationOptionId: Scalars['String']['output'];
  refundAmount?: Maybe<Money>;
};

export type C4arVoucherRefundOption = {
  __typename?: 'C4arVoucherRefundOption';
  cancellationOptionId: Scalars['String']['output'];
  refundAmount?: Maybe<Money>;
};

export type Cabin = {
  __typename?: 'Cabin';
  distribution: Array<Scalars['String']['output']>;
  exitRows: Array<Maybe<Scalars['Int']['output']>>;
  extraLegSeats: Array<Maybe<Scalars['String']['output']>>;
  firstSeatsRow: Scalars['Int']['output'];
  floor: Scalars['Int']['output'];
  lastSeatsRow: Scalars['Int']['output'];
  seatMapRowFrom: Scalars['Int']['output'];
  seatMapRowTo: Scalars['Int']['output'];
  seats: Array<Maybe<Seat>>;
};

export type CabinBag = {
  __typename?: 'CabinBag';
  carrier: Scalars['String']['output'];
  carrierConfiguration: CabinBagCarrierConfiguration;
  debugInfo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  fee: Money;
  /** @deprecated Field no longer supported */
  priceBreakdown: CabinBagPriceBreakdown;
  prices: Array<AncillaryPriceItem>;
  pricesPerUnit?: Maybe<Array<PricePerUnit>>;
  section: Scalars['Int']['output'];
  segment: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  totalPrice: Money;
  /** @deprecated Field no longer supported */
  totalPrimePrice?: Maybe<Money>;
};

export type CabinBagCarrierConfiguration = {
  __typename?: 'CabinBagCarrierConfiguration';
  cabinBagSize?: Maybe<Scalars['String']['output']>;
  cabinBagType: CabinBagType;
  cabinBagWeight?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  penalty?: Maybe<Scalars['String']['output']>;
  penaltyFee?: Maybe<Money>;
  priorityBoardingIncluded?: Maybe<Scalars['Boolean']['output']>;
  smallBagSize?: Maybe<Scalars['String']['output']>;
};

export type CabinBagCarrierConfigurationEntry = {
  __typename?: 'CabinBagCarrierConfigurationEntry';
  carrierCode: Scalars['String']['output'];
  config: CabinBagCarrierConfiguration;
};

export type CabinBagPbdConfiguration = {
  __typename?: 'CabinBagPBDConfiguration';
  cabinBagType?: Maybe<CabinBagType>;
  cabinBagWeight?: Maybe<Scalars['String']['output']>;
};

export type CabinBagPriceBreakDownItem = AncillaryProductItem & PriceBreakDownItem & {
  __typename?: 'CabinBagPriceBreakDownItem';
  cabinBagPBDConfiguration?: Maybe<CabinBagPbdConfiguration>;
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  providerPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  serviceFeeTaxes?: Maybe<Money>;
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export type CabinBagPriceBreakdown = {
  __typename?: 'CabinBagPriceBreakdown';
  fee: Money;
  primeFee?: Maybe<Money>;
  totalPrice: Money;
  totalPrimePrice?: Maybe<Money>;
};

export enum CabinBagType {
  CabinBag = 'CABIN_BAG',
  CabinBagAndPriority = 'CABIN_BAG_AND_PRIORITY',
  SmallBag = 'SMALL_BAG'
}

export type CabinBagsRequest = {
  numPassenger: Scalars['Int']['input'];
  section: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type CabinBagsSelection = {
  __typename?: 'CabinBagsSelection';
  debugInfo?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  fee: Money;
  numPassenger: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  priceBreakdown: CabinBagPriceBreakdown;
  prices: Array<AncillaryPriceItem>;
  section: Scalars['Int']['output'];
  segment: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  totalPrice: Money;
  /** @deprecated Field no longer supported */
  totalPrimePrice?: Maybe<Money>;
  type: Scalars['String']['output'];
};

export enum CabinClass {
  Business = 'BUSINESS',
  EconomicDiscounted = 'ECONOMIC_DISCOUNTED',
  First = 'FIRST',
  PremiumEconomy = 'PREMIUM_ECONOMY',
  Tourist = 'TOURIST'
}

export type CalculateMembershipRetentionOptionsResponse = {
  __typename?: 'CalculateMembershipRetentionOptionsResponse';
  membershipCancellationOptions: Array<MembershipCancellationOption>;
  membershipRetentionOffers: Array<MembershipRetentionOffer>;
  membershipRewards: MembershipRewards;
  retentionUserAccount?: Maybe<UserAccountResponse>;
};

export type CalculatePrimeSubscriptionOfferRequest = {
  context?: InputMaybe<PrimeSubscriptionOfferContext>;
  evaluationContext?: InputMaybe<PrimeSubscriptionOfferEvaluationContext>;
};

export type CalculatePrimeSubscriptionOfferResponse = {
  __typename?: 'CalculatePrimeSubscriptionOfferResponse';
  evaluationCode?: Maybe<MembershipProductEvaluationCode>;
  offer: PrimeSubscriptionOffer;
};

export type CalculatePrimeSubscriptionPostPurchaseOffersRequest = {
  bookingId?: InputMaybe<Scalars['Long']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  touchpoint: Touchpoint;
};

export type CalculatePrimeSubscriptionPostPurchaseOffersResponse = {
  __typename?: 'CalculatePrimeSubscriptionPostPurchaseOffersResponse';
  offers: Array<PostPurchaseSubscriptionOffer>;
};

export type CalculateReferralsOffersRequest = {
  referrerToken: Scalars['String']['input'];
};

export type CalculateReferralsOffersResponse = {
  __typename?: 'CalculateReferralsOffersResponse';
  offer: Array<ReferralSubscription>;
  reward?: Maybe<ReferralReward>;
};

export type CalculateSubscriptionOfferRequest = {
  funnel: Funnel;
  touchPoint?: InputMaybe<Touchpoint>;
};

export type CalculateSubscriptionOfferResponse = {
  __typename?: 'CalculateSubscriptionOfferResponse';
  offerOptions: Array<OfferOption>;
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignItineraryIds: Array<Scalars['String']['output']>;
  campaignKey: Scalars['String']['output'];
};

export type CampaignConfig = {
  __typename?: 'CampaignConfig';
  /** @deprecated Not used, will be removed in next iterations */
  airlineCampaignConfig?: Maybe<AirlineCampaignConfig>;
  primeDayConfig?: Maybe<PrimeDayConfig>;
};

export type CampaignConfigValue = {
  __typename?: 'CampaignConfigValue';
  campaignConfig: CampaignConfig;
  id: Scalars['ID']['output'];
};

export enum CampaignType {
  BlackFriday = 'BLACK_FRIDAY',
  FlashSale = 'FLASH_SALE',
  HotelSavingsFest = 'HOTEL_SAVINGS_FEST',
  HotelSuperSales = 'HOTEL_SUPER_SALES',
  OcAlwaysOnPromotion = 'OC_ALWAYS_ON_PROMOTION',
  PrimeDays = 'PRIME_DAYS',
  SummerSales = 'SUMMER_SALES',
  TravelTuesday = 'TRAVEL_TUESDAY',
  Unknown = 'UNKNOWN'
}

export type CanApplyItineraryDiscountRequest = {
  bookingId: Scalars['Long']['input'];
  buyerEmail: Scalars['String']['input'];
  travellers: Array<ItineraryTraveller>;
};

export type CanApplyItineraryDiscountResponse = {
  __typename?: 'CanApplyItineraryDiscountResponse';
  value: Scalars['Boolean']['output'];
};

export type CancelCheckoutRequest = {
  shoppingId: Scalars['ID']['input'];
  userPaymentInteractionIdInput?: InputMaybe<UserPaymentInteractionIdInput>;
};

export type CancelMembershipRequest = {
  buyerEmail: Scalars['String']['input'];
  cancellationOptionId: Scalars['ID']['input'];
};

export type CancelPenalty = {
  __typename?: 'CancelPenalty';
  endDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated it will simplified and migrate to value */
  nights?: Maybe<Scalars['Int']['output']>;
  /** @deprecated it will simplified and migrate to value */
  percentage?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CancellationPenaltyType>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type CancelShoppingBasketCheckoutRequest = {
  shoppingId: Scalars['ID']['input'];
  userPaymentInteractionIdInput?: InputMaybe<UserPaymentInteractionIdInput>;
};

export type CancelUnauthenticatedMembershipRequest = {
  email: Scalars['String']['input'];
  recaptchaTokenV2?: InputMaybe<Scalars['String']['input']>;
};

export type CancelUnauthenticatedMembershipResponse = {
  __typename?: 'CancelUnauthenticatedMembershipResponse';
  success: Scalars['Boolean']['output'];
};

export type CancellableRequest = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};

export type CancellableResponse = {
  __typename?: 'CancellableResponse';
  cancellable: Scalars['Boolean']['output'];
  notCancellableReason?: Maybe<NotCancellableReason>;
};

export type Cancellation = {
  __typename?: 'Cancellation';
  bookingItemId: Scalars['Long']['output'];
  cancellationId?: Maybe<CancellationId>;
  cancellationProviderItem?: Maybe<CancellationProviderItem>;
  cancellationRefund?: Maybe<CancellationRefund>;
  cancellationStatus?: Maybe<CancellationStatus>;
  incidents?: Maybe<Array<Maybe<Incident>>>;
  merchant: Scalars['Boolean']['output'];
  pnr?: Maybe<Scalars['String']['output']>;
  providerBookingItemId?: Maybe<Scalars['Long']['output']>;
};

export type CancellationCashRefundOption = {
  __typename?: 'CancellationCashRefundOption';
  basedOnProviderRules: Scalars['Boolean']['output'];
  cancellationOptionId: Scalars['String']['output'];
  refundAmount: Money;
};

export type CancellationDetails = {
  __typename?: 'CancellationDetails';
  refunded?: Maybe<Scalars['Boolean']['output']>;
};

export type CancellationId = {
  __typename?: 'CancellationId';
  id: Scalars['String']['output'];
};

export type CancellationInfo = {
  __typename?: 'CancellationInfo';
  cancellationDate?: Maybe<Scalars['String']['output']>;
  isCancellationAvailable: Scalars['Boolean']['output'];
};

export type CancellationInformation = {
  __typename?: 'CancellationInformation';
  cancellableStatus: Scalars['String']['output'];
  cancellationDetails?: Maybe<CancellationDetails>;
  cancellationOptions: Array<CancellationOption>;
};

export type CancellationMessage = Message & {
  __typename?: 'CancellationMessage';
  bookingId: Scalars['Long']['output'];
  cancellationType: CancellationType;
  cancellations: Array<Maybe<Cancellation>>;
  extraHeader: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  semantic: MessageSemantic;
  status: MessageStatus;
  type: MessageType;
};

export type CancellationOption = {
  __typename?: 'CancellationOption';
  from: Scalars['String']['output'];
  refundAmount: Money;
  refundPercentage: Scalars['Int']['output'];
  until: Scalars['String']['output'];
};

export enum CancellationPenaltyType {
  Amount = 'AMOUNT',
  Night = 'NIGHT',
  Percentage = 'PERCENTAGE'
}

export type CancellationPolicies = {
  __typename?: 'CancellationPolicies';
  cancellableStatus: Scalars['String']['output'];
  cancellationOptions: Array<CancellationOption>;
};

export type CancellationProviderItem = {
  __typename?: 'CancellationProviderItem';
  cashRefundAmount?: Maybe<Money>;
  classification?: Maybe<CancellationProviderItemClassification>;
  openTicketAmount?: Maybe<Money>;
  openTicketPrimeTotalAmount?: Maybe<Money>;
  openTicketTotalAmount?: Maybe<Money>;
  primeSubscriptionAmount?: Maybe<Money>;
  resolutionType?: Maybe<CancellationProviderItemResolutionType>;
  topUpVoucherAmount?: Maybe<Money>;
  topUpVoucherMinBasketAmount?: Maybe<Money>;
};

export enum CancellationProviderItemClassification {
  AirlineAlternative = 'AIRLINE_ALTERNATIVE',
  AtcAutomatic = 'ATC_AUTOMATIC',
  AtcManual = 'ATC_MANUAL',
  Bankruptcy = 'BANKRUPTCY',
  BspExternal = 'BSP_EXTERNAL',
  BspLcc = 'BSP_LCC',
  BspLink = 'BSP_LINK',
  Cashout = 'CASHOUT',
  CommercialRelationship = 'COMMERCIAL_RELATIONSHIP',
  CustomerAlternativeRequested = 'CUSTOMER_ALTERNATIVE_REQUESTED',
  CustomerDirectResolution = 'CUSTOMER_DIRECT_RESOLUTION',
  FreeRebookingManual = 'FREE_REBOOKING_MANUAL',
  LcCashRefund = 'LC_CASH_REFUND',
  Manual = 'MANUAL',
  ManualRefund = 'MANUAL_REFUND',
  NoCash = 'NO_CASH',
  OpenTicketError = 'OPEN_TICKET_ERROR',
  OpenTicketWithoutConsent = 'OPEN_TICKET_WITHOUT_CONSENT',
  OpenTicketWithConsent = 'OPEN_TICKET_WITH_CONSENT',
  PrimePlusRefundedAsVoucher = 'PRIME_PLUS_REFUNDED_AS_VOUCHER',
  RefundCheck = 'REFUND_CHECK',
  Resolved = 'RESOLVED',
  SendToAirlines = 'SEND_TO_AIRLINES',
  TfAutomatic = 'TF_AUTOMATIC',
  TfBsm = 'TF_BSM',
  Unknown = 'UNKNOWN',
  Voluntary = 'VOLUNTARY'
}

export enum CancellationProviderItemResolutionType {
  BspLink = 'BSP_LINK',
  CashOnly = 'CASH_ONLY',
  CustomerAlternativeIssued = 'CUSTOMER_ALTERNATIVE_ISSUED',
  ManagedByIcm = 'MANAGED_BY_ICM',
  ManagedByTouchless = 'MANAGED_BY_TOUCHLESS',
  Manual = 'MANUAL',
  NotValid = 'NOT_VALID',
  OpenTicketWithoutConsent = 'OPEN_TICKET_WITHOUT_CONSENT',
  OpenTicketWithConsent = 'OPEN_TICKET_WITH_CONSENT',
  PrimePlusRefundedAsVoucher = 'PRIME_PLUS_REFUNDED_AS_VOUCHER',
  RefundNotManagedByEdo = 'REFUND_NOT_MANAGED_BY_EDO',
  RefundWaitingConsent = 'REFUND_WAITING_CONSENT',
  Resolved = 'RESOLVED',
  ResolvedByCustomer = 'RESOLVED_BY_CUSTOMER',
  Unknown = 'UNKNOWN',
  Voluntary = 'VOLUNTARY'
}

export type CancellationRefund = {
  __typename?: 'CancellationRefund';
  status: CancellationRefundStatus;
  statusDateList?: Maybe<Array<Maybe<CancellationRefundStatusDateMapEntry>>>;
};

export enum CancellationRefundStatus {
  RefundAirlineApproved = 'REFUND_AIRLINE_APPROVED',
  RefundAirlinePending = 'REFUND_AIRLINE_PENDING',
  RefundAirlineRequested = 'REFUND_AIRLINE_REQUESTED',
  RefundFinalizing = 'REFUND_FINALIZING',
  RefundPrioritising = 'REFUND_PRIORITISING',
  RefundProcessing = 'REFUND_PROCESSING',
  RefundRequested = 'REFUND_REQUESTED',
  Unknown = 'UNKNOWN'
}

export type CancellationRefundStatusDateMapEntry = {
  __typename?: 'CancellationRefundStatusDateMapEntry';
  key: CancellationRefundStatus;
  value?: Maybe<Scalars['String']['output']>;
};

export enum CancellationStatus {
  Bankruptcy = 'BANKRUPTCY',
  CheckingRefund = 'CHECKING_REFUND',
  ContactAirline = 'CONTACT_AIRLINE',
  CustomerAlternativeIssued = 'CUSTOMER_ALTERNATIVE_ISSUED',
  CustomerAlternativeRequested = 'CUSTOMER_ALTERNATIVE_REQUESTED',
  ManagedByIcm = 'MANAGED_BY_ICM',
  ManagedByTouchless = 'MANAGED_BY_TOUCHLESS',
  ManualAirlineAlternative = 'MANUAL_AIRLINE_ALTERNATIVE',
  MultipleCancellations = 'MULTIPLE_CANCELLATIONS',
  OpenTicketAccepted = 'OPEN_TICKET_ACCEPTED',
  OpenTicketPending = 'OPEN_TICKET_PENDING',
  PendingClassification = 'PENDING_CLASSIFICATION',
  PrimePlusRefundedAsVoucher = 'PRIME_PLUS_REFUNDED_AS_VOUCHER',
  RedemptionPending = 'REDEMPTION_PENDING',
  RefundMerchant = 'REFUND_MERCHANT',
  RefundNotManagedByEdo = 'REFUND_NOT_MANAGED_BY_EDO',
  RefundNoMerchant = 'REFUND_NO_MERCHANT',
  RefundWaitingConsent = 'REFUND_WAITING_CONSENT',
  RefundWithStatus = 'REFUND_WITH_STATUS',
  Resolved = 'RESOLVED',
  ResolvedByCustomer = 'RESOLVED_BY_CUSTOMER',
  Unknown = 'UNKNOWN'
}

export enum CancellationType {
  Involuntary = 'INVOLUNTARY',
  Unknown = 'UNKNOWN',
  Voluntary = 'VOLUNTARY'
}

export type CarbonFootprint = {
  __typename?: 'CarbonFootprint';
  ecoPercentageThanAverage?: Maybe<Scalars['Int']['output']>;
  isEco?: Maybe<Scalars['Boolean']['output']>;
  totalCo2Kilos?: Maybe<Scalars['Float']['output']>;
  totalCo2eKilos?: Maybe<Scalars['Float']['output']>;
};

export type CarbonFootprintValue = {
  __typename?: 'CarbonFootprintValue';
  carbonFootprint: CarbonFootprint;
  id: Scalars['ID']['output'];
};

export type Carrier = {
  __typename?: 'Carrier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supportUrl?: Maybe<Scalars['String']['output']>;
};

export type CarrierCustomerAccount = {
  __typename?: 'CarrierCustomerAccount';
  username: Scalars['String']['output'];
};

export type CarrierCustomerCredentials = {
  __typename?: 'CarrierCustomerCredentials';
  email: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type CarrierCustomerCredentialsRequest = {
  bookingItemId: Scalars['Long']['input'];
  tripDetailsToken: Scalars['String']['input'];
};

export type CarrierCustomerCredentialsResponse = {
  __typename?: 'CarrierCustomerCredentialsResponse';
  carrierCustomerCredentials?: Maybe<CarrierCustomerCredentials>;
};

export type CarrierDocument = {
  __typename?: 'CarrierDocument';
  documentURL: Scalars['String']['output'];
  itineraryBookingId: Scalars['Long']['output'];
};

export type CarrierDocumentsRequest = {
  bookingItemId: Scalars['Long']['input'];
  tripDetailsToken: Scalars['String']['input'];
};

export type CarrierDocumentsResponse = {
  __typename?: 'CarrierDocumentsResponse';
  carrierDocuments?: Maybe<Array<Maybe<CarrierDocument>>>;
};

export type CarrierValue = {
  __typename?: 'CarrierValue';
  carrier: Carrier;
  id: Scalars['String']['output'];
};

export type CarriersCustomerCredentials = {
  __typename?: 'CarriersCustomerCredentials';
  credentials: Array<CustomerCredentials>;
};

export type CarriersCustomerCredentialsResponse = {
  __typename?: 'CarriersCustomerCredentialsResponse';
  carriersCustomerCredentials: CarriersCustomerCredentials;
};

export type CartPriceBreakDown = {
  __typename?: 'CartPriceBreakDown';
  items?: Maybe<Array<PriceBreakDownItem>>;
  priceSummary: PriceSummary;
};

export type ChangeItineraryRequest = {
  alternativeFareItineraryId: Scalars['ID']['input'];
};

export type ChangeItineraryResponse = {
  __typename?: 'ChangeItineraryResponse';
  bookingId?: Maybe<Scalars['Long']['output']>;
  creationTime?: Maybe<Scalars['Long']['output']>;
  discarded: Scalars['Boolean']['output'];
  items: Array<Item>;
  lastUpdate?: Maybe<Scalars['Long']['output']>;
  modificationId: Scalars['ID']['output'];
  price?: Maybe<ModificationPrice>;
};

export type ChangePasswordRequest = {
  newPassword: Scalars['String']['input'];
  persistentLogin?: InputMaybe<Scalars['Boolean']['input']>;
  type: ChangePasswordType;
  withHashCode?: InputMaybe<ChangePasswordRequestWithHashCode>;
  withOldPassword?: InputMaybe<ChangePasswordRequestWithOldPassword>;
};

export type ChangePasswordRequestWithHashCode = {
  hashCode: Scalars['String']['input'];
};

export type ChangePasswordRequestWithOldPassword = {
  oldPassword: Scalars['String']['input'];
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  success: Scalars['Boolean']['output'];
};

export enum ChangePasswordType {
  UsingHashCode = 'USING_HASH_CODE',
  UsingOldPassword = 'USING_OLD_PASSWORD'
}

export type ChangePaxNumberRequest = {
  extensions?: InputMaybe<Array<Extension>>;
  fareItineraryKey: Scalars['String']['input'];
  flightNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  pax: PaxNumberInput;
  promotedItineraryTypes?: InputMaybe<Array<PromotedItineraryType>>;
  segmentKeys: Array<Scalars['String']['input']>;
  shoppingInfo: ShoppingInfo;
};

export type ChatbotAirport = {
  __typename?: 'ChatbotAirport';
  cityName: Scalars['String']['output'];
  iataCode: Scalars['String']['output'];
};

export type ChatbotCabinBag = {
  __typename?: 'ChatbotCabinBag';
  kilos: Scalars['Float']['output'];
  pieces: Scalars['Int']['output'];
  type: ChatbotCabinBagType;
};

export enum ChatbotCabinBagType {
  CabinBag = 'CABIN_BAG',
  SmallBag = 'SMALL_BAG'
}

export type ChatbotCard = {
  __typename?: 'ChatbotCard';
  changeNameCard?: Maybe<ChatbotChangeNameCard>;
  checkinSummaryCard?: Maybe<ChatbotCheckinSummaryCard>;
  passengerSeatsAndBagsCard?: Maybe<ChatbotPassengerSeatsAndBagsCard>;
  refundCard?: Maybe<ChatbotRefundCard>;
  type: ChatbotCardType;
};

export type ChatbotCardListMessage = {
  __typename?: 'ChatbotCardListMessage';
  cards: Array<ChatbotCard>;
};

export enum ChatbotCardType {
  ChangeName = 'CHANGE_NAME',
  CheckinSummary = 'CHECKIN_SUMMARY',
  Refund = 'REFUND',
  SeatsAndBags = 'SEATS_AND_BAGS'
}

export type ChatbotChangeNameCard = {
  __typename?: 'ChatbotChangeNameCard';
  name: Scalars['String']['output'];
  numPassenger: Scalars['String']['output'];
  surnames: Scalars['String']['output'];
  title: ChatbotTravellerTitle;
  type: ChatbotTravellerType;
};

export enum ChatbotChannel {
  App = 'APP',
  TestApp = 'TEST_APP',
  TestWeb = 'TEST_WEB',
  Web = 'WEB'
}

export type ChatbotCheckinBag = {
  __typename?: 'ChatbotCheckinBag';
  kilos: Scalars['Float']['output'];
  pieces: Scalars['Int']['output'];
};

export type ChatbotCheckinSummaryCard = {
  __typename?: 'ChatbotCheckinSummaryCard';
  callToActionLink: Scalars['String']['output'];
  /** @deprecated we are exposing the same value in carrierName */
  carrier: Scalars['String']['output'];
  carrierCode: Scalars['String']['output'];
  carrierName: Scalars['String']['output'];
  destination: Scalars['String']['output'];
  origin: Scalars['String']['output'];
  pnr: Scalars['String']['output'];
  tickets: Array<ChatbotTicket>;
  userEmail: Scalars['String']['output'];
  virtualCredentials?: Maybe<ChatbotVirtualCredentials>;
};

export type ChatbotContext = {
  bookingId?: InputMaybe<Scalars['Long']['input']>;
  customParams?: InputMaybe<Array<ChatbotCustomParams>>;
  email?: InputMaybe<Scalars['String']['input']>;
  isPrimeUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatbotCustomParams = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ChatbotEditTravellerModalMessage = {
  __typename?: 'ChatbotEditTravellerModalMessage';
  element?: Maybe<ChatbotElement>;
};

export type ChatbotElement = {
  __typename?: 'ChatbotElement';
  traveller?: Maybe<ChatbotTraveller>;
};

export type ChatbotEvent = {
  channel: ChatbotChannel;
  context: ChatbotContext;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export enum ChatbotFeedback {
  ThumbsDown = 'THUMBS_DOWN',
  ThumbsUp = 'THUMBS_UP',
  Unknown = 'UNKNOWN'
}

export type ChatbotFeedbackRequest = {
  feedback: ChatbotFeedback;
  messageId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type ChatbotFeedbackResponse = {
  __typename?: 'ChatbotFeedbackResponse';
  response?: Maybe<Scalars['Boolean']['output']>;
};

export type ChatbotFlowBookingIdentificationRequest = {
  touchpoint?: InputMaybe<Scalars['String']['input']>;
  tripDetailsToken: Scalars['String']['input'];
  userInput: Scalars['String']['input'];
};

export type ChatbotFlowBookingIdentificationResponse = {
  __typename?: 'ChatbotFlowBookingIdentificationResponse';
  flowInformation?: Maybe<ChatbotFlowInformation>;
};

export type ChatbotFlowInformation = {
  __typename?: 'ChatbotFlowInformation';
  categoryTitleContentKey: Scalars['String']['output'];
  escalationFlowPath: Scalars['String']['output'];
  flowName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ChatbotInteractionResponse = {
  __typename?: 'ChatbotInteractionResponse';
  messages: Array<ChatbotResponseMessage>;
};

export type ChatbotPageEvent = {
  channel: ChatbotChannel;
  context: ChatbotContext;
  name: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type ChatbotPassengerSeatsAndBagsCard = {
  __typename?: 'ChatbotPassengerSeatsAndBagsCard';
  passengerName: Scalars['String']['output'];
  segments: Array<ChatbotSegment>;
  tripType: ChatbotTripType;
};

export type ChatbotQuickRepliesMessage = {
  __typename?: 'ChatbotQuickRepliesMessage';
  options: Array<ChatbotQuickReplyOption>;
};

export type ChatbotQuickReplyOption = {
  __typename?: 'ChatbotQuickReplyOption';
  payload: Scalars['String']['output'];
  response: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ChatbotRefund = {
  __typename?: 'ChatbotRefund';
  amount: Money;
  date: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ChatbotRefundCard = {
  __typename?: 'ChatbotRefundCard';
  refund?: Maybe<ChatbotRefund>;
};

export type ChatbotResponseMessage = {
  __typename?: 'ChatbotResponseMessage';
  cardListMessage?: Maybe<ChatbotCardListMessage>;
  category?: Maybe<ChatbotResponseMessageCategory>;
  disableTextArea: Scalars['Boolean']['output'];
  editTravellerModalMessage?: Maybe<ChatbotEditTravellerModalMessage>;
  quickRepliesMessage?: Maybe<ChatbotQuickRepliesMessage>;
  surveyMessage?: Maybe<ChatbotSurveyMessage>;
  textMessage?: Maybe<ChatbotTextMessage>;
  type: ChatbotResponseMessageType;
};

export enum ChatbotResponseMessageCategory {
  Alert = 'ALERT'
}

export enum ChatbotResponseMessageType {
  CardList = 'CARD_LIST',
  Edittravellermodal = 'EDITTRAVELLERMODAL',
  Handover = 'HANDOVER',
  QuickReplies = 'QUICK_REPLIES',
  Survey = 'SURVEY',
  Text = 'TEXT'
}

export type ChatbotSeat = {
  __typename?: 'ChatbotSeat';
  assignedSeat: Scalars['String']['output'];
  type: ChatbotSeatType;
};

export enum ChatbotSeatType {
  Seat = 'SEAT'
}

export type ChatbotSection = {
  __typename?: 'ChatbotSection';
  bags: Array<ChatbotCabinBag>;
  from: ChatbotAirport;
  seats: Array<ChatbotSeat>;
  to: ChatbotAirport;
};

export type ChatbotSegment = {
  __typename?: 'ChatbotSegment';
  bags: Array<ChatbotCheckinBag>;
  sections: Array<ChatbotSection>;
};

export type ChatbotSession = {
  __typename?: 'ChatbotSession';
  conversationStatus: ConversationStatus;
  sessionId: ChatbotSessionId;
};

export type ChatbotSessionId = {
  __typename?: 'ChatbotSessionId';
  id: Scalars['String']['output'];
};

export type ChatbotSurveyMessage = {
  __typename?: 'ChatbotSurveyMessage';
  options: Array<ChatbotSurveyOption>;
};

export type ChatbotSurveyOption = {
  __typename?: 'ChatbotSurveyOption';
  payload: Scalars['String']['output'];
  response: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ChatbotText = {
  channel: ChatbotChannel;
  context: ChatbotContext;
  sessionId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type ChatbotTextMessage = {
  __typename?: 'ChatbotTextMessage';
  llm?: Maybe<Scalars['Boolean']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type ChatbotTicket = {
  __typename?: 'ChatbotTicket';
  number: Scalars['String']['output'];
  passengerName?: Maybe<Scalars['String']['output']>;
};

export type ChatbotTraveller = {
  __typename?: 'ChatbotTraveller';
  name?: Maybe<Scalars['String']['output']>;
  numPassenger?: Maybe<Scalars['Int']['output']>;
  pageEventName?: Maybe<Scalars['String']['output']>;
  surnames?: Maybe<Scalars['String']['output']>;
  title?: Maybe<ChatbotTravellerTitle>;
  type?: Maybe<ChatbotTravellerType>;
};

export enum ChatbotTravellerTitle {
  Mr = 'MR',
  Mrs = 'MRS',
  Ms = 'MS'
}

export enum ChatbotTravellerType {
  Adult = 'ADULT',
  Child = 'CHILD',
  Infant = 'INFANT'
}

export enum ChatbotTripType {
  MultiDestination = 'MULTI_DESTINATION',
  OneWay = 'ONE_WAY',
  RoundTrip = 'ROUND_TRIP'
}

export type ChatbotVirtualCredentials = {
  __typename?: 'ChatbotVirtualCredentials';
  credential?: Maybe<Scalars['String']['output']>;
  login: Scalars['String']['output'];
};

export type CheckIn = {
  __typename?: 'CheckIn';
  boardingPasses: Array<BoardingPassV2>;
  section: TripSection;
  status: CheckInStatusV2;
  traveller: Traveller;
};

export type CheckInFunnelFormDocumentFields = {
  __typename?: 'CheckInFunnelFormDocumentFields';
  expirationDate: CheckInFunnelFormField;
  issueDate: CheckInFunnelFormField;
  issuingCountry: CheckInFunnelFormField;
  number: CheckInFunnelFormField;
};

export type CheckInFunnelFormField = {
  __typename?: 'CheckInFunnelFormField';
  defaultValue?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type CheckInFunnelRequest = {
  token: Scalars['String']['input'];
};

export type CheckInFunnelResponse = {
  __typename?: 'CheckInFunnelResponse';
  available: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type CheckInFunnelTravellerFormRequest = {
  citizenship: Scalars['String']['input'];
  token: Scalars['String']['input'];
  travellerIndex: Scalars['Int']['input'];
};

export type CheckInFunnelTravellerFormResponse = {
  __typename?: 'CheckInFunnelTravellerFormResponse';
  dateOfBirth: CheckInFunnelFormField;
  gender: CheckInFunnelFormField;
  nationalId: CheckInFunnelFormDocumentFields;
  passport: CheckInFunnelFormDocumentFields;
};

export enum CheckInStatusV2 {
  Completed = 'COMPLETED',
  CustomerVerificationRequired = 'CUSTOMER_VERIFICATION_REQUIRED',
  Failed = 'FAILED',
  Requested = 'REQUESTED'
}

export type CheckInsStatusRequest = {
  token: Scalars['String']['input'];
};

export type CheckInsStatusResponse = {
  __typename?: 'CheckInsStatusResponse';
  checkIns: Array<CheckIn>;
};

export enum CheckedBagOfferTag {
  BestDealPerKg = 'BEST_DEAL_PER_KG',
  MoreForLess = 'MORE_FOR_LESS'
}

export type CheckinAddress = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CheckinAvailability = {
  __typename?: 'CheckinAvailability';
  address?: Maybe<RequiredCheckinAddress>;
  available: Scalars['Boolean']['output'];
  checkinWindow?: Maybe<CheckinWindow>;
  nationalId?: Maybe<RequiredTravelDocument>;
  passport?: Maybe<RequiredTravelDocument>;
  paxInfo?: Maybe<RequiredAdvancedPaxInfo>;
  travelPermissions?: Maybe<RequiredCheckinTravelPermissions>;
};

export type CheckinRequest = {
  bookingId: Scalars['Long']['input'];
  travellers: Array<InputMaybe<CheckinTraveller>>;
};

export type CheckinResidentPermit = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['Boolean']['input']>;
  issuingCountry?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type CheckinSection = {
  __typename?: 'CheckinSection';
  boardingPass: BoardingPass;
  id: Scalars['Long']['output'];
  passengerName: Scalars['String']['output'];
  status: BoardingPassStatus;
};

export type CheckinStatus = {
  __typename?: 'CheckinStatus';
  sections: Array<Maybe<CheckinSection>>;
};

export type CheckinTravelPermissions = {
  noVisaReason?: InputMaybe<Scalars['String']['input']>;
  onwardTicket?: InputMaybe<OnwardTicket>;
  residentPermit?: InputMaybe<CheckinResidentPermit>;
  visaDetails?: InputMaybe<VisaDetails>;
};

export type CheckinTraveller = {
  address?: InputMaybe<CheckinAddress>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<EmergencyContact>;
  countryOfResidence?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<TravellerGender>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  numPassenger: Scalars['String']['input'];
  travelDocument?: InputMaybe<TravelDocument>;
  travelPermissions?: InputMaybe<CheckinTravelPermissions>;
};

export type CheckinWindow = {
  __typename?: 'CheckinWindow';
  closingTimeInMinutes: Scalars['Long']['output'];
  dataSyncOffsetInMinutes: Scalars['Long']['output'];
  openingTimeInMinutes: Scalars['Long']['output'];
};

export enum CheckoutFailure {
  BookingNotConfirmed = 'BOOKING_NOT_CONFIRMED',
  CardDenied = 'CARD_DENIED',
  CardTypeDebitNotmatch = 'CARD_TYPE_DEBIT_NOTMATCH',
  CardTypeNotmatch = 'CARD_TYPE_NOTMATCH',
  CollectionDeclined = 'COLLECTION_DECLINED',
  CollectionError = 'COLLECTION_ERROR',
  CollectionOptionNotOffered = 'COLLECTION_OPTION_NOT_OFFERED',
  CollectionWith_3DDeclined = 'COLLECTION_WITH_3_D_DECLINED',
  ConfirmationError = 'CONFIRMATION_ERROR',
  Duplicity = 'DUPLICITY',
  EmptyCollectionOptions = 'EMPTY_COLLECTION_OPTIONS',
  ErrorInProvider = 'ERROR_IN_PROVIDER',
  ErrorPaymentType = 'ERROR_PAYMENT_TYPE',
  ExpiredCardAtCheckIn = 'EXPIRED_CARD_AT_CHECK_IN',
  FareChanged = 'FARE_CHANGED',
  HighFraudRisk = 'HIGH_FRAUD_RISK',
  InternalError = 'INTERNAL_ERROR',
  InvalidExpirationDate = 'INVALID_EXPIRATION_DATE',
  InvalidParameters = 'INVALID_PARAMETERS',
  InvalidRequestSentToProvider = 'INVALID_REQUEST_SENT_TO_PROVIDER',
  InvalidSession = 'INVALID_SESSION',
  NotMatchingPrice = 'NOT_MATCHING_PRICE',
  ProductNotReadyForCheckout = 'PRODUCT_NOT_READY_FOR_CHECKOUT',
  ProfessionalInvoicingInfoNotInformed = 'PROFESSIONAL_INVOICING_INFO_NOT_INFORMED',
  ProviderInternalError = 'PROVIDER_INTERNAL_ERROR',
  ProviderPaymentGatewayDown = 'PROVIDER_PAYMENT_GATEWAY_DOWN',
  RepricingAboveThreshold = 'REPRICING_ABOVE_THRESHOLD',
  UnavailableProvider = 'UNAVAILABLE_PROVIDER',
  Unknown = 'UNKNOWN',
  ValidationError = 'VALIDATION_ERROR',
  WrongBookingData = 'WRONG_BOOKING_DATA'
}

export enum CheckoutMethod {
  CvvWith_3Ds = 'CVV_WITH_3DS',
  Only_3Ds = 'ONLY_3DS'
}

export enum CheckoutOrigin {
  AccommodationPayment = 'ACCOMMODATION_PAYMENT',
  DecouplePrimeSubscriptionItinerary = 'DECOUPLE_PRIME_SUBSCRIPTION_ITINERARY',
  ItineraryPayment = 'ITINERARY_PAYMENT',
  UniversalPayment = 'UNIVERSAL_PAYMENT'
}

export type CheckoutRequest = {
  accountCreationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  collectionMethod: CollectionMethodRequest;
  expectedPrice?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<InvoiceRequest>;
  origin?: InputMaybe<CheckoutOrigin>;
  saveCreditCard?: InputMaybe<Scalars['Boolean']['input']>;
  shoppingId: Scalars['ID']['input'];
  shoppingType: ShoppingType;
  specialRequirements?: InputMaybe<Scalars['String']['input']>;
  userCollectionTrackingId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutResponse = {
  __typename?: 'CheckoutResponse';
  flashOffersAvailable: Scalars['Boolean']['output'];
  myTripsRedirection?: Maybe<MyTripsRedirection>;
  /** @deprecated We have moved to myTripsRedirection */
  myTripsRedirectionToken?: Maybe<Scalars['String']['output']>;
  paymentPerception?: Maybe<PaymentPerception>;
  repricing?: Maybe<RepricingInfo>;
  revenue?: Maybe<RDataResponse>;
  /** @deprecated Use shoppingBundle instead */
  shoppingBasket?: Maybe<ShoppingBasketResponse>;
  shoppingBundle?: Maybe<ShoppingBundle>;
  shoppingCart?: Maybe<ShoppingCart>;
  /** @deprecated checkout refactor, use statusInfo instead */
  status: CheckoutStatus;
  statusInfo: StatusInfo;
  /** @deprecated Use userPaymentInteractionId instead */
  userInteraction?: Maybe<UserInteractionNeededResponse>;
  userPaymentInteractionId?: Maybe<UserPaymentInteractionId>;
};

export enum CheckoutStatus {
  Failed = 'FAILED',
  Repricing = 'REPRICING',
  Retry = 'RETRY',
  Stop = 'STOP',
  Success = 'SUCCESS',
  UserPaymentInteraction = 'USER_PAYMENT_INTERACTION'
}

export enum ChurnPredictionType {
  High = 'HIGH',
  Low = 'LOW',
  Unknown = 'UNKNOWN'
}

export type City = {
  __typename?: 'City';
  coordinates?: Maybe<GeoCoordinates>;
  iata?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type CityAccommodationRanking = {
  __typename?: 'CityAccommodationRanking';
  ranking: Scalars['Int']['output'];
  rankingOutOf: Scalars['Int']['output'];
  topRanked: Scalars['Boolean']['output'];
};

export type ClaimableReward = BaseMembershipReward & {
  __typename?: 'ClaimableReward';
  promoCodeRewards: Array<PromoCodeReward>;
  rewardType: RewardType;
};

export type CollectionMethod = {
  __typename?: 'CollectionMethod';
  creditCardLevel?: Maybe<CreditCardLevel>;
  creditCardType?: Maybe<CreditCardType>;
  /** @deprecated Field no longer supported */
  fee: Scalars['Float']['output'];
  feeMoney: Money;
  id: Scalars['String']['output'];
  isChosenMethod: Scalars['Boolean']['output'];
  type?: Maybe<PaymentMethod>;
};

export type CollectionMethodInfo = {
  collectionMethodCode?: InputMaybe<MethodTypeCode>;
  collectionMethodType?: InputMaybe<PaymentMethod>;
};

export type CollectionMethodRequest = {
  collectionMethodId?: InputMaybe<Scalars['String']['input']>;
  collectionMethodType: PaymentMethod;
  issuerBankType?: InputMaybe<IdealIssuerBankType>;
  methodTypeCode?: InputMaybe<MethodTypeCode>;
  paymentInstrumentToken: Scalars['String']['input'];
};

export type CommercialBrand = {
  __typename?: 'CommercialBrand';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompatibleInboundSegment = {
  __typename?: 'CompatibleInboundSegment';
  inboundSegmentId: Scalars['ID']['output'];
  itineraryKey: Scalars['ID']['output'];
};

export type Compensation = {
  __typename?: 'Compensation';
  amount?: Maybe<Money>;
};

export enum CompensationType {
  CashBack = 'CASH_BACK',
  Voucher = 'VOUCHER'
}

export type ConfirmDecouplingPrimeSubscriptionFlowRequest = {
  mainFunnelContext: MainFunnelContext;
  primeSubscriptionContext: PrimeSubscriptionContext;
};

export type ConfirmDecouplingPrimeSubscriptionFlowResponse = {
  __typename?: 'ConfirmDecouplingPrimeSubscriptionFlowResponse';
  success: Scalars['Boolean']['output'];
};

export type ConfirmFlashOfferRequest = {
  paymentInstrumentToken: Scalars['String']['input'];
};

export enum ConfirmFlashOfferStatus {
  Confirmed = 'CONFIRMED',
  Error = 'ERROR',
  TimedOut = 'TIMED_OUT',
  UserInteractionNeeded = 'USER_INTERACTION_NEEDED'
}

export type ConfirmReferralSubscriptionRequest = {
  subscriptionId: Scalars['String']['input'];
  unsubscribeToCommercials?: InputMaybe<Scalars['Boolean']['input']>;
  validationCode: Scalars['String']['input'];
};

export type ConfirmReferralSubscriptionResponse = {
  __typename?: 'ConfirmReferralSubscriptionResponse';
  status: ValidationCode;
  subscriptionId?: Maybe<Scalars['String']['output']>;
};

export type ConfirmSelectedFlashOfferAuthorizedResponse = FlashOfferConfirmationProcessResponse & {
  __typename?: 'ConfirmSelectedFlashOfferAuthorizedResponse';
  offer: FlashOffer;
  rData?: Maybe<RDataResponse>;
  status: ConfirmFlashOfferStatus;
};

export type ConfirmSelectedFlashOfferErrorResponse = FlashOfferConfirmationProcessResponse & {
  __typename?: 'ConfirmSelectedFlashOfferErrorResponse';
  rData?: Maybe<RDataResponse>;
  status: ConfirmFlashOfferStatus;
};

export type ConfirmSelectedFlashOfferInteractionNeededResponse = FlashOfferConfirmationProcessResponse & {
  __typename?: 'ConfirmSelectedFlashOfferInteractionNeededResponse';
  formSendType?: Maybe<FormSendType>;
  interactionStep: Scalars['Int']['output'];
  interactionType: InteractionType;
  parameters?: Maybe<Array<Param>>;
  rData?: Maybe<RDataResponse>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  status: ConfirmFlashOfferStatus;
};

export enum Consent {
  AirlineAlternative = 'AIRLINE_ALTERNATIVE',
  CashRefund = 'CASH_REFUND',
  CustomerAlternative = 'CUSTOMER_ALTERNATIVE'
}

export type ContactDetails = {
  __typename?: 'ContactDetails';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Phone>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type ContactDetailsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type ContactDetailsToUniversalShoppingBasketRequest = {
  address: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  countryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  typePhoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactType {
  Private = 'PRIVATE',
  Professional = 'PROFESSIONAL'
}

export type Continent = {
  __typename?: 'Continent';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ContractedMembershipPerk = LimitedContractedMembershipPerk | UnlimitedContractedMembershipPerk;

export enum ConversationStatus {
  HandoverFinished = 'HANDOVER_FINISHED',
  HandoverRequested = 'HANDOVER_REQUESTED',
  ManagedByAgent = 'MANAGED_BY_AGENT',
  ManagedByBot = 'MANAGED_BY_BOT'
}

export type ConvertSecretHotelIdRequest = {
  secretHotelId: Scalars['String']['input'];
};

export type ConvertSecretHotelIdResponse = {
  __typename?: 'ConvertSecretHotelIdResponse';
  propertyMappingId: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phonePrefix: Scalars['String']['output'];
};

export type CreateAccommodationProductRequest = {
  buyer: AccommodationBuyer;
  dealId?: InputMaybe<Scalars['ID']['input']>;
  guests: Array<Guest>;
  shoppingId?: InputMaybe<Scalars['ID']['input']>;
  shoppingType?: InputMaybe<ShoppingType>;
  updateUserProfile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAccommodationProductResponse = {
  __typename?: 'CreateAccommodationProductResponse';
  accommodationProduct?: Maybe<AccommodationProduct>;
  id?: Maybe<ProductId>;
  shoppingId?: Maybe<Scalars['ID']['output']>;
};

export type CreateCheckInV2Request = {
  token: Scalars['String']['input'];
  travellers: Array<CheckinTraveller>;
};

export type CreateCheckInV2Response = {
  __typename?: 'CreateCheckInV2Response';
  success: Scalars['Boolean']['output'];
};

export type CreateCheckinResponse = {
  __typename?: 'CreateCheckinResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateItineraryPriceFreezeRequest = {
  buyerEmail: Scalars['String']['input'];
  offerId: Scalars['ID']['input'];
  pax: Array<TravellerInput>;
  repricing?: InputMaybe<RepricingInformationInput>;
};

export type CreateMembershipCancellationOptionsResponse = {
  __typename?: 'CreateMembershipCancellationOptionsResponse';
  membershipCancellationOptions: Array<MembershipCancellationOption>;
};

export type CreatePriceFreezeRequest = {
  contactDetails: PriceFreezeContactDetails;
  itineraryPriceFreeze: CreateItineraryPriceFreezeRequest;
  shoppingBasketId: Scalars['ID']['input'];
};

export type CreateReferralSubscriptionRequest = {
  email: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  phoneNumber: PhoneNumber;
};

export type CreateReferralSubscriptionResponse = {
  __typename?: 'CreateReferralSubscriptionResponse';
  subscriptionId: Scalars['String']['output'];
  validationMethod: ValidationMethod;
};

export type CreateShoppingBasketRequest = {
  bundleId?: InputMaybe<BundleId>;
  shoppingType?: InputMaybe<ShoppingType>;
};

export type CreateShoppingBundleRequest = {
  extension?: InputMaybe<Array<Extension>>;
  fareItineraryKey: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  promotedItineraryTypes?: InputMaybe<Array<PromotedItineraryType>>;
  resident?: InputMaybe<Scalars['Boolean']['input']>;
  searchId: Scalars['String']['input'];
  segmentKey: Array<Scalars['String']['input']>;
  shoppingType: ShoppingType;
};

export type CreateShoppingBundleResponse = {
  __typename?: 'CreateShoppingBundleResponse';
  repricing?: Maybe<RepricingInfo>;
  shoppingBundle: ShoppingBundle;
};

export type CreateShoppingCartRequest = {
  extensions?: InputMaybe<Array<Extension>>;
  fareItineraryKey: Scalars['String']['input'];
  flightNumbers: Array<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  priceWithoutDiscountSelected?: InputMaybe<Scalars['Boolean']['input']>;
  promotedItineraryTypes?: InputMaybe<Array<PromotedItineraryType>>;
  resident?: InputMaybe<Scalars['Boolean']['input']>;
  searchId: Scalars['String']['input'];
  segmentKeys: Array<Scalars['String']['input']>;
};

export type CreateShoppingCartResponse = {
  __typename?: 'CreateShoppingCartResponse';
  shoppingCart: ShoppingCart;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  expirationMonth: Scalars['String']['output'];
  expirationYear: Scalars['String']['output'];
  first6NumberDigits: Scalars['String']['output'];
  holder: Scalars['String']['output'];
  last4NumberDigits: Scalars['String']['output'];
};

export type CreditCardBinDetails = {
  __typename?: 'CreditCardBinDetails';
  creditCardBin: Scalars['String']['output'];
  creditCardCountryCode?: Maybe<Scalars['String']['output']>;
  creditCardLevel?: Maybe<Scalars['String']['output']>;
  creditCardTypeCode?: Maybe<Scalars['String']['output']>;
  isPrimeBlocking?: Maybe<Scalars['Boolean']['output']>;
};

export type CreditCardDateDetailsResponse = {
  __typename?: 'CreditCardDateDetailsResponse';
  isValidDateForPrime?: Maybe<Scalars['Boolean']['output']>;
};

export type CreditCardLevel = {
  __typename?: 'CreditCardLevel';
  code?: Maybe<Scalars['String']['output']>;
};

export type CreditCardType = {
  __typename?: 'CreditCardType';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CreditCards = RecurringCollectionPaymentInstrument & {
  __typename?: 'CreditCards';
  creationDate?: Maybe<Scalars['String']['output']>;
  creditCardCode?: Maybe<Scalars['String']['output']>;
  creditCardNumber?: Maybe<Scalars['String']['output']>;
  creditCardTypeId?: Maybe<CreditCardsType>;
  expirationDateMonth?: Maybe<Scalars['String']['output']>;
  expirationDateYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  lastUsageDate?: Maybe<Scalars['String']['output']>;
  modifiedDate?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  paymentInstrumentTokenWithoutCvv: Scalars['String']['output'];
};

export enum CreditCardsType {
  Amex = 'AMEX',
  AmexConsumerCard = 'AMEX_CONSUMER_CARD',
  CartaEdreams = 'CARTA_EDREAMS',
  CarteBlue = 'CARTE_BLUE',
  Cofinoga = 'COFINOGA',
  CofinogaCarteOpodo = 'COFINOGA_CARTE_OPODO',
  DinersClub = 'DINERS_CLUB',
  EdreamsPrepaid = 'EDREAMS_PREPAID',
  Jbc = 'JBC',
  Maestro = 'MAESTRO',
  MasterCardConsumerDebit = 'MASTER_CARD_CONSUMER_DEBIT',
  MasterCardCredit = 'MASTER_CARD_CREDIT',
  MasterCardDebit = 'MASTER_CARD_DEBIT',
  MasterCardEdreams = 'MASTER_CARD_EDREAMS',
  MasterCardPrepaid = 'MASTER_CARD_PREPAID',
  MasterCardPrepaidIt = 'MASTER_CARD_PREPAID_IT',
  MasterCardSpanishCredit = 'MASTER_CARD_SPANISH_CREDIT',
  NotFound = 'NOT_FOUND',
  ViabuyPrepayMasterCard = 'VIABUY_PREPAY_MASTER_CARD',
  VisaCredit = 'VISA_CREDIT',
  VisaDebit = 'VISA_DEBIT',
  VisaDebitDelta = 'VISA_DEBIT_DELTA',
  VisaElectron = 'VISA_ELECTRON',
  VisaEntropay = 'VISA_ENTROPAY',
  VisaVueling = 'VISA_VUELING'
}

export enum CrossSellProductType {
  Accommodation = 'ACCOMMODATION',
  Itinerary = 'ITINERARY',
  VehicleRental = 'VEHICLE_RENTAL'
}

export type CustomerCredentials = {
  __typename?: 'CustomerCredentials';
  email: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  providerBookingItemId: Scalars['Long']['output'];
};

export enum CustomerPriceType {
  NoPrime = 'NO_PRIME',
  Prime = 'PRIME'
}

export type DateRange = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type Deal = {
  __typename?: 'Deal';
  apparentPricesByPax: Array<ApparentPrice>;
  arrivalDate: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  destination: City;
  discount: Scalars['Float']['output'];
  hottestDealType?: Maybe<HottestDealType>;
};

export type DealsRequest = {
  arrivalDateRange?: InputMaybe<DateRange>;
  departure: Scalars['Int']['input'];
  departureDateRange: DateRange;
  durationDays?: InputMaybe<NumberRange>;
  latestSearches?: InputMaybe<Array<InputMaybe<LatestSearch>>>;
  numAdults?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<DealsSortingType>;
  tripType?: InputMaybe<DealsTripType>;
};

export enum DealsSearchPriority {
  DealsOnDemand = 'DEALS_ON_DEMAND',
  SearchedDestination = 'SEARCHED_DESTINATION',
  UpcomingTrip = 'UPCOMING_TRIP'
}

export enum DealsSortingType {
  LowestPrice = 'LOWEST_PRICE',
  MostPopular = 'MOST_POPULAR'
}

export enum DealsTripType {
  MultiDestination = 'MULTI_DESTINATION',
  OneWay = 'ONE_WAY',
  RoundTrip = 'ROUND_TRIP'
}

export enum DecouplingPrimeSubscriptionFlowState {
  FinishedMembershipActivated = 'FINISHED_MEMBERSHIP_ACTIVATED',
  FinishedWaitingForActivation = 'FINISHED_WAITING_FOR_ACTIVATION',
  ForbiddenMembershipActivated = 'FORBIDDEN_MEMBERSHIP_ACTIVATED',
  Initialized = 'INITIALIZED',
  NotInitialized = 'NOT_INITIALIZED'
}

export type DecouplingPrimeSubscriptionFlowStateRequest = {
  mainFunnelContext: MainFunnelContext;
  primeSubscriptionContext?: InputMaybe<PrimeSubscriptionContext>;
};

export type DecouplingPrimeSubscriptionFlowStateResponse = {
  __typename?: 'DecouplingPrimeSubscriptionFlowStateResponse';
  state: DecouplingPrimeSubscriptionFlowState;
};

export type DecryptCrmUserTokenForAccommodationRequest = {
  token: Scalars['String']['input'];
};

export type DecryptCrmUserTokenForAccommodationResponse = {
  __typename?: 'DecryptCrmUserTokenForAccommodationResponse';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  isPrime?: Maybe<Scalars['Boolean']['output']>;
};

export type DefaultPriceBreakDownItem = PriceBreakDownItem & {
  __typename?: 'DefaultPriceBreakDownItem';
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  fare?: Maybe<Money>;
  markup?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  tax?: Maybe<Money>;
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export type DeleteAccommodationSearchHistoryRequest = {
  searchHistoryId: Scalars['String']['input'];
};

export type DeleteAccommodationSearchHistoryResponse = {
  __typename?: 'DeleteAccommodationSearchHistoryResponse';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteFavoriteAccommodationRequest = {
  propertyMappingId: Scalars['Long']['input'];
};

export type DeleteFavoriteAccommodationResponse = {
  __typename?: 'DeleteFavoriteAccommodationResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteUserAccountResponse = {
  __typename?: 'DeleteUserAccountResponse';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteUserCreditCardRequest = {
  id: Array<Scalars['Long']['input']>;
  paymentInstrumentTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeleteUserPaymentInstrumentRequest = {
  paymentInstrumentToken: Scalars['ID']['input'];
};

export type DeleteUserPaymentInstrumentResponse = {
  __typename?: 'DeleteUserPaymentInstrumentResponse';
  isDeleted: Scalars['Boolean']['output'];
};

export type Departure = {
  __typename?: 'Departure';
  gate?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
  timeDelay?: Maybe<Scalars['String']['output']>;
  timeISO8601?: Maybe<Scalars['String']['output']>;
  updatedTerminal?: Maybe<Scalars['String']['output']>;
};

export enum DestinationType {
  Hotel = 'HOTEL',
  Region = 'REGION'
}

export type Discount = {
  __typename?: 'Discount';
  packageAmount: Scalars['Float']['output'];
  packageAmountRounded: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  primeAmount: Scalars['Float']['output'];
  primeAmountRounded: Scalars['Int']['output'];
};

export type DiscountInfo = {
  __typename?: 'DiscountInfo';
  discount: Money;
  isApplied: Scalars['Boolean']['output'];
  percentage: Scalars['Int']['output'];
  type: DiscountType;
};

export enum DiscountType {
  Default = 'DEFAULT',
  Dynpack = 'DYNPACK',
  MembershipPerk = 'MEMBERSHIP_PERK',
  PaymentMethodFee = 'PAYMENT_METHOD_FEE',
  PromoCode = 'PROMO_CODE',
  Voucher = 'VOUCHER'
}

export type DuplicateShoppingBundleRequest = {
  shoppingId: Scalars['ID']['input'];
  shoppingType: ShoppingType;
};

export type DuplicateShoppingBundleResponse = {
  __typename?: 'DuplicateShoppingBundleResponse';
  shoppingId?: Maybe<Scalars['ID']['output']>;
};

export type DurationPolicy = {
  __typename?: 'DurationPolicy';
  duration?: Maybe<Scalars['Int']['output']>;
  durationTimeUnit?: Maybe<MembershipDurationTimeUnit>;
  renewalDuration?: Maybe<Scalars['Int']['output']>;
  renewalDurationTimeUnit?: Maybe<MembershipDurationTimeUnit>;
};

export enum EligibilityFlow {
  Call = 'CALL',
  /** @deprecated Field no longer supported */
  ChangeThroughOldFlow = 'CHANGE_THROUGH_OLD_FLOW',
  Eligible = 'ELIGIBLE',
  EligibleCompleteTripAndPartial = 'ELIGIBLE_COMPLETE_TRIP_AND_PARTIAL',
  EligibleOnlyPartial = 'ELIGIBLE_ONLY_PARTIAL',
  EstimatedPrices = 'ESTIMATED_PRICES',
  NotEligible = 'NOT_ELIGIBLE',
  ThirdParty = 'THIRD_PARTY'
}

export type EligibilityForIncidentRequest = {
  bookingId: Scalars['ID']['input'];
  providerBookingItemId: Scalars['ID']['input'];
};

export type EligibilityForIncidentResponse = {
  __typename?: 'EligibilityForIncidentResponse';
  eligible: Scalars['Boolean']['output'];
};

export type EligibilityResponse = {
  __typename?: 'EligibilityResponse';
  bookingInfo?: Maybe<BookingInfo>;
  eligibilityFlow: EligibilityFlow;
  estimated?: Maybe<Scalars['Boolean']['output']>;
  hasPenalty?: Maybe<Scalars['Boolean']['output']>;
  useAutocollection?: Maybe<Scalars['Boolean']['output']>;
};

export type EmailLoginRequest = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type EmergencyContact = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
};

export type EnrichedTrip = {
  __typename?: 'EnrichedTrip';
  messages?: Maybe<Array<Message>>;
  trip: Trip;
};

export type Evaluation = {
  __typename?: 'Evaluation';
  id: Scalars['ID']['output'];
  navigationTree: NavigationTree;
};

export type Extension = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ExternalSelection = {
  __typename?: 'ExternalSelection';
  id: Scalars['ID']['output'];
  segmentKeys: Array<Scalars['String']['output']>;
};

export type ExternalSelectionRequest = {
  collectionMethodId?: InputMaybe<Scalars['Int']['input']>;
  displayedCurrency?: InputMaybe<Scalars['String']['input']>;
  displayedPrice?: InputMaybe<Scalars['Float']['input']>;
  fareItineraryKey: Scalars['String']['input'];
  searchId: Scalars['Long']['input'];
  segmentKeys: Array<Scalars['String']['input']>;
};

export type FacebookLoginRequest = {
  persistentLogin?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};

export type FacilityGroups = {
  __typename?: 'FacilityGroups';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<Maybe<AccommodationFacilityGroup>>>;
};

export type FaqInformation = {
  __typename?: 'FaqInformation';
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
  trackingId: Scalars['String']['output'];
};

export type FaqRecommendation = {
  __typename?: 'FaqRecommendation';
  faqs: Array<FaqInformation>;
};

export type FareFamily = {
  __typename?: 'FareFamily';
  cabinClass: Scalars['String']['output'];
  fareFamilyPerks: Array<FareFamilyPerk>;
  name: Scalars['String']['output'];
  price: Money;
  providerItineraryIndex: Scalars['Int']['output'];
  totalPrice: Money;
};

export type FareFamilyPerk = {
  __typename?: 'FareFamilyPerk';
  availability: Scalars['String']['output'];
  description: Scalars['String']['output'];
  fareUpgradePerkType: Scalars['String']['output'];
  fareUpgradePerkTypeGroup: Scalars['String']['output'];
  units?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type FareFamilyRequest = {
  carrierIds: Array<Scalars['ID']['input']>;
  fareItineraryKey: Scalars['String']['input'];
  passengers?: InputMaybe<Scalars['Int']['input']>;
  searchId: Scalars['Long']['input'];
  segmentKeys: Array<Scalars['String']['input']>;
};

export type FastTrackAvailability = {
  __typename?: 'FastTrackAvailability';
  airlineCode: Scalars['String']['output'];
  airportCityName: Scalars['String']['output'];
  airportCode: Scalars['String']['output'];
  airportCountryName: Scalars['String']['output'];
  airportName?: Maybe<Scalars['String']['output']>;
  available: Scalars['Boolean']['output'];
  entryDateTime: Scalars['String']['output'];
  flightDirection: FastTrackFlightDirection;
  flightNumber: Scalars['String']['output'];
  offer?: Maybe<FastTrackOffer>;
  productId?: Maybe<Scalars['ID']['output']>;
  purchased: Scalars['Boolean']['output'];
  selected: Scalars['Boolean']['output'];
};

export enum FastTrackFlightDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type FastTrackOffer = {
  __typename?: 'FastTrackOffer';
  id: Scalars['String']['output'];
  unitaryPrice: Money;
};

export type FastTrackPostBookingOffer = {
  __typename?: 'FastTrackPostBookingOffer';
  airportIataCode: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
  price: Money;
};

export type FastTrackPostBookingOfferInput = {
  /** @deprecated moved to SearchFastTrackOffersRequest */
  entryDateTime?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated moved to SearchFastTrackOffersRequest */
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['String']['input'];
};

export type FastTrackProduct = {
  __typename?: 'FastTrackProduct';
  airportCode: Scalars['String']['output'];
  entryDateTime: Scalars['String']['output'];
  flightNumber: Scalars['String']['output'];
  pricePerception?: Maybe<FastTrackProductPricePerception>;
  productId: Scalars['String']['output'];
  totalPrice: Money;
};

export type FastTrackProductPricePerception = {
  __typename?: 'FastTrackProductPricePerception';
  totalPricePerPassenger: Money;
};

export type FastTrackSection = {
  airportCode: Scalars['String']['input'];
  entryDateTime?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FastTrackShoppingBasketProduct = {
  __typename?: 'FastTrackShoppingBasketProduct';
  productId: Scalars['ID']['output'];
};

export type FavoriteAccommodationsByLocationRequest = {
  geoId: Scalars['String']['input'];
};

export type FavoriteAccommodationsByLocationResponse = {
  __typename?: 'FavoriteAccommodationsByLocationResponse';
  accommodationSearchResponse: AccommodationSearchResponse;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  rooms: Array<FavoriteRoom>;
};

export type FavoriteAccommodationsLocation = {
  __typename?: 'FavoriteAccommodationsLocation';
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  countryName: Scalars['String']['output'];
  geoId: Scalars['String']['output'];
  rooms: Array<FavoriteRoom>;
};

export type FavoriteAccommodationsLocationResponse = {
  __typename?: 'FavoriteAccommodationsLocationResponse';
  locations: Array<FavoriteAccommodationsLocation>;
};

export type FavoriteRoom = {
  __typename?: 'FavoriteRoom';
  childrenAges: Array<Scalars['Int']['output']>;
  numAdults: Scalars['Int']['output'];
};

export type FavoriteRoomRequest = {
  childrenAges: Array<Scalars['Int']['input']>;
  numAdults: Scalars['Int']['input'];
};

export type FeatureVariationRequest = {
  name: Scalars['String']['input'];
};

export type FeatureVariationRequestWithVersion = {
  name: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type FeatureVariationResponse = {
  __typename?: 'FeatureVariationResponse';
  evaluable?: Maybe<Scalars['Boolean']['output']>;
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FeaturesEventTrackingRequest = {
  evaluable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  variation: Scalars['Int']['input'];
};

export type FeaturesEventTrackingResponse = {
  __typename?: 'FeaturesEventTrackingResponse';
  success: Scalars['Boolean']['output'];
};

export type Fee = {
  __typename?: 'Fee';
  price: Money;
  type: FeeType;
};

export enum FeeSelected {
  FullPrice = 'FULL_PRICE',
  PrimePrice = 'PRIME_PRICE'
}

export type FeeType = {
  __typename?: 'FeeType';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
};

export type FeeTypeValue = {
  __typename?: 'FeeTypeValue';
  id: Scalars['String']['output'];
  type: FeeType;
};

export type FieldObject = {
  __typename?: 'FieldObject';
  attributes?: Maybe<Attributes>;
  dataId: Scalars['String']['output'];
  dataName: Scalars['String']['output'];
  fieldType: FieldTypeValue;
  mandatory?: Maybe<RequiredFieldType>;
  options?: Maybe<Array<FieldValueOptions>>;
  position: Position;
  style?: Maybe<Style>;
};

export enum FieldSize {
  L = 'L',
  M = 'M',
  S = 'S',
  Xl = 'XL'
}

export enum FieldSpace {
  L = 'L',
  M = 'M',
  Nospace = 'NOSPACE',
  S = 'S',
  Xl = 'XL'
}

export enum FieldTypeValue {
  ComboBox = 'COMBO_BOX',
  DateField = 'DATE_FIELD',
  DateField_1Select_2Input = 'DATE_FIELD_1SELECT_2INPUT',
  DateField_3Selects = 'DATE_FIELD_3SELECTS',
  RadioButton = 'RADIO_BUTTON',
  TextField = 'TEXT_FIELD'
}

export enum FieldValidatorType {
  AddressRegex = 'ADDRESS_REGEX',
  AdultDateValidator = 'ADULT_DATE_VALIDATOR',
  ChildDateValidator = 'CHILD_DATE_VALIDATOR',
  CityRegex = 'CITY_REGEX',
  CountryCodeRegex = 'COUNTRY_CODE_REGEX',
  CvvRegex = 'CVV_REGEX',
  CvvRegex3 = 'CVV_REGEX3',
  CvvRegex4 = 'CVV_REGEX4',
  EmailRegex = 'EMAIL_REGEX',
  ExpirationDateValidator = 'EXPIRATION_DATE_VALIDATOR',
  FfcCodeRegex = 'FFC_CODE_REGEX',
  IdentificationValidator = 'IDENTIFICATION_VALIDATOR',
  IdentificationValidatorEs = 'IDENTIFICATION_VALIDATOR_ES',
  InfantDateValidator = 'INFANT_DATE_VALIDATOR',
  InvoiceNameRegex = 'INVOICE_NAME_REGEX',
  NieRegex = 'NIE_REGEX',
  NifRegex = 'NIF_REGEX',
  NotEmpty = 'NOT_EMPTY',
  NoBlankSpacesBeforeStringValidator = 'NO_BLANK_SPACES_BEFORE_STRING_VALIDATOR',
  NumberOnlyRegex = 'NUMBER_ONLY_REGEX',
  NumberOrLetterExcludingSymbolsRegex = 'NUMBER_OR_LETTER_EXCLUDING_SYMBOLS_REGEX',
  PassportRegex = 'PASSPORT_REGEX',
  PaxNameRegex = 'PAX_NAME_REGEX',
  PetsOptionsValidator = 'PETS_OPTIONS_VALIDATOR',
  PhoneNumberAllowingSpacesRegex = 'PHONE_NUMBER_ALLOWING_SPACES_REGEX',
  PhoneNumberRegex = 'PHONE_NUMBER_REGEX',
  RequiredStringValidator = 'REQUIRED_STRING_VALIDATOR',
  SecondEmailValidator = 'SECOND_EMAIL_VALIDATOR',
  SecondEmailValidatorCaseInsensitive = 'SECOND_EMAIL_VALIDATOR_CASE_INSENSITIVE',
  Utf8Regex = 'UTF8_REGEX',
  ZipCodeRegex = 'ZIP_CODE_REGEX',
  ZipCodeValidator = 'ZIP_CODE_VALIDATOR'
}

export type FieldValueOptions = {
  __typename?: 'FieldValueOptions';
  option?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FindRelatedAccommodationTripRequest = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};

export type FindRelatedAccommodationTripResponse = {
  __typename?: 'FindRelatedAccommodationTripResponse';
  tripSummary: Array<AccommodationTripSummary>;
};

export type FixDiscount = UserPromoCodeDiscount & {
  __typename?: 'FixDiscount';
  fixDiscount: Money;
  fixDiscountIsPerTraveller: Scalars['Boolean']['output'];
  maxAmount?: Maybe<Money>;
};

export type FlashOffer = {
  id: Scalars['ID']['output'];
  nonPrimePrice: Money;
  offerType: FlashOfferType;
  primePrice: Money;
  productType: FlashOfferProductType;
};

export type FlashOfferConfirmationProcessResponse = {
  rData?: Maybe<RDataResponse>;
  status: ConfirmFlashOfferStatus;
};

export enum FlashOfferProductType {
  Seat = 'SEAT'
}

export enum FlashOfferType {
  SitTogether = 'SIT_TOGETHER'
}

export type FlexibleDatesApparentPrice = {
  __typename?: 'FlexibleDatesApparentPrice';
  apparentPrice: Money;
  apparentPriceCriteria: Scalars['String']['output'];
};

export type FlexibleDatesDayPrice = {
  __typename?: 'FlexibleDatesDayPrice';
  date: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
};

export type FlexibleDatesMatrixData = {
  __typename?: 'FlexibleDatesMatrixData';
  apparentPrices: Array<FlexibleDatesApparentPrice>;
  departureDate: Scalars['String']['output'];
  matrixColumn: Scalars['Int']['output'];
  matrixRow: Scalars['Int']['output'];
  returnDate?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
};

export type FlexibleDatesPricesRequest = {
  adults?: InputMaybe<Scalars['Int']['input']>;
  children?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['String']['input'];
  destinationGeoNode: Scalars['Int']['input'];
  infants?: InputMaybe<Scalars['Int']['input']>;
  interfaceClient: InterfaceClientType;
  numberOfFutureDaysArr?: InputMaybe<Scalars['Int']['input']>;
  numberOfFutureDaysDep?: InputMaybe<Scalars['Int']['input']>;
  originGeoNode: Scalars['Int']['input'];
  priceFreshnessDays?: InputMaybe<Scalars['Int']['input']>;
  searchStrategy?: InputMaybe<SearchPriceType>;
  tripType: FlexibleDatesTripType;
};

export type FlexibleDatesPricesResponse = {
  __typename?: 'FlexibleDatesPricesResponse';
  currency?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<Maybe<FlexibleDatesPricesUnion>>>;
};

export type FlexibleDatesPricesUnion = FlexibleDatesDayPrice | FlexibleDatesReturnTripPrices;

export type FlexibleDatesReturnTripPrices = {
  __typename?: 'FlexibleDatesReturnTripPrices';
  date: Scalars['String']['output'];
  priceList?: Maybe<Array<Maybe<FlexibleDatesDayPrice>>>;
};

export type FlexibleDatesSearchRequest = {
  /** @deprecated it won't be used */
  adults?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated it won't be used */
  children?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['String']['input'];
  destinationGeoNode: Scalars['Int']['input'];
  /** @deprecated it won't be used */
  infants?: InputMaybe<Scalars['Int']['input']>;
  numberOfDaysFlexibility?: InputMaybe<Scalars['Int']['input']>;
  originGeoNode: Scalars['Int']['input'];
  priceCalculationCriteria?: InputMaybe<Scalars['String']['input']>;
  priceFreshnessDays?: InputMaybe<Scalars['Int']['input']>;
  returnDate?: InputMaybe<Scalars['String']['input']>;
  searchStrategy?: InputMaybe<SearchPriceType>;
  tripType: FlexibleDatesTripType;
};

export type FlexibleDatesSearchResponse = {
  __typename?: 'FlexibleDatesSearchResponse';
  destinationGeoNode: Scalars['Int']['output'];
  firstOriginDate: Scalars['String']['output'];
  firstReturnDate?: Maybe<Scalars['String']['output']>;
  lastOriginDate: Scalars['String']['output'];
  lastReturnDate?: Maybe<Scalars['String']['output']>;
  matrixEntries: Array<FlexibleDatesMatrixData>;
  numberOfColumns: Scalars['Int']['output'];
  numberOfRows: Scalars['Int']['output'];
  originGeoNode: Scalars['Int']['output'];
};

export enum FlexibleDatesTripType {
  OneWay = 'ONE_WAY',
  RoundTrip = 'ROUND_TRIP'
}

export enum FlexibleProduct {
  InsuranceAxaRebookingFlexrb160 = 'INSURANCE_AXA_REBOOKING_FLEXRB160',
  InsuranceFlexuk164 = 'INSURANCE_FLEXUK164',
  InsuranceFlexAx04 = 'INSURANCE_FLEX_AX04',
  InsuranceRebookingFlexrb156 = 'INSURANCE_REBOOKING_FLEXRB156',
  Unknown = 'UNKNOWN',
  WarrantyInternalFlexself = 'WARRANTY_INTERNAL_FLEXSELF'
}

export type FlexibleProductsApplicabilityRequest = {
  bookingId: Scalars['Long']['input'];
};

export type FlexibleProductsApplicabilityResponse = {
  __typename?: 'FlexibleProductsApplicabilityResponse';
  flexibleProductsApplicable: Array<FlexibleProduct>;
  flexibleProductsNotApplicable: Array<FlexibleProduct>;
};

export enum FlightStatus {
  Active = 'ACTIVE',
  Arrived = 'ARRIVED',
  Cancelled = 'CANCELLED',
  Delayed = 'DELAYED',
  Diverted = 'DIVERTED',
  Redirected = 'REDIRECTED',
  Scheduled = 'SCHEDULED',
  Unknown = 'UNKNOWN',
  Updated = 'UPDATED'
}

export type FormFields = {
  __typename?: 'FormFields';
  additionalFields?: Maybe<Array<Maybe<Array<FieldObject>>>>;
  fields: Array<Array<FieldObject>>;
};

export type FormGroups = {
  __typename?: 'FormGroups';
  buyerFields: FormFields;
  travellerFields: Array<FormFields>;
};

export type FormProperties = {
  __typename?: 'FormProperties';
  fields: FormGroups;
  requiredInformation: RequiredInformation;
};

export enum FormSendType {
  Get = 'GET',
  Post = 'POST'
}

export type FreeCancellationCashRefundOption = {
  __typename?: 'FreeCancellationCashRefundOption';
  cancellationOptionId: Scalars['String']['output'];
  hoursLeftToCancel: Scalars['Int']['output'];
  refundAmount: Money;
};

export type FreeCancellationLimit = {
  __typename?: 'FreeCancellationLimit';
  hoursApart?: Maybe<Scalars['Long']['output']>;
  limitTime?: Maybe<Scalars['Long']['output']>;
};

export type FreeTrialPolicy = {
  __typename?: 'FreeTrialPolicy';
  duration: SubscriptionOfferDuration;
  valueProposition: Array<MembershipOfferPerk>;
};

export type FrequentFlyerCard = {
  __typename?: 'FrequentFlyerCard';
  carrier?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type FrequentFlyerCardInput = {
  carrier: Scalars['String']['input'];
  number: Scalars['String']['input'];
};

export type FrozenCondition = {
  __typename?: 'FrozenCondition';
  cap: Money;
  deposit: Money;
  expirationDate: Scalars['String']['output'];
  frozenPrice: Money;
  /** @deprecated use frozenPrice for consistency */
  price: Money;
  primeMembershipActivationPolicy?: Maybe<PrimeMembershipActivationPolicy>;
  purchaseDate?: Maybe<Scalars['String']['output']>;
  redemptionPolicy: RedemptionPolicy;
};

export type FrozenItinerary = {
  __typename?: 'FrozenItinerary';
  airportCities: Array<Scalars['String']['output']>;
  firstDepartureDateTime: Scalars['String']['output'];
  lastArrivalDateTime: Scalars['String']['output'];
};

export enum FuelPolicy {
  Chauffuelinc = 'CHAUFFUELINC',
  Chauffulful = 'CHAUFFULFUL',
  Emptyempty = 'EMPTYEMPTY',
  Freetank = 'FREETANK',
  Fullempty = 'FULLEMPTY',
  Fullemptyrefund = 'FULLEMPTYREFUND',
  Fullfull = 'FULLFULL',
  Fullfullhybrid = 'FULLFULLHYBRID',
  Halfempty = 'HALFEMPTY',
  Halfhalf = 'HALFHALF',
  Quarterempty = 'QUARTEREMPTY',
  Quarterquarter = 'QUARTERQUARTER',
  Unknown = 'UNKNOWN'
}

export enum FuelType {
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC',
  Hybrid = 'HYBRID',
  Petrol = 'PETROL'
}

export enum Funnel {
  AccommodationFunnel = 'ACCOMMODATION_FUNNEL',
  FunnelBooking = 'FUNNEL_BOOKING',
  PriceFreeze = 'PRICE_FREEZE',
  StandalonePostBooking = 'STANDALONE_POST_BOOKING'
}

export type GenerateBaTokenResponse = {
  __typename?: 'GenerateBaTokenResponse';
  success: Scalars['Boolean']['output'];
};

export type GenesysInfo = {
  __typename?: 'GenesysInfo';
  queue?: Maybe<Queue>;
};

export type Geo = {
  __typename?: 'Geo';
  geoType?: Maybe<GeoType>;
  id: GeoId;
  regionType?: Maybe<RegionType>;
  text: Scalars['String']['output'];
};

export type GeoAccommodation = {
  __typename?: 'GeoAccommodation';
  geoType?: Maybe<GeoType>;
  id: GeoId;
  propertyMappingId: Scalars['Int']['output'];
};

export type GeoAccommodationAssociationsRequest = {
  geoId: Scalars['String']['input'];
  geoType: GeoType;
};

export type GeoAccommodationAssociationsResponse = {
  __typename?: 'GeoAccommodationAssociationsResponse';
  associations: Array<Region>;
};

export type GeoAccommodationDestination = {
  id: Scalars['String']['input'];
  type: GeoAccommodationDestinationType;
};

export enum GeoAccommodationDestinationType {
  Accommodation = 'ACCOMMODATION',
  City = 'CITY',
  Region = 'REGION'
}

export type GeoAccommodationLocationRequest = {
  geoId?: InputMaybe<Scalars['String']['input']>;
  geoNodeId?: InputMaybe<Scalars['Int']['input']>;
  geoType?: InputMaybe<GeoType>;
  polygon?: InputMaybe<GeoAccommodationPolygonRequest>;
};

export type GeoAccommodationLocationResponse = {
  __typename?: 'GeoAccommodationLocationResponse';
  coordinates: GeoCoordinates;
  countryCode: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  mainRegion: GeoLocationRegion;
  segments: Array<GeoLocationRegion>;
};

export type GeoAccommodationPolygonRequest = {
  associatedGeoId?: InputMaybe<Scalars['String']['input']>;
  geoType?: InputMaybe<GeoType>;
  points: Array<GeoCoordinatesRequest>;
};

export type GeoAccommodationRequest = {
  geoId: Scalars['String']['input'];
  geoType: GeoType;
};

export type GeoAccommodationResponse = {
  __typename?: 'GeoAccommodationResponse';
  /** @deprecated Not needed when we deprecate searchAccommodationByGeoAccommodation */
  geoAccommodations?: Maybe<Array<GeoAccommodation>>;
  geoRegion?: Maybe<GeoRegion>;
};

export type GeoAccommodationSearchRequest = {
  geoId: Scalars['String']['input'];
  geoType?: InputMaybe<GeoType>;
};

export type GeoAccommodationSearchResponse = {
  __typename?: 'GeoAccommodationSearchResponse';
  geoAccommodationResponse: GeoAccommodationResponse;
};

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type GeoCoordinatesRequest = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GeoDestination = {
  geoDestinationType?: InputMaybe<GeoDestinationType>;
  id: Scalars['Int']['input'];
};

export enum GeoDestinationType {
  Accommodation = 'ACCOMMODATION',
  City = 'CITY',
  Region = 'REGION'
}

export type GeoId = {
  __typename?: 'GeoId';
  value: Scalars['String']['output'];
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  city?: Maybe<City>;
  country?: Maybe<Country>;
  geoNodeCoordinates?: Maybe<GeoCoordinates>;
};

export type GeoLocationRegion = {
  __typename?: 'GeoLocationRegion';
  name: Scalars['String']['output'];
  regionId: Scalars['String']['output'];
  regionType: RegionType;
};

export type GeoNode = {
  id: Scalars['Int']['input'];
  type: GeoDestinationType;
};

export type GeoNodeId = {
  id: Scalars['Int']['input'];
};

export type GeoRegion = {
  __typename?: 'GeoRegion';
  geoNodeId: Scalars['Int']['output'];
  geoType?: Maybe<GeoType>;
  id: GeoId;
};

export type GeoServiceLocation = {
  __typename?: 'GeoServiceLocation';
  cityGeoNodeId?: Maybe<Scalars['Int']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  continent?: Maybe<Continent>;
  coordinates?: Maybe<GeoCoordinates>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  geoNodeId: Scalars['Int']['output'];
  geoNodeType?: Maybe<Scalars['String']['output']>;
  iataCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  regionName?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type GeoServiceLocationsRequest = {
  geoNodeIds: Array<Scalars['Int']['input']>;
  iatas: Array<Scalars['String']['input']>;
};

export type GeoServiceLocationsResponse = {
  __typename?: 'GeoServiceLocationsResponse';
  locations: Array<Maybe<GeoServiceLocation>>;
};

export enum GeoType {
  Accommodation = 'ACCOMMODATION',
  GooglePlace = 'GOOGLE_PLACE',
  Region = 'REGION'
}

export type GeolocationDescriptionSorted = {
  __typename?: 'GeolocationDescriptionSorted';
  coordinates?: Maybe<GeoCoordinates>;
  countryCode?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Int']['output']>;
  distanceUnit?: Maybe<GeolocationDistanceUnitType>;
  geolocationSuggestion: GeolocationSuggestion;
  locationNames: Array<Maybe<Scalars['String']['output']>>;
  matchName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  relatedLocations?: Maybe<Array<Maybe<GeolocationDescriptionSorted>>>;
  type: Scalars['String']['output'];
};

export enum GeolocationDistanceUnitType {
  Km = 'KM',
  Ml = 'ML'
}

export type GeolocationSuggestion = {
  __typename?: 'GeolocationSuggestion';
  cityName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<GeoCoordinates>;
  countryName?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Int']['output']>;
  distanceUnit?: Maybe<GeolocationDistanceUnitType>;
  geoNodeId: Scalars['Int']['output'];
  geoNodeType?: Maybe<Scalars['String']['output']>;
  iataCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  relatedLocations?: Maybe<Array<Maybe<GeolocationSuggestion>>>;
};

export type GeolocationSuggestionsByLocationRequest = {
  filter: Scalars['Boolean']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  productType?: GeolocationSuggestionsProductType;
  radius: Scalars['Int']['input'];
};

export type GeolocationSuggestionsByLocationResponse = {
  __typename?: 'GeolocationSuggestionsByLocationResponse';
  geolocationDescriptionsSorted: Array<GeolocationDescriptionSorted>;
};

export enum GeolocationSuggestionsInputType {
  Arrival = 'ARRIVAL',
  Departure = 'DEPARTURE'
}

export enum GeolocationSuggestionsProductType {
  Bus = 'BUS',
  Flight = 'FLIGHT',
  Hotel = 'HOTEL',
  Train = 'TRAIN'
}

export type GeolocationSuggestionsRequest = {
  includeCitiesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeCountry: Scalars['Boolean']['input'];
  includeNearestLocations: Scalars['Boolean']['input'];
  includeRegion: Scalars['Boolean']['input'];
  includeRelatedLocations: Scalars['Boolean']['input'];
  inputType: GeolocationSuggestionsInputType;
  productType: GeolocationSuggestionsProductType;
  searchWord: Scalars['String']['input'];
};

export type GeolocationSuggestionsResponse = {
  __typename?: 'GeolocationSuggestionsResponse';
  geolocationSuggestions: Array<GeolocationSuggestion>;
};

export type GetAncillariesPurchaseStateRequest = {
  token: Scalars['ID']['input'];
};

export type GetCancellationMessageResponse = {
  __typename?: 'GetCancellationMessageResponse';
  messages: Array<Maybe<Message>>;
};

export type GetCancellationPoliciesRequest = {
  tripDetailsToken: Scalars['String']['input'];
};

export type GetCancellationPoliciesResponse = {
  __typename?: 'GetCancellationPoliciesResponse';
  cancellationPolicies?: Maybe<CancellationPolicies>;
};

export type GetCountriesRequest = {
  locale: Scalars['String']['input'];
};

export type GetCountriesResponse = {
  __typename?: 'GetCountriesResponse';
  countries?: Maybe<Array<Maybe<Country>>>;
};

export type GetFastTrackAvailabilitiesRequest = {
  bookingId?: InputMaybe<Scalars['Long']['input']>;
  itineraryId: ItineraryId;
  shoppingBasketId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetFastTrackAvailabilitiesResponse = {
  __typename?: 'GetFastTrackAvailabilitiesResponse';
  availabilities: Array<FastTrackAvailability>;
};

export type GetFlashOffersResponse = {
  __typename?: 'GetFlashOffersResponse';
  estimatedExpirationDurationInSeconds?: Maybe<Scalars['Long']['output']>;
  expirationTimestamp?: Maybe<Scalars['Long']['output']>;
  flashOffers: Array<FlashOffer>;
};

export type GetMembershipProductRequest = {
  shoppingInfo: ShoppingInfo;
};

export type GetReferralRewardRequest = {
  subscriptionId: Scalars['String']['input'];
};

export type GetReferralRewardResponse = {
  __typename?: 'GetReferralRewardResponse';
  reward?: Maybe<ReferralReward>;
  subscription?: Maybe<ReferralSubscription>;
};

export type GetShoppingBookingIdRequest = {
  shoppingInfo: ShoppingInfo;
};

export type GoogleAccessTokenLoginRequest = {
  acceptsNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  persistentLogin?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};

export enum GoogleApiKey {
  Development = 'DEVELOPMENT',
  Dynpack = 'DYNPACK',
  Hsa = 'HSA',
  Intermediate = 'INTERMEDIATE'
}

export type GoogleLoginRequest = {
  acceptsNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  persistentLogin?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};

export type Guest = {
  countryCodeOfResidence?: InputMaybe<Scalars['String']['input']>;
  dayOfBirth?: InputMaybe<Scalars['Int']['input']>;
  firstLastName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  identification?: InputMaybe<Scalars['String']['input']>;
  identificationExpirationDay?: InputMaybe<Scalars['Int']['input']>;
  identificationExpirationMonth?: InputMaybe<Scalars['Int']['input']>;
  identificationExpirationYear?: InputMaybe<Scalars['Int']['input']>;
  identificationIssueCountryCode?: InputMaybe<Scalars['String']['input']>;
  identificationTypeName?: InputMaybe<Scalars['String']['input']>;
  localityCodeOfResidence?: InputMaybe<Scalars['String']['input']>;
  mealName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  monthOfBirth?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalityCountryCode?: InputMaybe<Scalars['String']['input']>;
  secondLastName?: InputMaybe<Scalars['String']['input']>;
  titleName?: InputMaybe<Scalars['String']['input']>;
  travellerTypeName?: InputMaybe<Scalars['String']['input']>;
  yearOfBirth?: InputMaybe<Scalars['Int']['input']>;
};

export type Headers = {
  ofJsession?: InputMaybe<Scalars['String']['input']>;
  visit?: InputMaybe<Scalars['String']['input']>;
};

export type HotelImage = {
  __typename?: 'HotelImage';
  thumbnail?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum HottestDealType {
  BestDiscount = 'BEST_DISCOUNT',
  BestPrice = 'BEST_PRICE',
  Regular = 'REGULAR'
}

export type HsaSearchUrlRequest = {
  accommodationProductId: Scalars['String']['input'];
  buyPath: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type HsaSearchUrlResponse = {
  __typename?: 'HsaSearchURLResponse';
  url: Scalars['String']['output'];
};

export type IdealAccount = RecurringCollectionPaymentInstrument & {
  __typename?: 'IdealAccount';
  idealIssuerBank: IdealIssuerBankType;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  paymentInstrumentToken: Scalars['ID']['output'];
};

export enum IdealIssuerBankType {
  AbnAmro = 'ABN_AMRO',
  Asn = 'ASN',
  Bunq = 'BUNQ',
  Ing = 'ING',
  Knab = 'KNAB',
  N26 = 'N26',
  NationaleNederlanden = 'NATIONALE_NEDERLANDEN',
  Rabobank = 'RABOBANK',
  Regiobank = 'REGIOBANK',
  Revolut = 'REVOLUT',
  Sns = 'SNS',
  Triodos = 'TRIODOS',
  VanLanschot = 'VAN_LANSCHOT',
  Yoursafe = 'YOURSAFE'
}

export type Identification = {
  __typename?: 'Identification';
  identificationCountryCode?: Maybe<Scalars['String']['output']>;
  identificationExpirationDate?: Maybe<Scalars['String']['output']>;
  identificationId?: Maybe<Scalars['String']['output']>;
  identificationType?: Maybe<IdentificationType>;
};

export type IdentificationDetailsInput = {
  identification?: InputMaybe<Scalars['String']['input']>;
  identificationCountryCode?: InputMaybe<Scalars['String']['input']>;
  identificationExpirationDate?: InputMaybe<Scalars['String']['input']>;
  identificationType?: InputMaybe<IdentificationType>;
  nationalityCountry?: InputMaybe<Scalars['String']['input']>;
};

export enum IdentificationType {
  BirthDate = 'BIRTH_DATE',
  Cif = 'CIF',
  NationalIdCard = 'NATIONAL_ID_CARD',
  Nie = 'NIE',
  Nif = 'NIF',
  Passport = 'PASSPORT'
}

export type Image = {
  __typename?: 'Image';
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Incident = {
  __typename?: 'Incident';
  consent?: Maybe<IncidentConsent>;
  creationDate: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  flightNumber?: Maybe<Scalars['String']['output']>;
  incidentId: IncidentId;
  incidentStatus?: Maybe<IncidentStatus>;
  source?: Maybe<Scalars['String']['output']>;
};

export type IncidentConsent = {
  __typename?: 'IncidentConsent';
  airlineAlternativeAccepted?: Maybe<Scalars['Boolean']['output']>;
  cashRefundAccepted?: Maybe<Scalars['Boolean']['output']>;
  emdAccepted?: Maybe<Scalars['Boolean']['output']>;
  flexibleTicketAccepted?: Maybe<Scalars['Boolean']['output']>;
  voucherAccepted?: Maybe<Scalars['Boolean']['output']>;
};

export type IncidentId = {
  __typename?: 'IncidentId';
  id: Scalars['String']['output'];
};

export enum IncidentStatus {
  CustomerCancellationChosen = 'CUSTOMER_CANCELLATION_CHOSEN',
  Unknown = 'UNKNOWN',
  WaitingForCustomerChoice = 'WAITING_FOR_CUSTOMER_CHOICE'
}

export type InitDecouplingPrimeSubscriptionFlowRequest = {
  mainFunnelContext: MainFunnelContext;
  primeSubscriptionContext?: InputMaybe<PrimeSubscriptionContext>;
  selectedOfferItemRef: Scalars['String']['input'];
};

export type InitDecouplingPrimeSubscriptionFlowResponse = {
  __typename?: 'InitDecouplingPrimeSubscriptionFlowResponse';
  shoppingBasketId: Scalars['ID']['output'];
};

export type InnerInsurance = {
  __typename?: 'InnerInsurance';
  offerId: Scalars['String']['output'];
  provider?: Maybe<NonEssentialProductProviderType>;
  urls?: Maybe<Array<Maybe<NonEssentialProductUrl>>>;
};

export type InputParam = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Insurance = {
  __typename?: 'Insurance';
  conditionsUrls: Array<InsuranceUrl>;
  description: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  policy: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type InsuranceBooking = {
  __typename?: 'InsuranceBooking';
  insurance: Insurance;
  providerPricePerTravellerType: Array<InsuranceBookingCoveragePassengerPrice>;
  totalPrice: Money;
};

export type InsuranceBookingCoveragePassengerPrice = {
  __typename?: 'InsuranceBookingCoveragePassengerPrice';
  coverageImport: Money;
  paxNum: Scalars['Int']['output'];
  providerPrice: Money;
  travellerType: TravellerAgeType;
};

export type InsuranceBookings = {
  __typename?: 'InsuranceBookings';
  bookings: Array<InsuranceBooking>;
};

export type InsuranceOffer = {
  __typename?: 'InsuranceOffer';
  id: Scalars['ID']['output'];
  policy: InsurancePolicy;
  url: Scalars['String']['output'];
};

export type InsuranceOfferId = {
  __typename?: 'InsuranceOfferId';
  id: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type InsuranceOfferType = {
  __typename?: 'InsuranceOfferType';
  conditionUrls?: Maybe<Array<Maybe<InsuranceUrl>>>;
  offerId: InsuranceOfferId;
  offerKey: Scalars['String']['output'];
  price: Money;
};

export type InsuranceOfferValue = {
  __typename?: 'InsuranceOfferValue';
  id: Scalars['ID']['output'];
  insuranceOffer: InsuranceOffer;
};

export type InsuranceOffersRequest = {
  bookingId: Scalars['Long']['input'];
  products?: InputMaybe<Array<InputMaybe<ProductIdRequest>>>;
};

export type InsuranceOffersResponse = {
  __typename?: 'InsuranceOffersResponse';
  insurances?: Maybe<Array<Maybe<InsuranceOfferType>>>;
};

export enum InsurancePolicy {
  ExternalInsurance = 'EXTERNAL_INSURANCE',
  OdigeoGuarantee = 'ODIGEO_GUARANTEE',
  Other = 'OTHER'
}

export type InsurancePriceBreakDownItem = PriceBreakDownItem & {
  __typename?: 'InsurancePriceBreakDownItem';
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  isTripInsurance: Scalars['Boolean']['output'];
  nonDiscountedPrice?: Maybe<Money>;
  offerId: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  price: Money;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export type InsuranceProduct = {
  __typename?: 'InsuranceProduct';
  offerKey: Scalars['String']['output'];
  price: Money;
  productId: Scalars['String']['output'];
};

export type InsuranceUrl = {
  __typename?: 'InsuranceUrl';
  type: InsuranceUrlType;
  url: Scalars['String']['output'];
};

export enum InsuranceUrlType {
  Extended = 'EXTENDED',
  Simple = 'SIMPLE'
}

export type InteractionFinished = {
  __typename?: 'InteractionFinished';
  finished: Scalars['Boolean']['output'];
};

export enum InteractionType {
  ApplePay = 'APPLE_PAY',
  FormRedirection = 'FORM_REDIRECTION',
  GooglePay = 'GOOGLE_PAY',
  Html = 'HTML',
  Javascript = 'JAVASCRIPT',
  Url = 'URL'
}

export enum InterfaceClientType {
  OneFrontSmartphone = 'ONE_FRONT_SMARTPHONE'
}

export enum InterfaceType {
  Native = 'NATIVE',
  Web = 'WEB'
}

export type Invoice = {
  __typename?: 'Invoice';
  id: Scalars['String']['output'];
  issuanceDate?: Maybe<Scalars['String']['output']>;
  requestDate: Scalars['String']['output'];
  requester: Scalars['String']['output'];
  status: InvoiceRequestStatus;
  todId?: Maybe<Scalars['Long']['output']>;
};

export type InvoiceComponents = {
  __typename?: 'InvoiceComponents';
  accommodationComponents?: Maybe<AccommodationInvoiceComponents>;
  additionalServicesAndFees: Scalars['Float']['output'];
  collectedAmount: Scalars['Float']['output'];
  collectedAmountExcludingMembershipDiscount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  itineraryComponents?: Maybe<ItineraryInvoiceComponents>;
  /** @deprecated misleading name, use collectedAmount instead */
  totalAmountPaid: Scalars['Float']['output'];
  totalMembershipDiscount?: Maybe<Scalars['Float']['output']>;
  totalPrice: Scalars['Float']['output'];
};

export type InvoiceContactDetails = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<ContactType>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  identification?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  contactType: ContactType;
  countryCode: Scalars['String']['output'];
  email: Scalars['String']['output'];
  identification?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type InvoiceRequest = {
  invoiceAddress: Scalars['String']['input'];
  invoiceCity: Scalars['String']['input'];
  invoiceCountryCode: Scalars['String']['input'];
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoiceMail?: InputMaybe<Scalars['String']['input']>;
  invoiceName: Scalars['String']['input'];
  invoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceZipCode: Scalars['String']['input'];
  professional: Scalars['Boolean']['input'];
};

export enum InvoiceRequestStatus {
  Error = 'ERROR',
  Issued = 'ISSUED',
  NotInAxaptaSystem = 'NOT_IN_AXAPTA_SYSTEM',
  Requested = 'REQUESTED'
}

export type IsAccommodationModifiableResponse = {
  __typename?: 'IsAccommodationModifiableResponse';
  isModifiable: Scalars['Boolean']['output'];
};

export type IsLoginVerifiedRequest = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type IssuedReward = BaseMembershipReward & {
  __typename?: 'IssuedReward';
  promoCodeRewards: Array<PromoCodeReward>;
  rewardType: RewardType;
};

export type Item = {
  __typename?: 'Item';
  bookingItemId: Scalars['Long']['output'];
  itemId: Scalars['ID']['output'];
  todId?: Maybe<Scalars['Long']['output']>;
};

export enum ItemCheckoutFlow {
  AccommodationBookingFlow = 'ACCOMMODATION_BOOKING_FLOW',
  AccommodationModificationFlow = 'ACCOMMODATION_MODIFICATION_FLOW',
  AccommodationShoppingCartFlow = 'ACCOMMODATION_SHOPPING_CART_FLOW',
  AirportFastTrackFlow = 'AIRPORT_FAST_TRACK_FLOW',
  BaggageBookingFlow = 'BAGGAGE_BOOKING_FLOW',
  FlightUpdateSmsFlow = 'FLIGHT_UPDATE_SMS_FLOW',
  InsuranceFlow = 'INSURANCE_FLOW',
  InsuranceShoppingCartFlow = 'INSURANCE_SHOPPING_CART_FLOW',
  ItineraryBookingFlow = 'ITINERARY_BOOKING_FLOW',
  ItineraryPriceFreezeFlow = 'ITINERARY_PRICE_FREEZE_FLOW',
  ItineraryPriceFreezeRedemptionFlow = 'ITINERARY_PRICE_FREEZE_REDEMPTION_FLOW',
  PostsellServiceOptionShoppingCartFlow = 'POSTSELL_SERVICE_OPTION_SHOPPING_CART_FLOW',
  PrimeAccountDisableAutoRenewalFlow = 'PRIME_ACCOUNT_DISABLE_AUTO_RENEWAL_FLOW',
  PrimeMembershipRenewalFlow = 'PRIME_MEMBERSHIP_RENEWAL_FLOW',
  PrimeMembershipRetentionFlow = 'PRIME_MEMBERSHIP_RETENTION_FLOW',
  PrimeSubscriptionCampaignFlow = 'PRIME_SUBSCRIPTION_CAMPAIGN_FLOW',
  PrimeSubscriptionFlow = 'PRIME_SUBSCRIPTION_FLOW',
  PromoCodeFlow = 'PROMO_CODE_FLOW',
  RecurringPaymentInstrumentVerifierFlow = 'RECURRING_PAYMENT_INSTRUMENT_VERIFIER_FLOW',
  SeatBookingFlow = 'SEAT_BOOKING_FLOW',
  Unknown = 'UNKNOWN',
  WalletFundFlow = 'WALLET_FUND_FLOW',
  WalletRedemptionShoppingCartFlow = 'WALLET_REDEMPTION_SHOPPING_CART_FLOW',
  WalletWithdrawalFlow = 'WALLET_WITHDRAWAL_FLOW'
}

export type Itinerary = {
  __typename?: 'Itinerary';
  campaignConfig?: Maybe<CampaignConfig>;
  carbonFootprint?: Maybe<CarbonFootprint>;
  fees: Array<Fee>;
  freeCancellation?: Maybe<Scalars['String']['output']>;
  freeCancellationLimit?: Maybe<FreeCancellationLimit>;
  hasFreeRebooking: Scalars['Boolean']['output'];
  hasRefundCarriers: Scalars['Boolean']['output'];
  hasReliableCarriers: Scalars['Boolean']['output'];
  hotelXSellingEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFareUpgradeAvailable: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  legs?: Maybe<Array<Leg>>;
  meRating: Scalars['Float']['output'];
  perks?: Maybe<Perks>;
  /** @deprecated You can find the same information in Itinerary.campaignConfig.primeDayConfig */
  primeDayConfig?: Maybe<PrimeDayConfig>;
  searchId?: Maybe<Scalars['Long']['output']>;
  ticketsLeft: Scalars['Int']['output'];
  transportTypes?: Maybe<Array<TransportType>>;
  tripType: TripType;
};

export type ItineraryAlternativeList = {
  __typename?: 'ItineraryAlternativeList';
  alternativeItineraries: Array<AlternativeItinerary>;
  itineraryId: Scalars['ID']['output'];
};

export type ItineraryCancellationApplicationRequest = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};

export type ItineraryCancellationApplicationResponse = {
  __typename?: 'ItineraryCancellationApplicationResponse';
  success: Scalars['Boolean']['output'];
};

export type ItineraryId = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type ItineraryInvoiceComponents = {
  __typename?: 'ItineraryInvoiceComponents';
  airFare: Scalars['Float']['output'];
  airlineChargesAmounts: Array<AirlineChargesAmounts>;
  airlineTaxes: Scalars['Float']['output'];
};

export type ItineraryPriceBreakDownItem = PriceBreakDownItem & {
  __typename?: 'ItineraryPriceBreakDownItem';
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  flightTaxes?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  providerFare?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  serviceFeeTaxes?: Maybe<Money>;
  totalPrice: Money;
  totalTaxes?: Maybe<Money>;
  type: PriceBreakDownItemType;
};

export type ItineraryPriceFreeze = {
  __typename?: 'ItineraryPriceFreeze';
  bookingId: Scalars['Long']['output'];
  condition: FrozenCondition;
  feeContainerId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated use itineraryPriceFreezeItinerary */
  itinerary?: Maybe<Itinerary>;
  itineraryPriceFreezeItinerary?: Maybe<ItineraryPriceFreezeItinerary>;
  itineraryPriceFreezeRedemptionId?: Maybe<ItineraryPriceFreezeRedemptionId>;
  status: PriceFreezeStatus;
};

export type ItineraryPriceFreezeBooking = {
  __typename?: 'ItineraryPriceFreezeBooking';
  id: Scalars['String']['output'];
};

export type ItineraryPriceFreezeFareItinerary = {
  __typename?: 'ItineraryPriceFreezeFareItinerary';
  price: Money;
  segments: Array<Maybe<ItineraryPriceFreezeSegment>>;
};

export type ItineraryPriceFreezeItinerary = {
  __typename?: 'ItineraryPriceFreezeItinerary';
  nonPrimePrice?: Maybe<Money>;
  numAdults: Scalars['Int']['output'];
  numChildren?: Maybe<Scalars['Int']['output']>;
  numInfants: Scalars['Int']['output'];
  primeAndNonPrimePricesDifference?: Maybe<Money>;
  primePrice: Money;
  segments: Array<Maybe<ItineraryPriceFreezeSegment>>;
  type: ItineraryPriceFreezeTripType;
};

export type ItineraryPriceFreezeOffer = {
  __typename?: 'ItineraryPriceFreezeOffer';
  /** @deprecated not used anymore */
  available: Scalars['Boolean']['output'];
  /** @deprecated use itineraryPriceFreezeItinerary */
  itinerary: Itinerary;
  itineraryPriceFreezeItinerary: ItineraryPriceFreezeItinerary;
  offer?: Maybe<PriceFreezeOffer>;
  searchCriteria: ItinerarySearchCriteria;
};

export type ItineraryPriceFreezeRedemption = {
  __typename?: 'ItineraryPriceFreezeRedemption';
  itineraryPriceFreeze: ItineraryPriceFreeze;
  itineraryPriceFreezeRedemptionCalculatedParams?: Maybe<ItineraryPriceFreezeRedemptionMoneyCalculatedValues>;
  itineraryPriceFreezeRedemptionOption?: Maybe<ItineraryPriceFreezeRedemptionOption>;
};

export type ItineraryPriceFreezeRedemptionId = {
  __typename?: 'ItineraryPriceFreezeRedemptionId';
  id?: Maybe<Scalars['ID']['output']>;
  itineraryPriceFreezeRedemptionType?: Maybe<ItineraryPriceFreezeRedemptionType>;
};

export type ItineraryPriceFreezeRedemptionMoneyCalculatedValues = {
  __typename?: 'ItineraryPriceFreezeRedemptionMoneyCalculatedValues';
  itineraryPriceIncreasedAmount: Money;
  minorItineraryPriceMinusDeposit: Money;
  overTheCapAmount: Money;
};

export type ItineraryPriceFreezeRedemptionOption = {
  __typename?: 'ItineraryPriceFreezeRedemptionOption';
  itineraryPriceFreezeFareItinerary: ItineraryPriceFreezeFareItinerary;
  reference: Scalars['ID']['output'];
  sellingPrice: Money;
};

export type ItineraryPriceFreezeRedemptionRequest = {
  id: Scalars['ID']['input'];
};

export enum ItineraryPriceFreezeRedemptionType {
  Itinerary = 'ITINERARY',
  Refund = 'REFUND'
}

export type ItineraryPriceFreezeRevenueData = {
  __typename?: 'ItineraryPriceFreezeRevenueData';
  itineraryPriceFreezeId: Scalars['ID']['output'];
  redemptionRate: Scalars['Float']['output'];
  revenue: Money;
};

export type ItineraryPriceFreezeRevenueDataRequest = {
  itineraryPriceFreezeId: Scalars['ID']['input'];
};

export type ItineraryPriceFreezeSection = {
  __typename?: 'ItineraryPriceFreezeSection';
  arrivalDate: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  departureLocation: Location;
  destinationLocation: Location;
  duration: Scalars['Long']['output'];
  marketingCarrierCode: Scalars['String']['output'];
};

export type ItineraryPriceFreezeSegment = {
  __typename?: 'ItineraryPriceFreezeSegment';
  referenceKey: Scalars['String']['output'];
  sections: Array<Maybe<ItineraryPriceFreezeSection>>;
};

export enum ItineraryPriceFreezeTripType {
  Hub = 'HUB',
  MultiDestination = 'MULTI_DESTINATION',
  OneWay = 'ONE_WAY',
  OneWayAsARoundTrip = 'ONE_WAY_AS_A_ROUND_TRIP',
  RoundTrip = 'ROUND_TRIP',
  Xfaring = 'XFARING'
}

export type ItineraryPriceFreezesRequest = {
  customerEmail: Scalars['String']['input'];
};

export type ItineraryPriceSummary = PriceSummary & {
  __typename?: 'ItineraryPriceSummary';
  /** @deprecated Field no longer supported */
  amount: Money;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  nonDiscountedPricePerPassenger?: Maybe<Money>;
  pricePerPassenger: Money;
  pricePerception: PricePerceptionConfig;
  totalPrice: Money;
};

export type ItineraryPrimeBooking = PrimeBooking & {
  __typename?: 'ItineraryPrimeBooking';
  bookingId: Scalars['ID']['output'];
  departureDate?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  destinationIataCode?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
};

export type ItineraryProduct = Product & {
  __typename?: 'ItineraryProduct';
  id?: Maybe<ProductId>;
  price?: Maybe<Money>;
  productInfo?: Maybe<Itinerary>;
};

export type ItineraryRequest = {
  cabinClass?: InputMaybe<Scalars['String']['input']>;
  excludeCarriers?: InputMaybe<Scalars['Boolean']['input']>;
  externalSelection?: InputMaybe<ExternalSelectionRequest>;
  mainAirportsOnly: Scalars['Boolean']['input'];
  numAdults: Scalars['Int']['input'];
  numChildren: Scalars['Int']['input'];
  numInfants: Scalars['Int']['input'];
  resident: Scalars['Boolean']['input'];
  segments: Array<SegmentRequest>;
};

export enum ItineraryResultPriceType {
  Cheapest = 'CHEAPEST',
  MemberPricePolicyDiscounted = 'MEMBER_PRICE_POLICY_DISCOUNTED',
  MemberPricePolicyDiscountedPlusCoupon = 'MEMBER_PRICE_POLICY_DISCOUNTED_PLUS_COUPON',
  MemberPricePolicyUndiscounted = 'MEMBER_PRICE_POLICY_UNDISCOUNTED'
}

export type ItinerarySearchAlternativeRequest = {
  bookingId: Scalars['Long']['input'];
  bookingItemId: Scalars['Long']['input'];
  departureDate?: InputMaybe<Scalars['String']['input']>;
  departureIata?: InputMaybe<Scalars['String']['input']>;
  destinationIata?: InputMaybe<Scalars['String']['input']>;
  legToChange: LegToChange;
  passengerIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
  returnDate?: InputMaybe<Scalars['String']['input']>;
  tripType: TripType;
};

export type ItinerarySearchAlternativeResponse = {
  __typename?: 'ItinerarySearchAlternativeResponse';
  /** @deprecated changed name in field response due to frontend developers request */
  alternativeFareItineraries: Array<AlternativeFareItinerary>;
  itineraryResults: Array<AlternativeFareItinerary>;
};

export type ItinerarySearchAlternativesRequest = {
  eligibleForDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  itineraryCarriers: Array<Scalars['String']['input']>;
  itineraryId: Scalars['ID']['input'];
  searchId: Scalars['Long']['input'];
  searchRequest: SearchRequest;
};

export type ItinerarySearchCriteria = {
  __typename?: 'ItinerarySearchCriteria';
  buyPath?: Maybe<Scalars['Int']['output']>;
  cabinClass?: Maybe<Scalars['String']['output']>;
  metaSelectedCollectionMethod?: Maybe<Scalars['Int']['output']>;
  pax: PaxNumber;
  resident?: Maybe<Scalars['Boolean']['output']>;
  segment?: Maybe<Array<SegmentSearchCriteria>>;
  tripType?: Maybe<TripType>;
};

export type ItinerarySearchCriteriaSelection = {
  __typename?: 'ItinerarySearchCriteriaSelection';
  fareItineraryKey: Scalars['String']['output'];
  segmentKeys: Array<Scalars['String']['output']>;
};

export type ItinerarySearchItineraryRequest = {
  cabinClass?: InputMaybe<Scalars['String']['input']>;
  excludeCarriers?: InputMaybe<Scalars['Boolean']['input']>;
  externalSelection?: InputMaybe<ExternalSelectionRequest>;
  numAdults: Scalars['Int']['input'];
  numChildren: Scalars['Int']['input'];
  numInfants: Scalars['Int']['input'];
  segments: Array<SegmentItineraryRequest>;
};

export type ItinerarySearchResponse = {
  __typename?: 'ItinerarySearchResponse';
  campaignConfigs: Array<CampaignConfigValue>;
  campaignsItineraryLists: Array<Campaign>;
  carbonFootprints: Array<CarbonFootprintValue>;
  carriers: Array<CarrierValue>;
  carriersWithRebooking?: Maybe<Array<Scalars['String']['output']>>;
  externalSelection?: Maybe<ExternalSelection>;
  fees: Array<FeeTypeValue>;
  freeCancellationItineraryIds?: Maybe<Array<Scalars['String']['output']>>;
  insuranceOffers: Array<InsuranceOfferValue>;
  isRebookingAvailable: Scalars['Boolean']['output'];
  itineraries: Array<ItinerarySearchResult>;
  /** @deprecated No longer used on frontend */
  itineraryAlternativesList: Array<ItineraryAlternativeList>;
  locations: Array<LocationValue>;
  priceTypeDisplayed?: Maybe<ItineraryResultPriceType>;
  searchCode?: Maybe<SearchCode>;
  searchId: Scalars['Long']['output'];
  trackingInfo?: Maybe<TrackingInfo>;
};

export type ItinerarySearchResult = {
  __typename?: 'ItinerarySearchResult';
  campaignConfigId?: Maybe<Scalars['ID']['output']>;
  carbonFootprintId?: Maybe<Scalars['ID']['output']>;
  fees: Array<SearchResponseFee>;
  hotelXSellingEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFareUpgradeAvailable: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  legs?: Maybe<Array<ItinerarySearchResultLeg>>;
  meRating: Scalars['Float']['output'];
  perks?: Maybe<Perks>;
  ticketsLeft: Scalars['Int']['output'];
  transportTypes?: Maybe<Array<TransportType>>;
};

export type ItinerarySearchResultLeg = {
  __typename?: 'ItinerarySearchResultLeg';
  segmentKeys: Array<Scalars['Int']['output']>;
  segments: Array<ItinerarySearchResultSegment>;
};

export type ItinerarySearchResultSection = {
  __typename?: 'ItinerarySearchResultSection';
  arrivalDate: Scalars['String']['output'];
  arrivalTerminal?: Maybe<Scalars['String']['output']>;
  cabinClass?: Maybe<CabinClass>;
  carrierId: Scalars['ID']['output'];
  commercialBrandId?: Maybe<Scalars['ID']['output']>;
  departureDate: Scalars['String']['output'];
  departureId: Scalars['ID']['output'];
  departureTerminal?: Maybe<Scalars['String']['output']>;
  destinationId: Scalars['ID']['output'];
  duration?: Maybe<Scalars['Long']['output']>;
  flightCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insuranceOfferId?: Maybe<Scalars['ID']['output']>;
  operatingCarrierId?: Maybe<Scalars['ID']['output']>;
  technicalStops: Array<TechnicalStop>;
  transportType?: Maybe<TransportType>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
};

export type ItinerarySearchResultSegment = {
  __typename?: 'ItinerarySearchResultSegment';
  baggageCondition: BaggageCondition;
  carrierId: Scalars['ID']['output'];
  duration?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  sections: Array<ItinerarySearchResultSection>;
  transportTypes: Array<TransportType>;
};

export enum ItinerarySectionType {
  Flight = 'FLIGHT',
  Train = 'TRAIN'
}

export type ItinerarySelection = {
  fareItineraryKey: Scalars['String']['input'];
  segmentKeys: Array<Scalars['String']['input']>;
};

export enum ItineraryStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  PartiallyConfirmed = 'PARTIALLY_CONFIRMED',
  Processing = 'PROCESSING'
}

export type ItineraryTraveller = {
  lastNames: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ItineraryVoluntaryCancellation = {
  __typename?: 'ItineraryVoluntaryCancellation';
  cancellationId: Scalars['String']['output'];
  refundTaskId?: Maybe<Scalars['Long']['output']>;
  taskOnDemandId?: Maybe<Scalars['Long']['output']>;
};

export type ItineraryVoluntaryCancellationRequest = {
  bookingId: Scalars['Long']['input'];
  bookingItemId: Scalars['Long']['input'];
  c4arRedemptionApplied?: InputMaybe<Scalars['Boolean']['input']>;
  c4arRedemptionType?: InputMaybe<C4ArRedemptionType>;
  email: Scalars['String']['input'];
};

export type JoinChatbotBookingSessionRequest = {
  bookingId: Scalars['Long']['input'];
  channel: ChatbotChannel;
  email: Scalars['String']['input'];
};

export type JoinTripAroundTheWorldContestResponse = {
  __typename?: 'JoinTripAroundTheWorldContestResponse';
  isSubscribed: Scalars['Boolean']['output'];
};

export enum Language {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Pt = 'PT'
}

export type LastInvoiceRequestedResponse = {
  __typename?: 'LastInvoiceRequestedResponse';
  customerDetails?: Maybe<InvoiceDetails>;
  requestDetails: Invoice;
};

export type LatestSearch = {
  arrivalDate?: InputMaybe<Scalars['String']['input']>;
  departureDate: Scalars['String']['input'];
  destinationIata: Scalars['String']['input'];
  numAdults?: InputMaybe<Scalars['Int']['input']>;
  originIata: Scalars['String']['input'];
  timestamp?: InputMaybe<Scalars['Long']['input']>;
};

export type Leg = {
  __typename?: 'Leg';
  /** @deprecated onefront integration */
  segmentKeys: Array<Scalars['Int']['output']>;
  segments: Array<Segment>;
};

export enum LegToChange {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND',
  WholeTrip = 'WHOLE_TRIP'
}

export type LimitedAvailableMembershipPerk = BaseMembershipPerk & {
  __typename?: 'LimitedAvailableMembershipPerk';
  availableQuota: Scalars['Int']['output'];
  type: MembershipPerkType;
};

export type LimitedContractedMembershipPerk = BaseMembershipPerk & {
  __typename?: 'LimitedContractedMembershipPerk';
  contractedQuota: Scalars['Int']['output'];
  type: MembershipPerkType;
};

export type LimitedMembershipPerk = BaseMembershipPerk & {
  __typename?: 'LimitedMembershipPerk';
  type: MembershipPerkType;
  usageQuota: Scalars['Int']['output'];
};

export type LimitedPrimeSubscriptionOfferTierValuePropositionPerk = PrimeSubscriptionOfferTierValuePropositionPerk & {
  __typename?: 'LimitedPrimeSubscriptionOfferTierValuePropositionPerk';
  type: PrimeOfferTierValuePropositionPerkType;
  usageQuota: Scalars['Int']['output'];
};

export type ListLoginSessionsResponse = {
  __typename?: 'ListLoginSessionsResponse';
  currentSession: LoginSession;
  remainingActiveSessions: Array<LoginSession>;
};

export enum Locale {
  Default = 'DEFAULT',
  Ar = 'ar',
  ArAe = 'ar_AE',
  ArQa = 'ar_QA',
  ArSa = 'ar_SA',
  CaEs = 'ca_ES',
  CsCz = 'cs_CZ',
  DaDk = 'da_DK',
  De = 'de',
  DeAt = 'de_AT',
  DeCh = 'de_CH',
  DeDe = 'de_DE',
  ElGr = 'el_GR',
  En = 'en',
  EnAe = 'en_AE',
  EnAu = 'en_AU',
  EnCa = 'en_CA',
  EnCz = 'en_CZ',
  EnDe = 'en_DE',
  EnDk = 'en_DK',
  EnEg = 'en_EG',
  EnEs = 'en_ES',
  EnFi = 'en_FI',
  EnFr = 'en_FR',
  EnGb = 'en_GB',
  EnHk = 'en_HK',
  EnHu = 'en_HU',
  EnId = 'en_ID',
  EnIn = 'en_IN',
  EnIt = 'en_IT',
  EnKr = 'en_KR',
  EnNo = 'en_NO',
  EnNz = 'en_NZ',
  EnPh = 'en_PH',
  EnPl = 'en_PL',
  EnQa = 'en_QA',
  EnSa = 'en_SA',
  EnSe = 'en_SE',
  EnSg = 'en_SG',
  EnTh = 'en_TH',
  EnTw = 'en_TW',
  EnUs = 'en_US',
  EnZa = 'en_ZA',
  Es = 'es',
  EsAr = 'es_AR',
  EsCl = 'es_CL',
  EsCo = 'es_CO',
  EsEs = 'es_ES',
  EsMx = 'es_MX',
  EsPe = 'es_PE',
  EsUs = 'es_US',
  EsVe = 'es_VE',
  EuEs = 'eu_ES',
  FiFi = 'fi_FI',
  Fr = 'fr',
  FrCa = 'fr_CA',
  FrCh = 'fr_CH',
  FrFr = 'fr_FR',
  FrMa = 'fr_MA',
  GlEs = 'gl_ES',
  HuHu = 'hu_HU',
  IsIs = 'is_IS',
  It = 'it',
  ItCh = 'it_CH',
  ItIt = 'it_IT',
  JaJp = 'ja_JP',
  KoKr = 'ko_KR',
  NlNl = 'nl_NL',
  NoNo = 'no_NO',
  PlPl = 'pl_PL',
  Pt = 'pt',
  PtBr = 'pt_BR',
  PtPt = 'pt_PT',
  RoRo = 'ro_RO',
  RuRu = 'ru_RU',
  SvSe = 'sv_SE',
  TrTr = 'tr_TR',
  ZhCn = 'zh_CN',
  ZhTw = 'zh_TW'
}

export type LocalizationByIpResponse = {
  __typename?: 'LocalizationByIpResponse';
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  domainCountryCode: Scalars['String']['output'];
  language: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  cityIata?: Maybe<Scalars['String']['output']>;
  cityName: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName: Scalars['String']['output'];
  iata?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationType: LocationType;
  name?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type LocationRequest = {
  geoNodeId?: InputMaybe<Scalars['Int']['input']>;
  iata?: InputMaybe<Scalars['String']['input']>;
};

export type LocationSearchCriteria = {
  __typename?: 'LocationSearchCriteria';
  geoNodeId?: Maybe<Scalars['Int']['output']>;
  iata?: Maybe<Scalars['String']['output']>;
};

export enum LocationType {
  Airport = 'AIRPORT',
  City = 'CITY',
  Other = 'OTHER',
  TrainStation = 'TRAIN_STATION'
}

export type LocationValue = {
  __typename?: 'LocationValue';
  id: Scalars['ID']['output'];
  location: Location;
};

export type LoginEmailRequest = {
  email: Scalars['String']['input'];
  recaptchaV2Response?: InputMaybe<Scalars['String']['input']>;
};

export type LoginEmailResponse = {
  __typename?: 'LoginEmailResponse';
  isAcknowledged: Scalars['Boolean']['output'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  landingPagePath?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type LoginSession = {
  __typename?: 'LoginSession';
  creationTimestamp: Scalars['Long']['output'];
  deviceUserAgent?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  nodeId?: Maybe<Scalars['Int']['output']>;
  userDeviceOs?: Maybe<Scalars['String']['output']>;
};

export type LoginTokenValidationRequest = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type LoginTokenValidationResponse = {
  __typename?: 'LoginTokenValidationResponse';
  success: Scalars['Boolean']['output'];
};

export type LogoutFromSessionRequest = {
  sessionId: Scalars['String']['input'];
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success: Scalars['Boolean']['output'];
};

export enum LoyaltyReward {
  MonthlyPromoCodeRewardForYearlySubscription = 'MONTHLY_PROMO_CODE_REWARD_FOR_YEARLY_SUBSCRIPTION',
  Unknown = 'UNKNOWN',
  WelcomePromoCodeRewardThreeMonthsClaimable = 'WELCOME_PROMO_CODE_REWARD_THREE_MONTHS_CLAIMABLE'
}

export type LoyaltyRewardsProgram = {
  __typename?: 'LoyaltyRewardsProgram';
  loyaltyRewards: Array<LoyaltyReward>;
};

export type MainFunnelContext = {
  shoppingInfo: ShoppingInfo;
};

export type MainProduct = {
  itinerarySelection: ItinerarySelection;
  searchId: Scalars['Long']['input'];
};

export enum MapImageFormat {
  Gif = 'GIF',
  Jpg = 'JPG',
  JpgBaseline = 'JPG_BASELINE',
  Png = 'PNG',
  Png8 = 'PNG8',
  Png32 = 'PNG32'
}

export type MapParam = {
  property?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MapStaticConfiguration = {
  additionalParams?: InputMaybe<Array<InputMaybe<MapParam>>>;
  format?: InputMaybe<MapImageFormat>;
  mapType?: InputMaybe<MapType>;
  markerUrl?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['Int']['input']>;
  size: Size;
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export enum MapType {
  Hybrid = 'HYBRID',
  Roadmap = 'ROADMAP',
  Satellite = 'SATELLITE',
  Terrain = 'TERRAIN'
}

export type MarkUserPaymentInstrumentAsPreferredRequest = {
  paymentInstrumentToken: Scalars['ID']['input'];
};

export type MarkUserPaymentInstrumentAsPreferredResponse = {
  __typename?: 'MarkUserPaymentInstrumentAsPreferredResponse';
  isMarkedAsPreferred: Scalars['Boolean']['output'];
};

export type MarketingCampaign = {
  __typename?: 'MarketingCampaign';
  endDate: Scalars['String']['output'];
  showBanner: Scalars['Boolean']['output'];
  type: CampaignType;
};

export type MarketingRevenue = {
  __typename?: 'MarketingRevenue';
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type MarketingRevenueData = {
  __typename?: 'MarketingRevenueData';
  marketingRevenueList?: Maybe<Array<Maybe<MarketingRevenue>>>;
};

export type Membership = {
  __typename?: 'Membership';
  /** @deprecated Not used, will be removed in next iterations */
  activationDate?: Maybe<Scalars['String']['output']>;
  autoRenewalStatus?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<MembershipDuration>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  isAutoApply?: Maybe<Scalars['Boolean']['output']>;
  isFreeTrial: Scalars['Boolean']['output'];
  lastNames: Scalars['String']['output'];
  /** @deprecated Not used, will be removed in next iterations */
  memberAccountId: Scalars['Long']['output'];
  /** @deprecated Deprecated to use the duration with timeUnit */
  monthsDuration: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  recurringCollectionId?: Maybe<Scalars['ID']['output']>;
  renewalDuration?: Maybe<MembershipDuration>;
  renewalPrice?: Maybe<Money>;
  /** @deprecated Not used, will be removed in next iterations */
  sourceType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Money>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MembershipAccountPropertiesResponse = {
  __typename?: 'MembershipAccountPropertiesResponse';
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isActiveLogged?: Maybe<Scalars['Boolean']['output']>;
};

export type MembershipCancellation = {
  __typename?: 'MembershipCancellation';
  cancellationId: Scalars['ID']['output'];
  cancellationOptionId: Scalars['ID']['output'];
  userAccount?: Maybe<UserAccountResponse>;
};

export type MembershipCancellationOption = {
  __typename?: 'MembershipCancellationOption';
  cancellationOptionId: Scalars['ID']['output'];
  refundAmount?: Maybe<Money>;
  type: MembershipCancellationOptionType;
};

export enum MembershipCancellationOptionType {
  FullRefundEligible = 'FULL_REFUND_ELIGIBLE',
  PartialRefundEligible = 'PARTIAL_REFUND_ELIGIBLE'
}

export type MembershipChurnPredictionRequest = {
  shoppingId: Scalars['ID']['input'];
};

export type MembershipChurnPredictionResponse = {
  __typename?: 'MembershipChurnPredictionResponse';
  prediction: ChurnPredictionType;
};

export type MembershipDiscount = {
  __typename?: 'MembershipDiscount';
  discount?: Maybe<Money>;
  percentage?: Maybe<Scalars['Int']['output']>;
};

export type MembershipDuration = {
  __typename?: 'MembershipDuration';
  amount: Scalars['Int']['output'];
  timeUnit: MembershipDurationTimeUnit;
};

export enum MembershipDurationTimeUnit {
  Days = 'DAYS',
  Months = 'MONTHS'
}

export type MembershipFreeCancellationVoucher = Voucher & {
  __typename?: 'MembershipFreeCancellationVoucher';
  amount: Money;
  isEnabled: Scalars['Boolean']['output'];
};

export type MembershipOffer = {
  __typename?: 'MembershipOffer';
  membershipOfferId: Scalars['String']['output'];
  plan: MembershipPlan;
};

export type MembershipOfferPerk = LimitedMembershipPerk | UnlimitedMembershipPerk;

export enum MembershipPageName {
  ReconfirmRepeat = 'RECONFIRM_REPEAT',
  RenewalRecapture = 'RENEWAL_RECAPTURE',
  SubscriptionFtl = 'SUBSCRIPTION_FTL',
  SubscriptionMultipleOffers = 'SUBSCRIPTION_MULTIPLE_OFFERS',
  SubscriptionSingleOffer = 'SUBSCRIPTION_SINGLE_OFFER'
}

export type MembershipPagesRequest = {
  shoppingInfo: ShoppingInfo;
};

export type MembershipPagesResponse = {
  __typename?: 'MembershipPagesResponse';
  pages: Array<MembershipPageName>;
};

export type MembershipPerk = {
  __typename?: 'MembershipPerk';
  discount: Money;
  isApplied: Scalars['Boolean']['output'];
  perkType: MembershipPerksType;
};

export enum MembershipPerkType {
  FriendsAndFamilyItineraryDiscount = 'FRIENDS_AND_FAMILY_ITINERARY_DISCOUNT',
  ItineraryCancellationsForRenewableMembershipFreeTrialPeriodAllowed = 'ITINERARY_CANCELLATIONS_FOR_RENEWABLE_MEMBERSHIP_FREE_TRIAL_PERIOD_ALLOWED',
  ItineraryCancellationsForRenewablePaidMembershipOnly = 'ITINERARY_CANCELLATIONS_FOR_RENEWABLE_PAID_MEMBERSHIP_ONLY',
  ItineraryCancellationForSubscriptionPurchase = 'ITINERARY_CANCELLATION_FOR_SUBSCRIPTION_PURCHASE',
  OneItineraryCancellationForRenewableMembership = 'ONE_ITINERARY_CANCELLATION_FOR_RENEWABLE_MEMBERSHIP',
  Unknown = 'UNKNOWN',
  UnlimitedAccommodationDiscount = 'UNLIMITED_ACCOMMODATION_DISCOUNT',
  UnlimitedBagsDiscounts = 'UNLIMITED_BAGS_DISCOUNTS',
  UnlimitedCarRentalDiscount = 'UNLIMITED_CAR_RENTAL_DISCOUNT',
  UnlimitedItineraryDiscount = 'UNLIMITED_ITINERARY_DISCOUNT',
  UnlimitedPriceFreezeDiscount = 'UNLIMITED_PRICE_FREEZE_DISCOUNT',
  UnlimitedSeatDiscounts = 'UNLIMITED_SEAT_DISCOUNTS'
}

export type MembershipPerks = {
  __typename?: 'MembershipPerks';
  /** @deprecated Perks will be included in each product */
  fee?: Maybe<Scalars['Float']['output']>;
  perks: Array<MembershipPerk>;
};

export enum MembershipPerksType {
  AccommodationPerks = 'ACCOMMODATION_PERKS',
  ItineraryAndAccommodationPerks = 'ITINERARY_AND_ACCOMMODATION_PERKS',
  ItineraryPerks = 'ITINERARY_PERKS'
}

export type MembershipPlan = {
  __typename?: 'MembershipPlan';
  membershipTier: MembershipTier;
  planName: PlanName;
};

export type MembershipPlanDetails = {
  autoRenewalPolicy: AutoRenewalPolicy;
  duration?: Maybe<SubscriptionOfferDuration>;
  renewalDuration?: Maybe<SubscriptionOfferDuration>;
  renewalPrice?: Maybe<Money>;
  tier?: Maybe<SubscriptionOfferType>;
};

export type MembershipPostBookingCompensation = {
  __typename?: 'MembershipPostBookingCompensation';
  amount: Money;
  type: CompensationType;
};

export type MembershipPriceBreakDownItem = PriceBreakDownItem & {
  __typename?: 'MembershipPriceBreakDownItem';
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  duration: MembershipDuration;
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  quantity: Scalars['Int']['output'];
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export enum MembershipProductEvaluationCode {
  BlockingBin = 'BLOCKING_BIN',
  BookingAbuser = 'BOOKING_ABUSER',
  InvoluntaryAbuser = 'INVOLUNTARY_ABUSER',
  NoRisk = 'NO_RISK',
  RiskyCreditCard = 'RISKY_CREDIT_CARD',
  VoluntaryAbuser = 'VOLUNTARY_ABUSER',
  YearlyRejected = 'YEARLY_REJECTED'
}

export type MembershipProductEvaluationRequest = {
  creditCardBin: Scalars['String']['input'];
  creditCardDate: Scalars['String']['input'];
  paymentInstrumentToken: Scalars['String']['input'];
  shoppingInfo: ShoppingInfo;
};

export type MembershipProductEvaluationResponse = {
  __typename?: 'MembershipProductEvaluationResponse';
  code: MembershipProductEvaluationCode;
};

export type MembershipRejoinOffer = {
  __typename?: 'MembershipRejoinOffer';
  basePrice: Money;
  membershipRejoinOfferId: Scalars['String']['output'];
  plan: MembershipPlan;
};

export type MembershipRejoinOffersResponse = {
  __typename?: 'MembershipRejoinOffersResponse';
  membershipRejoinOffers: Array<MembershipRejoinOffer>;
};

export type MembershipRenewalProduct = Product & {
  __typename?: 'MembershipRenewalProduct';
  id?: Maybe<ProductId>;
  price?: Maybe<Money>;
  productInfo?: Maybe<MembershipRenewalResponse>;
};

export type MembershipRenewalResponse = {
  __typename?: 'MembershipRenewalResponse';
  offerAdded: SubscriptionResponse;
  primeMember: PrimeMemberBuyerInfo;
};

export type MembershipRequest = {
  shoppingInfo?: InputMaybe<ShoppingInfo>;
};

export type MembershipRetentionOffer = {
  __typename?: 'MembershipRetentionOffer';
  id: Scalars['ID']['output'];
  membershipOffers: Array<MembershipRetentionOfferType>;
  /** @deprecated Field no longer supported */
  membershipPerks: Array<MembershipRetentionOfferPerkType>;
};

export enum MembershipRetentionOfferPerkType {
  ItineraryCancellation = 'ITINERARY_CANCELLATION'
}

export enum MembershipRetentionOfferType {
  FlightCancellationOption = 'FLIGHT_CANCELLATION_OPTION'
}

export type MembershipRewards = {
  __typename?: 'MembershipRewards';
  claimableRewards: Array<ClaimableReward>;
  issuedRewards: Array<IssuedReward>;
  totals?: Maybe<MembershipRewardsTotals>;
};

export type MembershipRewardsTotals = {
  __typename?: 'MembershipRewardsTotals';
  claimableTotal: Money;
  issuedTotal: Money;
  overallTotal: Money;
};

export type MembershipStandaloneAccountDetails = {
  __typename?: 'MembershipStandaloneAccountDetails';
  name: Scalars['String']['output'];
};

export type MembershipStandaloneCampaignRequest = {
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipStandaloneCampaignResponse = {
  __typename?: 'MembershipStandaloneCampaignResponse';
  campaignCode: Scalars['String']['output'];
  funnel: MembershipStandaloneFunnel;
  offer?: Maybe<MembershipStandalonePlanDetails>;
  personalDetails?: Maybe<PersonalDetails>;
};

export type MembershipStandaloneCheckoutStatusRequest = {
  shoppingBasketId: Scalars['ID']['input'];
};

export type MembershipStandaloneCheckoutStatusResponse = {
  __typename?: 'MembershipStandaloneCheckoutStatusResponse';
  activated: Scalars['Boolean']['output'];
};

export enum MembershipStandaloneFunnel {
  StandaloneCampaign = 'STANDALONE_CAMPAIGN',
  StandaloneCampaignPaypal = 'STANDALONE_CAMPAIGN_PAYPAL',
  StandaloneCustomerServices = 'STANDALONE_CUSTOMER_SERVICES',
  StandalonePartner = 'STANDALONE_PARTNER',
  Unknown = 'UNKNOWN'
}

export type MembershipStandaloneOfferDetailsRequest = {
  shoppingBasketId: Scalars['ID']['input'];
};

export type MembershipStandaloneOfferDetailsResponse = {
  __typename?: 'MembershipStandaloneOfferDetailsResponse';
  offer?: Maybe<MembershipStandalonePlanDetails>;
};

export type MembershipStandalonePaymentCreditCard = MembershipStandalonePaymentInstrument & {
  __typename?: 'MembershipStandalonePaymentCreditCard';
  lastDigits: Scalars['String']['output'];
  type: PaymentMethod;
};

export type MembershipStandalonePaymentInstrument = {
  type: PaymentMethod;
};

export type MembershipStandalonePersonalData = {
  __typename?: 'MembershipStandalonePersonalData';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  email: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Phone;
  postalCode: Scalars['String']['output'];
};

export type MembershipStandalonePersonalDataInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: PhoneInput;
  postalCode: Scalars['String']['input'];
};

export type MembershipStandalonePersonalDataRequest = {
  shoppingBasketId: Scalars['ID']['input'];
};

export type MembershipStandalonePersonalDataResponse = {
  __typename?: 'MembershipStandalonePersonalDataResponse';
  membershipStandalonePersonalData?: Maybe<MembershipStandalonePersonalData>;
};

export type MembershipStandalonePlanDetails = MembershipPlanDetails & {
  __typename?: 'MembershipStandalonePlanDetails';
  autoRenewalPolicy: AutoRenewalPolicy;
  contractedPerks: Array<ContractedMembershipPerk>;
  discountPercentage: Scalars['Int']['output'];
  discountedPrice: Money;
  duration: SubscriptionOfferDuration;
  id: Scalars['ID']['output'];
  originalPrice: Money;
  renewalDuration: SubscriptionOfferDuration;
  renewalPrice: Money;
  tier: SubscriptionOfferType;
};

export type MembershipStandalonePostBookingRequest = {
  expirationDate: Scalars['String']['input'];
  hash: Scalars['String']['input'];
  shoppingId: Scalars['ID']['input'];
};

export type MembershipStandalonePostBookingResponse = {
  __typename?: 'MembershipStandalonePostBookingResponse';
  accountDetails?: Maybe<MembershipStandaloneAccountDetails>;
  paymentDetails?: Maybe<MembershipStandalonePaymentInstrument>;
  planDetails?: Maybe<PrimeMemberPlanDetails>;
  status: MembershipStandaloneResponseStatus;
};

export enum MembershipStandaloneResponseStatus {
  Init = 'INIT',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type MembershipStandaloneShoppingBasketCreationRequest = {
  membershipStandalonePersonalData?: InputMaybe<MembershipStandalonePersonalDataInput>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MembershipStandaloneShoppingBasketCreationResponse = {
  __typename?: 'MembershipStandaloneShoppingBasketCreationResponse';
  shoppingBasketId: Scalars['ID']['output'];
};

export enum MembershipSubscriptionActions {
  Add = 'ADD',
  Edit = 'EDIT',
  Remove = 'REMOVE'
}

export type MembershipSubscriptionProduct = Product & {
  __typename?: 'MembershipSubscriptionProduct';
  id?: Maybe<ProductId>;
  price?: Maybe<Money>;
  productInfo?: Maybe<MembershipSubscriptionResponse>;
};

export type MembershipSubscriptionResponse = {
  __typename?: 'MembershipSubscriptionResponse';
  offerAdded: SubscriptionResponse;
  primeMember: PrimeMemberBuyerInfo;
};

export type MembershipTier = {
  __typename?: 'MembershipTier';
  loyaltyRewardsProgram?: Maybe<LoyaltyRewardsProgram>;
  membershipTierId: Scalars['String']['output'];
  policies: MembershipTierPolicies;
  valueProposition: Array<MembershipOfferPerk>;
};

export type MembershipTierPolicies = {
  __typename?: 'MembershipTierPolicies';
  autoRenewalPolicy: AutoRenewalPolicy;
  durationPolicy: SubscriptionOfferDuration;
  freeTrialPolicy?: Maybe<FreeTrialPolicy>;
};

export type MembershipTokenResponse = {
  __typename?: 'MembershipTokenResponse';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MembershipUpdateInfo = {
  offerId: Scalars['String']['input'];
};

export type Message = {
  bookingId: Scalars['Long']['output'];
  extraHeader: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  semantic: MessageSemantic;
  status: MessageStatus;
  type: MessageType;
};

export type MessageFilter = {
  providerBookingItemId?: InputMaybe<Scalars['Long']['input']>;
};

export enum MessageSemantic {
  Critical = 'CRITICAL',
  Informative = 'INFORMATIVE',
  Successful = 'SUCCESSFUL',
  Unknown = 'UNKNOWN'
}

export enum MessageStatus {
  AllBankruptcy = 'ALL_BANKRUPTCY',
  AllContactAirline = 'ALL_CONTACT_AIRLINE',
  AllCritical = 'ALL_CRITICAL',
  AllCustomerAlternativeIssued = 'ALL_CUSTOMER_ALTERNATIVE_ISSUED',
  AllCustomerAlternativeRequested = 'ALL_CUSTOMER_ALTERNATIVE_REQUESTED',
  AllInformative = 'ALL_INFORMATIVE',
  AllManagedByIcm = 'ALL_MANAGED_BY_ICM',
  AllManagedByTouchless = 'ALL_MANAGED_BY_TOUCHLESS',
  AllManualAirlineAlternative = 'ALL_MANUAL_AIRLINE_ALTERNATIVE',
  AllOpenTicketAccepted = 'ALL_OPEN_TICKET_ACCEPTED',
  AllOpenTicketPending = 'ALL_OPEN_TICKET_PENDING',
  AllPendingClassification = 'ALL_PENDING_CLASSIFICATION',
  AllRedemptionPending = 'ALL_REDEMPTION_PENDING',
  AllRefund = 'ALL_REFUND',
  AllRefundNotManagedByEdo = 'ALL_REFUND_NOT_MANAGED_BY_EDO',
  AllRefundWaitingConsent = 'ALL_REFUND_WAITING_CONSENT',
  AllResolved = 'ALL_RESOLVED',
  AllResolvedByCustomer = 'ALL_RESOLVED_BY_CUSTOMER',
  AllSuccessful = 'ALL_SUCCESSFUL',
  Bankruptcy = 'BANKRUPTCY',
  Cancelled = 'CANCELLED',
  CheckingRefund = 'CHECKING_REFUND',
  Confirmed = 'CONFIRMED',
  ContactAirline = 'CONTACT_AIRLINE',
  CustomerAlternativeIssued = 'CUSTOMER_ALTERNATIVE_ISSUED',
  CustomerAlternativeRequested = 'CUSTOMER_ALTERNATIVE_REQUESTED',
  ManagedByIcm = 'MANAGED_BY_ICM',
  ManagedByTouchless = 'MANAGED_BY_TOUCHLESS',
  ManualAirlineAlternative = 'MANUAL_AIRLINE_ALTERNATIVE',
  ManualRecovery = 'MANUAL_RECOVERY',
  Modification = 'MODIFICATION',
  OpenTicketAccepted = 'OPEN_TICKET_ACCEPTED',
  OpenTicketPending = 'OPEN_TICKET_PENDING',
  PartiallyConfirmed = 'PARTIALLY_CONFIRMED',
  Pending = 'PENDING',
  PendingClassification = 'PENDING_CLASSIFICATION',
  RedemptionPending = 'REDEMPTION_PENDING',
  RefundMerchant = 'REFUND_MERCHANT',
  RefundNotManagedByEdo = 'REFUND_NOT_MANAGED_BY_EDO',
  RefundNoMerchant = 'REFUND_NO_MERCHANT',
  RefundVoluntary = 'REFUND_VOLUNTARY',
  RefundVoluntaryAsVoucher = 'REFUND_VOLUNTARY_AS_VOUCHER',
  RefundWaitingConsent = 'REFUND_WAITING_CONSENT',
  RefundWithStatus = 'REFUND_WITH_STATUS',
  Reimbursement = 'REIMBURSEMENT',
  Resolved = 'RESOLVED',
  ResolvedByCustomer = 'RESOLVED_BY_CUSTOMER',
  TripDatesChange = 'TRIP_DATES_CHANGE',
  Unknown = 'UNKNOWN'
}

export enum MessageType {
  BookingStatus = 'BOOKING_STATUS',
  Cancellation = 'CANCELLATION',
  Modification = 'MODIFICATION',
  Reimbursement = 'REIMBURSEMENT',
  Unknown = 'UNKNOWN'
}

export enum MethodTypeCode {
  Ab = 'AB',
  Ad = 'AD',
  Ax = 'AX',
  Ca = 'CA',
  Cb = 'CB',
  Cf = 'CF',
  Cm = 'CM',
  Co = 'CO',
  Dc = 'DC',
  Dl = 'DL',
  Dm = 'DM',
  Ds = 'DS',
  E1 = 'E1',
  Ea = 'EA',
  Ec = 'EC',
  Er = 'ER',
  Ey = 'EY',
  Hs = 'HS',
  Jc = 'JC',
  M4 = 'M4',
  M6 = 'M6',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Mf = 'MF',
  Mi = 'MI',
  Mp = 'MP',
  Rm = 'RM',
  Rv = 'RV',
  Ta = 'TA',
  Tc = 'TC',
  Td = 'TD',
  Te = 'TE',
  Tf = 'TF',
  Tp = 'TP',
  Tv = 'TV',
  Vb = 'VB',
  Vd = 'VD',
  Ve = 'VE',
  Vi = 'VI',
  Vv = 'VV'
}

export type MinimalBookingInfoRequest = {
  token: Scalars['String']['input'];
};

export type MinimalBookingInfoResponse = {
  __typename?: 'MinimalBookingInfoResponse';
  bookingId: Scalars['Long']['output'];
  email: Scalars['String']['output'];
};

export type ModifiableRequest = {
  bookingId: Scalars['Long']['input'];
  bookingItemId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};

export type ModifiableResponse = {
  __typename?: 'ModifiableResponse';
  modifiable: ModifiableResult;
};

export enum ModifiableResult {
  ImmediateDeparture = 'IMMEDIATE_DEPARTURE',
  ImmediateDepartureOnlyInboundProcessable = 'IMMEDIATE_DEPARTURE_ONLY_INBOUND_PROCESSABLE',
  IncidentPresent = 'INCIDENT_PRESENT',
  NotConfirmedBooking = 'NOT_CONFIRMED_BOOKING',
  Processable = 'PROCESSABLE',
  RequestInProgress = 'REQUEST_IN_PROGRESS',
  TripInThePast = 'TRIP_IN_THE_PAST',
  TripInThePastOnlyInboundProcessable = 'TRIP_IN_THE_PAST_ONLY_INBOUND_PROCESSABLE'
}

export type Modification = {
  __typename?: 'Modification';
  lastUpdated?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ModificationRequestStatus>;
};

export enum ModificationCategory {
  TripDatesChange = 'TRIP_DATES_CHANGE',
  Unknown = 'UNKNOWN'
}

export type ModificationMessage = Message & {
  __typename?: 'ModificationMessage';
  bookingId: Scalars['Long']['output'];
  extraHeader: Scalars['Boolean']['output'];
  modification: Modification;
  modificationCategory: ModificationCategory;
  modificationType: ModificationType;
  priority: Scalars['Int']['output'];
  semantic: MessageSemantic;
  status: MessageStatus;
  type: MessageType;
};

export type ModificationPrice = {
  __typename?: 'ModificationPrice';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  difference?: Maybe<Scalars['Float']['output']>;
  estimated?: Maybe<Scalars['Boolean']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  penalty?: Maybe<Scalars['Float']['output']>;
};

export enum ModificationRequestStatus {
  AgentReview = 'AGENT_REVIEW',
  Prioritising = 'PRIORITISING',
  Processing = 'PROCESSING',
  Requested = 'REQUESTED',
  Unknown = 'UNKNOWN'
}

export enum ModificationType {
  Involuntary = 'INVOLUNTARY',
  Unknown = 'UNKNOWN',
  Voluntary = 'VOLUNTARY'
}

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type MoneyRequest = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export type MonitoringAlert = {
  __typename?: 'MonitoringAlert';
  id: Scalars['String']['output'];
  monitoringAlertList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAgentAlternative: AcceptAgentAlternativeResponse;
  acceptAlternative: AcceptAlternativeResponse;
  acceptMembershipRetentionOffer?: Maybe<AcceptMembershipRetentionOfferResponse>;
  activateUserByToken: SignupResponse;
  addBookingBuyerToShoppingBasket: Scalars['Boolean']['output'];
  addContactDetailsToShoppingBasket: Scalars['Boolean']['output'];
  addContactDetailsToUniversalShoppingBasket: UniversalContactDetailsResponse;
  addCreditCard?: Maybe<User>;
  addFavoriteAccommodation: AddFavoriteAccommodationResponse;
  addItineraryModification: AddItineraryModificationResponse;
  addOutcome: AddOutcomeResponse;
  addPaymentInstrumentToRecurringCollection: RecurringCollectionResponse;
  addPersonalInfo: AddPersonalInfoResponse;
  addProductToShoppingBasket: Scalars['Boolean']['output'];
  addProductToUniversalShoppingBasket: UniversalShoppingBasketProductResponse;
  addPromoCodeToShoppingBasket: AddShoppingBasketPromoCodeResponse;
  addPromoCodeToUniversalShoppingBasket: UniversalShoppingBasketPromoCodeResponse;
  addUserCollectionTracking?: Maybe<UserCollectionTrackingResponse>;
  applyAccommodationModification: AccommodationModificationOption;
  applyCancellationOption: ItineraryVoluntaryCancellation;
  applyItineraryCancellationPerk: ItineraryCancellationApplicationResponse;
  calculateMembershipRetentionOptions: CalculateMembershipRetentionOptionsResponse;
  cancelAccommodation: AccommodationCancellation;
  cancelCheckout: CheckoutResponse;
  cancelMembership: MembershipCancellation;
  cancelShoppingBasketCheckout: CheckoutResponse;
  cancelUnauthenticatedMembership: CancelUnauthenticatedMembershipResponse;
  changeItinerary: ChangeItineraryResponse;
  changePassword: ChangePasswordResponse;
  changePaxNumber: ShoppingBundle;
  checkout: CheckoutResponse;
  confirmDecouplingPrimeSubscriptionFlow: ConfirmDecouplingPrimeSubscriptionFlowResponse;
  confirmReferralSubscription: ConfirmReferralSubscriptionResponse;
  confirmSelectedFlashOffer: FlashOfferConfirmationProcessResponse;
  createAccommodationProduct: CreateAccommodationProductResponse;
  /** @deprecated Field no longer supported */
  createBankTransfer: Scalars['Boolean']['output'];
  createCheckInV2: CreateCheckInV2Response;
  /** @deprecated Field no longer supported */
  createCheckinRequest: CreateCheckinResponse;
  createInvoiceRequest: Invoice;
  createItineraryVoluntaryCancellation: ItineraryVoluntaryCancellation;
  createMembershipCancellationOptions: CreateMembershipCancellationOptionsResponse;
  createMembershipStandaloneShoppingBasket?: Maybe<MembershipStandaloneShoppingBasketCreationResponse>;
  createRecurringPaymentInstrumentVerifierShoppingBasketForCrmToken: RecurringPaymentInstrumentVerifierShoppingBasketCreationResponse;
  createRecurringPaymentInstrumentVerifierShoppingBasketForLoggedInUser: RecurringPaymentInstrumentVerifierShoppingBasketCreationResponse;
  createReferralSubscription: CreateReferralSubscriptionResponse;
  createShoppingBasket: ShoppingBasketResponse;
  createShoppingBundle: CreateShoppingBundleResponse;
  createShoppingCart: CreateShoppingCartResponse;
  createUniversalShoppingBasket: UniversalShoppingBasketResponse;
  deleteAccommodationSearchHistory: DeleteAccommodationSearchHistoryResponse;
  deleteCreditCard?: Maybe<User>;
  deleteFavoriteAccommodation: DeleteFavoriteAccommodationResponse;
  deleteUserAccount?: Maybe<DeleteUserAccountResponse>;
  deleteUserPaymentInstrument?: Maybe<DeleteUserPaymentInstrumentResponse>;
  duplicateShoppingBundle: DuplicateShoppingBundleResponse;
  emailLogin: LoginResponse;
  facebookLogin: LoginResponse;
  favoriteAccommodationsByLocation?: Maybe<FavoriteAccommodationsByLocationResponse>;
  generateBaToken: GenerateBaTokenResponse;
  generateTripToken: TripToken;
  googleAccessTokenLogin: LoginResponse;
  googleLogin: LoginResponse;
  identifyChatbotFlowByBooking: ChatbotFlowBookingIdentificationResponse;
  /** @deprecated Use importBookingInTravelPlansV2 instead. */
  importBookingInTravelPlans: TravelPlansImportBookingResponse;
  /** @deprecated Use importBookingInTravelPlansByTripDetailsTokenV2 instead. */
  importBookingInTravelPlansByTripDetailsToken: TravelPlansImportBookingResponse;
  importBookingInTravelPlansByTripDetailsTokenV2: TravelPlansImportBookingResponseV2;
  importBookingInTravelPlansV2: TravelPlansImportBookingResponseV2;
  importTrip: Trip;
  importTripByTripDetailsToken: Trip;
  importTripsForLoggedInUser: Array<Trip>;
  initDecouplingPrimeSubscriptionFlow: InitDecouplingPrimeSubscriptionFlowResponse;
  isLoginVerified: LoginResponse;
  itineraryPriceFreeze: Scalars['ID']['output'];
  itinerarySearchAlternatives: ItinerarySearchResponse;
  joinChatbotBookingSession: ChatbotSession;
  joinTripAroundTheWorldContest: JoinTripAroundTheWorldContestResponse;
  loginTokenValidation: LoginTokenValidationResponse;
  logout: LogoutResponse;
  logoutFromOtherSessions: LogoutResponse;
  logoutFromSession: LogoutResponse;
  markPaymentInstrumentAsDefault: RecurringCollectionResponse;
  markUserPaymentInstrumentAsPreferred: MarkUserPaymentInstrumentAsPreferredResponse;
  membershipProductEvaluation?: Maybe<MembershipProductEvaluationResponse>;
  membershipStandalonePostBooking: MembershipStandalonePostBookingResponse;
  passwordLogin: LoginResponse;
  passwordSignup: SignupResponse;
  primeSubscriptionPostPurchase: PrimeSubscriptionPostPurchaseResponse;
  rebuildAccommodationOffer: RebuildAccommodationOfferResponse;
  recoverPassword: RecoverPasswordResponse;
  recurringPaymentInstrumentVerifierProductEvaluation: RecurringPaymentInstrumentVerifierProductEvaluationResponse;
  registerRecaptchaV3Token: RegisterRecaptchaV3TokenResponse;
  rejectFlashOffers: RejectFlashOffersResponse;
  removePaymentInstrumentFromRecurringCollection: RecurringCollectionResponse;
  removeProductFromShoppingBasket: Scalars['Boolean']['output'];
  removeProductFromUniversalShoppingBasket: UniversalShoppingBasketProductResponse;
  removePromoCodeFromShoppingBasket: RemoveShoppingBasketPromoCodeResponse;
  removePromoCodeFromUniversalShoppingBasket: UniversalShoppingBasketPromoCodeResponse;
  requestPrimeBookingFreeCancellation: PrimeBookingFreeCancellationResponse;
  requestReactivationVoucher?: Maybe<ReactivationVoucherResponse>;
  requestRetentionVoucher?: Maybe<RetentionVoucherResponse>;
  resendConfirmationEmail: ResendConfirmationEmailResponse;
  resumeCheckout: CheckoutResponse;
  resumeShoppingBasket: CheckoutResponse;
  selectAccommodationInsurance: SelectAccommodationInsuranceResponse;
  selectAccommodationOffer: SelectAccommodationOfferResponse;
  selectAncillaries: SelectedAncillariesResponse;
  selectAncillaryBundle: AncillaryBundleProduct;
  selectFastTrack: SelectFastTrackResponse;
  selectFastTrackOfferForItinerary: SelectFastTrackOfferForItineraryResponse;
  selectFlashOffer: SelectFlashOfferResponse;
  selectInsuranceOffer: SelectInsuranceOfferResponse;
  selectNonEssentialInsurancesProducts: NonEssentialProductsResponse;
  selectNonEssentialPostsellProducts: NonEssentialProductsResponse;
  /** @deprecated unused */
  selectNonEssentialProducts: SelectNonEssentialProductsResponse;
  selectPostBookingSubscriptionOffer: SelectPostBookingSubscriptionOfferResponse;
  selectUnchainedMembershipPostBooking: SelectUnchainedMembershipPostBookingResponse;
  selectUnchainedMembershipPostBookingV2: SelectUnchainedMembershipPostBookingResponse;
  semItinerarySelection: SemItinerarySelectionResponse;
  sendAuthenticationEmail: AuthenticationEmailResponse;
  sendAuthenticationEmailAndJoinTripAroundTheWorldContest: AuthenticationEmailResponse;
  sendChatbotEvent: ChatbotInteractionResponse;
  sendChatbotFeedback: ChatbotFeedbackResponse;
  sendChatbotPageEvent: ChatbotInteractionResponse;
  sendChatbotText: ChatbotInteractionResponse;
  sendLoginEmail: LoginEmailResponse;
  sendReauthenticationEmail: ReauthenticationEmailResponse;
  sendSetPasswordEmail: SendSetPasswordEmailResponse;
  shoppingBasketAddCreditCard: ShoppingBasketAddCreditCardResponse;
  shoppingBasketAddRedirect: ShoppingBasketAddRedirectResponse;
  shoppingBasketAddUserCollectionTracking?: Maybe<ShoppingBasketUserCollectionTrackingResponse>;
  shoppingBasketAddUserPaymentInteractionOutcome: ShoppingBasketAddUserPaymentInteractionOutcomeResponse;
  shoppingBasketCheckout: ShoppingBasketCheckoutResponse;
  shoppingBasketResume: ShoppingBasketCheckoutResponse;
  storeSmsConsent: StoreSmsConsentResponse;
  submitBankTransferRequest: BankTransferResponse;
  subscribeAccommodationSearchPriceAlertNewsletter: AccommodationSearchPriceAlertNewsletterResponse;
  subscribeToFdo: SubscriptionFdoResponse;
  subscribeToNewsletter: NewsletterSubscriptionResponse;
  /** @deprecated Use trackJavaScriptSnippetFinalized instead of this to track the error reason */
  trackJavaScriptSnippetExecutionFinalized: Scalars['Boolean']['output'];
  trackJavaScriptSnippetExecutionStarted: Scalars['Boolean']['output'];
  trackJavaScriptSnippetFinalized: TrackJavaScriptSnippetResponse;
  unselectAccommodationInsurance: UnselectAccommodationInsuranceResponse;
  unselectFastTrack: UnselectFastTrackResponse;
  unsubscribe: UnsubscriptionResponse;
  updateConsent: UpdateConsentResponse;
  updateCreditCard?: Maybe<User>;
  updateMembershipProduct?: Maybe<MembershipSubscriptionResponse>;
  updateProductsInShoppingBasket: UpdateProductsInShoppingBasketResponse;
  updatePromoCode: PromoCodeResponse;
  updateSubscriptionProductBinBased?: Maybe<MembershipSubscriptionResponse>;
  updateUserMembership?: Maybe<Membership>;
  updateUserMembershipPlan?: Maybe<Membership>;
};


export type MutationAcceptAgentAlternativeArgs = {
  acceptAgentAlternativeRequest: AcceptAgentAlternativeRequest;
};


export type MutationAcceptAlternativeArgs = {
  acceptAlternativeRequest: AcceptAlternativeRequest;
};


export type MutationAcceptMembershipRetentionOfferArgs = {
  membershipRetentionOfferAccepted?: InputMaybe<AcceptMembershipRetentionOfferRequest>;
};


export type MutationActivateUserByTokenArgs = {
  request: ActivateTokenUserRequest;
};


export type MutationAddBookingBuyerToShoppingBasketArgs = {
  request: AddBookingBuyerToShoppingBasketRequest;
};


export type MutationAddContactDetailsToShoppingBasketArgs = {
  request?: InputMaybe<AddContactDetailsToShoppingBasketRequest>;
};


export type MutationAddContactDetailsToUniversalShoppingBasketArgs = {
  request: AddContactDetailsToUniversalShoppingBasketRequest;
};


export type MutationAddCreditCardArgs = {
  request: SaveUserCreditCardRequest;
};


export type MutationAddFavoriteAccommodationArgs = {
  request: AddFavoriteAccommodationRequest;
};


export type MutationAddItineraryModificationArgs = {
  addItineraryModificationRequest: AddItineraryModificationRequest;
};


export type MutationAddOutcomeArgs = {
  request: AddOutcomeRequest;
};


export type MutationAddPaymentInstrumentToRecurringCollectionArgs = {
  addPaymentInstrumentToRecurringCollectionRequest: UpdateRecurringCollectionRequest;
};


export type MutationAddPersonalInfoArgs = {
  request: AddPersonalInfoRequest;
};


export type MutationAddProductToShoppingBasketArgs = {
  request?: InputMaybe<AddProductToShoppingBasketRequest>;
};


export type MutationAddProductToUniversalShoppingBasketArgs = {
  request: AddProductToUniversalShoppingBasketRequest;
};


export type MutationAddPromoCodeToShoppingBasketArgs = {
  request: AddShoppingBasketPromoCodeRequest;
};


export type MutationAddPromoCodeToUniversalShoppingBasketArgs = {
  request: AddUniversalShoppingBasketPromoCodeRequest;
};


export type MutationAddUserCollectionTrackingArgs = {
  request: UserCollectionTrackingRequest;
};


export type MutationApplyAccommodationModificationArgs = {
  applyAccommodationModificationRequest: ApplyAccommodationModificationRequest;
};


export type MutationApplyCancellationOptionArgs = {
  applyCancellationOptionRequest: ApplyCancellationOptionRequest;
};


export type MutationApplyItineraryCancellationPerkArgs = {
  request: ItineraryCancellationApplicationRequest;
};


export type MutationCancelAccommodationArgs = {
  cancellationOptionId: Scalars['ID']['input'];
};


export type MutationCancelCheckoutArgs = {
  request: CancelCheckoutRequest;
};


export type MutationCancelMembershipArgs = {
  cancelMembershipRequest: CancelMembershipRequest;
};


export type MutationCancelShoppingBasketCheckoutArgs = {
  request: CancelShoppingBasketCheckoutRequest;
};


export type MutationCancelUnauthenticatedMembershipArgs = {
  cancelUnauthenticatedMembershipRequest: CancelUnauthenticatedMembershipRequest;
};


export type MutationChangeItineraryArgs = {
  changeItineraryRequest: ChangeItineraryRequest;
};


export type MutationChangePasswordArgs = {
  request: ChangePasswordRequest;
};


export type MutationChangePaxNumberArgs = {
  request: ChangePaxNumberRequest;
};


export type MutationCheckoutArgs = {
  request?: InputMaybe<CheckoutRequest>;
};


export type MutationConfirmDecouplingPrimeSubscriptionFlowArgs = {
  request: ConfirmDecouplingPrimeSubscriptionFlowRequest;
};


export type MutationConfirmReferralSubscriptionArgs = {
  request: ConfirmReferralSubscriptionRequest;
};


export type MutationConfirmSelectedFlashOfferArgs = {
  request: ConfirmFlashOfferRequest;
};


export type MutationCreateAccommodationProductArgs = {
  request: CreateAccommodationProductRequest;
};


export type MutationCreateBankTransferArgs = {
  accountHolder: Scalars['String']['input'];
  bic: Scalars['String']['input'];
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
  iban: Scalars['String']['input'];
};


export type MutationCreateCheckInV2Args = {
  request: CreateCheckInV2Request;
};


export type MutationCreateCheckinRequestArgs = {
  checkinRequest?: InputMaybe<CheckinRequest>;
};


export type MutationCreateInvoiceRequestArgs = {
  bookingId: Scalars['Long']['input'];
  contactDetails?: InputMaybe<InvoiceContactDetails>;
  email: Scalars['String']['input'];
};


export type MutationCreateItineraryVoluntaryCancellationArgs = {
  itineraryVoluntaryCancellationRequest: ItineraryVoluntaryCancellationRequest;
};


export type MutationCreateMembershipStandaloneShoppingBasketArgs = {
  request?: InputMaybe<MembershipStandaloneShoppingBasketCreationRequest>;
};


export type MutationCreateRecurringPaymentInstrumentVerifierShoppingBasketForCrmTokenArgs = {
  request: RecurringPaymentInstrumentVerifierShoppingBasketCreationRequest;
};


export type MutationCreateReferralSubscriptionArgs = {
  request: CreateReferralSubscriptionRequest;
};


export type MutationCreateShoppingBasketArgs = {
  request?: InputMaybe<CreateShoppingBasketRequest>;
};


export type MutationCreateShoppingBundleArgs = {
  request: CreateShoppingBundleRequest;
};


export type MutationCreateShoppingCartArgs = {
  request: CreateShoppingCartRequest;
};


export type MutationDeleteAccommodationSearchHistoryArgs = {
  deleteRequest: DeleteAccommodationSearchHistoryRequest;
};


export type MutationDeleteCreditCardArgs = {
  request: DeleteUserCreditCardRequest;
};


export type MutationDeleteFavoriteAccommodationArgs = {
  request: DeleteFavoriteAccommodationRequest;
};


export type MutationDeleteUserPaymentInstrumentArgs = {
  request?: InputMaybe<DeleteUserPaymentInstrumentRequest>;
};


export type MutationDuplicateShoppingBundleArgs = {
  request: DuplicateShoppingBundleRequest;
};


export type MutationEmailLoginArgs = {
  request: EmailLoginRequest;
};


export type MutationFacebookLoginArgs = {
  request: FacebookLoginRequest;
};


export type MutationFavoriteAccommodationsByLocationArgs = {
  request: FavoriteAccommodationsByLocationRequest;
};


export type MutationGenerateBaTokenArgs = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};


export type MutationGenerateTripTokenArgs = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};


export type MutationGoogleAccessTokenLoginArgs = {
  request: GoogleAccessTokenLoginRequest;
};


export type MutationGoogleLoginArgs = {
  request: GoogleLoginRequest;
};


export type MutationIdentifyChatbotFlowByBookingArgs = {
  request: ChatbotFlowBookingIdentificationRequest;
};


export type MutationImportBookingInTravelPlansArgs = {
  request: TravelPlansImportBookingRequest;
};


export type MutationImportBookingInTravelPlansByTripDetailsTokenArgs = {
  request: TravelPlansImportBookingByTripDetailsTokenRequest;
};


export type MutationImportBookingInTravelPlansByTripDetailsTokenV2Args = {
  request: TravelPlansImportBookingByTripDetailsTokenRequest;
};


export type MutationImportBookingInTravelPlansV2Args = {
  request: TravelPlansImportBookingRequest;
};


export type MutationImportTripArgs = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};


export type MutationImportTripByTripDetailsTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationInitDecouplingPrimeSubscriptionFlowArgs = {
  request: InitDecouplingPrimeSubscriptionFlowRequest;
};


export type MutationIsLoginVerifiedArgs = {
  request: IsLoginVerifiedRequest;
};


export type MutationItineraryPriceFreezeArgs = {
  request: CreatePriceFreezeRequest;
};


export type MutationItinerarySearchAlternativesArgs = {
  itinerarySearchAlternativesRequest: ItinerarySearchAlternativesRequest;
};


export type MutationJoinChatbotBookingSessionArgs = {
  joinChatbotBookingSessionRequest: JoinChatbotBookingSessionRequest;
};


export type MutationLoginTokenValidationArgs = {
  request: LoginTokenValidationRequest;
};


export type MutationLogoutFromSessionArgs = {
  request: LogoutFromSessionRequest;
};


export type MutationMarkPaymentInstrumentAsDefaultArgs = {
  markPaymentInstrumentAsDefaultRequest: UpdateRecurringCollectionRequest;
};


export type MutationMarkUserPaymentInstrumentAsPreferredArgs = {
  request: MarkUserPaymentInstrumentAsPreferredRequest;
};


export type MutationMembershipProductEvaluationArgs = {
  request?: InputMaybe<MembershipProductEvaluationRequest>;
};


export type MutationMembershipStandalonePostBookingArgs = {
  request: MembershipStandalonePostBookingRequest;
};


export type MutationPasswordLoginArgs = {
  request: PasswordLoginRequest;
};


export type MutationPasswordSignupArgs = {
  request: PasswordSignupRequest;
};


export type MutationPrimeSubscriptionPostPurchaseArgs = {
  request: PrimeSubscriptionPostPurchaseRequest;
};


export type MutationRebuildAccommodationOfferArgs = {
  request: RebuildAccommodationOfferRequest;
};


export type MutationRecoverPasswordArgs = {
  request: RecoverPasswordRequest;
};


export type MutationRecurringPaymentInstrumentVerifierProductEvaluationArgs = {
  request: RecurringPaymentInstrumentVerifierProductEvaluationRequest;
};


export type MutationRegisterRecaptchaV3TokenArgs = {
  request: RegisterRecaptchaV3TokenRequest;
};


export type MutationRemovePaymentInstrumentFromRecurringCollectionArgs = {
  removePaymentInstrumentFromRecurringCollectionRequest: UpdateRecurringCollectionRequest;
};


export type MutationRemoveProductFromShoppingBasketArgs = {
  request?: InputMaybe<RemoveProductFromShoppingBasketRequest>;
};


export type MutationRemoveProductFromUniversalShoppingBasketArgs = {
  request: RemoveProductFromUniversalShoppingBasketRequest;
};


export type MutationRemovePromoCodeFromShoppingBasketArgs = {
  request: RemoveShoppingBasketPromoCodeRequest;
};


export type MutationRemovePromoCodeFromUniversalShoppingBasketArgs = {
  request: RemoveUniversalShoppingBasketPromoCodeRequest;
};


export type MutationRequestPrimeBookingFreeCancellationArgs = {
  primeBookingFreeCancellationRequest: PrimeBookingFreeCancellationRequest;
};


export type MutationResendConfirmationEmailArgs = {
  bookingId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationResumeCheckoutArgs = {
  request: ResumeCheckoutRequest;
};


export type MutationResumeShoppingBasketArgs = {
  request?: InputMaybe<ResumeShoppingBasketRequest>;
};


export type MutationSelectAccommodationInsuranceArgs = {
  request: SelectAccommodationInsuranceRequest;
};


export type MutationSelectAccommodationOfferArgs = {
  request: SelectAccommodationOfferRequest;
};


export type MutationSelectAncillariesArgs = {
  request: SelectAncillariesRequest;
};


export type MutationSelectAncillaryBundleArgs = {
  request: AncillaryBundleSelectionRequest;
};


export type MutationSelectFastTrackArgs = {
  request: SelectFastTrackRequest;
};


export type MutationSelectFastTrackOfferForItineraryArgs = {
  request: SelectFastTrackOfferForItineraryRequest;
};


export type MutationSelectFlashOfferArgs = {
  request: SelectFlashOfferRequest;
};


export type MutationSelectInsuranceOfferArgs = {
  request?: InputMaybe<SelectInsuranceOfferRequest>;
};


export type MutationSelectNonEssentialInsurancesProductsArgs = {
  request: SelectNonEssentialInsurancesProductsRequest;
};


export type MutationSelectNonEssentialPostsellProductsArgs = {
  request: SelectNonEssentialPostsellProductsRequest;
};


export type MutationSelectNonEssentialProductsArgs = {
  request: SelectNonEssentialProductsRequest;
};


export type MutationSelectPostBookingSubscriptionOfferArgs = {
  postBookingSubscriptionToken: SelectPostBookingSubscriptionOfferRequest;
};


export type MutationSelectUnchainedMembershipPostBookingArgs = {
  request: SelectUnchainedMembershipPostBookingRequest;
};


export type MutationSelectUnchainedMembershipPostBookingV2Args = {
  request: UnchainedMembershipOfferTokenInput;
};


export type MutationSemItinerarySelectionArgs = {
  semItinerarySelectionRequest: SemItinerarySelectionRequest;
};


export type MutationSendAuthenticationEmailArgs = {
  request: AuthenticationEmailRequest;
};


export type MutationSendAuthenticationEmailAndJoinTripAroundTheWorldContestArgs = {
  request: AuthenticationEmailWithTripAroundTheWorldContestParticipationRequest;
};


export type MutationSendChatbotEventArgs = {
  chatbotEvent: ChatbotEvent;
};


export type MutationSendChatbotFeedbackArgs = {
  chatbotFeedback: ChatbotFeedbackRequest;
};


export type MutationSendChatbotPageEventArgs = {
  chatbotPageEvent: ChatbotPageEvent;
};


export type MutationSendChatbotTextArgs = {
  chatbotText: ChatbotText;
};


export type MutationSendLoginEmailArgs = {
  loginEmailRequest: LoginEmailRequest;
};


export type MutationSendReauthenticationEmailArgs = {
  request: ReauthenticationEmailRequest;
};


export type MutationSendSetPasswordEmailArgs = {
  request: SendSetPasswordEmailRequest;
};


export type MutationShoppingBasketAddCreditCardArgs = {
  request: ShoppingBasketAddCreditCardRequest;
};


export type MutationShoppingBasketAddRedirectArgs = {
  request: ShoppingBasketAddRedirectRequest;
};


export type MutationShoppingBasketAddUserCollectionTrackingArgs = {
  request: ShoppingBasketUserCollectionTrackingRequest;
};


export type MutationShoppingBasketAddUserPaymentInteractionOutcomeArgs = {
  request: ShoppingBasketAddUserPaymentInteractionOutcomeRequest;
};


export type MutationShoppingBasketCheckoutArgs = {
  request: ShoppingBasketCheckoutRequest;
};


export type MutationShoppingBasketResumeArgs = {
  request: ShoppingBasketResumeRequest;
};


export type MutationStoreSmsConsentArgs = {
  request: StoreSmsConsentRequest;
};


export type MutationSubmitBankTransferRequestArgs = {
  bankTransferRequest: BankTransferRequest;
};


export type MutationSubscribeAccommodationSearchPriceAlertNewsletterArgs = {
  accommodationSearchPriceAlertNewsletterRequest: AccommodationSearchPriceAlertNewsletterRequest;
};


export type MutationSubscribeToFdoArgs = {
  email: Scalars['String']['input'];
};


export type MutationSubscribeToNewsletterArgs = {
  request: NewsletterSubscriptionRequest;
};


export type MutationTrackJavaScriptSnippetExecutionFinalizedArgs = {
  userPaymentInteractionId: Scalars['String']['input'];
};


export type MutationTrackJavaScriptSnippetExecutionStartedArgs = {
  userPaymentInteractionId: Scalars['String']['input'];
};


export type MutationTrackJavaScriptSnippetFinalizedArgs = {
  request: TrackJavaScriptSnippetFinalizedRequest;
};


export type MutationUnselectAccommodationInsuranceArgs = {
  request: UnselectAccommodationInsuranceRequest;
};


export type MutationUnselectFastTrackArgs = {
  request: UnselectFastTrackRequest;
};


export type MutationUnsubscribeArgs = {
  request: UnsubscriptionRequest;
};


export type MutationUpdateConsentArgs = {
  updateConsentRequest: UpdateConsentRequest;
};


export type MutationUpdateCreditCardArgs = {
  request: SaveUserCreditCardRequest;
};


export type MutationUpdateMembershipProductArgs = {
  updateMembershipProductRequest?: InputMaybe<UpdateMembershipProductRequest>;
};


export type MutationUpdateProductsInShoppingBasketArgs = {
  request?: InputMaybe<UpdateProductsInShoppingBasketRequest>;
};


export type MutationUpdatePromoCodeArgs = {
  request?: InputMaybe<PromoCodeRequest>;
};


export type MutationUpdateSubscriptionProductBinBasedArgs = {
  updateSubscriptionProductBinBasedRequest: UpdateSubscriptionProductBinBasedRequest;
};


export type MutationUpdateUserMembershipArgs = {
  updateUserMembershipRequest?: InputMaybe<UpdateUserMembershipRequest>;
};


export type MutationUpdateUserMembershipPlanArgs = {
  updateUserMembershipPlanRequest?: InputMaybe<UpdateUserMembershipPlanRequest>;
};

export type MyTripsRedirection = {
  __typename?: 'MyTripsRedirection';
  native?: Maybe<Scalars['String']['output']>;
  rToken?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export enum NagType {
  Continuance = 'CONTINUANCE',
  Reject = 'REJECT'
}

export type NativeItineraryCalendarDay = {
  __typename?: 'NativeItineraryCalendarDay';
  date: Scalars['String']['output'];
  level: NativeItineraryCalendarPriceLevel;
  price: Money;
};

export enum NativeItineraryCalendarPriceLevel {
  Average = 'AVERAGE',
  Cheap = 'CHEAP',
  High = 'HIGH'
}

export type NativeItineraryCalendarRequest = {
  adults?: InputMaybe<Scalars['Int']['input']>;
  calendarDaysFromDepartureDate?: InputMaybe<Scalars['Int']['input']>;
  children?: InputMaybe<Scalars['Int']['input']>;
  departureDate: Scalars['String']['input'];
  destinationGeoNode: Scalars['Int']['input'];
  infants?: InputMaybe<Scalars['Int']['input']>;
  originGeoNode: Scalars['Int']['input'];
  tripType: NativeItineraryCalendarTripType;
};

export type NativeItineraryCalendarResponse = {
  __typename?: 'NativeItineraryCalendarResponse';
  levels: Array<NativeItineraryCalendarDay>;
  thresholds?: Maybe<NativeItineraryCalendarThresholds>;
};

export type NativeItineraryCalendarThresholds = {
  __typename?: 'NativeItineraryCalendarThresholds';
  cheapThreshold?: Maybe<Money>;
  highThreshold?: Maybe<Money>;
};

export enum NativeItineraryCalendarTripType {
  OneWay = 'ONE_WAY',
  RoundTrip = 'ROUND_TRIP'
}

export type NavigationTree = {
  __typename?: 'NavigationTree';
  product: AncillaryProduct;
};

export type NewsletterSubscriptionRequest = {
  campaign: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type NewsletterSubscriptionResponse = {
  __typename?: 'NewsletterSubscriptionResponse';
  campaign: Scalars['String']['output'];
  email: Scalars['String']['output'];
};

export type NextDynpackFunnelPageRequest = {
  currentPage: PageInput;
  shoppingCartId: Scalars['Long']['input'];
};

export type NextFunnelPageResponse = {
  __typename?: 'NextFunnelPageResponse';
  nextPage?: Maybe<Page>;
};

export type NextItineraryFunnelPageRequest = {
  currentPage: PageInput;
  shoppingCartId: Scalars['Long']['input'];
};

export type NonEssentialInfoProduct = Product & {
  __typename?: 'NonEssentialInfoProduct';
  id?: Maybe<ProductId>;
  price?: Maybe<Money>;
  productInfo?: Maybe<NonEssentialProductsResponse>;
};

export type NonEssentialPayWithProductResponse = {
  __typename?: 'NonEssentialPayWithProductResponse';
  products: Array<Maybe<PayWithProductOffer>>;
};

export type NonEssentialProduct = {
  __typename?: 'NonEssentialProduct';
  compensation?: Maybe<Money>;
  farePrice?: Maybe<Price>;
  id?: Maybe<Scalars['String']['output']>;
  offerId: Scalars['String']['output'];
  premiumTaxPercentage?: Maybe<Scalars['Float']['output']>;
  price: Price;
  provider?: Maybe<NonEssentialProductProviderType>;
  totalCompensation?: Maybe<Money>;
  totalPrice?: Maybe<Price>;
  urls: Array<Maybe<NonEssentialProductUrl>>;
};

export type NonEssentialProductFastTrack = {
  __typename?: 'NonEssentialProductFastTrack';
  price: Price;
};

export type NonEssentialProductOffer = {
  __typename?: 'NonEssentialProductOffer';
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<NonEssentialProduct>;
  uiConfig?: Maybe<NonEssentialProductsUiConfig>;
};

export type NonEssentialProductPriceBreakDownItem = PriceBreakDownItem & {
  __typename?: 'NonEssentialProductPriceBreakDownItem';
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  offerId: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  price: Money;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export enum NonEssentialProductProviderType {
  Ace = 'ACE',
  Ami = 'AMI',
  Aon = 'AON',
  CovermoreTravelInsurance = 'COVERMORE_TRAVEL_INSURANCE',
  CoverGenius = 'COVER_GENIUS',
  CsaTravelProtection = 'CSA_TRAVEL_PROTECTION',
  EdreamsOdigeo = 'EDREAMS_ODIGEO',
  Elvia = 'ELVIA',
  Eura = 'EURA',
  EuropAssistance = 'EUROP_ASSISTANCE',
  Intermundial = 'INTERMUNDIAL',
  Ipp = 'IPP',
  Nosupp = 'NOSUPP'
}

export type NonEssentialProductUrl = {
  __typename?: 'NonEssentialProductUrl';
  url: Scalars['String']['output'];
  urlType: NonEssentialProductUrlType;
};

export enum NonEssentialProductUrlType {
  Extended = 'EXTENDED',
  ImportantProductInformation = 'IMPORTANT_PRODUCT_INFORMATION',
  IntermediationServiceAgreement = 'INTERMEDIATION_SERVICE_AGREEMENT',
  Ipid = 'IPID',
  PreContractualInformation = 'PRE_CONTRACTUAL_INFORMATION',
  PreContractualInformationSummary = 'PRE_CONTRACTUAL_INFORMATION_SUMMARY',
  Simple = 'SIMPLE',
  StatusDisclosureInformation = 'STATUS_DISCLOSURE_INFORMATION'
}

export type NonEssentialProductsIdRequest = {
  id: Scalars['String']['input'];
};

export type NonEssentialProductsModal = {
  __typename?: 'NonEssentialProductsModal';
  active: Scalars['Boolean']['output'];
  features?: Maybe<Array<Maybe<NonEssentialProductsModalFeatureType>>>;
};

export enum NonEssentialProductsModalFeatureType {
  Attachable = 'ATTACHABLE',
  Benefits = 'BENEFITS',
  DualContract = 'DUAL_CONTRACT',
  Exclusions = 'EXCLUSIONS'
}

export type NonEssentialProductsOfferResponse = {
  __typename?: 'NonEssentialProductsOfferResponse';
  additions: Array<Maybe<ServiceOptionNonEssentialProductOffer>>;
  disruptions: Array<NonEssentialProductOffer>;
  fareRules: Array<Maybe<ServiceOptionNonEssentialProductOffer>>;
  guarantees: Array<Maybe<NonEssentialProductOffer>>;
  insurances: Array<Maybe<NonEssentialProductOffer>>;
  rebooking: Array<Maybe<NonEssentialProductOffer>>;
  serviceOptions: Array<Maybe<ServiceOptionNonEssentialProductOffer>>;
};

export type NonEssentialProductsRequest = {
  bookingId: Scalars['Long']['input'];
  feeSelected?: InputMaybe<FeeSelected>;
  products: Array<InputMaybe<NonEssentialProductsIdRequest>>;
};

export type NonEssentialProductsResponse = {
  __typename?: 'NonEssentialProductsResponse';
  additions: Array<Maybe<NonEssentialProduct>>;
  disruptions: Array<NonEssentialProduct>;
  fareRules: Array<Maybe<NonEssentialProduct>>;
  fastTracks: Array<NonEssentialProductFastTrack>;
  guarantees: Array<Maybe<NonEssentialProduct>>;
  insurances: Array<Maybe<NonEssentialProduct>>;
  rebooking: Array<Maybe<NonEssentialProduct>>;
  serviceOptions: Array<Maybe<NonEssentialProduct>>;
};

export enum NonEssentialProductsThemeType {
  Default = 'DEFAULT',
  Highlight = 'HIGHLIGHT'
}

export type NonEssentialProductsUiConfig = {
  __typename?: 'NonEssentialProductsUIConfig';
  availableNags?: Maybe<Array<Maybe<NagType>>>;
  /** @deprecated Field no longer supported */
  compensation?: Maybe<Money>;
  dualContractTerms?: Maybe<Scalars['Boolean']['output']>;
  modal?: Maybe<NonEssentialProductsModal>;
  prechecked?: Maybe<Scalars['Boolean']['output']>;
  theme?: Maybe<NonEssentialProductsThemeType>;
};

export type NonPciScopeCreditCard = {
  __typename?: 'NonPciScopeCreditCard';
  last4NumberDigits: Scalars['String']['output'];
};

export type NonPciScopeCreditCardRequest = {
  paymentInstrumentToken: Scalars['String']['input'];
};

export type NonPciScopeCreditCardResponse = {
  __typename?: 'NonPciScopeCreditCardResponse';
  creditCard: NonPciScopeCreditCard;
};

export enum NotCancellableReason {
  ImmediateDeparture = 'IMMEDIATE_DEPARTURE',
  IncidentPresent = 'INCIDENT_PRESENT',
  RequestInProgress = 'REQUEST_IN_PROGRESS',
  ThirdParty = 'THIRD_PARTY',
  TripInThePast = 'TRIP_IN_THE_PAST',
  Unknown = 'UNKNOWN'
}

export type NumberRange = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

export type OfferId = {
  id: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type OfferOption = {
  __typename?: 'OfferOption';
  offerOptionId: Scalars['ID']['output'];
  plan: PlanName;
  price: Money;
  renewalPrice: Money;
  tier: MembershipTier;
};

export enum OfferType {
  PremiumPrime = 'PREMIUM_PRIME',
  RegularType = 'REGULAR_TYPE',
  StandardPrime = 'STANDARD_PRIME'
}

export type OneClickBagDeals = {
  __typename?: 'OneClickBagDeals';
  checkedBagDeals: OneClickCheckedBagDeals;
};

export type OneClickCheckedBagDeals = {
  __typename?: 'OneClickCheckedBagDeals';
  checkedBagOffers: Array<OneClickCheckedBagOffer>;
};

export type OneClickCheckedBagOffer = {
  __typename?: 'OneClickCheckedBagOffer';
  descriptor: BaggageDescriptor;
  tags: Array<CheckedBagOfferTag>;
};

export type OnwardTicket = {
  date?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PackagePriceBreakDownItem = PriceBreakDownItem & {
  __typename?: 'PackagePriceBreakDownItem';
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  providerFare?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  serviceFeeTaxes?: Maybe<Money>;
  taxes?: Maybe<Money>;
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export type PackagePriceSummary = PriceSummary & {
  __typename?: 'PackagePriceSummary';
  /** @deprecated Field no longer supported */
  amount: Money;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  nonDiscountedPricePerPassenger?: Maybe<Money>;
  nonDiscountedPricePrime?: Maybe<Money>;
  pricePerPassenger: Money;
  pricePerception: PricePerceptionConfig;
  totalPrice: Money;
};

export type Page = {
  __typename?: 'Page';
  url: Scalars['String']['output'];
};

export type PageInput = {
  url: Scalars['String']['input'];
};

export type PaginationValue = {
  maxNumBookingsByPage: Scalars['Int']['input'];
  offsetPage: Scalars['Int']['input'];
};

export type Param = {
  __typename?: 'Param';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum Partner {
  Paypal = 'PAYPAL'
}

export type PassengerSeatsSelectionRequest = {
  passenger: Scalars['Int']['input'];
  selection?: InputMaybe<Array<SelectedSeatRequest>>;
};

export type PasswordLoginRequest = {
  acceptsNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  persistentLogin?: InputMaybe<Scalars['Boolean']['input']>;
  recaptchaResponse?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordSignupRequest = {
  acceptsNewsletter: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  landingPagePath?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type PaxNumber = {
  __typename?: 'PaxNumber';
  numAdults: Scalars['Int']['output'];
  numChildren: Scalars['Int']['output'];
  numInfants: Scalars['Int']['output'];
};

export type PaxNumberInput = {
  numAdults: Scalars['Int']['input'];
  numChildren: Scalars['Int']['input'];
  numInfants: Scalars['Int']['input'];
};

export type PayAtDestinationTaxes = {
  __typename?: 'PayAtDestinationTaxes';
  taxes?: Maybe<Array<Tax>>;
  total?: Maybe<Money>;
  totalCustomerCurrency?: Maybe<Money>;
};

export type PayWithProductOffer = {
  __typename?: 'PayWithProductOffer';
  id: Scalars['String']['output'];
  nonDiscountedPrice: Money;
  offerId: Scalars['String']['output'];
  price: Money;
  urls: Array<Maybe<NonEssentialProductUrl>>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  creditCard?: Maybe<CreditCard>;
  paymentDetailsType: PaymentDetailsType;
  paymentInstrumentToken: Scalars['String']['output'];
};

export enum PaymentDetailsType {
  CreditCard = 'CREDIT_CARD',
  NoPaymentType = 'NO_PAYMENT_TYPE',
  Other = 'OTHER',
  Paypal = 'PAYPAL'
}

export enum PaymentInstrumentFilter {
  RecurringOnly = 'RECURRING_ONLY',
  UserOnly = 'USER_ONLY'
}

export enum PaymentMethod {
  Alipay = 'ALIPAY',
  Applepay = 'APPLEPAY',
  Banktransfer = 'BANKTRANSFER',
  Cash = 'CASH',
  Cofinoga = 'COFINOGA',
  Creditcard = 'CREDITCARD',
  Dotpay = 'DOTPAY',
  Elv = 'ELV',
  Giropay = 'GIROPAY',
  Googlepay = 'GOOGLEPAY',
  Ideal = 'IDEAL',
  Installment = 'INSTALLMENT',
  Klarna = 'KLARNA',
  KlarnaAccount = 'KLARNA_ACCOUNT',
  Multibanco = 'MULTIBANCO',
  Paypal = 'PAYPAL',
  Poli = 'POLI',
  Prepay = 'PREPAY',
  Samsungpay = 'SAMSUNGPAY',
  Secure3D = 'SECURE3D',
  Sepadd = 'SEPADD',
  Sofort = 'SOFORT',
  TravelAccount = 'TRAVEL_ACCOUNT',
  Trustly = 'TRUSTLY',
  Unionpay = 'UNIONPAY',
  Unknown = 'UNKNOWN'
}

export type PaymentPerception = {
  __typename?: 'PaymentPerception';
  merchant: Scalars['Boolean']['output'];
  merchantAmount: Money;
};

export type PaypalAccount = RecurringCollectionPaymentInstrument & {
  __typename?: 'PaypalAccount';
  email: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  paymentInstrumentToken: Scalars['ID']['output'];
};

export type PaypalUserPaymentInteraction = {
  __typename?: 'PaypalUserPaymentInteraction';
  merchantId?: Maybe<Scalars['String']['output']>;
  paypalToken?: Maybe<Scalars['String']['output']>;
};

export type PercentageDiscount = UserPromoCodeDiscount & {
  __typename?: 'PercentageDiscount';
  maxAmount?: Maybe<Money>;
  percentage: Scalars['Float']['output'];
};

export type Perks = {
  __typename?: 'Perks';
  alternativeItineraryDiscount?: Maybe<Money>;
  alternativeItineraryDiscountPerPassenger?: Maybe<Money>;
  extraPrimeCoupon?: Maybe<Money>;
  extraPrimeCouponPerPassenger?: Maybe<Money>;
  primeDiscount?: Maybe<Money>;
  primeDiscountPerPassenger?: Maybe<Money>;
};

export type PersonalDetails = {
  __typename?: 'PersonalDetails';
  email: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PersonalInfo = {
  __typename?: 'PersonalInfo';
  ageType?: Maybe<TravellerAgeType>;
  birthDate?: Maybe<Scalars['String']['output']>;
  firstLastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nationalityCountryCode?: Maybe<Scalars['String']['output']>;
  secondLastName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<TravellerTitleType>;
  travellerGender?: Maybe<TravellerGender>;
};

export type PersonalInfoInput = {
  ageType?: InputMaybe<TravellerAgeType>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  firstLastName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  secondLastName?: InputMaybe<Scalars['String']['input']>;
  travellerGender?: InputMaybe<TravellerGender>;
};

export type Phone = {
  __typename?: 'Phone';
  countryCode?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PhoneInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneNumber = {
  countryCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum PlanName {
  Basic = 'BASIC',
  Discovery = 'DISCOVERY',
  Employee = 'EMPLOYEE',
  Plus = 'PLUS',
  Unknown = 'UNKNOWN'
}

export type Position = {
  __typename?: 'Position';
  column: Scalars['Int']['output'];
  row: Scalars['Int']['output'];
};

export type PostBookingAncillaryBundleOfferRequest = {
  bundleTypes: Array<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type PostBookingAncillaryBundleOffersResponse = {
  __typename?: 'PostBookingAncillaryBundleOffersResponse';
  offers: Array<AncillaryBundleOffer>;
};

export type PostBookingParameter = {
  key: PostBookingParameterType;
  value: Scalars['String']['input'];
};

export enum PostBookingParameterType {
  OpenResultsMapView = 'OPEN_RESULTS_MAP_VIEW',
  SelectedPropertyId = 'SELECTED_PROPERTY_ID'
}

export type PostBookingSubscriptionOffer = {
  __typename?: 'PostBookingSubscriptionOffer';
  duration: SubscriptionOfferDuration;
  plan: SubscriptionOfferType;
  price: Money;
  renewalDuration: SubscriptionOfferDuration;
  renewalPrice: Money;
  rewards?: Maybe<Array<PostBookingSubscriptionOfferReward>>;
};

export type PostBookingSubscriptionOfferReward = {
  __typename?: 'PostBookingSubscriptionOfferReward';
  amount: Money;
  type: PostBookingSubscriptionOfferRewardType;
};

export enum PostBookingSubscriptionOfferRewardType {
  Voucher = 'VOUCHER'
}

export type PostBookingUrlRequest = {
  bookingId: Scalars['Long']['input'];
  buyPath: Scalars['Int']['input'];
  email: Scalars['String']['input'];
};

export type PostBookingUrlResponse = {
  __typename?: 'PostBookingURLResponse';
  url: Scalars['String']['output'];
};

export type PostPurchaseSubscriptionOffer = {
  __typename?: 'PostPurchaseSubscriptionOffer';
  offerInformation: PostBookingSubscriptionOffer;
  token: PostPurchaseSubscriptionToken;
};

export type PostPurchaseSubscriptionToken = {
  __typename?: 'PostPurchaseSubscriptionToken';
  token: Scalars['String']['output'];
  tokenType: PostPurchaseSubscriptionTokenType;
};

export enum PostPurchaseSubscriptionTokenType {
  Unchained = 'UNCHAINED',
  ZeroAuth = 'ZERO_AUTH'
}

export type PostsellToAdd = {
  monitoringAlertId?: InputMaybe<Array<Scalars['String']['input']>>;
  offerId: Scalars['String']['input'];
  smsNotificationId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Price = {
  __typename?: 'Price';
  perception: PricePerception;
  value: Money;
};

export type PriceAlertImageRequest = {
  geoId: Scalars['String']['input'];
};

export type PriceAlertImageResponse = {
  __typename?: 'PriceAlertImageResponse';
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type PriceAlertRequest = {
  arrivalDate: Scalars['String']['input'];
  arrivalIata: Scalars['String']['input'];
  departureDate: Scalars['String']['input'];
  departureIata: Scalars['String']['input'];
  email: Scalars['String']['input'];
  headers?: InputMaybe<Headers>;
  newsletterAccepted: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
  searchId?: InputMaybe<Scalars['Long']['input']>;
};

export type PriceBreakDownItem = {
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export enum PriceBreakDownItemType {
  Accommodation = 'ACCOMMODATION',
  Addition = 'ADDITION',
  AncillaryServiceCharges = 'ANCILLARY_SERVICE_CHARGES',
  Baggage = 'BAGGAGE',
  BrandPaymentMethodDiscount = 'BRAND_PAYMENT_METHOD_DISCOUNT',
  CabinBag = 'CABIN_BAG',
  Discount = 'DISCOUNT',
  FareRule = 'FARE_RULE',
  FastTrack = 'FAST_TRACK',
  Flight = 'FLIGHT',
  FlightAndAccommodation = 'FLIGHT_AND_ACCOMMODATION',
  HandBaggage = 'HAND_BAGGAGE',
  Insurance = 'INSURANCE',
  MembershipSubscription = 'MEMBERSHIP_SUBSCRIPTION',
  PaymentMethodFee = 'PAYMENT_METHOD_FEE',
  PromoCode = 'PROMO_CODE',
  Seat = 'SEAT',
  ServiceFee = 'SERVICE_FEE',
  ServiceOptions = 'SERVICE_OPTIONS'
}

export type PriceBreakDownRequest = {
  collectionMethodInfo?: InputMaybe<CollectionMethodInfo>;
  feeSelected?: InputMaybe<FeeSelected>;
  requestPage?: InputMaybe<PriceBreakdownPage>;
  shoppingInfo?: InputMaybe<ShoppingInfo>;
};

export type PriceBreakdown = {
  __typename?: 'PriceBreakdown';
  discount: Discount;
  price: Scalars['Float']['output'];
  pricePerNight: Scalars['Float']['output'];
  pricePerNightRounded: Scalars['Int']['output'];
  pricePerNightWithoutDiscount: Scalars['Float']['output'];
  pricePerNightWithoutDiscountRounded: Scalars['Int']['output'];
  priceRounded: Scalars['Int']['output'];
  priceWithoutDiscount: Scalars['Float']['output'];
  priceWithoutDiscountRounded: Scalars['Int']['output'];
};

export enum PriceBreakdownPage {
  Passengers = 'PASSENGERS',
  Payment = 'PAYMENT'
}

export type PriceFreezeContactDetails = {
  email: Scalars['String']['input'];
  phone: PhoneInput;
};

export type PriceFreezeEligibility = {
  __typename?: 'PriceFreezeEligibility';
  expirationDays?: Maybe<Scalars['Int']['output']>;
  isEligible: Scalars['Boolean']['output'];
};

export type PriceFreezeEligibilityRequest = {
  departureDate: Scalars['Long']['input'];
  paxNumber: PaxNumberInput;
  tripType: TripType;
};

export type PriceFreezeOffer = {
  __typename?: 'PriceFreezeOffer';
  cap: Money;
  deposit: Money;
  expirationDate: Scalars['Long']['output'];
  frozenPrice: Money;
  /** @deprecated use frozenPrice */
  frozenPrimePrice: Money;
  id: Scalars['ID']['output'];
  offerType: PriceFreezeOfferType;
  purchaseDate: Scalars['String']['output'];
};

export type PriceFreezeOfferRequest = {
  fareItineraryKey: Scalars['ID']['input'];
  searchId: Scalars['ID']['input'];
  segmentKeys: Array<Scalars['Int']['input']>;
};

export enum PriceFreezeOfferType {
  NonPrime = 'NON_PRIME',
  Prime = 'PRIME'
}

export type PriceFreezeShoppingBundleProduct = Product & {
  __typename?: 'PriceFreezeShoppingBundleProduct';
  id?: Maybe<ProductId>;
  price?: Maybe<Money>;
  productInfo?: Maybe<PriceFreezeShoppingBundleProductInfo>;
};

export type PriceFreezeShoppingBundleProductInfo = {
  __typename?: 'PriceFreezeShoppingBundleProductInfo';
  frozenPrice?: Maybe<Money>;
};

export enum PriceFreezeStatus {
  Available = 'AVAILABLE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Redeemed = 'REDEEMED',
  Selected = 'SELECTED'
}

export enum PriceLogic {
  BestPrice = 'BEST_PRICE',
  FullPrice = 'FULL_PRICE',
  MinimumPurchasePriceWithDiscount = 'MINIMUM_PURCHASE_PRICE_WITH_DISCOUNT',
  NoPrice = 'NO_PRICE'
}

export type PricePerUnit = {
  __typename?: 'PricePerUnit';
  membershipType: AncillaryPriceType;
  price: Money;
  unit: PriceUnit;
};

export type PricePerception = {
  __typename?: 'PricePerception';
  type: PricePerceptionType;
};

export enum PricePerceptionConfig {
  BestPrice = 'BEST_PRICE',
  DisplayPriceWithoutSeparatedTax = 'DISPLAY_PRICE_WITHOUT_SEPARATED_TAX',
  DisplayPriceWithSeparatedTax = 'DISPLAY_PRICE_WITH_SEPARATED_TAX',
  FullPrice = 'FULL_PRICE'
}

export enum PricePerceptionType {
  Included = 'INCLUDED',
  Perpax = 'PERPAX',
  PerpaxWithtax = 'PERPAX_WITHTAX',
  Perplan = 'PERPLAN',
  Persegment = 'PERSEGMENT',
  Total = 'TOTAL'
}

export type PriceSummary = {
  /** @deprecated Field no longer supported */
  amount: Money;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  pricePerception: PricePerceptionConfig;
  totalPrice: Money;
};

export enum PriceUnit {
  PerKg = 'PER_KG'
}

export type PrimeActiveFunnels = {
  __typename?: 'PrimeActiveFunnels';
  cars?: Maybe<Scalars['Boolean']['output']>;
  dynpack?: Maybe<Scalars['Boolean']['output']>;
  flights?: Maybe<Scalars['Boolean']['output']>;
  hotels?: Maybe<Scalars['Boolean']['output']>;
};

export type PrimeBooking = {
  bookingId: Scalars['ID']['output'];
};

export type PrimeBookingFreeCancellationRequest = {
  bookingToken: Scalars['String']['input'];
  cancellationID: Scalars['ID']['input'];
};

export type PrimeBookingFreeCancellationResponse = {
  __typename?: 'PrimeBookingFreeCancellationResponse';
  success: Scalars['Boolean']['output'];
};

export type PrimeDayConfig = {
  __typename?: 'PrimeDayConfig';
  isPrimeDayFare: Scalars['Boolean']['output'];
  primeDayFareType?: Maybe<PrimeDayFareType>;
};

export enum PrimeDayFareType {
  Bronze = 'BRONZE',
  Gold = 'GOLD',
  Silver = 'SILVER'
}

export enum PrimeDiscountType {
  Hidden = 'HIDDEN',
  NoDiscount = 'NO_DISCOUNT',
  Secret = 'SECRET',
  Visible = 'VISIBLE'
}

export type PrimeFreeCancellationCompensation = PrimeFreeVoucherCancellationCompensation;

export type PrimeFreeCancellationRequest = {
  bookingToken: Scalars['String']['input'];
};

export type PrimeFreeCancellationResponse = {
  __typename?: 'PrimeFreeCancellationResponse';
  compensation: PrimeFreeCancellationCompensation;
};

export type PrimeFreeVoucherCancellationCompensation = {
  __typename?: 'PrimeFreeVoucherCancellationCompensation';
  amount: Money;
};

export type PrimeInfo = {
  __typename?: 'PrimeInfo';
  /** @deprecated Use MembershipAccountPropertiesResponse */
  isLoggedPrimeUser: Scalars['Boolean']['output'];
  /** @deprecated Use PrimeSitePropertiesResponse */
  isPrimeSite: Scalars['Boolean']['output'];
  /** @deprecated Use MembershipAccountPropertiesResponse */
  isPrimeUser: Scalars['Boolean']['output'];
  /** @deprecated Use PrimeSitePropertiesResponse */
  isPrimeUserFromCookie: Scalars['Boolean']['output'];
};

export type PrimeMemberBuyerInfo = {
  __typename?: 'PrimeMemberBuyerInfo';
  lastNames?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PrimeMemberPlanDetails = MembershipPlanDetails & {
  __typename?: 'PrimeMemberPlanDetails';
  autoRenewalPolicy: AutoRenewalPolicy;
  duration?: Maybe<SubscriptionOfferDuration>;
  renewalDuration?: Maybe<SubscriptionOfferDuration>;
  renewalPrice?: Maybe<Money>;
  tier?: Maybe<SubscriptionOfferType>;
};

export type PrimeMembershipActivationPolicy = {
  __typename?: 'PrimeMembershipActivationPolicy';
  primeMembershipActivationRequiredIfNotPrimeMember: PrimeMembershipType;
};

export enum PrimeMembershipType {
  Plus = 'PLUS'
}

export enum PrimeOfferTierValuePropositionPerkType {
  FriendsAndFamilyItineraryDiscount = 'FRIENDS_AND_FAMILY_ITINERARY_DISCOUNT',
  ItineraryCancellationsForRenewableMembershipFreeTrialPeriodAllowed = 'ITINERARY_CANCELLATIONS_FOR_RENEWABLE_MEMBERSHIP_FREE_TRIAL_PERIOD_ALLOWED',
  ItineraryCancellationsForRenewablePaidMembershipOnly = 'ITINERARY_CANCELLATIONS_FOR_RENEWABLE_PAID_MEMBERSHIP_ONLY',
  ItineraryCancellationForSubscriptionPurchase = 'ITINERARY_CANCELLATION_FOR_SUBSCRIPTION_PURCHASE',
  OneItineraryCancellationForRenewableMembership = 'ONE_ITINERARY_CANCELLATION_FOR_RENEWABLE_MEMBERSHIP',
  UnlimitedAccommodationDiscount = 'UNLIMITED_ACCOMMODATION_DISCOUNT',
  UnlimitedBagsDiscounts = 'UNLIMITED_BAGS_DISCOUNTS',
  UnlimitedCarRentalDiscount = 'UNLIMITED_CAR_RENTAL_DISCOUNT',
  UnlimitedFastTrackDiscount = 'UNLIMITED_FAST_TRACK_DISCOUNT',
  UnlimitedItineraryDiscount = 'UNLIMITED_ITINERARY_DISCOUNT',
  UnlimitedPriceFreezeDiscount = 'UNLIMITED_PRICE_FREEZE_DISCOUNT',
  UnlimitedSeatDiscounts = 'UNLIMITED_SEAT_DISCOUNTS'
}

export type PrimeSitePropertiesResponse = {
  __typename?: 'PrimeSitePropertiesResponse';
  /** @deprecated Field no longer supported */
  activePrimeMarket: PrimeActiveFunnels;
  isPossibleReturningPrimeVisitor?: Maybe<Scalars['Boolean']['output']>;
  isPrimeMarket: Scalars['Boolean']['output'];
  /** @deprecated We're going to replace it with isPossibleReturningPrimeVisitor. Should be removed in next refactors */
  isPrimeUserFromCookies?: Maybe<Scalars['Boolean']['output']>;
  primeActiveFunnels: PrimeActiveFunnels;
};

export type PrimeSubscriptionContext = {
  shoppingInfo: ShoppingInfo;
};

export type PrimeSubscriptionOffer = {
  __typename?: 'PrimeSubscriptionOffer';
  offerItems: Array<PrimeSubscriptionOfferItem>;
};

export type PrimeSubscriptionOfferContext = {
  funnel?: InputMaybe<PrimeSubscriptionOfferContextFunnel>;
  touchpoint?: InputMaybe<PrimeSubscriptionOfferContextTouchPoint>;
};

export enum PrimeSubscriptionOfferContextFunnel {
  Accommodation = 'ACCOMMODATION',
  Itinerary = 'ITINERARY',
  PriceFreeze = 'PRICE_FREEZE'
}

export enum PrimeSubscriptionOfferContextTouchPoint {
  AccountDetails = 'ACCOUNT_DETAILS',
  EmergingLayerPaymentPage = 'EMERGING_LAYER_PAYMENT_PAGE',
  ManageBooking = 'MANAGE_BOOKING',
  MyTrips = 'MY_TRIPS',
  PriceFreeze = 'PRICE_FREEZE'
}

export type PrimeSubscriptionOfferEvaluationContext = {
  creditCardBin?: InputMaybe<Scalars['String']['input']>;
  creditCardDate?: InputMaybe<Scalars['String']['input']>;
  paymentInstrumentToken?: InputMaybe<Scalars['String']['input']>;
  selectedOfferItemRef: Scalars['String']['input'];
  shoppingInfo: ShoppingInfo;
};

export type PrimeSubscriptionOfferItem = {
  __typename?: 'PrimeSubscriptionOfferItem';
  itemRef: Scalars['String']['output'];
  planName: PrimeSubscriptionOfferItemPlanName;
  price: Money;
  tier: PrimeSubscriptionOfferItemTier;
};

export enum PrimeSubscriptionOfferItemPlanName {
  Basic = 'BASIC',
  Plus = 'PLUS'
}

export type PrimeSubscriptionOfferItemTier = {
  __typename?: 'PrimeSubscriptionOfferItemTier';
  conditions: Array<PrimeSubscriptionOfferTierCondition>;
  valueProposition: PrimeSubscriptionOfferTierValueProposition;
};

export type PrimeSubscriptionOfferTierCondition = {
  code: PrimeSubscriptionOfferTierConditionCode;
};

export enum PrimeSubscriptionOfferTierConditionCode {
  DeactivateAutoRenewal = 'DEACTIVATE_AUTO_RENEWAL',
  FreeTrialPeriod = 'FREE_TRIAL_PERIOD',
  Renewal = 'RENEWAL',
  YearlyWithMonthlyCollection = 'YEARLY_WITH_MONTHLY_COLLECTION',
  YearlyWithQuarterlyCollection = 'YEARLY_WITH_QUARTERLY_COLLECTION'
}

export type PrimeSubscriptionOfferTierFreeTrialCondition = PrimeSubscriptionOfferTierCondition & {
  __typename?: 'PrimeSubscriptionOfferTierFreeTrialCondition';
  code: PrimeSubscriptionOfferTierConditionCode;
  period: Scalars['String']['output'];
};

export type PrimeSubscriptionOfferTierRenewalCondition = PrimeSubscriptionOfferTierCondition & {
  __typename?: 'PrimeSubscriptionOfferTierRenewalCondition';
  code: PrimeSubscriptionOfferTierConditionCode;
  commitmentPeriod: Scalars['String']['output'];
  period: Scalars['String']['output'];
  price: Money;
};

export type PrimeSubscriptionOfferTierValueProposition = {
  __typename?: 'PrimeSubscriptionOfferTierValueProposition';
  perks: Array<PrimeSubscriptionOfferTierValuePropositionPerk>;
};

export type PrimeSubscriptionOfferTierValuePropositionPerk = {
  type: PrimeOfferTierValuePropositionPerkType;
};

export type PrimeSubscriptionOfferTierYearlyWithMonthlyCollectionCondition = PrimeSubscriptionOfferTierCondition & {
  __typename?: 'PrimeSubscriptionOfferTierYearlyWithMonthlyCollectionCondition';
  code: PrimeSubscriptionOfferTierConditionCode;
};

export type PrimeSubscriptionOfferTierYearlyWithQuarterlyCollectionCondition = PrimeSubscriptionOfferTierCondition & {
  __typename?: 'PrimeSubscriptionOfferTierYearlyWithQuarterlyCollectionCondition';
  code: PrimeSubscriptionOfferTierConditionCode;
};

export type PrimeSubscriptionPostPurchaseCompensation = {
  __typename?: 'PrimeSubscriptionPostPurchaseCompensation';
  amount: Money;
  type: PrimeSubscriptionPostPurchaseCompensationType;
};

export enum PrimeSubscriptionPostPurchaseCompensationType {
  Voucher = 'VOUCHER'
}

export type PrimeSubscriptionPostPurchaseOfferRequest = {
  token: Scalars['String']['input'];
};

export type PrimeSubscriptionPostPurchaseOfferResponse = {
  __typename?: 'PrimeSubscriptionPostPurchaseOfferResponse';
  compensation: Array<PrimeSubscriptionPostPurchaseCompensation>;
  eligible: Scalars['Boolean']['output'];
  planDetails: PrimeMemberPlanDetails;
};

export type PrimeSubscriptionPostPurchaseRequest = {
  token: Scalars['String']['input'];
};

export type PrimeSubscriptionPostPurchaseResponse = {
  __typename?: 'PrimeSubscriptionPostPurchaseResponse';
  accountDetails: MembershipStandaloneAccountDetails;
  compensation: Array<PrimeSubscriptionPostPurchaseCompensation>;
  planDetails: PrimeMemberPlanDetails;
  status: MembershipStandaloneResponseStatus;
};

export type PrimeSubscriptionPostPurchaseToken = {
  __typename?: 'PrimeSubscriptionPostPurchaseToken';
  token: Scalars['String']['output'];
};

export type PrimeSubscriptionPostPurchaseTokenRequest = {
  bookingId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type PrimeSubscriptionPostPurchaseTokenResponse = {
  __typename?: 'PrimeSubscriptionPostPurchaseTokenResponse';
  primeSubscriptionPostPurchaseToken: PrimeSubscriptionPostPurchaseToken;
};

export type PrimeVoucherBookingCancellationOption = BookingCancellationOption & {
  __typename?: 'PrimeVoucherBookingCancellationOption';
  amount: Money;
  id: Scalars['ID']['output'];
};

export type Product = {
  id?: Maybe<ProductId>;
  price?: Maybe<Money>;
};

export enum ProductActionResponseCode {
  ProductAdded = 'PRODUCT_ADDED',
  ProductNoAdded = 'PRODUCT_NO_ADDED',
  ProductNoOffered = 'PRODUCT_NO_OFFERED',
  ProductRequestNoValid = 'PRODUCT_REQUEST_NO_VALID',
  PromoBrandError = 'PROMO_BRAND_ERROR',
  PromoCampaignCodeInvalid = 'PROMO_CAMPAIGN_CODE_INVALID',
  PromoCampaignMaxExceeded = 'PROMO_CAMPAIGN_MAX_EXCEEDED',
  PromoCampaignMaxReached = 'PROMO_CAMPAIGN_MAX_REACHED',
  PromoCampaignMaxUsagesReached = 'PROMO_CAMPAIGN_MAX_USAGES_REACHED'
}

export type ProductForTracking = {
  __typename?: 'ProductForTracking';
  productId: Scalars['String']['output'];
  productType?: Maybe<ProductType>;
};

export type ProductId = {
  __typename?: 'ProductId';
  id: Scalars['String']['output'];
  type: ProductType;
};

export type ProductIdRequest = {
  id: Scalars['String']['input'];
  type: ProductType;
};

export type ProductSelection = {
  offerId: Scalars['String']['input'];
};

export enum ProductToApply {
  Accommodation = 'ACCOMMODATION',
  Itinerary = 'ITINERARY'
}

export enum ProductType {
  Accommodation = 'ACCOMMODATION',
  AdditionalFareRule = 'ADDITIONAL_FARE_RULE',
  AdditionalProduct = 'ADDITIONAL_PRODUCT',
  AirportFastTrack = 'AIRPORT_FAST_TRACK',
  Baggage = 'BAGGAGE',
  BoardingOption = 'BOARDING_OPTION',
  Insurance = 'INSURANCE',
  Itinerary = 'ITINERARY',
  ItineraryPriceFreeze = 'ITINERARY_PRICE_FREEZE',
  MembershipRenewal = 'MEMBERSHIP_RENEWAL',
  MembershipSubscription = 'MEMBERSHIP_SUBSCRIPTION',
  PromoCode = 'PROMO_CODE',
  RecurringPaymentInstrumentVerifier = 'RECURRING_PAYMENT_INSTRUMENT_VERIFIER',
  Seat = 'SEAT',
  ServiceOption = 'SERVICE_OPTION',
  VehicleRental = 'VEHICLE_RENTAL'
}

export type ProductsForTrackingRequest = {
  bookingToken: Scalars['String']['input'];
};

export type ProductsForTrackingResponse = {
  __typename?: 'ProductsForTrackingResponse';
  products: Array<ProductForTracking>;
};

export type PromoCode = {
  __typename?: 'PromoCode';
  amount?: Maybe<Money>;
  code: Scalars['String']['output'];
};

export enum PromoCodeActions {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type PromoCodeApplicationConditions = {
  __typename?: 'PromoCodeApplicationConditions';
  carrierConditions?: Maybe<WalletElementCarrierConditions>;
  productTypeConditions?: Maybe<WalletElementProductTypeConditions>;
  promoCodeDestinationConditions?: Maybe<PromoCodeDestinationConditions>;
  promoCodeInterfaceConditions?: Maybe<PromoCodeInterfaceConditions>;
  purchaseAmountConditions?: Maybe<WalletElementPurchaseAmountConditions>;
  usageDateConditions?: Maybe<UsageDateConditions>;
};

export type PromoCodeDestinationCondition = {
  __typename?: 'PromoCodeDestinationCondition';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PromoCodeDestinationConditions = {
  __typename?: 'PromoCodeDestinationConditions';
  destinations: Array<PromoCodeDestinationCondition>;
};

export type PromoCodeInfo = {
  __typename?: 'PromoCodeInfo';
  promoCodes?: Maybe<Array<PromoCode>>;
  totalDiscount: Money;
};

export enum PromoCodeInterfaceCondition {
  NativeAndroidEdreams = 'NATIVE_ANDROID_EDREAMS',
  NativeAndroidGov = 'NATIVE_ANDROID_GOV',
  NativeAndroidOpodo = 'NATIVE_ANDROID_OPODO',
  NativeAndroidTravellink = 'NATIVE_ANDROID_TRAVELLINK',
  NativeIosEdreams = 'NATIVE_IOS_EDREAMS',
  NativeIosGov = 'NATIVE_IOS_GOV',
  NativeIosOpodo = 'NATIVE_IOS_OPODO',
  NativeIosTravellink = 'NATIVE_IOS_TRAVELLINK',
  OneFrontDesktop = 'ONE_FRONT_DESKTOP',
  OneFrontSmartphone = 'ONE_FRONT_SMARTPHONE'
}

export type PromoCodeInterfaceConditions = {
  __typename?: 'PromoCodeInterfaceConditions';
  interfaces: Array<PromoCodeInterfaceCondition>;
};

export type PromoCodeInterfaceConditionsFilter = {
  interfaces: Array<PromoCodeInterfaceCondition>;
};

export type PromoCodePriceBreakDownItem = PriceBreakDownItem & {
  __typename?: 'PromoCodePriceBreakDownItem';
  code: Scalars['String']['output'];
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  id: Scalars['ID']['output'];
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export type PromoCodeRequest = {
  action: PromoCodeActions;
  promoCode: Array<Scalars['String']['input']>;
  shoppingInfo: ShoppingInfo;
};

export type PromoCodeResponse = {
  __typename?: 'PromoCodeResponse';
  code?: Maybe<ProductActionResponseCode>;
  promoCodeInfo?: Maybe<PromoCodeInfo>;
  success: Scalars['Boolean']['output'];
};

export type PromoCodeReward = {
  __typename?: 'PromoCodeReward';
  discount: Money;
  productToApply: ProductToApply;
};

export enum PromotedItineraryType {
  Default = 'DEFAULT',
  GreenerChoice = 'GREENER_CHOICE',
  OdiRating = 'ODI_RATING',
  Personalized = 'PERSONALIZED'
}

export type Promotion = {
  __typename?: 'Promotion';
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PropertyMappingId = {
  __typename?: 'PropertyMappingId';
  id?: Maybe<Scalars['Long']['output']>;
};

export enum PurchasedQuantity {
  All = 'ALL',
  None = 'NONE',
  Some = 'SOME'
}

export type Query = {
  __typename?: 'Query';
  accommodationCancellationOptions?: Maybe<AccommodationCancellationOption>;
  /** @deprecated Use accommodationDealsV2 instead */
  accommodationDeals: Array<AccommodationDeal>;
  /** @deprecated Use accommodationDealsV2 instead */
  accommodationDealsByDestination: Array<AccommodationDeal>;
  accommodationDealsV2: AccommodationDealsResponse;
  accommodationDetails: AccommodationDetailsResponse;
  accommodationImages: AccommodationImagesResponse;
  accommodationInsurances: AccommodationInsurancesResponse;
  accommodationModificationOptions: AccommodationModificationOptionsResponse;
  accommodationPostBookingURL: PostBookingUrlResponse;
  accommodationRecommendation: AccommodationRecommendationResponse;
  accommodationSearchDeeplinkForAccommodationProduct: HsaSearchUrlResponse;
  accommodationSearchHistory: AccommodationSearchHistoryResponse;
  accommodationSearchRoomURL: AccommodationSearchRoomUrlResponse;
  accommodationStaticContent: AccommodationStaticContentResponse;
  accommodationStaticMap: StaticMapResponse;
  accommodationSuggestion: AccommodationSuggestionResponse;
  accommodationSummary: AccommodationSummaryResponse;
  activeCampaign: ActiveCampaignResponse;
  addRedirect: InteractionFinished;
  /** @deprecated Field no longer supported */
  ancillariesRetailingEvaluation: AncillariesRetailingEvaluationResponse;
  ancillariesRetailingEvaluationNavigationTree: AncillariesRetailingEvaluationNavigationTreeResponse;
  ancillaryBundleProduct: AncillaryBundleProduct;
  ancillaryBundlesByRelatedTripProduct: AncillaryBundlesByRelatedTripProductResponse;
  ancillaryOptions: AncillaryResponse;
  ancillaryProductSelection: AncillarySelectionResponse;
  autoCompleteSearch: AutoCompleteSearchResponse;
  autoCompleteSearchV2: AutoCompleteSearchResponseV2;
  availableNonEssentialProducts: NonEssentialProductsOfferResponse;
  availablePayWithProduct: NonEssentialPayWithProductResponse;
  /** @deprecated Field no longer supported */
  boardingPasses?: Maybe<BoardingPassesResponse>;
  calculatePrimeSubscriptionOffer: CalculatePrimeSubscriptionOfferResponse;
  calculatePrimeSubscriptionPostPurchaseOffers: CalculatePrimeSubscriptionPostPurchaseOffersResponse;
  calculateReferralsOffers: CalculateReferralsOffersResponse;
  calculateSubscriptionOffer: CalculateSubscriptionOfferResponse;
  canAccessUserArea?: Maybe<UserAreaAccess>;
  canApplyItineraryDiscount: CanApplyItineraryDiscountResponse;
  checkInFunnel: CheckInFunnelResponse;
  checkInFunnelTravellerForm: CheckInFunnelTravellerFormResponse;
  checkInsStatus: CheckInsStatusResponse;
  checkUserPaymentInteraction: InteractionFinished;
  checkinAvailability?: Maybe<CheckinAvailability>;
  /** @deprecated Field no longer supported */
  checkinStatus?: Maybe<CheckinStatus>;
  convertSecretHotelId: ConvertSecretHotelIdResponse;
  creditCardDateDetailsResponse: CreditCardDateDetailsResponse;
  deals: Array<Deal>;
  decouplingPrimeSubscriptionFlowState: DecouplingPrimeSubscriptionFlowStateResponse;
  decryptCrmUserTokenForAccommodation: DecryptCrmUserTokenForAccommodationResponse;
  evaluateFeaturesEventTracking: FeaturesEventTrackingResponse;
  fareFamilies: Array<Maybe<FareFamily>>;
  favoriteAccommodationsLocation: FavoriteAccommodationsLocationResponse;
  featureVariations: Array<FeatureVariationResponse>;
  featureVariationsWithVersion: Array<FeatureVariationResponse>;
  findRelatedAccommodationTrip: FindRelatedAccommodationTripResponse;
  findVehicleRentals: VehicleRentalResponse;
  flexibleDates: FlexibleDatesSearchResponse;
  flexibleDatesPrices: FlexibleDatesPricesResponse;
  geoAccommodationAssociations: GeoAccommodationAssociationsResponse;
  geoAccommodationLocation: GeoAccommodationLocationResponse;
  geoLocationByGeoAccommodation?: Maybe<GeoLocation>;
  geolocationSuggestions: GeolocationSuggestionsResponse;
  geolocationSuggestionsByLocation: GeolocationSuggestionsByLocationResponse;
  getAccommodationRecommendationsByIataCode: AccommodationRecommendationByIataCodeResponse;
  /** @deprecated Field no longer supported */
  getAncillariesPurchaseState: AncillariesPurchaseStateResponse;
  getApplePayPaymentSession: ApplePayPaymentSession;
  getAvailableCollectionMethods: AvailableCollectionMethodsResponse;
  getCSFaqRecommendations: FaqRecommendation;
  getCSQueue: GenesysInfo;
  getCancellationPolicies: GetCancellationPoliciesResponse;
  /** @deprecated This query only supports credentials for one carrier */
  getCarrierCustomerCredentials: CarrierCustomerCredentialsResponse;
  getCarrierDocuments: CarrierDocumentsResponse;
  getCarriersCustomerCredentials: CarriersCustomerCredentialsResponse;
  getCartPriceBreakDown: CartPriceBreakDown;
  getCountries: GetCountriesResponse;
  getCreditCardBinDetails: CreditCardBinDetails;
  getEligibility: EligibilityResponse;
  getEligibilityForIncident: EligibilityForIncidentResponse;
  getEmailSuggestions: Array<Maybe<Scalars['String']['output']>>;
  getEstimatedRefundAmount: RefundAmountResponse;
  getFastTrackAvailabilities: GetFastTrackAvailabilitiesResponse;
  getFlashOffers: GetFlashOffersResponse;
  getFlexibleProductsApplicability: FlexibleProductsApplicabilityResponse;
  getGeoLocation: GeoLocation;
  /** @deprecated Obsolete call. Not in use anymore. */
  getInsuranceOffers: InsuranceOffersResponse;
  getInvoiceComponents?: Maybe<InvoiceComponents>;
  getInvoiceDetailsById?: Maybe<InvoiceDetails>;
  getInvoicesByBookingId: Array<Maybe<Invoice>>;
  getLastInvoiceRequestByBookingId?: Maybe<LastInvoiceRequestedResponse>;
  getLocationByIp: LocalizationByIpResponse;
  getLocations: GeoServiceLocationsResponse;
  getMinimalBookingInfo: MinimalBookingInfoResponse;
  getRecaptchaConfig: RecaptchaConfigResponse;
  getReferralReward: GetReferralRewardResponse;
  getShoppingBasket: ShoppingBasketResponse;
  getShoppingBasketByToken: ShoppingBasketResponse;
  getShoppingBasketPrice: ShoppingBasketPriceResponse;
  getShoppingBookingId: Scalars['ID']['output'];
  getShoppingBundle: ShoppingBundle;
  getShoppingBundleForTracking: ShoppingBundleForTracking;
  getShoppingCart: ShoppingCart;
  getShoppingSummary: ShoppingSummary;
  getSummaryInfo: ShoppingSummary;
  getSummaryPrice: PriceSummary;
  /** @deprecated Use getTravelPlansV2 instead. */
  getTravelPlans: TravelPlansResponse;
  getTravelPlansV2: TravelPlansResponseV2;
  getTravellers?: Maybe<Array<UserTraveller>>;
  getTrip: TripResponse;
  getTripByToken: TripResponse;
  getTrips: TripListResponse;
  getUniversalRevenueForTracking: UniversalRevenueForTrackingResponse;
  getUniversalShoppingBasket: UniversalShoppingBasketResponse;
  getUniversalShoppingBasketByToken: UniversalShoppingBasketResponse;
  getUniversalShoppingBasketCheckoutOptions: UniversalShoppingBasketCheckoutOptionsResponse;
  getUniversalShoppingBasketForTracking: UniversalShoppingBasketForTrackingResponse;
  getUser?: Maybe<User>;
  getUserByToken?: Maybe<User>;
  getUserCreditCards?: Maybe<UserCreditCardsResponse>;
  getVehicleRentalOffers: VehicleRentalSearchResponse;
  getVehicleRentalOffersByAccommodationId: VehicleRentalSearchResponse;
  getVehicleRentalOffersByAccommodationIdV2: VehicleRentalSearchResponse;
  getVehicleRentalOffersByItineraryId: VehicleRentalSearchResponse;
  getVehicleRentalOffersByItineraryIdV2: VehicleRentalSearchResponse;
  isAccommodationModifiable: IsAccommodationModifiableResponse;
  isCancellable: CancellableResponse;
  isModifiable: ModifiableResponse;
  isReturningCustomer: SemIsReturningCustomerResponse;
  itineraryPriceFreeze?: Maybe<ItineraryPriceFreeze>;
  itineraryPriceFreezeEligibility: PriceFreezeEligibility;
  itineraryPriceFreezeOffer?: Maybe<ItineraryPriceFreezeOffer>;
  itineraryPriceFreezeOffers: Array<ItineraryPriceFreezeOffer>;
  itineraryPriceFreezeRedemption: ItineraryPriceFreezeRedemption;
  itineraryPriceFreezeRevenueData: ItineraryPriceFreezeRevenueData;
  itineraryPriceFreezes: Array<Maybe<ItineraryPriceFreeze>>;
  itinerarySearch: ItinerarySearchResponse;
  listLoginSessions: ListLoginSessionsResponse;
  membership?: Maybe<Membership>;
  membershipAccountProperties: MembershipAccountPropertiesResponse;
  membershipChurnPrediction: MembershipChurnPredictionResponse;
  membershipPages: MembershipPagesResponse;
  membershipProduct?: Maybe<MembershipSubscriptionResponse>;
  membershipRejoinOffers: MembershipRejoinOffersResponse;
  membershipStandaloneCampaign?: Maybe<MembershipStandaloneCampaignResponse>;
  membershipStandaloneCheckoutStatus?: Maybe<MembershipStandaloneCheckoutStatusResponse>;
  membershipStandaloneOfferDetails?: Maybe<MembershipStandaloneOfferDetailsResponse>;
  membershipStandalonePersonalData?: Maybe<MembershipStandalonePersonalDataResponse>;
  nativeItineraryCalendar: NativeItineraryCalendarResponse;
  nextDynpackFunnelPage: NextFunnelPageResponse;
  nextItineraryFunnelPage: NextFunnelPageResponse;
  nonPciScopeCreditCard: NonPciScopeCreditCardResponse;
  numberOfBookingsByToken: SemNumberOfBookingsByTokenResponse;
  postBookingAncillaryBundleOffers: PostBookingAncillaryBundleOffersResponse;
  postBookingSearchAccommodation: AccommodationSearchResponse;
  /** @deprecated Not used, will be removed in next iterations */
  postBookingURL: PostBookingUrlResponse;
  priceAlert: Scalars['Boolean']['output'];
  /** @deprecated Breaking this query into others, like: primeSiteProperties */
  primeInfo: PrimeInfo;
  primeSiteProperties: PrimeSitePropertiesResponse;
  primeSubscriptionPostPurchaseOffer: PrimeSubscriptionPostPurchaseOfferResponse;
  primeSubscriptionPostPurchaseToken: PrimeSubscriptionPostPurchaseTokenResponse;
  /** @deprecated No longer in use */
  productsForTracking: ProductsForTrackingResponse;
  rData: RDataResponse;
  recogniseUser?: Maybe<RecogniseUserResponse>;
  recogniseUserForAccommodation: RecogniseUserForAccommodationResponse;
  recurringCollection: RecurringCollectionResponse;
  residentDiscountZones: ResidentDiscountResponse;
  retentionInfo?: Maybe<RetentionFlowInfoResponse>;
  /** @deprecated InsteadOf direct call, we get imageUrl by geoAccommodationLocation query */
  retrieveAccommodationPriceAlertImage: PriceAlertImageResponse;
  retrievePaypalStandaloneEligibility: RetrievePaypalStandaloneEligibilityResponse;
  retrievePostBookingSubscriptionCheckoutDetails: RetrieveSubscriptionCheckoutDetailsResponse;
  retrievePrimeFreeCancellationCompensation: PrimeFreeCancellationResponse;
  retrieveRedirect: UserPaymentInteractionRedirect;
  retrieveReferralLinkToken: SelectReferralLinkTokenResponse;
  retrieveReferralLinkTokenV2: SelectReferralLinkTokenResponseV2;
  retrieveReferralLinkTokenV2CRMFlow: SelectReferralLinkTokenResponseV2;
  /** @deprecated Field no longer supported */
  retrieveSubscriptionEligibilityOfferDetails: RetrieveSubscriptionEligibilityOfferDetailsResponse;
  retrieveUnchainedMembershipPostBookingEligibility: RetrieveUnchainedMembershipPostBookingEligibilityResponse;
  retrieveUserPaymentInteraction: UserPaymentInteraction;
  retrieveVoluntaryCancellationOptions: VoluntaryCancellationOptionsRetrievementResponse;
  roomDetailsStatic: RoomsDetailResponse;
  /** @deprecated Not used anymore since the payload reduction development rollout */
  search: SearchResponse;
  searchAccommodation: AccommodationSearchResponse;
  searchAccommodationAsync: AccommodationSearchAsyncResponse;
  /** @deprecated The query accommodationStaticContent is no longer used */
  searchAccommodationByDedupId: AccommodationSearchResponse;
  /** @deprecated InsteadOf direct call, we reach geo-accommodation by searchAccommodation */
  searchAccommodationByGeoAccommodation: GeoAccommodationSearchResponse;
  searchAccommodationBySearchId: AccommodationSearchResponse;
  searchAlternativesForIncident: SearchAlternativesForIncidentResponse;
  searchCriteria: SearchCriteria;
  searchFastTrackOffers: SearchFastTrackOffersResponse;
  searchFastTracksByItinerary: SearchFastTracksByItineraryResponse;
  searchItinerary: SearchItineraryResponse;
  searchItineraryAlternatives: ItinerarySearchAlternativeResponse;
  searchRoomAvailability: SearchRoomAvailabilityResponse;
  searchRoomDetails: AccommodationDetailResponse;
  searchTrains: SearchItineraryResponse;
  selectMembershipStandaloneReferral: SelectMembershipStandaloneReferralResponse;
  semItinerarySearch: SemItinerariesSearchResponse;
  semSearch: SemSearchResponse;
  shoppingBasketFastTrackProducts: ShoppingBasketFastTrackProductsResponse;
  shoppingBasketIdToToken: ShoppingBasketToken;
  shoppingBasketTokenByPayByLinkContentId: ShoppingBasketTokenByPayByLinkContentIdResponse;
  shoppingBasketUserPaymentInteraction: ShoppingBasketUserPaymentInteractionResponse;
  shoppingBasketUserStoredCreditCards: ShoppingBasketUserStoredCreditCardsResponse;
  subscriptionOfferById?: Maybe<SubscriptionResponse>;
  subscriptionOffers: Array<SubscriptionResponse>;
  tokenInfo?: Maybe<MembershipTokenResponse>;
  topDestinations: Array<Maybe<TopDestination>>;
  touchPointMessaging: TouchPointMessagingResponse;
  tripadvisorReview: TripadvisorReviewResponse;
  trustpilotParams: TrustpilotParamsResponse;
  userAccount?: Maybe<UserAccountResponse>;
  userInfo?: Maybe<UserInfo>;
  userSegment?: Maybe<UserSegmentResponse>;
  variations: Array<Maybe<Scalars['Int']['output']>>;
};


export type QueryAccommodationCancellationOptionsArgs = {
  bookingId: Scalars['Long']['input'];
  isPrime: Scalars['Boolean']['input'];
};


export type QueryAccommodationDealsArgs = {
  request: AccommodationDealRequest;
};


export type QueryAccommodationDealsByDestinationArgs = {
  request: AccommodationDealByDestinationRequest;
};


export type QueryAccommodationDealsV2Args = {
  request: AccommodationDealRequest;
};


export type QueryAccommodationDetailsArgs = {
  accommodationDetailsRequest: AccommodationDetailsRequest;
};


export type QueryAccommodationImagesArgs = {
  accommodationImagesRequest: AccommodationImagesRequest;
};


export type QueryAccommodationInsurancesArgs = {
  request: AccommodationInsurancesRequest;
};


export type QueryAccommodationModificationOptionsArgs = {
  accommodationModificationOptionsRequest: AccommodationModificationOptionsRequest;
};


export type QueryAccommodationPostBookingUrlArgs = {
  postBookingURLRequest: AccommodationPostBookingUrlRequest;
};


export type QueryAccommodationRecommendationArgs = {
  accommodationRecommendationRequest: AccommodationRecommendationRequest;
};


export type QueryAccommodationSearchDeeplinkForAccommodationProductArgs = {
  searchRequest: HsaSearchUrlRequest;
};


export type QueryAccommodationSearchHistoryArgs = {
  accommodationSearchHistoryRequest: AccommodationSearchHistoryRequest;
};


export type QueryAccommodationSearchRoomUrlArgs = {
  accommodationRoomSearchRequest: AccommodationSearchRoomUrlRequest;
};


export type QueryAccommodationStaticContentArgs = {
  accommodationStaticContentRequest: AccommodationStaticContentRequest;
};


export type QueryAccommodationStaticMapArgs = {
  accommodationStaticMapRequest: AccommodationStaticMapRequest;
};


export type QueryAccommodationSuggestionArgs = {
  accommodationSuggestionRequest: AccommodationSuggestionRequest;
};


export type QueryAccommodationSummaryArgs = {
  accommodationSummaryRequest: AccommodationSummaryRequest;
};


export type QueryAddRedirectArgs = {
  request: UserPaymentInteractionRedirectRequest;
};


export type QueryAncillariesRetailingEvaluationArgs = {
  request: AncillariesRetailingEvaluationRequest;
};


export type QueryAncillariesRetailingEvaluationNavigationTreeArgs = {
  request: AncillariesRetailingEvaluationRequest;
};


export type QueryAncillaryBundleProductArgs = {
  request: AncillaryBundleProductRequest;
};


export type QueryAncillaryBundlesByRelatedTripProductArgs = {
  request: AncillaryBundlesByRelatedTripProductRequest;
};


export type QueryAncillaryOptionsArgs = {
  bookingID?: InputMaybe<Scalars['ID']['input']>;
  flow: AncillaryFlowType;
};


export type QueryAncillaryProductSelectionArgs = {
  productId: ProductIdRequest;
};


export type QueryAutoCompleteSearchArgs = {
  autoCompleteSearchRequest?: InputMaybe<AutoCompleteSearchRequest>;
};


export type QueryAutoCompleteSearchV2Args = {
  autoCompleteSearchRequest: AutoCompleteSearchRequestV2;
};


export type QueryAvailableNonEssentialProductsArgs = {
  request: NonEssentialProductsRequest;
};


export type QueryAvailablePayWithProductArgs = {
  request?: InputMaybe<PriceBreakDownRequest>;
};


export type QueryBoardingPassesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCalculatePrimeSubscriptionOfferArgs = {
  request: CalculatePrimeSubscriptionOfferRequest;
};


export type QueryCalculatePrimeSubscriptionPostPurchaseOffersArgs = {
  request: CalculatePrimeSubscriptionPostPurchaseOffersRequest;
};


export type QueryCalculateReferralsOffersArgs = {
  request: CalculateReferralsOffersRequest;
};


export type QueryCalculateSubscriptionOfferArgs = {
  request: CalculateSubscriptionOfferRequest;
};


export type QueryCanApplyItineraryDiscountArgs = {
  request: CanApplyItineraryDiscountRequest;
};


export type QueryCheckInFunnelArgs = {
  request: CheckInFunnelRequest;
};


export type QueryCheckInFunnelTravellerFormArgs = {
  request: CheckInFunnelTravellerFormRequest;
};


export type QueryCheckInsStatusArgs = {
  request: CheckInsStatusRequest;
};


export type QueryCheckUserPaymentInteractionArgs = {
  request?: InputMaybe<UserPaymentInteractionRequest>;
};


export type QueryCheckinAvailabilityArgs = {
  bookingID?: InputMaybe<Scalars['ID']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckinStatusArgs = {
  bookingID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryConvertSecretHotelIdArgs = {
  convertSecretHotelIdRequest: ConvertSecretHotelIdRequest;
};


export type QueryCreditCardDateDetailsResponseArgs = {
  date: Scalars['String']['input'];
};


export type QueryDealsArgs = {
  request?: InputMaybe<DealsRequest>;
};


export type QueryDecouplingPrimeSubscriptionFlowStateArgs = {
  request: DecouplingPrimeSubscriptionFlowStateRequest;
};


export type QueryDecryptCrmUserTokenForAccommodationArgs = {
  request: DecryptCrmUserTokenForAccommodationRequest;
};


export type QueryEvaluateFeaturesEventTrackingArgs = {
  feature: FeaturesEventTrackingRequest;
};


export type QueryFareFamiliesArgs = {
  fareFamilyRequest: FareFamilyRequest;
};


export type QueryFeatureVariationsArgs = {
  aliases: Array<FeatureVariationRequest>;
};


export type QueryFeatureVariationsWithVersionArgs = {
  aliases: Array<FeatureVariationRequestWithVersion>;
};


export type QueryFindRelatedAccommodationTripArgs = {
  findRelatedAccommodationTripRequest: FindRelatedAccommodationTripRequest;
};


export type QueryFindVehicleRentalsArgs = {
  vehicleRentalFindFilter: VehicleRentalFindRequest;
};


export type QueryFlexibleDatesArgs = {
  flexibleDatesSearchRequest?: InputMaybe<FlexibleDatesSearchRequest>;
};


export type QueryFlexibleDatesPricesArgs = {
  flexibleDatesPricesRequest?: InputMaybe<FlexibleDatesPricesRequest>;
};


export type QueryGeoAccommodationAssociationsArgs = {
  geoAccommodationAssociationsRequest: GeoAccommodationAssociationsRequest;
};


export type QueryGeoAccommodationLocationArgs = {
  geoAccommodationLocationRequest: GeoAccommodationLocationRequest;
};


export type QueryGeoLocationByGeoAccommodationArgs = {
  geoAccommodation: GeoAccommodationRequest;
};


export type QueryGeolocationSuggestionsArgs = {
  geolocationSuggestionsRequest?: InputMaybe<GeolocationSuggestionsRequest>;
};


export type QueryGeolocationSuggestionsByLocationArgs = {
  geolocationSuggestionsByLocationRequest?: InputMaybe<GeolocationSuggestionsByLocationRequest>;
};


export type QueryGetAccommodationRecommendationsByIataCodeArgs = {
  accommodationRecommendationByIataCodeRequest?: InputMaybe<AccommodationRecommendationByIataCodeRequest>;
};


export type QueryGetAncillariesPurchaseStateArgs = {
  request: GetAncillariesPurchaseStateRequest;
};


export type QueryGetApplePayPaymentSessionArgs = {
  request: ApplePayPaymentSessionRequest;
};


export type QueryGetAvailableCollectionMethodsArgs = {
  request?: InputMaybe<AvailableCollectionMethodsRequest>;
};


export type QueryGetCsFaqRecommendationsArgs = {
  bookingId: Scalars['Long']['input'];
};


export type QueryGetCsQueueArgs = {
  queueRequest: QueueRequest;
};


export type QueryGetCancellationPoliciesArgs = {
  request: GetCancellationPoliciesRequest;
};


export type QueryGetCarrierCustomerCredentialsArgs = {
  request: CarrierCustomerCredentialsRequest;
};


export type QueryGetCarrierDocumentsArgs = {
  request: CarrierDocumentsRequest;
};


export type QueryGetCarriersCustomerCredentialsArgs = {
  request: CarrierCustomerCredentialsRequest;
};


export type QueryGetCartPriceBreakDownArgs = {
  request?: InputMaybe<PriceBreakDownRequest>;
};


export type QueryGetCountriesArgs = {
  getCountriesRequest?: InputMaybe<GetCountriesRequest>;
};


export type QueryGetCreditCardBinDetailsArgs = {
  bin: Scalars['String']['input'];
};


export type QueryGetEligibilityArgs = {
  bookingId: Scalars['Long']['input'];
  bookingItemId: Scalars['Long']['input'];
  providerBookingItemId?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryGetEligibilityForIncidentArgs = {
  eligibilityForIncidentRequest: EligibilityForIncidentRequest;
};


export type QueryGetEmailSuggestionsArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetEstimatedRefundAmountArgs = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};


export type QueryGetFastTrackAvailabilitiesArgs = {
  request: GetFastTrackAvailabilitiesRequest;
};


export type QueryGetFlexibleProductsApplicabilityArgs = {
  flexibleProductsApplicabilityRequest: FlexibleProductsApplicabilityRequest;
};


export type QueryGetGeoLocationArgs = {
  geoNodeId: Scalars['Int']['input'];
};


export type QueryGetInsuranceOffersArgs = {
  request?: InputMaybe<InsuranceOffersRequest>;
};


export type QueryGetInvoiceComponentsArgs = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};


export type QueryGetInvoiceDetailsByIdArgs = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
};


export type QueryGetInvoicesByBookingIdArgs = {
  bookingId: Scalars['Long']['input'];
};


export type QueryGetLastInvoiceRequestByBookingIdArgs = {
  bookingInvoicesRequest: BookingInvoicesRequest;
};


export type QueryGetLocationByIpArgs = {
  ip?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLocationsArgs = {
  locationsRequest: GeoServiceLocationsRequest;
};


export type QueryGetMinimalBookingInfoArgs = {
  request?: InputMaybe<MinimalBookingInfoRequest>;
};


export type QueryGetReferralRewardArgs = {
  request: GetReferralRewardRequest;
};


export type QueryGetShoppingBasketArgs = {
  request?: InputMaybe<ShoppingBasketRequest>;
};


export type QueryGetShoppingBasketByTokenArgs = {
  shoppingBasketToken: Scalars['String']['input'];
};


export type QueryGetShoppingBasketPriceArgs = {
  request: ShoppingBasketPriceRequest;
};


export type QueryGetShoppingBookingIdArgs = {
  request?: InputMaybe<GetShoppingBookingIdRequest>;
};


export type QueryGetShoppingBundleArgs = {
  request?: InputMaybe<ShoppingBundleRequest>;
};


export type QueryGetShoppingBundleForTrackingArgs = {
  request?: InputMaybe<ShoppingBundleForTrackingRequest>;
};


export type QueryGetShoppingCartArgs = {
  bookingId: Scalars['Long']['input'];
};


export type QueryGetShoppingSummaryArgs = {
  request: ShoppingSummaryRequest;
};


export type QueryGetSummaryInfoArgs = {
  request: ShoppingInfo;
};


export type QueryGetSummaryPriceArgs = {
  request: ShoppingSummaryRequest;
};


export type QueryGetTripArgs = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
  filter?: InputMaybe<TripFilter>;
};


export type QueryGetTripByTokenArgs = {
  filter?: InputMaybe<TripFilter>;
  token: Scalars['String']['input'];
};


export type QueryGetTripsArgs = {
  filter?: InputMaybe<TripListFilter>;
  pagination?: InputMaybe<PaginationValue>;
};


export type QueryGetUniversalRevenueForTrackingArgs = {
  request: UniversalRevenueForTrackingRequest;
};


export type QueryGetUniversalShoppingBasketArgs = {
  request: UniversalShoppingBasketRequest;
};


export type QueryGetUniversalShoppingBasketByTokenArgs = {
  request: UniversalShoppingBasketByTokenRequest;
};


export type QueryGetUniversalShoppingBasketCheckoutOptionsArgs = {
  request: UniversalShoppingBasketCheckoutOptionsRequest;
};


export type QueryGetUniversalShoppingBasketForTrackingArgs = {
  request: UniversalShoppingBasketRequest;
};


export type QueryGetUserByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetVehicleRentalOffersArgs = {
  vehicleSearchCriteriaRequest: VehicleSearchCriteriaRequest;
};


export type QueryGetVehicleRentalOffersByAccommodationIdArgs = {
  vehicleRentalSearchRequest: VehicleRentalSearchRequest;
};


export type QueryGetVehicleRentalOffersByAccommodationIdV2Args = {
  vehicleRentalSearchRequest: VehicleRentalSearchRequestByAccommodationV2;
};


export type QueryGetVehicleRentalOffersByItineraryIdArgs = {
  vehicleRentalSearchRequest: VehicleRentalSearchRequest;
};


export type QueryGetVehicleRentalOffersByItineraryIdV2Args = {
  vehicleRentalSearchRequest: VehicleRentalSearchRequestV2;
};


export type QueryIsAccommodationModifiableArgs = {
  isAccommodationModifiableRequest: AccommodationModificationOptionsRequest;
};


export type QueryIsCancellableArgs = {
  request: CancellableRequest;
};


export type QueryIsModifiableArgs = {
  request: ModifiableRequest;
};


export type QueryIsReturningCustomerArgs = {
  request: SemIsReturningCustomerRequest;
};


export type QueryItineraryPriceFreezeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryItineraryPriceFreezeEligibilityArgs = {
  priceFreezeEligibilityRequest: PriceFreezeEligibilityRequest;
};


export type QueryItineraryPriceFreezeOfferArgs = {
  offerRequest: PriceFreezeOfferRequest;
};


export type QueryItineraryPriceFreezeOffersArgs = {
  offerRequest: PriceFreezeOfferRequest;
};


export type QueryItineraryPriceFreezeRedemptionArgs = {
  itineraryPriceFreezeRedemptionRequest?: InputMaybe<ItineraryPriceFreezeRedemptionRequest>;
};


export type QueryItineraryPriceFreezeRevenueDataArgs = {
  itineraryPriceFreezeRevenueDataRequest?: InputMaybe<ItineraryPriceFreezeRevenueDataRequest>;
};


export type QueryItineraryPriceFreezesArgs = {
  itineraryPriceFreezesRequest?: InputMaybe<ItineraryPriceFreezesRequest>;
};


export type QueryItinerarySearchArgs = {
  searchRequest: SearchRequest;
};


export type QueryMembershipArgs = {
  membershipRequest?: InputMaybe<MembershipRequest>;
};


export type QueryMembershipAccountPropertiesArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMembershipChurnPredictionArgs = {
  membershipChurnPredictionRequest: MembershipChurnPredictionRequest;
};


export type QueryMembershipPagesArgs = {
  membershipPagesRequest?: InputMaybe<MembershipPagesRequest>;
};


export type QueryMembershipProductArgs = {
  membershipProductRequest?: InputMaybe<GetMembershipProductRequest>;
};


export type QueryMembershipStandaloneCampaignArgs = {
  request?: InputMaybe<MembershipStandaloneCampaignRequest>;
};


export type QueryMembershipStandaloneCheckoutStatusArgs = {
  request?: InputMaybe<MembershipStandaloneCheckoutStatusRequest>;
};


export type QueryMembershipStandaloneOfferDetailsArgs = {
  request?: InputMaybe<MembershipStandaloneOfferDetailsRequest>;
};


export type QueryMembershipStandalonePersonalDataArgs = {
  request?: InputMaybe<MembershipStandalonePersonalDataRequest>;
};


export type QueryNativeItineraryCalendarArgs = {
  nativeItineraryCalendarRequest?: InputMaybe<NativeItineraryCalendarRequest>;
};


export type QueryNextDynpackFunnelPageArgs = {
  request: NextDynpackFunnelPageRequest;
};


export type QueryNextItineraryFunnelPageArgs = {
  request: NextItineraryFunnelPageRequest;
};


export type QueryNonPciScopeCreditCardArgs = {
  request: NonPciScopeCreditCardRequest;
};


export type QueryNumberOfBookingsByTokenArgs = {
  request: SemNumberOfBookingsByTokenRequest;
};


export type QueryPostBookingAncillaryBundleOffersArgs = {
  request: PostBookingAncillaryBundleOfferRequest;
};


export type QueryPostBookingSearchAccommodationArgs = {
  accommodationPostBookingSearchRequest: AccommodationPostBookingSearchRequest;
};


export type QueryPostBookingUrlArgs = {
  postBookingURLRequest: PostBookingUrlRequest;
};


export type QueryPriceAlertArgs = {
  priceAlertRequest: PriceAlertRequest;
};


export type QueryPrimeInfoArgs = {
  headers?: InputMaybe<Headers>;
};


export type QueryPrimeSubscriptionPostPurchaseOfferArgs = {
  request: PrimeSubscriptionPostPurchaseOfferRequest;
};


export type QueryPrimeSubscriptionPostPurchaseTokenArgs = {
  request: PrimeSubscriptionPostPurchaseTokenRequest;
};


export type QueryProductsForTrackingArgs = {
  request: ProductsForTrackingRequest;
};


export type QueryRDataArgs = {
  request: RDataRequest;
};


export type QueryRecurringCollectionArgs = {
  recurringCollectionId: Scalars['ID']['input'];
};


export type QueryResidentDiscountZonesArgs = {
  request?: InputMaybe<ResidentDiscountRequest>;
};


export type QueryRetrieveAccommodationPriceAlertImageArgs = {
  priceAlertImageRequest: PriceAlertImageRequest;
};


export type QueryRetrievePostBookingSubscriptionCheckoutDetailsArgs = {
  request: RetrieveSubscriptionCheckoutDetailsRequest;
};


export type QueryRetrievePrimeFreeCancellationCompensationArgs = {
  request: PrimeFreeCancellationRequest;
};


export type QueryRetrieveRedirectArgs = {
  request: UserPaymentInteractionRequest;
};


export type QueryRetrieveReferralLinkTokenV2CrmFlowArgs = {
  request: SelectReferralLinkTokenRequestV2CrmFlow;
};


export type QueryRetrieveSubscriptionEligibilityOfferDetailsArgs = {
  request: RetrieveSubscriptionEligibilityOfferDetailsRequest;
};


export type QueryRetrieveUnchainedMembershipPostBookingEligibilityArgs = {
  request: RetrieveUnchainedMembershipPostBookingEligibilityRequest;
};


export type QueryRetrieveUserPaymentInteractionArgs = {
  request?: InputMaybe<UserPaymentInteractionRequest>;
};


export type QueryRetrieveVoluntaryCancellationOptionsArgs = {
  request: VoluntaryCancellationOptionsRetrievementRequest;
};


export type QueryRoomDetailsStaticArgs = {
  roomDetailsRequest: RoomsDetailRequest;
};


export type QuerySearchArgs = {
  searchRequest: SearchRequest;
};


export type QuerySearchAccommodationArgs = {
  accommodationSearchRequest: AccommodationSearchRequest;
};


export type QuerySearchAccommodationAsyncArgs = {
  accommodationSearchAsyncRequest: AccommodationSearchAsyncRequest;
};


export type QuerySearchAccommodationByDedupIdArgs = {
  accommodationSearchByDedupIdRequest: AccommodationSearchByDedupIdRequest;
};


export type QuerySearchAccommodationByGeoAccommodationArgs = {
  geoAccommodationRequest?: InputMaybe<GeoAccommodationSearchRequest>;
};


export type QuerySearchAccommodationBySearchIdArgs = {
  accommodationSearchBySearchIdRequest: AccommodationSearchBySearchIdRequest;
};


export type QuerySearchAlternativesForIncidentArgs = {
  searchAlternativesForIncidentRequest: SearchAlternativesForIncidentRequest;
};


export type QuerySearchCriteriaArgs = {
  searchId: Scalars['Long']['input'];
};


export type QuerySearchFastTrackOffersArgs = {
  request: SearchFastTrackOffersRequest;
};


export type QuerySearchFastTracksByItineraryArgs = {
  request: SearchFastTracksByItineraryRequest;
};


export type QuerySearchItineraryArgs = {
  searchItineraryRequest: SearchItineraryRequest;
};


export type QuerySearchItineraryAlternativesArgs = {
  itinerarySearchAlternativeRequest: ItinerarySearchAlternativeRequest;
};


export type QuerySearchRoomAvailabilityArgs = {
  searchRoomAvailabilityRequest: SearchRoomAvailabilityRequest;
};


export type QuerySearchRoomDetailsArgs = {
  roomDetailsRequest: AccommodationDetailRequest;
};


export type QuerySearchTrainsArgs = {
  searchTrainsRequest: SearchTrainsRequest;
};


export type QuerySelectMembershipStandaloneReferralArgs = {
  request: SelectMembershipStandaloneReferralRequest;
};


export type QuerySemItinerarySearchArgs = {
  semItinerariesSearchRequest: SemItinerariesSearchRequest;
};


export type QuerySemSearchArgs = {
  semSearchRequest: SemSearchRequest;
};


export type QueryShoppingBasketFastTrackProductsArgs = {
  request: ShoppingBasketFastTrackProductsRequest;
};


export type QueryShoppingBasketIdToTokenArgs = {
  membershipId: Scalars['String']['input'];
};


export type QueryShoppingBasketTokenByPayByLinkContentIdArgs = {
  shoppingBasketTokenByPayByLinkContentIdRequest: ShoppingBasketTokenByPayByLinkContentIdRequest;
};


export type QueryShoppingBasketUserPaymentInteractionArgs = {
  request: ShoppingBasketUserPaymentInteractionRequest;
};


export type QueryShoppingBasketUserStoredCreditCardsArgs = {
  request: ShoppingBasketUserStoredCreditCardsRequest;
};


export type QuerySubscriptionOfferByIdArgs = {
  offerId: Scalars['String']['input'];
};


export type QuerySubscriptionOffersArgs = {
  request?: InputMaybe<SubscriptionOffersRequest>;
};


export type QueryTokenInfoArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTripadvisorReviewArgs = {
  tripadvisorReviewRequest: TripadvisorReviewRequest;
};


export type QueryUserAccountArgs = {
  userAccountRequest?: InputMaybe<UserAccountRequest>;
};


export type QueryVariationsArgs = {
  aliases: Array<InputMaybe<Scalars['String']['input']>>;
};

export type Queue = {
  __typename?: 'Queue';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: QueueStatus;
};

export type QueueRequest = {
  bookingId?: InputMaybe<Scalars['Long']['input']>;
  type: QueueRequestType;
};

export enum QueueRequestType {
  HsaMmb = 'HSA_MMB'
}

export enum QueueStatus {
  Open = 'OPEN',
  OutsideWorkingHours = 'OUTSIDE_WORKING_HOURS'
}

export type RDataRequest = {
  products: Array<InputMaybe<ProductIdRequest>>;
};

export type RDataResponse = {
  __typename?: 'RDataResponse';
  rMarketing: Scalars['Float']['output'];
  rSem: Scalars['Float']['output'];
};

export type ReactivationVoucherResponse = {
  __typename?: 'ReactivationVoucherResponse';
  code: VoucherCodeType;
};

export type ReauthenticationEmailRequest = {
  fallbackLandingPagePath?: InputMaybe<Scalars['String']['input']>;
  landingPagePath?: InputMaybe<Scalars['String']['input']>;
};

export type ReauthenticationEmailResponse = {
  __typename?: 'ReauthenticationEmailResponse';
  acknowledged: Scalars['Boolean']['output'];
};

export type RebuildAccommodationOfferRequest = {
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  contentKey: Scalars['String']['input'];
  dedupId: Scalars['Int']['input'];
  destination: LocationRequest;
  mainProduct?: InputMaybe<MainProduct>;
  roomGroupKey: Scalars['String']['input'];
  roomRequests: Array<RoomRequest>;
  searchType: AccommodationSearchType;
  selectedCustomerPriceType: CustomerPriceType;
  upsell?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Long']['input']>;
};

export type RebuildAccommodationOfferResponse = {
  __typename?: 'RebuildAccommodationOfferResponse';
  responseType: RebuildAccommodationOfferResponseType;
  searchId?: Maybe<Scalars['Long']['output']>;
  shoppingId?: Maybe<Scalars['ID']['output']>;
};

export enum RebuildAccommodationOfferResponseType {
  NoAccommodationAvailable = 'NO_ACCOMMODATION_AVAILABLE',
  NoRoomAvailable = 'NO_ROOM_AVAILABLE',
  NoRoomRateAvailable = 'NO_ROOM_RATE_AVAILABLE',
  Success = 'SUCCESS'
}

export type RecaptchaConfigResponse = {
  __typename?: 'RecaptchaConfigResponse';
  recaptchaV2: RecaptchaConfigV2;
  recaptchaV3: RecaptchaConfigV3;
};

export type RecaptchaConfigV2 = {
  __typename?: 'RecaptchaConfigV2';
  isEnabled: Scalars['Boolean']['output'];
  siteKey: Scalars['String']['output'];
};

export type RecaptchaConfigV3 = {
  __typename?: 'RecaptchaConfigV3';
  isEnabled: Scalars['Boolean']['output'];
  siteKey: Scalars['String']['output'];
};

export type RecogniseUserForAccommodationResponse = {
  __typename?: 'RecogniseUserForAccommodationResponse';
  accommodationRecognisedUser?: Maybe<AccommodationRecognisedUser>;
  recognised: Scalars['Boolean']['output'];
};

export type RecogniseUserResponse = {
  __typename?: 'RecogniseUserResponse';
  /** @deprecated old name, recognised instead */
  isRecognised: Scalars['Boolean']['output'];
  recognised: Scalars['Boolean']['output'];
};

export type RecoverPasswordRequest = {
  email: Scalars['String']['input'];
  recaptchaResponse?: InputMaybe<Scalars['String']['input']>;
};

export type RecoverPasswordResponse = {
  __typename?: 'RecoverPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type RecurringCollectionPaymentInstrument = {
  isDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type RecurringCollectionResponse = {
  __typename?: 'RecurringCollectionResponse';
  id: Scalars['ID']['output'];
  paymentInstruments?: Maybe<Array<Maybe<RecurringCollectionPaymentInstrument>>>;
};

export enum RecurringPaymentInstrumentVerifierProductEvaluationCode {
  BlockingBin = 'BLOCKING_BIN',
  ExistingPaymentInstrumentToken = 'EXISTING_PAYMENT_INSTRUMENT_TOKEN',
  ExpiringBeforeMembershipRenewal = 'EXPIRING_BEFORE_MEMBERSHIP_RENEWAL',
  NoRisk = 'NO_RISK'
}

export type RecurringPaymentInstrumentVerifierProductEvaluationRequest = {
  creditCardBin: Scalars['String']['input'];
  /** @deprecated Not used, will be removed in next iterations */
  creditCardExpirationDate?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not used, will be removed in next iterations */
  membershipId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not used, will be removed in next iterations */
  paymentInstrumentToken?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringPaymentInstrumentVerifierProductEvaluationResponse = {
  __typename?: 'RecurringPaymentInstrumentVerifierProductEvaluationResponse';
  code: RecurringPaymentInstrumentVerifierProductEvaluationCode;
};

export type RecurringPaymentInstrumentVerifierShoppingBasketCreationRequest = {
  crmToken: Scalars['String']['input'];
};

export type RecurringPaymentInstrumentVerifierShoppingBasketCreationResponse = {
  __typename?: 'RecurringPaymentInstrumentVerifierShoppingBasketCreationResponse';
  shoppingBasketId: Scalars['ID']['output'];
};

export type RedemptionPolicy = {
  __typename?: 'RedemptionPolicy';
  primeMembershipRequired: Scalars['Boolean']['output'];
};

export enum RedirectType {
  Iframe = 'IFRAME',
  Page = 'PAGE'
}

export type ReferralLinkToken = {
  __typename?: 'ReferralLinkToken';
  token: Scalars['String']['output'];
};

export type ReferralReward = {
  __typename?: 'ReferralReward';
  referred: Array<Compensation>;
  referrer: Array<Compensation>;
};

export enum ReferralStandaloneResponseStatus {
  Init = 'INIT',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type ReferralSubscription = {
  __typename?: 'ReferralSubscription';
  durationPolicy: DurationPolicy;
  freeTrial: Scalars['Boolean']['output'];
  offerId: Scalars['String']['output'];
  subscriptionPlan: SubscriptionOfferType;
  subscriptionPrice: SubscriptionPrice;
};

export type ReferralSubscriptionOffer = {
  __typename?: 'ReferralSubscriptionOffer';
  durationPolicy: DurationPolicy;
  freeTrial: Scalars['Boolean']['output'];
  plan: SubscriptionOfferType;
};

export type RefundAmountResponse = {
  __typename?: 'RefundAmountResponse';
  /** @deprecated used for backward compatibility */
  amount: Scalars['Float']['output'];
  basedOnFareRules: Scalars['Boolean']['output'];
  /** @deprecated used for backward compatibility */
  currency: Scalars['String']['output'];
  refundAmount: Money;
};

export enum RefundType {
  FreeRefundable = 'FREE_REFUNDABLE',
  NonRefundable = 'NON_REFUNDABLE',
  PartiallyRefundable = 'PARTIALLY_REFUNDABLE',
  Unknown = 'UNKNOWN'
}

export type Region = {
  __typename?: 'Region';
  coordinates: GeoCoordinates;
  countryCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  regionType: RegionType;
  translations: Array<Translation>;
};

export enum RegionType {
  Airport = 'AIRPORT',
  BusStation = 'BUS_STATION',
  City = 'CITY',
  Continent = 'CONTINENT',
  Country = 'COUNTRY',
  HighLevelRegion = 'HIGH_LEVEL_REGION',
  MetroStation = 'METRO_STATION',
  MultiCityVicinity = 'MULTI_CITY_VICINITY',
  Neighbourhood = 'NEIGHBOURHOOD',
  PointOfInterest = 'POINT_OF_INTEREST',
  ProvinceState = 'PROVINCE_STATE',
  TrainStation = 'TRAIN_STATION'
}

export type RegisterRecaptchaV3TokenRequest = {
  action: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RegisterRecaptchaV3TokenResponse = {
  __typename?: 'RegisterRecaptchaV3TokenResponse';
  success: Scalars['Boolean']['output'];
};

export type Reimbursement = {
  __typename?: 'Reimbursement';
  creationDate: Scalars['String']['output'];
};

export type ReimbursementMessage = Message & {
  __typename?: 'ReimbursementMessage';
  bookingId: Scalars['Long']['output'];
  extraHeader: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  reimbursements: Array<Reimbursement>;
  semantic: MessageSemantic;
  status: MessageStatus;
  type: MessageType;
};

export enum RejectFlashOfferStatus {
  Error = 'ERROR',
  Rejected = 'REJECTED'
}

export type RejectFlashOffersResponse = {
  __typename?: 'RejectFlashOffersResponse';
  status: RejectFlashOfferStatus;
};

export type RemoveProductFromShoppingBasketRequest = {
  product: ProductIdRequest;
  shoppingBasketId: Scalars['String']['input'];
  shoppingType?: InputMaybe<ShoppingType>;
};

export type RemoveProductFromUniversalShoppingBasketRequest = {
  product: UniversalShoppingBasketProductRequest;
  shoppingBasketId: Scalars['ID']['input'];
};

export type RemoveShoppingBasketPromoCodeRequest = {
  id: Scalars['ID']['input'];
  shoppingBasketId: Scalars['ID']['input'];
};

export type RemoveShoppingBasketPromoCodeResponse = {
  __typename?: 'RemoveShoppingBasketPromoCodeResponse';
  success: Scalars['Boolean']['output'];
};

export type RemoveUniversalShoppingBasketPromoCodeRequest = {
  id: Scalars['ID']['input'];
  shoppingBasketId: Scalars['ID']['input'];
};

export type RentalCompany = {
  __typename?: 'RentalCompany';
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scoreAsRatio: Scalars['Float']['output'];
};

export type RentalCompanyV2 = {
  __typename?: 'RentalCompanyV2';
  rentalCompanyPictureUrl?: Maybe<Scalars['String']['output']>;
  shortName: Scalars['String']['output'];
};

export type RentalOfferDuration = {
  __typename?: 'RentalOfferDuration';
  amount: Scalars['Int']['output'];
  timeUnit: RentalOfferTimeUnit;
};

export enum RentalOfferTimeUnit {
  Days = 'DAYS'
}

export type RentalPrice = {
  __typename?: 'RentalPrice';
  price: Money;
  rentalPriceBreakDown?: Maybe<RentalPriceBreakdown>;
};

export type RentalPriceBreakDownItem = {
  __typename?: 'RentalPriceBreakDownItem';
  rentalPrice: RentalPrice;
  type: RentalPriceBreakDownItemType;
};

export enum RentalPriceBreakDownItemType {
  PrimeDiscount = 'PRIME_DISCOUNT',
  PrimePrice = 'PRIME_PRICE',
  ProviderPrice = 'PROVIDER_PRICE'
}

export type RentalPriceBreakdown = {
  __typename?: 'RentalPriceBreakdown';
  rentalPriceBreakDownItem: Array<RentalPriceBreakDownItem>;
};

export type RentalPricePerception = {
  __typename?: 'RentalPricePerception';
  rentalPrice: RentalPrice;
  type: RentalPricePerceptionEnum;
};

export enum RentalPricePerceptionEnum {
  DailyNonPrime = 'DAILY_NON_PRIME',
  DailyPrime = 'DAILY_PRIME',
  TotalNonPrime = 'TOTAL_NON_PRIME',
  TotalPrime = 'TOTAL_PRIME'
}

export type RepricingInfo = {
  __typename?: 'RepricingInfo';
  difference: Scalars['Float']['output'];
  newPrice: Money;
  newPricePerTraveller: Money;
  oldPrice: Money;
  oldPricePerTraveller: Money;
};

export type RepricingInformationInput = {
  totalPriceDifference?: InputMaybe<MoneyRequest>;
};

export type RequiredAdvancedPaxInfo = {
  __typename?: 'RequiredAdvancedPaxInfo';
  citizenship: Scalars['Boolean']['output'];
  countryOfResidence: Scalars['Boolean']['output'];
  dateOfBirth: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  emergencyContact: RequiredEmergencyContact;
  gender: Scalars['Boolean']['output'];
  locale: Scalars['Boolean']['output'];
  mobilePhone: Scalars['Boolean']['output'];
};

export type RequiredCheckinAddress = {
  __typename?: 'RequiredCheckinAddress';
  address: Scalars['Boolean']['output'];
  city: Scalars['Boolean']['output'];
  state: Scalars['Boolean']['output'];
  zip: Scalars['Boolean']['output'];
};

export type RequiredCheckinResidentPermit = {
  __typename?: 'RequiredCheckinResidentPermit';
  expirationDate: Scalars['Boolean']['output'];
  expires: Scalars['Boolean']['output'];
  issuingCountry: Scalars['Boolean']['output'];
  number: Scalars['Boolean']['output'];
};

export type RequiredCheckinTravelPermissions = {
  __typename?: 'RequiredCheckinTravelPermissions';
  noVisaReason: Scalars['Boolean']['output'];
  onwardTicket?: Maybe<RequiredOnwardTicket>;
  residentPermit?: Maybe<RequiredCheckinResidentPermit>;
  visaDetails?: Maybe<RequiredVisaDetails>;
};

export type RequiredEmergencyContact = {
  __typename?: 'RequiredEmergencyContact';
  fullName: Scalars['Boolean']['output'];
  phone: Scalars['Boolean']['output'];
  relation: Scalars['Boolean']['output'];
};

export enum RequiredFieldType {
  ConditionalRequired = 'CONDITIONAL_REQUIRED',
  Mandatory = 'MANDATORY',
  NotRequired = 'NOT_REQUIRED',
  Optional = 'OPTIONAL'
}

export type RequiredInformation = {
  __typename?: 'RequiredInformation';
  buyer: BuyerInformationDescription;
  traveller: Array<TravellerInformationDescription>;
};

export type RequiredOnwardTicket = {
  __typename?: 'RequiredOnwardTicket';
  date: Scalars['Boolean']['output'];
  destination: Scalars['Boolean']['output'];
  id: Scalars['Boolean']['output'];
};

export type RequiredTravelDocument = {
  __typename?: 'RequiredTravelDocument';
  expirationDate: Scalars['Boolean']['output'];
  issueDate: Scalars['Boolean']['output'];
  issuingCountry: Scalars['Boolean']['output'];
  monthsDocumentValidity: Scalars['Long']['output'];
  number: Scalars['Boolean']['output'];
  type: TravelDocumentType;
};

export type RequiredVisaDetails = {
  __typename?: 'RequiredVisaDetails';
  expirationDate: Scalars['Boolean']['output'];
  issueCountry: Scalars['Boolean']['output'];
  issueDate: Scalars['Boolean']['output'];
  number: Scalars['Boolean']['output'];
  possibleTypes: Array<Maybe<Scalars['String']['output']>>;
};

export type ResendConfirmationEmailResponse = {
  __typename?: 'ResendConfirmationEmailResponse';
  isSuccessful: Scalars['Boolean']['output'];
};

export type ResidentDiscountRequest = {
  arrivalIata: Scalars['String']['input'];
  departureIata: Scalars['String']['input'];
};

export type ResidentDiscountResponse = {
  __typename?: 'ResidentDiscountResponse';
  zones: Array<Maybe<ResidentGroup>>;
};

export enum ResidentGroup {
  Baleares = 'BALEARES',
  Canarias = 'CANARIAS',
  Ceuta = 'CEUTA',
  Melilla = 'MELILLA'
}

export type ResidentGroupContainer = {
  __typename?: 'ResidentGroupContainer';
  name?: Maybe<ResidentGroup>;
  residentLocalities?: Maybe<Array<Maybe<ResidentGroupLocality>>>;
};

export type ResidentGroupLocality = {
  __typename?: 'ResidentGroupLocality';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ResumeCheckoutRequest = {
  shoppingInfo: ShoppingInfo;
  userPaymentInteractionIdInput: UserPaymentInteractionIdInput;
};

export type ResumeShoppingBasketRequest = {
  shoppingId: Scalars['ID']['input'];
  userPaymentInteractionIdInput?: InputMaybe<UserPaymentInteractionIdInput>;
};

export enum RetailBookingStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  ManualRecovery = 'MANUAL_RECOVERY',
  PartiallyConfirmed = 'PARTIALLY_CONFIRMED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type RetailStrategy = {
  __typename?: 'RetailStrategy';
  /** @deprecated Field no longer supported */
  hiddenDummyPrice?: Maybe<Money>;
  highlightedFlashSale: Scalars['Boolean']['output'];
  isHighlightedOC?: Maybe<Scalars['Boolean']['output']>;
  isPromoCodeApplicable: Scalars['Boolean']['output'];
  isSavingFest: Scalars['Boolean']['output'];
  offerType: OfferType;
  primeDiscountType: PrimeDiscountType;
  showAbsoluteDiscount: Scalars['Boolean']['output'];
  showPercentageDiscount: Scalars['Boolean']['output'];
  showPrimeExclusive: Scalars['Boolean']['output'];
};

export type RetentionFlowInfoResponse = {
  __typename?: 'RetentionFlowInfoResponse';
  flowType?: Maybe<RetentionFlowType>;
  hasUpcomingBookings?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use upcomingBookings instead */
  upcomingBooking?: Maybe<RetentionFlowUpcomingBooking>;
  upcomingBookings: Array<RetentionFlowUpcomingBooking>;
};

export enum RetentionFlowType {
  Default = 'DEFAULT',
  UpcomingTrip = 'UPCOMING_TRIP'
}

export type RetentionFlowUpcomingBooking = {
  __typename?: 'RetentionFlowUpcomingBooking';
  arrivalCityName?: Maybe<Scalars['String']['output']>;
  departureDate?: Maybe<Scalars['String']['output']>;
};

export enum RetentionFunnelStatus {
  AutorenewalCanceled = 'AUTORENEWAL_CANCELED',
  FreeCancellationAdded = 'FREE_CANCELLATION_ADDED',
  Keep = 'KEEP',
  MembershipCanceled = 'MEMBERSHIP_CANCELED',
  ReminderRequested = 'REMINDER_REQUESTED',
  TokenExpired = 'TOKEN_EXPIRED',
  VoucherRequested = 'VOUCHER_REQUESTED'
}

export enum RetentionRuleCodeType {
  RuleAlreadyApplied = 'RULE_ALREADY_APPLIED',
  RuleApplied = 'RULE_APPLIED'
}

export enum RetentionRuleFeatureType {
  CancellationRule = 'CANCELLATION_RULE',
  VoucherRule = 'VOUCHER_RULE'
}

export type RetentionVoucherResponse = {
  __typename?: 'RetentionVoucherResponse';
  code: VoucherCodeType;
};

export type RetrievePaypalStandaloneEligibilityResponse = {
  __typename?: 'RetrievePaypalStandaloneEligibilityResponse';
  eligible: Scalars['Boolean']['output'];
  planDetails?: Maybe<PrimeMemberPlanDetails>;
};

export type RetrieveSubscriptionCheckoutDetailsRequest = {
  shoppingBasketId: Scalars['ID']['input'];
};

export type RetrieveSubscriptionCheckoutDetailsResponse = {
  __typename?: 'RetrieveSubscriptionCheckoutDetailsResponse';
  buyer?: Maybe<BuyerCheckoutDetails>;
  offerInformation: PostBookingSubscriptionOffer;
  status: SubscriptionPbOperationResponseStatus;
};

export type RetrieveSubscriptionEligibilityOfferDetailsRequest = {
  email: Scalars['String']['input'];
  touchpoint: Touchpoint;
};

export type RetrieveSubscriptionEligibilityOfferDetailsResponse = {
  __typename?: 'RetrieveSubscriptionEligibilityOfferDetailsResponse';
  eligible: Scalars['Boolean']['output'];
  offerInformation: PostBookingSubscriptionOffer;
  token: Scalars['String']['output'];
};

export type RetrieveUnchainedMembershipPostBookingEligibilityRequest = {
  bookingId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type RetrieveUnchainedMembershipPostBookingEligibilityResponse = {
  __typename?: 'RetrieveUnchainedMembershipPostBookingEligibilityResponse';
  compensation: Array<MembershipPostBookingCompensation>;
  eligible: Scalars['Boolean']['output'];
  planDetails: PrimeMemberPlanDetails;
  unchainedMembershipOfferToken: UnchainedMembershipOfferToken;
};

export type ReviewCountAndPercentage = {
  __typename?: 'ReviewCountAndPercentage';
  count: Scalars['Int']['output'];
  percentageOfTotalReviews: Scalars['Int']['output'];
};

export enum RewardType {
  MonthlyPromoCodeRewardForYearlySubscription = 'MONTHLY_PROMO_CODE_REWARD_FOR_YEARLY_SUBSCRIPTION',
  WelcomePromoCodeRewardThreeMonthsClaimable = 'WELCOME_PROMO_CODE_REWARD_THREE_MONTHS_CLAIMABLE'
}

export type Room = {
  __typename?: 'Room';
  cancelPenalties: Array<Maybe<CancelPenalty>>;
  cancellationFree?: Maybe<Scalars['Boolean']['output']>;
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  combinations?: Maybe<Array<Maybe<RoomCombination>>>;
  debugInfo?: Maybe<Scalars['String']['output']>;
  hasMerchandisePrice?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  payInAdvance?: Maybe<Scalars['Boolean']['output']>;
  priceBreakdown?: Maybe<PriceBreakdown>;
  providerId?: Maybe<Scalars['String']['output']>;
  refundType?: Maybe<RefundType>;
  roomDetails: Array<RoomLegend>;
  roomGroupKey?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['String']['output'];
  roomOffer: RoomOffer;
};

export type RoomAmenity = {
  __typename?: 'RoomAmenity';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type RoomCombination = {
  __typename?: 'RoomCombination';
  counter?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
};

export type RoomDeal = {
  __typename?: 'RoomDeal';
  key?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
};

export type RoomDealSummary = {
  __typename?: 'RoomDealSummary';
  bedsDescription?: Maybe<Scalars['String']['output']>;
  boardType?: Maybe<BoardType>;
  cancelPolicy?: Maybe<Scalars['String']['output']>;
  depositRequired?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isCancellationFree?: Maybe<Scalars['Boolean']['output']>;
  paymentAtDestination?: Maybe<Scalars['Boolean']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['String']['output']>;
  roomKey?: Maybe<Scalars['String']['output']>;
  roomsLeft?: Maybe<Scalars['Int']['output']>;
  smokingPreference?: Maybe<RoomSmokingPreference>;
};

export type RoomGroup = {
  __typename?: 'RoomGroup';
  roomIds: Array<Scalars['String']['output']>;
};

export type RoomGroupDeal = {
  __typename?: 'RoomGroupDeal';
  key?: Maybe<Scalars['String']['output']>;
  roomsKeys?: Maybe<Array<Scalars['String']['output']>>;
  searchId?: Maybe<Scalars['Long']['output']>;
};

export type RoomLegend = {
  __typename?: 'RoomLegend';
  amenities?: Maybe<Array<Maybe<RoomAmenity>>>;
  bedsDescription?: Maybe<Scalars['String']['output']>;
  boardType?: Maybe<BoardType>;
  description?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Image>>>;
  mainImage?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  roomKey?: Maybe<Scalars['String']['output']>;
  roomsLeft?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RoomOffer = {
  __typename?: 'RoomOffer';
  hasDiscount: Scalars['Boolean']['output'];
  retailStrategy: RetailStrategy;
};

export type RoomRate = {
  boardType: BoardType;
  freeCancellation: Scalars['Boolean']['input'];
};

export type RoomRequest = {
  childrenAges?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numAdults: Scalars['Int']['input'];
};

export type RoomRequested = {
  __typename?: 'RoomRequested';
  childrenAges: Array<Scalars['Int']['output']>;
  numAdults: Scalars['Int']['output'];
};

export type RoomSearchCriteria = {
  __typename?: 'RoomSearchCriteria';
  childrenAges?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numAdults: Scalars['Int']['output'];
};

export enum RoomSmokingPreference {
  Indifferent = 'INDIFFERENT',
  NonSmoking = 'NON_SMOKING',
  Smoking = 'SMOKING',
  Unknown = 'UNKNOWN'
}

export type RoomsDetailRequest = {
  locale: Scalars['String']['input'];
  roomIds: Array<Scalars['String']['input']>;
  supplierCode: Scalars['String']['input'];
  supplierHotelId: Scalars['String']['input'];
};

export type RoomsDetailResponse = {
  __typename?: 'RoomsDetailResponse';
  roomsDetails?: Maybe<Array<Maybe<StaticRoomDetails>>>;
};

export type SaveUserCreditCardRequest = {
  creditCardsInfo: Array<UserCreditCardInfo>;
};

export type SearchAlternativesForIncidentRequest = {
  bookingId: Scalars['ID']['input'];
  bookingItemId: Scalars['ID']['input'];
  changeNewDepartureDate?: InputMaybe<Scalars['String']['input']>;
  changeNewReturnDate?: InputMaybe<Scalars['String']['input']>;
  providerBookingItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchAlternativesForIncidentResponse = {
  __typename?: 'SearchAlternativesForIncidentResponse';
  canSearchForAlternatives: Scalars['Boolean']['output'];
  itineraryResults: Array<AlternativeItineraryForIncident>;
};

export type SearchCode = {
  __typename?: 'SearchCode';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type SearchCriteria = {
  __typename?: 'SearchCriteria';
  accommodation?: Maybe<AccommodationSearchCriteria>;
  itinerary?: Maybe<ItinerarySearchCriteria>;
};

export type SearchFastTrackOffersRequest = {
  sections: Array<FastTrackSection>;
};

export type SearchFastTrackOffersResponse = {
  __typename?: 'SearchFastTrackOffersResponse';
  offers: Array<FastTrackPostBookingOffer>;
};

export type SearchFastTracksByItineraryRequest = {
  itineraryId: ItineraryId;
};

export type SearchFastTracksByItineraryResponse = {
  __typename?: 'SearchFastTracksByItineraryResponse';
  products: Array<FastTrackProduct>;
};

export type SearchItineraryRequest = {
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  itinerary: ItinerarySearchItineraryRequest;
  tripType: TripType;
  unbundledMappingGrouping?: UnbundledMappingGroupingType;
};

export type SearchItineraryResponse = {
  __typename?: 'SearchItineraryResponse';
  campaignConfigs: Array<CampaignConfigValue>;
  campaignsItineraryLists: Array<Campaign>;
  carbonFootprints: Array<CarbonFootprintValue>;
  carriers: Array<CarrierValue>;
  externalSelection?: Maybe<ExternalSelection>;
  freeCancellationItineraryIds?: Maybe<Array<Scalars['String']['output']>>;
  insuranceOffers: Array<InsuranceOfferValue>;
  itineraries: Array<SearchItineraryResult>;
  locations: Array<LocationValue>;
  priceTypeDisplayed?: Maybe<ItineraryResultPriceType>;
  searchCode?: Maybe<SearchCode>;
  searchId: Scalars['Long']['output'];
  sections: Array<SectionValue>;
  segments: Array<SegmentValue>;
  trackingInfo?: Maybe<TrackingInfo>;
  unbundledMapping: Array<UnbundledMapping>;
};

export type SearchItineraryResult = {
  __typename?: 'SearchItineraryResult';
  campaignConfigId?: Maybe<Scalars['ID']['output']>;
  carbonFootprintId?: Maybe<Scalars['ID']['output']>;
  fees: Array<SearchResponseFee>;
  hotelXSellingEnabled: Scalars['Boolean']['output'];
  isFareUpgradeAvailable: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  legs?: Maybe<Array<SearchItineraryResultLeg>>;
  meRating: Scalars['Float']['output'];
  perks?: Maybe<Perks>;
  ticketsLeft: Scalars['Int']['output'];
  transportTypes: Array<TransportType>;
};

export type SearchItineraryResultLeg = {
  __typename?: 'SearchItineraryResultLeg';
  segmentId: Scalars['ID']['output'];
  segmentKey: Scalars['ID']['output'];
};

export type SearchItineraryResultSection = {
  __typename?: 'SearchItineraryResultSection';
  arrivalDate: Scalars['String']['output'];
  arrivalTerminal?: Maybe<Scalars['String']['output']>;
  cabinClass: CabinClass;
  carrierId: Scalars['ID']['output'];
  commercialBrandId?: Maybe<Scalars['ID']['output']>;
  departureDate: Scalars['String']['output'];
  departureId: Scalars['ID']['output'];
  departureTerminal?: Maybe<Scalars['String']['output']>;
  destinationId: Scalars['ID']['output'];
  duration?: Maybe<Scalars['Long']['output']>;
  flightCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insuranceOfferId?: Maybe<Scalars['ID']['output']>;
  operatingCarrierId?: Maybe<Scalars['ID']['output']>;
  technicalStops: Array<TechnicalStop>;
  transportType: TransportType;
  vehicleModel?: Maybe<Scalars['String']['output']>;
};

export type SearchItineraryResultSegment = {
  __typename?: 'SearchItineraryResultSegment';
  baggageCondition: BaggageCondition;
  carrierId: Scalars['ID']['output'];
  duration?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  sections: Array<Scalars['ID']['output']>;
  ticketsLeft: Scalars['Int']['output'];
  transportTypes: Array<TransportType>;
};

export enum SearchPriceType {
  ItineraryPricingStats = 'ITINERARY_PRICING_STATS',
  SearchPrice = 'SEARCH_PRICE'
}

export type SearchRequest = {
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  headers?: InputMaybe<Headers>;
  itinerary: ItineraryRequest;
  tripType: TripType;
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  campaignsItineraryLists?: Maybe<Array<Campaign>>;
  carriersWithRebooking: Array<Scalars['String']['output']>;
  defaultFeeType?: Maybe<FeeType>;
  externalSelection?: Maybe<ExternalSelection>;
  /** @deprecated You can find the same information in campaignsItineraryLists.campaignsItineraryLists */
  freeCancellationItineraryIds?: Maybe<Array<Scalars['String']['output']>>;
  isRebookingAvailable: Scalars['Boolean']['output'];
  itineraries: Array<Itinerary>;
  /** @deprecated No longer used on frontend */
  itineraryAlternativesList: Array<ItineraryAlternativeList>;
  searchCode?: Maybe<SearchCode>;
  searchId: Scalars['Long']['output'];
  trackingInfo?: Maybe<TrackingInfo>;
};

export type SearchResponseFee = {
  __typename?: 'SearchResponseFee';
  price: Money;
  type: Scalars['String']['output'];
};

export type SearchRoomAvailabilityRequest = {
  accommodationDealKey: Scalars['Long']['input'];
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  dedupId?: InputMaybe<Scalars['Int']['input']>;
  searchId: Scalars['Long']['input'];
};

export type SearchRoomAvailabilityResponse = {
  __typename?: 'SearchRoomAvailabilityResponse';
  currency?: Maybe<Scalars['String']['output']>;
  roomGroups?: Maybe<Array<RoomGroup>>;
  rooms?: Maybe<Array<Maybe<Room>>>;
  searchId: Scalars['Long']['output'];
};

/**
 * Input for the searchTrain query. Includes all fields from the standard
 * itinerary, using the specific itineraryRequest for trains.
 */
export type SearchTrainsRequest = {
  buyPath?: InputMaybe<Scalars['Int']['input']>;
  itinerary: TrainSearchItineraryRequest;
  tripType: TripType;
};

export type Seat = {
  __typename?: 'Seat';
  characteristics: Array<Maybe<SeatCharacteristic>>;
  column: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  fee: Money;
  floor: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  price: Money;
  prices: Array<AncillaryPriceItem>;
  /** @deprecated Field no longer supported */
  primePrice?: Maybe<Money>;
  row: Scalars['Int']['output'];
  seatMapRow: Scalars['Int']['output'];
  type: SeatType;
};

export enum SeatCharacteristic {
  ChargeableSeat = 'CHARGEABLE_SEAT',
  Exit = 'EXIT',
  ExtraLeg = 'EXTRA_LEG',
  Galley = 'GALLEY',
  InfantAllowed = 'INFANT_ALLOWED',
  Lavatory = 'LAVATORY'
}

export type SeatMap = {
  __typename?: 'SeatMap';
  cabins: Array<Cabin>;
  section: Scalars['Int']['output'];
};

export type SeatMapSegment = {
  __typename?: 'SeatMapSegment';
  seatMaps: Array<Maybe<SeatMap>>;
  segment: Scalars['Int']['output'];
};

export type SeatPriceBreakDownItem = AncillaryProductItem & PriceBreakDownItem & {
  __typename?: 'SeatPriceBreakDownItem';
  discountInfo?: Maybe<Array<DiscountInfo>>;
  discountedPrice?: Maybe<Money>;
  nonDiscountedPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  price: Money;
  providerPrice?: Maybe<Money>;
  /** @deprecated Field no longer supported */
  quantity: Scalars['Int']['output'];
  serviceFeeTaxes?: Maybe<Money>;
  totalPrice: Money;
  type: PriceBreakDownItemType;
};

export type SeatRequest = {
  column: Scalars['String']['input'];
  displayedPrice: MoneyRequest;
  floor: Scalars['Int']['input'];
  row: Scalars['Int']['input'];
  seatMapRow: Scalars['Int']['input'];
};

export enum SeatType {
  Aisle = 'AISLE',
  Middle = 'MIDDLE',
  NoSeat = 'NO_SEAT',
  Window = 'WINDOW'
}

export type SeatsSelection = {
  __typename?: 'SeatsSelection';
  column: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  fee: Money;
  floor: Scalars['Int']['output'];
  passenger: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  price: Money;
  prices: Array<AncillaryPriceItem>;
  /** @deprecated Field no longer supported */
  primePrice?: Maybe<Money>;
  row: Scalars['Int']['output'];
  seatMapRow: Scalars['Int']['output'];
  section: Scalars['Int']['output'];
  segment: Scalars['Int']['output'];
};

export type Section = {
  __typename?: 'Section';
  arrivalDate: Scalars['String']['output'];
  arrivalTerminal?: Maybe<Scalars['String']['output']>;
  baggageAllowance?: Maybe<Scalars['Int']['output']>;
  cabinClass?: Maybe<CabinClass>;
  carrier: Carrier;
  commercialBrand?: Maybe<CommercialBrand>;
  departure: Location;
  departureDate: Scalars['String']['output'];
  departureTerminal?: Maybe<Scalars['String']['output']>;
  destination: Location;
  /** @deprecated old data structure, use originalDurationInMinutes instead */
  duration?: Maybe<Scalars['Long']['output']>;
  flightCode: Scalars['String']['output'];
  flightNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceOffer?: Maybe<InsuranceOffer>;
  isHub: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  operatingCarrier?: Maybe<Carrier>;
  originalDurationInMinutes?: Maybe<Scalars['Long']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  stopDuration?: Maybe<Scalars['Long']['output']>;
  technicalStops: Array<TechnicalStop>;
  transportType?: Maybe<TransportType>;
  updatedDurationInMinutes?: Maybe<Scalars['Long']['output']>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
};

export enum SectionType {
  Arrival = 'ARRIVAL',
  Hub = 'HUB',
  Scale = 'SCALE'
}

export type SectionValue = {
  __typename?: 'SectionValue';
  id: Scalars['ID']['output'];
  section: SearchItineraryResultSection;
};

export type Segment = {
  __typename?: 'Segment';
  allStops?: Maybe<Scalars['Int']['output']>;
  baggageCondition: BaggageCondition;
  carrier: Carrier;
  /** @deprecated old data structure, use originalDurationInMinutes instead */
  duration?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  originalDurationInMinutes?: Maybe<Scalars['Long']['output']>;
  seats?: Maybe<Scalars['Int']['output']>;
  sections: Array<Section>;
  stops?: Maybe<Scalars['Int']['output']>;
  technicalStops?: Maybe<Scalars['Int']['output']>;
  transportTypes: Array<TransportType>;
  updatedDurationInMinutes?: Maybe<Scalars['Long']['output']>;
};

export type SegmentItineraryRequest = {
  date: Scalars['String']['input'];
  departure: LocationRequest;
  destination: LocationRequest;
};

export type SegmentRequest = {
  date: Scalars['String']['input'];
  departure: LocationRequest;
  destination: LocationRequest;
};

export type SegmentSearchCriteria = {
  __typename?: 'SegmentSearchCriteria';
  date: Scalars['String']['output'];
  departureGeoNode: Scalars['Int']['output'];
  departureIata: Scalars['String']['output'];
  destinationGeoNode: Scalars['Int']['output'];
  destinationIata: Scalars['String']['output'];
};

export enum SegmentTypeIndex {
  Fifth = 'FIFTH',
  First = 'FIRST',
  Fourth = 'FOURTH',
  Second = 'SECOND',
  Sixth = 'SIXTH',
  Third = 'THIRD'
}

export type SegmentValue = {
  __typename?: 'SegmentValue';
  id: Scalars['ID']['output'];
  segment: SearchItineraryResultSegment;
};

export type SelectAccommodationInsuranceRequest = {
  offerId: Scalars['String']['input'];
  priceType?: InputMaybe<AccommodationInsurancePriceType>;
  shoppingBasketId: Scalars['ID']['input'];
};

export type SelectAccommodationInsuranceResponse = {
  __typename?: 'SelectAccommodationInsuranceResponse';
  productId: Scalars['String']['output'];
};

export type SelectAccommodationOfferRequest = {
  accommodationDealKey: Scalars['String']['input'];
  roomDealKey: Scalars['String']['input'];
  searchId: Scalars['String']['input'];
  selectedCustomerPriceType: CustomerPriceType;
};

export type SelectAccommodationOfferResponse = {
  __typename?: 'SelectAccommodationOfferResponse';
  shoppingId: Scalars['ID']['output'];
};

export type SelectAncillariesRequest = {
  bookingID?: InputMaybe<Scalars['ID']['input']>;
  flow: AncillaryFlowType;
  selection: AncillariesSelectionRequest;
  shoppingBasketID?: InputMaybe<Scalars['ID']['input']>;
};

export type SelectFastTrackOfferForItineraryRequest = {
  itineraryId: ItineraryId;
  offers: Array<FastTrackPostBookingOfferInput>;
};

export type SelectFastTrackOfferForItineraryResponse = {
  __typename?: 'SelectFastTrackOfferForItineraryResponse';
  products: Array<FastTrackProduct>;
};

export type SelectFastTrackRequest = {
  bookingId?: InputMaybe<Scalars['Long']['input']>;
  itineraryId: ItineraryId;
  offersIds: Array<Scalars['String']['input']>;
  shoppingBasketId?: InputMaybe<Scalars['ID']['input']>;
};

export type SelectFastTrackResponse = {
  __typename?: 'SelectFastTrackResponse';
  productIds: Array<Scalars['ID']['output']>;
};

export enum SelectFlashOfferError {
  Error = 'ERROR',
  InvalidSelection = 'INVALID_SELECTION',
  TimedOut = 'TIMED_OUT'
}

export type SelectFlashOfferRequest = {
  offerId: Scalars['ID']['input'];
};

export type SelectFlashOfferResponse = {
  __typename?: 'SelectFlashOfferResponse';
  error?: Maybe<SelectFlashOfferError>;
  offer?: Maybe<FlashOffer>;
};

export type SelectInsuranceOfferRequest = {
  offerId: OfferId;
  shoppingBasketId: ShoppingBasketId;
};

export type SelectInsuranceOfferResponse = {
  __typename?: 'SelectInsuranceOfferResponse';
  productId: ProductId;
};

export type SelectMembershipStandaloneReferralRequest = {
  token: Scalars['String']['input'];
};

export type SelectMembershipStandaloneReferralResponse = {
  __typename?: 'SelectMembershipStandaloneReferralResponse';
  accountDetails: MembershipStandaloneAccountDetails;
  planDetails: PrimeMemberPlanDetails;
  status: ReferralStandaloneResponseStatus;
};

export type SelectNonEssentialInsurancesProductsRequest = {
  productsToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  productsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  shoppingId: Scalars['String']['input'];
};

export type SelectNonEssentialPostsellProductsRequest = {
  buyerPhone: PhoneInput;
  productsToAdd?: InputMaybe<Array<PostsellToAdd>>;
  productsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  shoppingId: Scalars['String']['input'];
};

export type SelectNonEssentialProductsRequest = {
  products: Array<InputMaybe<ProductSelection>>;
  shoppingBasketId: ShoppingBasketId;
};

export type SelectNonEssentialProductsResponse = {
  __typename?: 'SelectNonEssentialProductsResponse';
  productId: Array<Maybe<ProductId>>;
};

export type SelectPostBookingSubscriptionOfferRequest = {
  token: Scalars['String']['input'];
};

export type SelectPostBookingSubscriptionOfferResponse = {
  __typename?: 'SelectPostBookingSubscriptionOfferResponse';
  bookingId: Scalars['Long']['output'];
  checkoutMethod: CheckoutMethod;
  collectionMethodId: Scalars['String']['output'];
  offerInformation: PostBookingSubscriptionOffer;
  paymentInstrumentToken: Scalars['String']['output'];
  shoppingBasketId: Scalars['ID']['output'];
};

export type SelectReferralLinkTokenRequestV2CrmFlow = {
  userToken: Scalars['String']['input'];
};

export type SelectReferralLinkTokenResponse = {
  __typename?: 'SelectReferralLinkTokenResponse';
  token?: Maybe<ReferralLinkToken>;
  voucher?: Maybe<VoucherDetails>;
};

export type SelectReferralLinkTokenResponseV2 = {
  __typename?: 'SelectReferralLinkTokenResponseV2';
  maxSaveMoney?: Maybe<Scalars['Float']['output']>;
  referralSubscriptionOffer?: Maybe<ReferralSubscriptionOffer>;
  referredVoucher: Array<VoucherDetails>;
  referrerVoucher: Array<VoucherDetails>;
  token?: Maybe<ReferralLinkToken>;
};

export type SelectUnchainedMembershipPostBookingRequest = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  unchainedMembershipOfferToken?: InputMaybe<UnchainedMembershipOfferTokenInput>;
};

export type SelectUnchainedMembershipPostBookingResponse = {
  __typename?: 'SelectUnchainedMembershipPostBookingResponse';
  accountDetails: MembershipStandaloneAccountDetails;
  compensation: Array<MembershipPostBookingCompensation>;
  planDetails: PrimeMemberPlanDetails;
  status: MembershipStandaloneResponseStatus;
};

export type SelectableBaggageDescriptor = {
  __typename?: 'SelectableBaggageDescriptor';
  baggageDescriptor?: Maybe<BaggageDescriptor>;
  /** @deprecated Field no longer supported */
  price?: Maybe<Money>;
  prices: Array<AncillaryPriceItem>;
  pricesPerUnit?: Maybe<Array<PricePerUnit>>;
  /** @deprecated Field no longer supported */
  primePrice?: Maybe<Money>;
};

export type SelectableDelayedCollectionItem = {
  __typename?: 'SelectableDelayedCollectionItem';
  checkoutFlow: ItemCheckoutFlow;
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SelectedAncillariesResponse = {
  __typename?: 'SelectedAncillariesResponse';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<SelectedAncillaryProduct>>;
  success: Scalars['Boolean']['output'];
};

export type SelectedAncillaryProduct = {
  __typename?: 'SelectedAncillaryProduct';
  id: Scalars['ID']['output'];
  type: AncillaryProductType;
};

export type SelectedSeatRequest = {
  Seat?: InputMaybe<SeatRequest>;
  section: Scalars['Int']['input'];
};

export type SelectionRoomRequest = {
  accommodationDealKey: Scalars['String']['input'];
  roomDealKey: Scalars['String']['input'];
  searchId: Scalars['String']['input'];
};

export type SemIsReturningCustomerRequest = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};

export type SemIsReturningCustomerResponse = {
  __typename?: 'SemIsReturningCustomerResponse';
  isReturning: Scalars['Boolean']['output'];
};

export type SemItinerariesSearchRequest = {
  itinerary: SemItineraryRequest;
  tripType: TripType;
};

export type SemItinerariesSearchResponse = {
  __typename?: 'SemItinerariesSearchResponse';
  itineraries: Array<SemItinerary>;
  priceTypeDisplayed: FeeType;
};

export type SemItinerary = {
  __typename?: 'SemItinerary';
  fees: Array<Fee>;
  legs: Array<SemLeg>;
  ticketsLeft: Scalars['Int']['output'];
  transportTypes: Array<TransportType>;
};

export type SemItineraryRequest = {
  segments: Array<SemSegmentRequest>;
};

export type SemItinerarySelectRequest = {
  mainAirportsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  numAdults?: InputMaybe<Scalars['Int']['input']>;
  numChildren?: InputMaybe<Scalars['Int']['input']>;
  numInfants?: InputMaybe<Scalars['Int']['input']>;
  resident?: InputMaybe<Scalars['Boolean']['input']>;
  segments: Array<SemSelectSegmentRequest>;
};

export type SemItinerarySelectionRequest = {
  buyPath: Scalars['Int']['input'];
  itinerarySearchRequest: SemItinerarySelectRequest;
  selectDealSegmentFlightNumbers: Array<SemSelectDealSegmentFlightNumberRequest>;
  tripType: TripType;
};

export type SemItinerarySelectionResponse = {
  __typename?: 'SemItinerarySelectionResponse';
  itineraries: Array<Itinerary>;
  searchId: Scalars['Long']['output'];
  trackingInfo: TrackingInfo;
};

export type SemLeg = {
  __typename?: 'SemLeg';
  segments: Array<SemSegment>;
};

export type SemNumberOfBookingsByTokenRequest = {
  token: Scalars['String']['input'];
};

export type SemNumberOfBookingsByTokenResponse = {
  __typename?: 'SemNumberOfBookingsByTokenResponse';
  numberOfBookings: Scalars['Long']['output'];
};

export type SemSearchRequest = {
  itinerary: SemItineraryRequest;
  tripType: TripType;
};

export type SemSearchResponse = {
  __typename?: 'SemSearchResponse';
  itineraries: Array<SemItinerary>;
  priceTypeDisplayed: FeeType;
};

export type SemSection = {
  __typename?: 'SemSection';
  arrivalDate: Scalars['String']['output'];
  carrier: Carrier;
  departure: Location;
  departureDate: Scalars['String']['output'];
  destination: Location;
  duration: Scalars['Long']['output'];
  flightCode: Scalars['String']['output'];
  transportType: TransportType;
};

export type SemSegment = {
  __typename?: 'SemSegment';
  baggageCondition: BaggageCondition;
  carrier: Carrier;
  duration: Scalars['Long']['output'];
  sections: Array<SemSection>;
  transportTypes: Array<TransportType>;
};

export type SemSegmentRequest = {
  departure: LocationRequest;
  destination: LocationRequest;
};

export type SemSelectDealSegmentFlightNumberRequest = {
  flightNumbers: Array<Scalars['String']['input']>;
};

export type SemSelectSegmentRequest = {
  date: Scalars['String']['input'];
  departure: LocationRequest;
  destination: LocationRequest;
};

export type SendSetPasswordEmailRequest = {
  email: Scalars['String']['input'];
  landingPagePath?: InputMaybe<Scalars['String']['input']>;
  newsletterSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  recaptchaV2Response?: InputMaybe<Scalars['String']['input']>;
};

export type SendSetPasswordEmailResponse = {
  __typename?: 'SendSetPasswordEmailResponse';
  acknowledged: Scalars['Boolean']['output'];
};

export type ServiceOptionInnerProductUnion = InnerInsurance | MonitoringAlert | SimpleProduct | SmsNotification;

export type ServiceOptionNonEssentialProductOffer = {
  __typename?: 'ServiceOptionNonEssentialProductOffer';
  innerProducts?: Maybe<Array<Maybe<ServiceOptionProduct>>>;
  nonEssentialProduct?: Maybe<NonEssentialProductOffer>;
};

export type ServiceOptionProduct = {
  __typename?: 'ServiceOptionProduct';
  innerProduct?: Maybe<ServiceOptionInnerProductUnion>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ShoppingBasket = {
  __typename?: 'ShoppingBasket';
  primeDiscountPlusPromoCodes?: Maybe<Money>;
  products: Array<ShoppingBasketProduct>;
  promoCodes: Array<TripShoppingBasketPromoCode>;
  showPrimeDiscountPlusPromoCodes?: Maybe<Scalars['Boolean']['output']>;
  totalPrice?: Maybe<Money>;
};

export type ShoppingBasketAddCreditCardRequest = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  paymentInstrumentToken: Scalars['String']['input'];
};

export type ShoppingBasketAddCreditCardResponse = {
  __typename?: 'ShoppingBasketAddCreditCardResponse';
  success: Scalars['Boolean']['output'];
};

export type ShoppingBasketAddRedirectRequest = {
  checkoutOrigin: CheckoutOrigin;
  redirectType: RedirectType;
  shoppingBasketId: Scalars['ID']['input'];
  userPaymentInteractionId: Scalars['ID']['input'];
};

export type ShoppingBasketAddRedirectResponse = {
  __typename?: 'ShoppingBasketAddRedirectResponse';
  success: Scalars['Boolean']['output'];
};

export type ShoppingBasketAddUserPaymentInteractionOutcomeRequest = {
  outcome: Array<UserPaymentInteractionParamInput>;
  userPaymentInteractionId: ShoppingBasketUserPaymentInteractionIdInput;
};

export type ShoppingBasketAddUserPaymentInteractionOutcomeResponse = {
  __typename?: 'ShoppingBasketAddUserPaymentInteractionOutcomeResponse';
  success: Scalars['Boolean']['output'];
};

export type ShoppingBasketCheckoutCollectionInfo = {
  __typename?: 'ShoppingBasketCheckoutCollectionInfo';
  collectionFailure?: Maybe<ShoppingBasketCollectionFailure>;
  collectionStatus: ShoppingBasketCollectionStatus;
};

export type ShoppingBasketCheckoutRequest = {
  collectionOptionId: Scalars['ID']['input'];
  invoice?: InputMaybe<ShoppingBasketInvoiceRequest>;
  paymentInstrumentToken: Scalars['String']['input'];
  shoppingBasketId: Scalars['ID']['input'];
  userCollectionTrackingId: Scalars['ID']['input'];
};

export type ShoppingBasketCheckoutResponse = {
  __typename?: 'ShoppingBasketCheckoutResponse';
  collectionInfo: ShoppingBasketCheckoutCollectionInfo;
  userPaymentInteractionId?: Maybe<Scalars['ID']['output']>;
};

export enum ShoppingBasketCollectionFailure {
  AcquirerUnavailable = 'ACQUIRER_UNAVAILABLE',
  AmountHigherThanAllowed = 'AMOUNT_HIGHER_THAN_ALLOWED',
  BuyersFundingSourceFailed = 'BUYERS_FUNDING_SOURCE_FAILED',
  CardExpired = 'CARD_EXPIRED',
  CardNotInAuthorizersDb = 'CARD_NOT_IN_AUTHORIZERS_DB',
  DataValidationError = 'DATA_VALIDATION_ERROR',
  Declined = 'DECLINED',
  FraudSuspect = 'FRAUD_SUSPECT',
  InsufficientCredit = 'INSUFFICIENT_CREDIT',
  InvalidAmount = 'INVALID_AMOUNT',
  InvalidCardNumber = 'INVALID_CARD_NUMBER',
  InvalidCurrency = 'INVALID_CURRENCY',
  LostCard = 'LOST_CARD',
  NotPermittedToCardholder = 'NOT_PERMITTED_TO_CARDHOLDER',
  OrderAlreadyUsed = 'ORDER_ALREADY_USED',
  OrderNotAuthorize = 'ORDER_NOT_AUTHORIZE',
  OrderWithoutRefundablePayments = 'ORDER_WITHOUT_REFUNDABLE_PAYMENTS',
  RejectedByBank = 'REJECTED_BY_BANK',
  SchemeRejection = 'SCHEME_REJECTION',
  TransactionNoExist = 'TRANSACTION_NO_EXIST',
  UnexpectedStatus = 'UNEXPECTED_STATUS',
  Unknown = 'UNKNOWN',
  UnknownOrder = 'UNKNOWN_ORDER',
  UnknownOriginIp = 'UNKNOWN_ORIGIN_IP',
  UnsupportedGatewayCollectionMethod = 'UNSUPPORTED_GATEWAY_COLLECTION_METHOD',
  WrongCreditcardExpirationDate = 'WRONG_CREDITCARD_EXPIRATION_DATE',
  WrongCvv2 = 'WRONG_CVV2',
  WrongElvAccount = 'WRONG_ELV_ACCOUNT'
}

export enum ShoppingBasketCollectionStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN',
  UserPaymentInteraction = 'USER_PAYMENT_INTERACTION'
}

export type ShoppingBasketCreditCard = {
  __typename?: 'ShoppingBasketCreditCard';
  creditCardCode?: Maybe<Scalars['String']['output']>;
  creditCardNumber?: Maybe<Scalars['String']['output']>;
  creditCardTypeId?: Maybe<CreditCardsType>;
  expirationDateMonth?: Maybe<Scalars['String']['output']>;
  expirationDateYear?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  paymentInstrumentTokenWithoutCvv: Scalars['String']['output'];
};

export type ShoppingBasketFastTrackProductsRequest = {
  fastTracksIds: Array<Scalars['ID']['input']>;
  shoppingBasketId: Scalars['ID']['input'];
};

export type ShoppingBasketFastTrackProductsResponse = {
  __typename?: 'ShoppingBasketFastTrackProductsResponse';
  products: Array<FastTrackProduct>;
};

export enum ShoppingBasketFormSendType {
  Get = 'GET',
  Post = 'POST'
}

export type ShoppingBasketId = {
  id: Scalars['Long']['input'];
};

export type ShoppingBasketInvoiceRequest = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fiscalCode: Scalars['String']['input'];
  legalName: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  professional: Scalars['Boolean']['input'];
  required: Scalars['Boolean']['input'];
};

export type ShoppingBasketPrice = {
  __typename?: 'ShoppingBasketPrice';
  amount: Money;
  breakdown?: Maybe<ShoppingBasketPriceBreakdownList>;
};

export type ShoppingBasketPriceBreakdown = {
  __typename?: 'ShoppingBasketPriceBreakdown';
  price: ShoppingBasketPrice;
  priceBreakDownByProductType: Array<ShoppingBasketProductTypePriceBreakdown>;
};

export type ShoppingBasketPriceBreakdownItem = {
  __typename?: 'ShoppingBasketPriceBreakdownItem';
  /** @deprecated Use priceConcept instead */
  concept: Scalars['String']['output'];
  price: ShoppingBasketPrice;
  priceConcept: ShoppingBasketPriceBreakdownItemConcept;
};

export enum ShoppingBasketPriceBreakdownItemConcept {
  PrimeDiscount = 'PRIME_DISCOUNT',
  PromocodeDiscount = 'PROMOCODE_DISCOUNT',
  ProviderPrice = 'PROVIDER_PRICE',
  ServiceFee = 'SERVICE_FEE'
}

export type ShoppingBasketPriceBreakdownList = {
  __typename?: 'ShoppingBasketPriceBreakdownList';
  items: Array<ShoppingBasketPriceBreakdownItem>;
};

export type ShoppingBasketPricePerception = {
  __typename?: 'ShoppingBasketPricePerception';
  items: Array<ShoppingBasketPricePerceptionItem>;
};

export type ShoppingBasketPricePerceptionItem = {
  __typename?: 'ShoppingBasketPricePerceptionItem';
  price: ShoppingBasketPrice;
  type: ShoppingBasketPricePerceptionType;
};

export enum ShoppingBasketPricePerceptionType {
  NonPrimePricePerTraveller = 'NON_PRIME_PRICE_PER_TRAVELLER',
  PrimePricePerTraveller = 'PRIME_PRICE_PER_TRAVELLER'
}

export type ShoppingBasketPriceRequest = {
  collectionOptionIdSelected?: InputMaybe<Scalars['ID']['input']>;
  products?: InputMaybe<Array<ShoppingBasketProductPriceRequest>>;
  shoppingInfo: ShoppingInfo;
};

export type ShoppingBasketPriceResponse = {
  __typename?: 'ShoppingBasketPriceResponse';
  price?: Maybe<ShoppingBasketPrice>;
  pricePerception?: Maybe<ShoppingBasketPricePerception>;
};

export type ShoppingBasketProduct = {
  __typename?: 'ShoppingBasketProduct';
  id: Scalars['ID']['output'];
  price?: Maybe<Money>;
  type: Scalars['String']['output'];
};

export type ShoppingBasketProductPriceBreakdown = {
  __typename?: 'ShoppingBasketProductPriceBreakdown';
  price: ShoppingBasketPrice;
  productId: ProductId;
  /** @deprecated Use price field instead */
  totalPrice: Money;
};

export type ShoppingBasketProductPriceRequest = {
  productId: ProductIdRequest;
  sellingPrice?: InputMaybe<Scalars['String']['input']>;
};

export type ShoppingBasketProductTypePriceBreakdown = {
  __typename?: 'ShoppingBasketProductTypePriceBreakdown';
  price: ShoppingBasketPrice;
  productType: ProductType;
  products: Array<ShoppingBasketProductPriceBreakdown>;
  /** @deprecated Use price field instead */
  totalPrice: Money;
};

export type ShoppingBasketPromoCode = {
  __typename?: 'ShoppingBasketPromoCode';
  amount: Money;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ShoppingBasketRequest = {
  shoppingBasketId: Scalars['String']['input'];
  shoppingType?: InputMaybe<ShoppingType>;
};

export type ShoppingBasketResponse = {
  __typename?: 'ShoppingBasketResponse';
  accommodations?: Maybe<Array<Maybe<AccommodationProduct>>>;
  buyer?: Maybe<Buyer>;
  fastTracks?: Maybe<Array<Maybe<FastTrackShoppingBasketProduct>>>;
  /** @deprecated Field no longer supported */
  insurances?: Maybe<Array<Maybe<InsuranceProduct>>>;
  membershipSubscription?: Maybe<MembershipSubscriptionProduct>;
  priceBreakdown: ShoppingBasketPriceBreakdown;
  products: Array<ProductId>;
  promoCodes: Array<ShoppingBasketPromoCode>;
  shoppingBasketId: Scalars['String']['output'];
  shoppingBasketToken: ShoppingBasketToken;
  totalPrice?: Maybe<Money>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ShoppingBasketResumeRequest = {
  shoppingBasketId: Scalars['ID']['input'];
  userPaymentInteractionId: Scalars['ID']['input'];
};

export type ShoppingBasketToken = {
  __typename?: 'ShoppingBasketToken';
  token: Scalars['String']['output'];
};

export type ShoppingBasketTokenByPayByLinkContentIdRequest = {
  payByLinkContentId: Scalars['ID']['input'];
};

export type ShoppingBasketTokenByPayByLinkContentIdResponse = {
  __typename?: 'ShoppingBasketTokenByPayByLinkContentIdResponse';
  shoppingBasketToken: ShoppingBasketToken;
};

export type ShoppingBasketUserCollectionBrowser = {
  height: Scalars['String']['input'];
  width: Scalars['String']['input'];
};

export type ShoppingBasketUserCollectionTrackingRequest = {
  browserData?: InputMaybe<ShoppingBasketUserCollectionBrowser>;
  shoppingBasketId: Scalars['ID']['input'];
};

export type ShoppingBasketUserCollectionTrackingResponse = {
  __typename?: 'ShoppingBasketUserCollectionTrackingResponse';
  userCollectionTrackingId?: Maybe<Scalars['String']['output']>;
};

export type ShoppingBasketUserPaymentInteractionIdInput = {
  id: Scalars['ID']['input'];
};

export type ShoppingBasketUserPaymentInteractionRequest = {
  userPaymentInteractionId: ShoppingBasketUserPaymentInteractionIdInput;
};

export type ShoppingBasketUserPaymentInteractionResponse = {
  __typename?: 'ShoppingBasketUserPaymentInteractionResponse';
  formSendType?: Maybe<ShoppingBasketFormSendType>;
  javascriptSnippet?: Maybe<Scalars['String']['output']>;
  parameters: Array<UserPaymentInteractionParam>;
  paypalUserPaymentInteraction?: Maybe<PaypalUserPaymentInteraction>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type ShoppingBasketUserStoredCreditCard = {
  __typename?: 'ShoppingBasketUserStoredCreditCard';
  collectionOptionId: Scalars['String']['output'];
  creditCard: ShoppingBasketCreditCard;
};

export type ShoppingBasketUserStoredCreditCardsRequest = {
  shoppingBasketId: Scalars['ID']['input'];
};

export type ShoppingBasketUserStoredCreditCardsResponse = {
  __typename?: 'ShoppingBasketUserStoredCreditCardsResponse';
  userStoredCreditCards: Array<ShoppingBasketUserStoredCreditCard>;
};

export type ShoppingBundle = {
  __typename?: 'ShoppingBundle';
  buyer?: Maybe<Buyer>;
  forms?: Maybe<FormProperties>;
  /** @deprecated Use hasSpecialRequirements in showConfig */
  hasSpecialRequirements: Scalars['Boolean']['output'];
  membershipPerks?: Maybe<MembershipPerks>;
  products?: Maybe<Array<Product>>;
  promoCodeInfo?: Maybe<PromoCodeInfo>;
  repricing?: Maybe<RepricingInfo>;
  shoppingId: Scalars['ID']['output'];
  showConfig: ShowConfig;
  travellers: Array<Maybe<ShoppingTraveller>>;
};

export type ShoppingBundleForTracking = {
  __typename?: 'ShoppingBundleForTracking';
  products?: Maybe<Array<Product>>;
  promoCodeInfo?: Maybe<PromoCodeInfo>;
  shoppingId: Scalars['ID']['output'];
  totalPrice: Money;
};

export type ShoppingBundleForTrackingRequest = {
  collectionMethodInfo?: InputMaybe<CollectionMethodInfo>;
  feeSelected?: InputMaybe<FeeSelected>;
  shoppingInfo?: InputMaybe<ShoppingInfo>;
};

export type ShoppingBundleRequest = {
  shoppingInfo?: InputMaybe<ShoppingInfo>;
};

export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  accommodationShoppingItem?: Maybe<AccommodationShoppingItem>;
  baggageTotalFee?: Maybe<Scalars['Float']['output']>;
  bookingId: Scalars['Long']['output'];
  buyer?: Maybe<Buyer>;
  collectionMethods?: Maybe<AvailableCollectionMethodsResponse>;
  collectionTotalFee?: Maybe<Scalars['Float']['output']>;
  formGroups: FormGroups;
  itinerary?: Maybe<Itinerary>;
  marketingRevenueData?: Maybe<MarketingRevenueData>;
  membershipPerks?: Maybe<MembershipPerks>;
  /** @deprecated perks are included in membershipPerks field */
  membershipPerksFee?: Maybe<Scalars['Float']['output']>;
  nonEssentialProducts?: Maybe<NonEssentialProductsResponse>;
  /** @deprecated Field no longer supported */
  paymentInformation?: Maybe<ShoppingCartPaymentInformation>;
  price: Money;
  requiredBuyerInformation: BuyerInformationDescription;
  requiredTravellerInformation: Array<TravellerInformationDescription>;
  /** @deprecated This attribute will move to price as Money  */
  totalPrice: Scalars['Float']['output'];
  /** @deprecated Use ShoppingBundle query, travellers field */
  travellers: Array<ShoppingCartTraveller>;
};

export type ShoppingCartPaymentInformation = {
  __typename?: 'ShoppingCartPaymentInformation';
  collectionOptions: Array<CollectionMethod>;
  priceLogic: PriceLogic;
};

export type ShoppingCartTraveller = {
  __typename?: 'ShoppingCartTraveller';
  countryCodeOfResidence?: Maybe<Scalars['String']['output']>;
  frequentFlyerNumbers?: Maybe<Array<FrequentFlyerCard>>;
  identification?: Maybe<Scalars['String']['output']>;
  identificationExpirationDate?: Maybe<Scalars['String']['output']>;
  identificationIssueCountryCode?: Maybe<Scalars['String']['output']>;
  identificationType?: Maybe<IdentificationType>;
  localityCodeOfResidence?: Maybe<Scalars['String']['output']>;
  localityNameOfResidence?: Maybe<Scalars['String']['output']>;
  meal?: Maybe<TravellerMeal>;
  numPassenger: Scalars['Int']['output'];
  personalInfo: PersonalInfo;
};

export type ShoppingContactDetailsInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  localityCode?: InputMaybe<Scalars['String']['input']>;
};

export type ShoppingInfo = {
  shoppingId: Scalars['ID']['input'];
  shoppingType: ShoppingType;
};

export type ShoppingPersonalInfoInput = {
  ageType?: InputMaybe<TravellerAgeType>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  firstLastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  secondLastName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<TravellerTitleType>;
  travellerGender?: InputMaybe<TravellerGender>;
};

export type ShoppingSummary = {
  __typename?: 'ShoppingSummary';
  buyer?: Maybe<Buyer>;
  products: Array<Product>;
  totalNumPassengers: Scalars['Int']['output'];
  travellers?: Maybe<Array<ShoppingTraveller>>;
};

export type ShoppingSummaryRequest = {
  collectionMethodId?: InputMaybe<Scalars['Int']['input']>;
  fareItineraryKey: Scalars['String']['input'];
  feeSelected: FeeSelected;
  isMeta?: InputMaybe<Scalars['Boolean']['input']>;
  searchId: Scalars['ID']['input'];
  segmentKeys: Array<Scalars['Int']['input']>;
};

export type ShoppingTraveller = {
  __typename?: 'ShoppingTraveller';
  /** @deprecated Field no longer supported */
  baggageSelections?: Maybe<Array<BaggageSelection>>;
  countryCodeOfResidence?: Maybe<Scalars['String']['output']>;
  frequentFlyerNumbers?: Maybe<Array<FrequentFlyerCard>>;
  identification?: Maybe<Scalars['String']['output']>;
  identificationExpirationDate?: Maybe<Scalars['String']['output']>;
  identificationIssueCountryCode?: Maybe<Scalars['String']['output']>;
  identificationType?: Maybe<IdentificationType>;
  localityCodeOfResidence?: Maybe<Scalars['String']['output']>;
  localityNameOfResidence?: Maybe<Scalars['String']['output']>;
  meal?: Maybe<TravellerMeal>;
  numPassenger: Scalars['Int']['output'];
  personalInfo: PersonalInfo;
};

export type ShoppingTravellerInput = {
  contactDetails?: InputMaybe<ShoppingContactDetailsInput>;
  frequentFlyer?: InputMaybe<Array<FrequentFlyerCardInput>>;
  identificationDetails?: InputMaybe<IdentificationDetailsInput>;
  meal?: InputMaybe<TravellerMeal>;
  nationalityCountryCode?: InputMaybe<Scalars['String']['input']>;
  personalInfo: ShoppingPersonalInfoInput;
  storedTravellerId?: InputMaybe<Scalars['Long']['input']>;
};

export enum ShoppingType {
  BasketV2 = 'BASKET_V2',
  BasketV3 = 'BASKET_V3',
  Cart = 'CART'
}

export type ShowConfig = {
  __typename?: 'ShowConfig';
  hasIdInParticularInvoice: Scalars['Boolean']['output'];
  hasPromoCode: Scalars['Boolean']['output'];
  hasSpecialRequirements: Scalars['Boolean']['output'];
  nonTransparentFeeMessage: Scalars['Boolean']['output'];
};

export type SignupResponse = {
  __typename?: 'SignupResponse';
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type SimpleProduct = {
  __typename?: 'SimpleProduct';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<NonEssentialProductProviderType>;
};

export type SitTogetherFlashOffer = FlashOffer & {
  __typename?: 'SitTogetherFlashOffer';
  id: Scalars['ID']['output'];
  nonPrimePrice: Money;
  offerType: FlashOfferType;
  primePrice: Money;
  productType: FlashOfferProductType;
  seats: Array<SitTogetherSeat>;
};

export type SitTogetherOffer = {
  __typename?: 'SitTogetherOffer';
  price: Money;
  primePrice: Money;
  seats: Array<SitTogetherSeat>;
};

export type SitTogetherSeat = {
  __typename?: 'SitTogetherSeat';
  column: Scalars['String']['output'];
  floor: Scalars['Int']['output'];
  row: Scalars['Int']['output'];
  seatMapRow: Scalars['Int']['output'];
  section: Scalars['Int']['output'];
};

export type Size = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type SmsNotification = {
  __typename?: 'SmsNotification';
  countries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
  smsNotificationType?: Maybe<SmsNotificationProductType>;
};

export enum SmsNotificationProductType {
  Accommodation = 'ACCOMMODATION',
  Dynpack = 'DYNPACK',
  Itinerary = 'ITINERARY'
}

export enum StarRating {
  H0 = 'H0',
  H0_5 = 'H0_5',
  H1 = 'H1',
  H1_5 = 'H1_5',
  H2 = 'H2',
  H2_5 = 'H2_5',
  H3 = 'H3',
  H3_5 = 'H3_5',
  H4 = 'H4',
  H4_5 = 'H4_5',
  H5 = 'H5',
  H5_5 = 'H5_5',
  H7 = 'H7'
}

export type StaticMapResponse = {
  __typename?: 'StaticMapResponse';
  image: Scalars['String']['output'];
};

export type StaticRoomDetails = {
  __typename?: 'StaticRoomDetails';
  mainRoomImage?: Maybe<StaticRoomImage>;
  providerRoomId: Scalars['String']['output'];
  roomDescription?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['String']['output'];
  roomImages?: Maybe<Array<Maybe<StaticRoomImage>>>;
  roomName?: Maybe<Scalars['String']['output']>;
};

export type StaticRoomImage = {
  __typename?: 'StaticRoomImage';
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StatusInfo = {
  __typename?: 'StatusInfo';
  code?: Maybe<CheckoutFailure>;
  message?: Maybe<Scalars['String']['output']>;
  status: CheckoutStatus;
};

export type StoreSmsConsentRequest = {
  consent: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  shoppingId: Scalars['ID']['input'];
  webSiteCode: Scalars['String']['input'];
};

export type StoreSmsConsentResponse = {
  __typename?: 'StoreSmsConsentResponse';
  success: Scalars['Boolean']['output'];
};

export type Style = {
  __typename?: 'Style';
  size?: Maybe<FieldSize>;
  space?: Maybe<FieldSpace>;
};

export type SubRating = {
  __typename?: 'SubRating';
  cleanliness?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['Float']['output']>;
  room?: Maybe<Scalars['Float']['output']>;
  service?: Maybe<Scalars['Float']['output']>;
  sleep?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum SubRatingType {
  Cleanliness = 'CLEANLINESS',
  Location = 'LOCATION',
  Room = 'ROOM',
  Service = 'SERVICE',
  Sleep = 'SLEEP',
  Value = 'VALUE'
}

export type SubscriptionFdoResponse = {
  __typename?: 'SubscriptionFdoResponse';
  email: Scalars['String']['output'];
};

export type SubscriptionOfferDuration = {
  __typename?: 'SubscriptionOfferDuration';
  amount: Scalars['Int']['output'];
  timeUnit: SubscriptionOfferTimeUnit;
};

export enum SubscriptionOfferPeriod {
  FreeTrial = 'FREE_TRIAL',
  Paid = 'PAID'
}

export enum SubscriptionOfferTimeUnit {
  Days = 'DAYS',
  Months = 'MONTHS'
}

export enum SubscriptionOfferType {
  Basic = 'BASIC',
  Plus = 'PLUS'
}

export type SubscriptionOffersRequest = {
  touchpoint: Touchpoint;
};

export enum SubscriptionPbOperationResponseStatus {
  Error = 'ERROR',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type SubscriptionPlanDetails = MembershipPlanDetails & {
  __typename?: 'SubscriptionPlanDetails';
  autoRenewalPolicy: AutoRenewalPolicy;
  duration: SubscriptionOfferDuration;
  id: Scalars['ID']['output'];
  isFreeTrial: Scalars['Boolean']['output'];
  price: Money;
  renewalDuration: SubscriptionOfferDuration;
  renewalPrice: Money;
  tier: SubscriptionOfferType;
};

export type SubscriptionPrice = {
  __typename?: 'SubscriptionPrice';
  price?: Maybe<Money>;
  renewalPrice?: Maybe<Money>;
};

export type SubscriptionResponse = {
  __typename?: 'SubscriptionResponse';
  catalogueOffer?: Maybe<MembershipOffer>;
  duration: SubscriptionOfferDuration;
  /** @deprecated This value is the same as in price, which maps to the real response object. */
  fee: Money;
  offerId: Scalars['String']['output'];
  price: Money;
  productId: Scalars['Long']['output'];
  renewalDuration: SubscriptionOfferDuration;
  renewalPrice: Money;
  subscriptionPeriod: SubscriptionOfferPeriod;
  type?: Maybe<SubscriptionOfferType>;
};

export type Tax = {
  __typename?: 'Tax';
  amount: Money;
  type: Scalars['String']['output'];
};

export type TechnicalStop = {
  __typename?: 'TechnicalStop';
  arrivalDate: Scalars['String']['output'];
  departureDate: Scalars['String']['output'];
  location: Location;
  stopDuration?: Maybe<Scalars['Long']['output']>;
};

export enum ThreeValuedLogic {
  False = 'FALSE',
  True = 'TRUE',
  Unknown = 'UNKNOWN'
}

export type TicketNumber = {
  __typename?: 'TicketNumber';
  airlineCode: Scalars['String']['output'];
  numPassenger: Scalars['Int']['output'];
  number: Scalars['Long']['output'];
};

export type TopDestination = {
  __typename?: 'TopDestination';
  cityName?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  geoNodeId: Scalars['Int']['output'];
  iataCode?: Maybe<Scalars['String']['output']>;
};

export type TouchPointMessagingResponse = {
  __typename?: 'TouchPointMessagingResponse';
  isPrimeWithoutPastHotelBooking?: Maybe<Scalars['Boolean']['output']>;
};

export enum Touchpoint {
  /** @deprecated Field no longer supported */
  AccountDetails = 'ACCOUNT_DETAILS',
  ConfPage = 'CONF_PAGE',
  EmergingLayerPaymentPage = 'EMERGING_LAYER_PAYMENT_PAGE',
  /** @deprecated Field no longer supported */
  Eml = 'EML',
  FlightsConfirmationXsell = 'FLIGHTS_CONFIRMATION_XSELL',
  HomePage = 'HOME_PAGE',
  LoginAndSecurity = 'LOGIN_AND_SECURITY',
  ManageBooking = 'MANAGE_BOOKING',
  MyTrips = 'MY_TRIPS',
  PriceFreeze = 'PRICE_FREEZE',
  UnlockVipSupport = 'UNLOCK_VIP_SUPPORT'
}

export type TrackJavaScriptSnippetFinalizedRequest = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  userPaymentInteractionId: Scalars['String']['input'];
};

export type TrackJavaScriptSnippetResponse = {
  __typename?: 'TrackJavaScriptSnippetResponse';
  success: Scalars['Boolean']['output'];
};

export type TrackingInfo = {
  __typename?: 'TrackingInfo';
  airlinePositionTracking?: Maybe<Array<AirlineTracking>>;
  airlineSteeringTracking?: Maybe<Array<AirlineTracking>>;
  returningUserDeviceId: Scalars['String']['output'];
};

export type TrackingPosition = {
  __typename?: 'TrackingPosition';
  crossFaring: Scalars['Boolean']['output'];
  itineraryId: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

/** Request for the passenger age and type. */
export type TrainPassengerRequest = {
  age: Scalars['Int']['input'];
  travellerType: TravellerType;
};

/**
 * Input for the itinerary train search. Includes all fields from the standard
 * itinerary search (except numAdults, numChildren and numInfants) plus a train passengers request with their specific type and age.
 */
export type TrainSearchItineraryRequest = {
  cabinClass?: InputMaybe<Scalars['String']['input']>;
  excludeCarriers?: InputMaybe<Scalars['Boolean']['input']>;
  passengers: Array<TrainPassengerRequest>;
  segments: Array<SegmentItineraryRequest>;
};

export type Translation = {
  __typename?: 'Translation';
  languageCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum Transmission {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export enum TransportType {
  Plane = 'PLANE',
  Train = 'TRAIN'
}

export type TravelDocument = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['String']['input']>;
  issuingCountry?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TravelDocumentType>;
};

export enum TravelDocumentType {
  NationalId = 'NATIONAL_ID',
  Passport = 'PASSPORT'
}

export type TravelPlan = {
  __typename?: 'TravelPlan';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  products: Array<TravelPlanProduct>;
  startDateTime: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TravelPlanAccommodation = TravelPlanProduct & {
  __typename?: 'TravelPlanAccommodation';
  /** @deprecated the booking has to be nullable */
  booking: Booking;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  crossSellRecommendations: Array<CrossSellProductType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stars?: Maybe<Scalars['Float']['output']>;
  type: ProductType;
};

export type TravelPlanAccommodationV2 = TravelPlanProductV2 & {
  __typename?: 'TravelPlanAccommodationV2';
  booking?: Maybe<BookingV2>;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stars?: Maybe<Scalars['Float']['output']>;
  status: AccommodationStatus;
  type: ProductType;
};

export type TravelPlanItinerary = TravelPlanProduct & {
  __typename?: 'TravelPlanItinerary';
  airportCities: Array<Scalars['String']['output']>;
  /** @deprecated the booking has to be nullable */
  booking: Booking;
  crossSellRecommendations: Array<CrossSellProductType>;
  firstDepartureDateTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastArrivalDateTime: Scalars['String']['output'];
  type: ProductType;
};

export type TravelPlanItineraryPriceFreeze = TravelPlanProduct & {
  __typename?: 'TravelPlanItineraryPriceFreeze';
  /** @deprecated the booking has to be nullable */
  booking: Booking;
  crossSellRecommendations: Array<CrossSellProductType>;
  expirationDateTime: Scalars['Long']['output'];
  frozenItinerary: FrozenItinerary;
  id: Scalars['ID']['output'];
  type: ProductType;
};

export type TravelPlanItineraryPriceFreezeV2 = TravelPlanProductV2 & {
  __typename?: 'TravelPlanItineraryPriceFreezeV2';
  booking?: Maybe<BookingV2>;
  expirationDateTime: Scalars['Long']['output'];
  frozenItinerary: FrozenItinerary;
  id: Scalars['ID']['output'];
  status: PriceFreezeStatus;
  type: ProductType;
};

export type TravelPlanItineraryV2 = TravelPlanProductV2 & {
  __typename?: 'TravelPlanItineraryV2';
  booking?: Maybe<BookingV2>;
  cities: Array<Scalars['String']['output']>;
  firstDepartureDateTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastArrivalDateTime: Scalars['String']['output'];
  sectionTypes: Array<ItinerarySectionType>;
  status: ItineraryStatus;
  type: ProductType;
};

export type TravelPlanProduct = {
  /** @deprecated the booking has to be nullable */
  booking: Booking;
  /** @deprecated the recommendations have been moved to the travel plan level */
  crossSellRecommendations: Array<CrossSellProductType>;
  id: Scalars['ID']['output'];
  type: ProductType;
};

export type TravelPlanProductV2 = {
  booking?: Maybe<BookingV2>;
  id: Scalars['ID']['output'];
  type: ProductType;
};

export type TravelPlanV2 = {
  __typename?: 'TravelPlanV2';
  crossSellRecommendations: Array<CrossSellProductType>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  products: Array<TravelPlanProductV2>;
  startDateTime: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TravelPlanVehicleRental = TravelPlanProductV2 & {
  __typename?: 'TravelPlanVehicleRental';
  booking?: Maybe<BookingV2>;
  dropOffDateTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modelName: Scalars['String']['output'];
  pickUpDateTime: Scalars['String']['output'];
  providerBookingDeeplink?: Maybe<Scalars['String']['output']>;
  providerBookingReference: Scalars['String']['output'];
  status: VehicleRentalStatus;
  type: ProductType;
};

export type TravelPlansImportBookingByTripDetailsTokenRequest = {
  token: Scalars['String']['input'];
};

export type TravelPlansImportBookingRequest = {
  bookingId: Scalars['Long']['input'];
  email: Scalars['String']['input'];
};

export type TravelPlansImportBookingResponse = {
  __typename?: 'TravelPlansImportBookingResponse';
  bookingId: Scalars['Long']['output'];
  /** @deprecated Field no longer supported */
  travelPlans: TravelPlansResponse;
};

export type TravelPlansImportBookingResponseV2 = {
  __typename?: 'TravelPlansImportBookingResponseV2';
  importedBookingId: Scalars['Long']['output'];
  upcoming: Array<TravelPlanV2>;
};

export type TravelPlansResponse = {
  __typename?: 'TravelPlansResponse';
  /** @deprecated Field no longer supported */
  upcoming: Array<TravelPlan>;
};

export type TravelPlansResponseV2 = {
  __typename?: 'TravelPlansResponseV2';
  upcoming: Array<TravelPlanV2>;
};

export type Traveller = {
  __typename?: 'Traveller';
  age?: Maybe<Scalars['Int']['output']>;
  baggages: Array<TravellerBaggage>;
  birthDate?: Maybe<Scalars['String']['output']>;
  boardingPreferences: Array<BoardingPreference>;
  firstLastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nationalityCountryCode?: Maybe<Scalars['String']['output']>;
  numPassenger?: Maybe<Scalars['Int']['output']>;
  seats: Array<TravellerSeat>;
  secondLastName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  travellerGender?: Maybe<TravellerGender>;
  travellerType: Scalars['String']['output'];
};

export type TravellerAddress = {
  __typename?: 'TravellerAddress';
  address?: Maybe<Scalars['String']['output']>;
  addressType?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum TravellerAgeType {
  Adult = 'ADULT',
  Child = 'CHILD',
  Infant = 'INFANT'
}

export type TravellerBaggage = {
  __typename?: 'TravellerBaggage';
  baggageDescriptionList: Array<BaggageDescriptor>;
  from: Location;
  to: Location;
};

export enum TravellerGender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type TravellerInformationDescription = {
  __typename?: 'TravellerInformationDescription';
  availableMeals?: Maybe<Array<TravellerMealType>>;
  baggageConditions: Array<BaggageConditions>;
  conditionallyNeededFields?: Maybe<Array<Maybe<TravellerInformationFieldConditionRule>>>;
  frequentFlyerAirlineGroups?: Maybe<Array<AirlineGroup>>;
  identificationTypes?: Maybe<Array<IdentificationType>>;
  needsBirthDate: RequiredFieldType;
  needsCountryOfResidence: RequiredFieldType;
  needsGender: RequiredFieldType;
  needsIdentification: RequiredFieldType;
  needsIdentificationCountry: RequiredFieldType;
  needsIdentificationExpirationDate: RequiredFieldType;
  needsName: RequiredFieldType;
  needsNationality: RequiredFieldType;
  needsTitle: RequiredFieldType;
  residentGroups?: Maybe<Array<Maybe<ResidentGroupContainer>>>;
  travellerType: TravellerAgeType;
};

export enum TravellerInformationField {
  Age = 'AGE',
  BirthDate = 'BIRTH_DATE',
  CountryOfResidence = 'COUNTRY_OF_RESIDENCE',
  FirstLastName = 'FIRST_LAST_NAME',
  FrequentFlyerCardAirlineCode = 'FREQUENT_FLYER_CARD_AIRLINE_CODE',
  FrequentFlyerCardNumber = 'FREQUENT_FLYER_CARD_NUMBER',
  Gender = 'GENDER',
  Identification = 'IDENTIFICATION',
  IdentificationCountry = 'IDENTIFICATION_COUNTRY',
  IdentificationExpirationDate = 'IDENTIFICATION_EXPIRATION_DATE',
  IdentificationType = 'IDENTIFICATION_TYPE',
  MiddleName = 'MIDDLE_NAME',
  MobileNumber = 'MOBILE_NUMBER',
  Name = 'NAME',
  Nationality = 'NATIONALITY',
  PhoneNumber = 'PHONE_NUMBER',
  Resident = 'RESIDENT',
  SecondLastName = 'SECOND_LAST_NAME',
  Title = 'TITLE'
}

export type TravellerInformationFieldCondition = {
  __typename?: 'TravellerInformationFieldCondition';
  travellerInformationField?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TravellerInformationFieldConditionRule = {
  __typename?: 'TravellerInformationFieldConditionRule';
  conditionallyRequiredTravellerInformationField?: Maybe<TravellerInformationField>;
  travellerInformationFieldConditions?: Maybe<Array<Maybe<TravellerInformationFieldCondition>>>;
};

export type TravellerInput = {
  contactDetails?: InputMaybe<ContactDetailsInput>;
  personalInfo?: InputMaybe<PersonalInfoInput>;
};

export enum TravellerMeal {
  Baby = 'BABY',
  Child = 'CHILD',
  Diabetic = 'DIABETIC',
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  Hindu = 'HINDU',
  Kosher = 'KOSHER',
  LowCholesterol = 'LOW_CHOLESTEROL',
  LowSodium = 'LOW_SODIUM',
  Standard = 'STANDARD',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

export enum TravellerMealType {
  Baby = 'BABY',
  Child = 'CHILD',
  Diabetic = 'DIABETIC',
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  Hindu = 'HINDU',
  Kosher = 'KOSHER',
  LowCholesterol = 'LOW_CHOLESTEROL',
  LowSodium = 'LOW_SODIUM',
  Standard = 'STANDARD',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

export type TravellerSeat = {
  __typename?: 'TravellerSeat';
  from?: Maybe<Location>;
  seatDescription?: Maybe<TravellerSeatDescription>;
  sectionId?: Maybe<Scalars['ID']['output']>;
  to?: Maybe<Location>;
};

export type TravellerSeatDescription = {
  __typename?: 'TravellerSeatDescription';
  assignedSeat?: Maybe<Scalars['String']['output']>;
  columnSelection?: Maybe<Scalars['String']['output']>;
  rowSelection?: Maybe<Scalars['String']['output']>;
};

export enum TravellerTitleType {
  Mr = 'MR',
  Mrs = 'MRS',
  Ms = 'MS'
}

/** Enum for the travellerType. */
export enum TravellerType {
  Adult = 'ADULT',
  Child = 'CHILD',
  Infant = 'INFANT'
}

export type Trip = {
  __typename?: 'Trip';
  /** @deprecated old data structure (from travel-companion), for any new implementation use accommodationProductBooking (from accommodation-booking) instead */
  accommodationBooking?: Maybe<AccommodationBooking>;
  accommodationInsuranceTripDetails?: Maybe<AccommodationInsuranceTripDetails>;
  accommodationProductBooking?: Maybe<AccommodationProductBooking>;
  additions: Array<NonEssentialProduct>;
  bookingCancellationOptions: Array<BookingCancellationOption>;
  bookingDisplayStatus: BookingDisplayStatus;
  bookingInterface: Scalars['String']['output'];
  bookingProductStatus?: Maybe<BookingProductStatus>;
  bookingStatus?: Maybe<BookingStatus>;
  bookingUserComment?: Maybe<Scalars['String']['output']>;
  buyer: Buyer;
  carriersConfiguration: Array<CabinBagCarrierConfigurationEntry>;
  creationDate: Scalars['Long']['output'];
  creationDateISO8601: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insuranceBookings: InsuranceBookings;
  itinerary?: Maybe<TripItinerary>;
  itineraryPriceFreeze?: Maybe<ItineraryPriceFreezeBooking>;
  mmbToken: Scalars['String']['output'];
  paymentDetails?: Maybe<PaymentDetails>;
  premiumOptions: Array<NonEssentialProduct>;
  price: Money;
  prime: Scalars['Boolean']['output'];
  primeMembershipContracted: Scalars['Boolean']['output'];
  serviceOptions: Array<NonEssentialProduct>;
  shoppingBasket?: Maybe<ShoppingBasket>;
  shoppingBasketsProductDetails: Array<TripProduct>;
  tdToken: Scalars['String']['output'];
  travellers: Array<Maybe<Traveller>>;
  userSessionLocale: Scalars['String']['output'];
  website: Website;
};

export type TripFilter = {
  messageFilter?: InputMaybe<MessageFilter>;
};

export type TripItinerary = {
  __typename?: 'TripItinerary';
  arrivalDate: Scalars['Long']['output'];
  arrivalDateISO8601: Scalars['String']['output'];
  bookingItemId: Scalars['Long']['output'];
  departureDate: Scalars['Long']['output'];
  departureDateISO8601: Scalars['String']['output'];
  destination?: Maybe<Location>;
  isItineraryCancellationAvailable: Scalars['Boolean']['output'];
  itineraryType?: Maybe<Scalars['String']['output']>;
  legs: Array<TripLeg>;
  origin?: Maybe<Location>;
  transportTypes: Array<TransportType>;
  tripType: TripType;
};

export type TripLeg = {
  __typename?: 'TripLeg';
  /** @deprecated old data structure, use originalDurationInMinutes instead */
  duration: Scalars['Int']['output'];
  originalDurationInMinutes: Scalars['Int']['output'];
  sections: Array<TripSection>;
  transportTypes: Array<TransportType>;
  updatedDurationInMinutes: Scalars['Int']['output'];
};

export enum TripListFilter {
  MostRelevant = 'MOST_RELEVANT',
  Past = 'PAST',
  Upcoming = 'UPCOMING',
  UpcomingNotDidnotbuy = 'UPCOMING_NOT_DIDNOTBUY'
}

export type TripListResponse = {
  __typename?: 'TripListResponse';
  trips?: Maybe<Array<Maybe<EnrichedTrip>>>;
  userMembership?: Maybe<UserMembership>;
};

export type TripProduct = Product & {
  __typename?: 'TripProduct';
  id?: Maybe<ProductId>;
  price?: Maybe<Money>;
  status: TripProductStatus;
};

export enum TripProductStatus {
  Contract = 'CONTRACT',
  Didnotbuy = 'DIDNOTBUY',
  Init = 'INIT',
  Pending = 'PENDING',
  Request = 'REQUEST'
}

export type TripResponse = {
  __typename?: 'TripResponse';
  messages?: Maybe<Array<Message>>;
  trip: Trip;
  userMembership?: Maybe<UserMembership>;
};

export type TripSection = {
  __typename?: 'TripSection';
  additionalPnr?: Maybe<Scalars['String']['output']>;
  arrival: Location;
  arrivalDate: Scalars['Long']['output'];
  arrivalDateISO8601: Scalars['String']['output'];
  arrivalInfo: Arrival;
  cabinClass?: Maybe<CabinClass>;
  cabinClassCode: Scalars['String']['output'];
  carrier: Carrier;
  carrierCustomerAccount?: Maybe<CarrierCustomerAccount>;
  departure: Location;
  departureDate: Scalars['Long']['output'];
  departureDateISO8601: Scalars['String']['output'];
  departureInfo: Departure;
  /** @deprecated old data structure, use originalDurationInMinutes instead */
  duration: Scalars['Long']['output'];
  flightCode: Scalars['String']['output'];
  flightStatus: FlightStatus;
  hasMerchantPayments: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  operatingCarrier?: Maybe<Carrier>;
  originalDurationInMinutes: Scalars['Long']['output'];
  pnr?: Maybe<Scalars['String']['output']>;
  productStatus?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  providerBookingItemId: Scalars['ID']['output'];
  sectionType: SectionType;
  stopDurationInMinutes: Scalars['Long']['output'];
  ticketNumbers?: Maybe<Array<TicketNumber>>;
  transportType: TransportType;
  updatedDurationInMinutes: Scalars['Long']['output'];
  validatingCarrier?: Maybe<Carrier>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
};

export type TripShoppingBasketPromoCode = {
  __typename?: 'TripShoppingBasketPromoCode';
  code: Scalars['String']['output'];
  price: Money;
};

export type TripToken = {
  __typename?: 'TripToken';
  bookingId: Scalars['Long']['output'];
  email: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export enum TripType {
  MultipleDestinations = 'MULTIPLE_DESTINATIONS',
  OneWay = 'ONE_WAY',
  RoundTrip = 'ROUND_TRIP'
}

export type TripTypeReviewCountAndPercentage = {
  __typename?: 'TripTypeReviewCountAndPercentage';
  business: ReviewCountAndPercentage;
  couples: ReviewCountAndPercentage;
  family: ReviewCountAndPercentage;
  friends: ReviewCountAndPercentage;
  solo: ReviewCountAndPercentage;
};

export type TripadvisorReview = {
  __typename?: 'TripadvisorReview';
  awards: Array<Award>;
  bubbleRating: Scalars['Float']['output'];
  cityAccommodationRanking: CityAccommodationRanking;
  highlightedSubRatingTypes: Array<SubRatingType>;
  rating: Scalars['Float']['output'];
  subRatings?: Maybe<SubRating>;
  totalReviews: Scalars['Int']['output'];
  tripTypeReviewCountAndPercentage: TripTypeReviewCountAndPercentage;
  tripadvisorReviewsUrl: Scalars['String']['output'];
  userReviews: Array<TripadvisorUserReview>;
};

export type TripadvisorReviewRequest = {
  /** @deprecated The language will be retrieved from the visit */
  language?: InputMaybe<Language>;
  propertyMappingId: Scalars['Int']['input'];
};

export type TripadvisorReviewResponse = {
  __typename?: 'TripadvisorReviewResponse';
  tripadvisorReview?: Maybe<TripadvisorReview>;
};

export enum TripadvisorTripType {
  Business = 'BUSINESS',
  Couples = 'COUPLES',
  Family = 'FAMILY',
  Friends = 'FRIENDS',
  Solo = 'SOLO'
}

export type TripadvisorUserReview = {
  __typename?: 'TripadvisorUserReview';
  highlighted: Scalars['Boolean']['output'];
  rating: Scalars['Float']['output'];
  subRatings?: Maybe<SubRating>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  translated: Scalars['Boolean']['output'];
  travelDate: Scalars['String']['output'];
  tripType?: Maybe<TripadvisorTripType>;
  userCityAndCountry?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type TrustpilotParamsResponse = {
  __typename?: 'TrustpilotParamsResponse';
  businessUnitId: Scalars['String']['output'];
  href: Scalars['String']['output'];
  language: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  template?: Maybe<TrustpilotTemplate>;
};

export type TrustpilotTemplate = {
  __typename?: 'TrustpilotTemplate';
  ratingId: Scalars['String']['output'];
  reviewsId: Scalars['String']['output'];
};

export type UnbundledMapping = {
  __typename?: 'UnbundledMapping';
  bestMeRating: Scalars['Float']['output'];
  cheapestFees: Array<SearchResponseFee>;
  compatibleInboundSegments: Array<CompatibleInboundSegment>;
  outboundSegmentId: Scalars['ID']['output'];
};

export enum UnbundledMappingGroupingType {
  Default = 'DEFAULT',
  TransportTypes = 'TRANSPORT_TYPES'
}

export type UnchainedMembershipOfferToken = {
  __typename?: 'UnchainedMembershipOfferToken';
  token: Scalars['String']['output'];
};

export type UnchainedMembershipOfferTokenInput = {
  token: Scalars['String']['input'];
};

export type UniversalContactDetailsResponse = {
  __typename?: 'UniversalContactDetailsResponse';
  success: Scalars['Boolean']['output'];
};

export type UniversalRevenueForTrackingRequest = {
  products: Array<UniversalRevenueProductPerType>;
};

export type UniversalRevenueForTrackingResponse = {
  __typename?: 'UniversalRevenueForTrackingResponse';
  rMarketing: Scalars['Float']['output'];
  rSem: Scalars['Float']['output'];
};

export type UniversalRevenueProduct = {
  revenue: Scalars['Float']['input'];
  totalPrice: UniversalShoppingBasketMoneyRequest;
};

export type UniversalRevenueProductPerType = {
  productType: UniversalShoppingBasketProductType;
  products: Array<UniversalRevenueProduct>;
};

export type UniversalShoppingBasketApplePayCollectionOption = {
  __typename?: 'UniversalShoppingBasketApplePayCollectionOption';
  id: Scalars['ID']['output'];
};

export type UniversalShoppingBasketBundle = {
  __typename?: 'UniversalShoppingBasketBundle';
  checkoutFlow: UniversalShoppingBasketBundleCheckoutFlow;
  id: Scalars['ID']['output'];
  type: UniversalShoppingBasketBundleType;
};

export enum UniversalShoppingBasketBundleCheckoutFlow {
  AncillaryBundleFlow = 'ANCILLARY_BUNDLE_FLOW'
}

export type UniversalShoppingBasketBundlePriceBreakdown = {
  __typename?: 'UniversalShoppingBasketBundlePriceBreakdown';
  bundleId: UniversalShoppingBasketBundle;
  price: ShoppingBasketPrice;
};

export enum UniversalShoppingBasketBundleType {
  AncillaryBundle = 'ANCILLARY_BUNDLE'
}

export type UniversalShoppingBasketBundleTypePriceBreakdown = {
  __typename?: 'UniversalShoppingBasketBundleTypePriceBreakdown';
  bundleType: UniversalShoppingBasketBundleType;
  bundles: Array<UniversalShoppingBasketBundlePriceBreakdown>;
  price: ShoppingBasketPrice;
};

export type UniversalShoppingBasketByTokenRequest = {
  shoppingBasketToken: Scalars['String']['input'];
};

export type UniversalShoppingBasketCheckoutOptionsRequest = {
  shoppingBasketId: Scalars['ID']['input'];
};

export type UniversalShoppingBasketCheckoutOptionsResponse = {
  __typename?: 'UniversalShoppingBasketCheckoutOptionsResponse';
  collectionOptions: UniversalShoppingBasketCollectionOptions;
};

export enum UniversalShoppingBasketCheckoutStatus {
  Finished = 'FINISHED',
  NotStarted = 'NOT_STARTED',
  PendingCollection = 'PENDING_COLLECTION',
  RolledBack = 'ROLLED_BACK',
  Started = 'STARTED',
  UserPaymentInteraction = 'USER_PAYMENT_INTERACTION'
}

export type UniversalShoppingBasketCollectionOptions = {
  __typename?: 'UniversalShoppingBasketCollectionOptions';
  applePayCollectionOptions: Array<UniversalShoppingBasketApplePayCollectionOption>;
  creditCardCollectionOptions: Array<UniversalShoppingBasketCreditCardCollectionOption>;
  googlePayCollectionOptions: Array<UniversalShoppingBasketGooglePayCollectionOption>;
  idealCollectionOptions: Array<UniversalShoppingBasketIdealCollectionOption>;
  paypalCollectionOptions: Array<UniversalShoppingBasketPaypalCollectionOption>;
};

export type UniversalShoppingBasketContactDetails = {
  __typename?: 'UniversalShoppingBasketContactDetails';
  address: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  countryPhoneNumber?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  typePhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type UniversalShoppingBasketCreditCardCollectionOption = {
  __typename?: 'UniversalShoppingBasketCreditCardCollectionOption';
  creditCardType: UniversalShoppingBasketCreditCardType;
  id: Scalars['ID']['output'];
};

export type UniversalShoppingBasketCreditCardType = {
  __typename?: 'UniversalShoppingBasketCreditCardType';
  category: Scalars['String']['output'];
  code?: Maybe<MethodTypeCode>;
  name: Scalars['String']['output'];
  scheme: Scalars['String']['output'];
};

export type UniversalShoppingBasketForTrackingResponse = {
  __typename?: 'UniversalShoppingBasketForTrackingResponse';
  bookingId: Scalars['ID']['output'];
  priceBreakdown: UniversalShoppingBasketPriceBreakdown;
  promoCodes: Array<UniversalShoppingBasketPromoCode>;
};

export type UniversalShoppingBasketGooglePayCollectionOption = {
  __typename?: 'UniversalShoppingBasketGooglePayCollectionOption';
  id: Scalars['ID']['output'];
};

export type UniversalShoppingBasketIdealCollectionOption = {
  __typename?: 'UniversalShoppingBasketIdealCollectionOption';
  id: Scalars['ID']['output'];
};

export type UniversalShoppingBasketMoneyRequest = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export type UniversalShoppingBasketPaypalCollectionOption = {
  __typename?: 'UniversalShoppingBasketPaypalCollectionOption';
  id: Scalars['ID']['output'];
};

export type UniversalShoppingBasketPriceBreakdown = {
  __typename?: 'UniversalShoppingBasketPriceBreakdown';
  price: ShoppingBasketPrice;
  priceBreakDownByBundleType: Array<UniversalShoppingBasketBundleTypePriceBreakdown>;
  priceBreakDownByProductType: Array<UniversalShoppingBasketProductTypePriceBreakdown>;
};

export type UniversalShoppingBasketProduct = {
  __typename?: 'UniversalShoppingBasketProduct';
  id: Scalars['ID']['output'];
  type: UniversalShoppingBasketProductType;
};

export type UniversalShoppingBasketProductPriceBreakdown = {
  __typename?: 'UniversalShoppingBasketProductPriceBreakdown';
  price: ShoppingBasketPrice;
  productId: UniversalShoppingBasketProduct;
};

export type UniversalShoppingBasketProductRequest = {
  id: Scalars['ID']['input'];
  type: UniversalShoppingBasketProductType;
};

export type UniversalShoppingBasketProductResponse = {
  __typename?: 'UniversalShoppingBasketProductResponse';
  success: Scalars['Boolean']['output'];
};

export enum UniversalShoppingBasketProductType {
  Accommodation = 'ACCOMMODATION',
  AirportFastTrack = 'AIRPORT_FAST_TRACK',
  Baggage = 'BAGGAGE',
  ItineraryPriceFreeze = 'ITINERARY_PRICE_FREEZE',
  MembershipRenewal = 'MEMBERSHIP_RENEWAL',
  MembershipSubscription = 'MEMBERSHIP_SUBSCRIPTION',
  RecurringPaymentInstrumentVerifier = 'RECURRING_PAYMENT_INSTRUMENT_VERIFIER',
  Seat = 'SEAT'
}

export type UniversalShoppingBasketProductTypePriceBreakdown = {
  __typename?: 'UniversalShoppingBasketProductTypePriceBreakdown';
  price: ShoppingBasketPrice;
  productType: UniversalShoppingBasketProductType;
  products: Array<UniversalShoppingBasketProductPriceBreakdown>;
};

export type UniversalShoppingBasketPromoCode = {
  __typename?: 'UniversalShoppingBasketPromoCode';
  amount: Money;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type UniversalShoppingBasketPromoCodeResponse = {
  __typename?: 'UniversalShoppingBasketPromoCodeResponse';
  success: Scalars['Boolean']['output'];
};

export type UniversalShoppingBasketRequest = {
  shoppingBasketId: Scalars['ID']['input'];
};

export type UniversalShoppingBasketResponse = {
  __typename?: 'UniversalShoppingBasketResponse';
  bundles: Array<UniversalShoppingBasketBundle>;
  checkoutStatus: UniversalShoppingBasketCheckoutStatus;
  contactDetails?: Maybe<UniversalShoppingBasketContactDetails>;
  priceBreakdown: UniversalShoppingBasketPriceBreakdown;
  products: Array<UniversalShoppingBasketProduct>;
  promoCodes: Array<UniversalShoppingBasketPromoCode>;
  shoppingBasketId: Scalars['ID']['output'];
  shoppingBasketToken: UniversalShoppingBasketToken;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UniversalShoppingBasketToken = {
  __typename?: 'UniversalShoppingBasketToken';
  token: Scalars['String']['output'];
};

export type UnlimitedAvailableMembershipPerk = BaseMembershipPerk & {
  __typename?: 'UnlimitedAvailableMembershipPerk';
  type: MembershipPerkType;
};

export type UnlimitedContractedMembershipPerk = BaseMembershipPerk & {
  __typename?: 'UnlimitedContractedMembershipPerk';
  type: MembershipPerkType;
};

export type UnlimitedMembershipPerk = BaseMembershipPerk & {
  __typename?: 'UnlimitedMembershipPerk';
  type: MembershipPerkType;
};

export type UnlimitedPrimeSubscriptionOfferTierValuePropositionPerk = PrimeSubscriptionOfferTierValuePropositionPerk & {
  __typename?: 'UnlimitedPrimeSubscriptionOfferTierValuePropositionPerk';
  type: PrimeOfferTierValuePropositionPerkType;
};

export type UnselectAccommodationInsuranceRequest = {
  productId: Scalars['String']['input'];
  shoppingBasketId: Scalars['ID']['input'];
};

export type UnselectAccommodationInsuranceResponse = {
  __typename?: 'UnselectAccommodationInsuranceResponse';
  productId: Scalars['String']['output'];
};

export type UnselectFastTrackRequest = {
  bookingId?: InputMaybe<Scalars['Long']['input']>;
  productId: Scalars['ID']['input'];
  shoppingBasketId?: InputMaybe<Scalars['ID']['input']>;
};

export type UnselectFastTrackResponse = {
  __typename?: 'UnselectFastTrackResponse';
  productId?: Maybe<Scalars['ID']['output']>;
};

export type UnsubscriptionRequest = {
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UnsubscriptionResponse = {
  __typename?: 'UnsubscriptionResponse';
  email: Scalars['String']['output'];
};

export type UpdateConsentRequest = {
  consent: Consent;
  incidentId: Scalars['ID']['input'];
  tripDetailsToken: Scalars['String']['input'];
};

export type UpdateConsentResponse = {
  __typename?: 'UpdateConsentResponse';
  incidentId: Scalars['ID']['output'];
};

export type UpdateMembershipProductRequest = {
  action: MembershipSubscriptionActions;
  email: Scalars['String']['input'];
  lastNames: Scalars['String']['input'];
  names: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  shoppingInfo: ShoppingInfo;
};

export type UpdateProductsInShoppingBasketActionStatus = {
  __typename?: 'UpdateProductsInShoppingBasketActionStatus';
  productId: ProductId;
  success: Scalars['Boolean']['output'];
};

export type UpdateProductsInShoppingBasketRequest = {
  productsToAdd: Array<InputMaybe<ProductIdRequest>>;
  productsToRemove: Array<InputMaybe<ProductIdRequest>>;
  shoppingId: Scalars['String']['input'];
};

export type UpdateProductsInShoppingBasketResponse = {
  __typename?: 'UpdateProductsInShoppingBasketResponse';
  status: Array<Maybe<UpdateProductsInShoppingBasketActionStatus>>;
};

export type UpdateRecurringCollectionRequest = {
  id: Scalars['ID']['input'];
  paymentInstrumentToken: Scalars['ID']['input'];
};

export type UpdateSubscriptionProductBinBasedRequest = {
  action: MembershipSubscriptionActions;
  creditCardBin: Scalars['String']['input'];
  email: Scalars['String']['input'];
  lastNames: Scalars['String']['input'];
  names: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
  shoppingInfo: ShoppingInfo;
};

export enum UpdateUserMembershipAction {
  ActivateMembership = 'ACTIVATE_MEMBERSHIP',
  ActivateRenewalReminder = 'ACTIVATE_RENEWAL_REMINDER',
  ActivateRenewalStatus = 'ACTIVATE_RENEWAL_STATUS',
  DeactivateMembership = 'DEACTIVATE_MEMBERSHIP',
  DeactivateRenewalReminder = 'DEACTIVATE_RENEWAL_REMINDER',
  DeactivateRenewalStatus = 'DEACTIVATE_RENEWAL_STATUS'
}

export enum UpdateUserMembershipPlanAction {
  DowngradeMembership = 'DOWNGRADE_MEMBERSHIP',
  UpgradeMembership = 'UPGRADE_MEMBERSHIP'
}

export type UpdateUserMembershipPlanRequest = {
  action: UpdateUserMembershipPlanAction;
  membershipUpdateInfo: MembershipUpdateInfo;
  shoppingInfo?: InputMaybe<ShoppingInfo>;
};

export type UpdateUserMembershipRequest = {
  action: UpdateUserMembershipAction;
  shoppingInfo?: InputMaybe<ShoppingInfo>;
};

export type UsageDateConditions = {
  __typename?: 'UsageDateConditions';
  requiredUsageDateAfter?: Maybe<Scalars['String']['output']>;
  requiredUsageDateBefore?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  creditCards?: Maybe<UserCreditCardsResponse>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  membership?: Maybe<Membership>;
  travellers?: Maybe<Array<UserTraveller>>;
};

export type UserAccountRequest = {
  paymentInstrumentFilter?: InputMaybe<PaymentInstrumentFilter>;
  shoppingInfo?: InputMaybe<ShoppingInfo>;
  walletFilter?: InputMaybe<UserWalletFilter>;
};

export type UserAccountResponse = {
  __typename?: 'UserAccountResponse';
  email: Scalars['String']['output'];
  isAllowedToDelete: Scalars['Boolean']['output'];
  isLoggedIn: Scalars['Boolean']['output'];
  isRegistered: Scalars['Boolean']['output'];
  passwordChangeAllowed: Scalars['Boolean']['output'];
  passwordPresent: Scalars['Boolean']['output'];
  userDefaultProfile?: Maybe<UserDefaultProfile>;
  userMembership: UserMembership;
  userPaymentInstruments: Array<Maybe<UserPaymentInstrument>>;
  userTravellers: Array<Maybe<UserTraveller>>;
  /** @deprecated Use userWallet instead */
  userVouchers: UserVouchers;
  userWallet?: Maybe<UserWallet>;
};

export type UserAreaAccess = {
  __typename?: 'UserAreaAccess';
  canAccess: Scalars['Boolean']['output'];
  notAccessibleReason?: Maybe<UserAreaNotAccessibleReason>;
};

export enum UserAreaNotAccessibleReason {
  AuthenticationNeeded = 'AUTHENTICATION_NEEDED'
}

export type UserCollectionBrowser = {
  height: Scalars['String']['input'];
  width: Scalars['String']['input'];
};

export type UserCollectionTrackingRequest = {
  browserData?: InputMaybe<UserCollectionBrowser>;
  shoppingInfo: ShoppingInfo;
};

export type UserCollectionTrackingResponse = {
  __typename?: 'UserCollectionTrackingResponse';
  userCollectionTrackingId?: Maybe<Scalars['String']['output']>;
};

export type UserCreditCardInfo = {
  creditCardTypeCode: Scalars['String']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  paymentInstrumentToken: Scalars['String']['input'];
};

export type UserCreditCardsResponse = {
  __typename?: 'UserCreditCardsResponse';
  creditCards?: Maybe<Array<CreditCards>>;
};

export type UserDefaultProfile = {
  __typename?: 'UserDefaultProfile';
  address?: Maybe<Address>;
  displayName?: Maybe<Scalars['String']['output']>;
  lastNames?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Phone>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  id: Scalars['ID']['output'];
  isPrime: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type UserInteractionNeededResponse = {
  __typename?: 'UserInteractionNeededResponse';
  formSendType: FormSendType;
  htmlCode?: Maybe<Scalars['String']['output']>;
  interactionStep: Scalars['Int']['output'];
  interactionType: InteractionType;
  javascriptSnippet?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Array<Param>>;
  paypalToken?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type UserMembership = {
  __typename?: 'UserMembership';
  accountDetails?: Maybe<UserMembershipAccountDetails>;
  activeMemberSince?: Maybe<Scalars['String']['output']>;
  associatedBookings: Array<PrimeBooking>;
  availablePlans: Array<Maybe<MembershipPlanDetails>>;
  isActive: Scalars['Boolean']['output'];
  membershipID: Scalars['ID']['output'];
  membershipRewards?: Maybe<MembershipRewards>;
  subscriptionDetails?: Maybe<UserMembershipSubscriptionDetails>;
};

export type UserMembershipAccountDetails = {
  __typename?: 'UserMembershipAccountDetails';
  lastNames?: Maybe<Scalars['String']['output']>;
  names?: Maybe<Scalars['String']['output']>;
};

export type UserMembershipCollectionDetails = {
  __typename?: 'UserMembershipCollectionDetails';
  transactionDate: Scalars['String']['output'];
  userPaymentInstrument: UserPaymentInstrument;
};

export enum UserMembershipPerk {
  AccommodationDiscount = 'ACCOMMODATION_DISCOUNT',
  AccommodationShippingAndHandlingCancellation = 'ACCOMMODATION_SHIPPING_AND_HANDLING_CANCELLATION',
  BaggagesDiscount = 'BAGGAGES_DISCOUNT',
  FriendsAndFamilies = 'FRIENDS_AND_FAMILIES',
  ItineraryCancellation = 'ITINERARY_CANCELLATION',
  ItineraryDiscount = 'ITINERARY_DISCOUNT',
  ItineraryShippingAndHandlingCancellation = 'ITINERARY_SHIPPING_AND_HANDLING_CANCELLATION',
  SeatsDiscount = 'SEATS_DISCOUNT',
  UnlimitedPriceFreezeDiscount = 'UNLIMITED_PRICE_FREEZE_DISCOUNT'
}

export type UserMembershipSubscriptionDetails = {
  __typename?: 'UserMembershipSubscriptionDetails';
  activationDate?: Maybe<Scalars['String']['output']>;
  automaticallyCancellable?: Maybe<Scalars['Boolean']['output']>;
  availablePerks: Array<AvailableMembershipPerk>;
  cancellationInfo?: Maybe<CancellationInfo>;
  collectionDetails?: Maybe<UserMembershipCollectionDetails>;
  committedUntil: Scalars['String']['output'];
  contractedPerks: Array<ContractedMembershipPerk>;
  currentPlanDetails?: Maybe<MembershipPlanDetails>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  hasValidRenewablePaymentMethod: Scalars['Boolean']['output'];
  isAutoRenewalEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFreeTrial?: Maybe<Scalars['Boolean']['output']>;
  isRemindRenewalEnabled?: Maybe<Scalars['Boolean']['output']>;
  loyaltyRewardsProgram?: Maybe<LoyaltyRewardsProgram>;
  manuallyCancellable: Scalars['Boolean']['output'];
  /** @deprecated Use availablePerks or contractedPerks instead */
  perks: Array<UserMembershipPerk>;
  status?: Maybe<UserMembershipSubscriptionStatus>;
};

export enum UserMembershipSubscriptionStatus {
  Activated = 'ACTIVATED',
  Expired = 'EXPIRED',
  Pta = 'PTA',
  Ptc = 'PTC'
}

export type UserPaymentInstrument = {
  isRenewalChargeable: Scalars['Boolean']['output'];
  isRenewalDefault: Scalars['Boolean']['output'];
  paymentInstrumentToken: Scalars['ID']['output'];
};

export type UserPaymentInstrumentCard = UserPaymentInstrument & {
  __typename?: 'UserPaymentInstrumentCard';
  cardHolder: Scalars['String']['output'];
  cardNumberObfuscated: Scalars['String']['output'];
  cardType?: Maybe<CreditCardsType>;
  cardTypeCode: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  isRenewalChargeable: Scalars['Boolean']['output'];
  isRenewalDefault: Scalars['Boolean']['output'];
  paymentInstrumentToken: Scalars['ID']['output'];
};

export type UserPaymentInstrumentIdeal = UserPaymentInstrument & {
  __typename?: 'UserPaymentInstrumentIdeal';
  idealIssuerBank: IdealIssuerBankType;
  isRenewalChargeable: Scalars['Boolean']['output'];
  isRenewalDefault: Scalars['Boolean']['output'];
  paymentInstrumentToken: Scalars['ID']['output'];
};

export type UserPaymentInstrumentPaypal = UserPaymentInstrument & {
  __typename?: 'UserPaymentInstrumentPaypal';
  email: Scalars['String']['output'];
  isRenewalChargeable: Scalars['Boolean']['output'];
  isRenewalDefault: Scalars['Boolean']['output'];
  paymentInstrumentToken: Scalars['ID']['output'];
};

export type UserPaymentInteraction = {
  __typename?: 'UserPaymentInteraction';
  formSendType?: Maybe<FormSendType>;
  htmlCode?: Maybe<Scalars['String']['output']>;
  initialRecurringCollection: Scalars['Boolean']['output'];
  interactionStep: Scalars['Int']['output'];
  interactionType: InteractionType;
  javascriptSnippet?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Array<Param>>;
  paypalToken?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type UserPaymentInteractionId = {
  __typename?: 'UserPaymentInteractionId';
  id: Scalars['ID']['output'];
};

export type UserPaymentInteractionIdInput = {
  id: Scalars['ID']['input'];
};

export type UserPaymentInteractionParam = {
  __typename?: 'UserPaymentInteractionParam';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UserPaymentInteractionParamInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UserPaymentInteractionRedirect = {
  __typename?: 'UserPaymentInteractionRedirect';
  interfaceType?: Maybe<InterfaceType>;
  redirectType?: Maybe<RedirectType>;
  referenceId?: Maybe<Scalars['String']['output']>;
  shoppingId?: Maybe<Scalars['String']['output']>;
  shoppingType?: Maybe<ShoppingType>;
};

export type UserPaymentInteractionRedirectRequest = {
  interfaceType: InterfaceType;
  redirectType: RedirectType;
  referenceId: Scalars['String']['input'];
  shoppingId: Scalars['String']['input'];
  shoppingType: ShoppingType;
};

export type UserPaymentInteractionRequest = {
  userPaymentInteractionId: UserPaymentInteractionIdInput;
};

export type UserPromoCode = {
  __typename?: 'UserPromoCode';
  campaign: UserPromoCodeCampaign;
  code: Scalars['String']['output'];
  conditions: PromoCodeApplicationConditions;
  discount: UserPromoCodeDiscount;
  isEnabled: Scalars['Boolean']['output'];
  prime: Scalars['Boolean']['output'];
  sponsor: UserPromoCodeSponsor;
};

export type UserPromoCodeCampaign = {
  __typename?: 'UserPromoCodeCampaign';
  department: UserPromoCodeDepartment;
};

export enum UserPromoCodeDepartment {
  Affiliates = 'AFFILIATES',
  Crm = 'CRM',
  CustomerCare = 'CUSTOMER_CARE',
  InternalCommunications = 'INTERNAL_COMMUNICATIONS',
  Merchandising = 'MERCHANDISING',
  OfflineSales = 'OFFLINE_SALES',
  Others = 'OTHERS',
  PrimeReferralReferred = 'PRIME_REFERRAL_REFERRED',
  PrimeReferralReferrer = 'PRIME_REFERRAL_REFERRER',
  PrimeRetentionOffline = 'PRIME_RETENTION_OFFLINE',
  PrimeRetentionOnline = 'PRIME_RETENTION_ONLINE',
  ProductMarketing = 'PRODUCT_MARKETING',
  PublicRelations = 'PUBLIC_RELATIONS',
  SocialMedia = 'SOCIAL_MEDIA',
  Test = 'TEST',
  UxResearch = 'UX_RESEARCH',
  VipCases = 'VIP_CASES',
  VoucherVendor = 'VOUCHER_VENDOR'
}

export type UserPromoCodeDiscount = {
  maxAmount?: Maybe<Money>;
};

export type UserPromoCodeSponsor = {
  __typename?: 'UserPromoCodeSponsor';
  name: Scalars['String']['output'];
  sponsored: Scalars['Boolean']['output'];
};

export type UserPromoCodes = {
  __typename?: 'UserPromoCodes';
  disabledPromoCodes: Array<UserPromoCode>;
  enabledPromoCodes: Array<UserPromoCode>;
  unusedPromoCodes: Array<UserPromoCode>;
  usedPromoCodes: Array<UserPromoCode>;
};

export type UserReview = {
  __typename?: 'UserReview';
  rating?: Maybe<Scalars['Float']['output']>;
  totalReviews?: Maybe<Scalars['Int']['output']>;
};

export type UserSegmentResponse = {
  __typename?: 'UserSegmentResponse';
  segment?: Maybe<Scalars['String']['output']>;
};

export type UserTraveller = {
  __typename?: 'UserTraveller';
  address?: Maybe<TravellerAddress>;
  alternatePhoneNumber?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<Scalars['Boolean']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  frequentFlyerNumbers?: Maybe<Array<FrequentFlyerCard>>;
  id: Scalars['Long']['output'];
  identificationList?: Maybe<Array<Maybe<Identification>>>;
  importedFromLocal?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isPrimeOwner: Scalars['Boolean']['output'];
  meal?: Maybe<TravellerMeal>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  personalInfo: PersonalInfo;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  prefixAlternatePhoneNumber?: Maybe<Scalars['String']['output']>;
  prefixPhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type UserVoucher = {
  __typename?: 'UserVoucher';
  amount: Money;
  code: Scalars['String']['output'];
  conditions: VoucherApplicationConditions;
  isEnabled: Scalars['Boolean']['output'];
};

export type UserVouchers = {
  __typename?: 'UserVouchers';
  disabledVouchers: Array<UserVoucher>;
  enabledVouchers: Array<UserVoucher>;
  /** @deprecated use the type UserWalletTotalAmounts */
  totalAmount: Money;
  unusedVouchers: Array<UserVoucher>;
  usedVouchers: Array<UserVoucher>;
  /** @deprecated Use usedVouchers and unusedVouchers instead */
  vouchers: Array<Voucher>;
};

export type UserWallet = {
  __typename?: 'UserWallet';
  totalAmounts?: Maybe<UserWalletAmountPerception>;
  userPromoCodes?: Maybe<UserPromoCodes>;
  userVouchers?: Maybe<UserVouchers>;
};

export type UserWalletAmountPerception = {
  __typename?: 'UserWalletAmountPerception';
  allPromoCodesTotalAmount: Money;
  disabledPromoCodesTotalAmount: Money;
  enabledPromoCodesTotalAmount: Money;
};

export type UserWalletCarrier = {
  __typename?: 'UserWalletCarrier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserWalletFilter = {
  applicationConditionsFilter?: InputMaybe<ApplicationConditionsFilter>;
};

export enum UserWalletProductType {
  Dynpack = 'DYNPACK',
  Flight = 'FLIGHT'
}

export enum ValidationCode {
  Error = 'ERROR',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Success = 'SUCCESS'
}

export enum ValidationMethod {
  Sms = 'SMS'
}

export type Validator = {
  __typename?: 'Validator';
  regex?: Maybe<Scalars['String']['output']>;
  type: FieldValidatorType;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  bags: Scalars['String']['output'];
  category: VehicleCategory;
  doors: Scalars['String']['output'];
  fuelType?: Maybe<FuelType>;
  modelName: Scalars['String']['output'];
  pax: Scalars['String']['output'];
  pictureUrl: Scalars['String']['output'];
  transmissionType: Transmission;
};

export enum VehicleCategory {
  Compact = 'COMPACT',
  CompactElite = 'COMPACT_ELITE',
  Economy = 'ECONOMY',
  EconomyElite = 'ECONOMY_ELITE',
  Fullsize = 'FULLSIZE',
  FullsizeElite = 'FULLSIZE_ELITE',
  Intermediate = 'INTERMEDIATE',
  IntermediateElite = 'INTERMEDIATE_ELITE',
  Luxury = 'LUXURY',
  LuxuryElite = 'LUXURY_ELITE',
  Mini = 'MINI',
  MiniElite = 'MINI_ELITE',
  Oversize = 'OVERSIZE',
  Premium = 'PREMIUM',
  PremiumElite = 'PREMIUM_ELITE',
  Special = 'SPECIAL',
  Standard = 'STANDARD',
  StandardElite = 'STANDARD_ELITE'
}

export type VehicleProduct = {
  __typename?: 'VehicleProduct';
  modelName: Scalars['String']['output'];
  vehiclePictureUrl?: Maybe<Scalars['String']['output']>;
};

export type VehicleRental = {
  __typename?: 'VehicleRental';
  pickupAt: Scalars['String']['output'];
  pickupLocation: VehicleRentalLocation;
  providerBookingDeeplink?: Maybe<Scalars['String']['output']>;
  providerBookingReference: Scalars['ID']['output'];
  rentalCompany: RentalCompanyV2;
  returnAt: Scalars['String']['output'];
  returnLocation: VehicleRentalLocation;
  status: VehicleRentalBookingStatus;
  vehicle: VehicleProduct;
};

export type VehicleRentalAirport = {
  __typename?: 'VehicleRentalAirport';
  cityName?: Maybe<Scalars['String']['output']>;
  geoNodeId: Scalars['Int']['output'];
  iataCode?: Maybe<Scalars['String']['output']>;
};

export enum VehicleRentalBookingStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED'
}

export type VehicleRentalFindRequest = {
  returnDateFromInclusive?: InputMaybe<Scalars['String']['input']>;
  returnDateToExclusive?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleRentalLocation = {
  __typename?: 'VehicleRentalLocation';
  address?: Maybe<Scalars['String']['output']>;
  closestAirport?: Maybe<VehicleRentalAirport>;
  coordinates?: Maybe<GeoCoordinates>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type VehicleRentalOffer = {
  __typename?: 'VehicleRentalOffer';
  duration: RentalOfferDuration;
  id: Scalars['ID']['output'];
  pricePerceptions: Array<RentalPricePerception>;
  providerSelectionDeepLink?: Maybe<Scalars['String']['output']>;
  rentalCompany: RentalCompany;
  vehicle: Vehicle;
};

export type VehicleRentalResponse = {
  __typename?: 'VehicleRentalResponse';
  results: Array<VehicleRental>;
};

export type VehicleRentalSearchRequest = {
  itineraryId: Scalars['ID']['input'];
};

export type VehicleRentalSearchRequestByAccommodationV2 = {
  bookingId: Scalars['ID']['input'];
  touchPoint: VehicleRentalTouchPoint;
};

export type VehicleRentalSearchRequestV2 = {
  itineraryId: Scalars['ID']['input'];
  touchPoint: VehicleRentalTouchPoint;
};

export type VehicleRentalSearchResponse = {
  __typename?: 'VehicleRentalSearchResponse';
  searchId: Scalars['String']['output'];
  vehicleRentalOffers: Array<VehicleRentalOffer>;
};

export enum VehicleRentalStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED'
}

export type VehicleRentalTouchPoint = {
  page: VehicleRentalTouchPointPage;
};

export type VehicleRentalTouchPointPage = {
  url: Scalars['String']['input'];
};

export type VehicleSearchCriteriaRequest = {
  pickupAt: Scalars['String']['input'];
  pickupLocation: LocationRequest;
  returnAt?: InputMaybe<Scalars['String']['input']>;
  returnLocation?: InputMaybe<LocationRequest>;
};

export type VisaDetails = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  issueCountry?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VisaType>;
};

export enum VisaType {
  AirportTransit = 'AIRPORT_TRANSIT',
  Business = 'BUSINESS',
  BusinessMedia = 'BUSINESS_MEDIA',
  Conference = 'CONFERENCE',
  Crew = 'CREW',
  EastAfricaBorderless = 'EAST_AFRICA_BORDERLESS',
  Entry = 'ENTRY',
  GovernmentContract = 'GOVERNMENT_CONTRACT',
  Humanitarian = 'HUMANITARIAN',
  Journalist = 'JOURNALIST',
  LooseLeaf = 'LOOSE_LEAF',
  Medical = 'MEDICAL',
  Missionary = 'MISSIONARY',
  Ngo = 'NGO',
  Private = 'PRIVATE',
  ScientificResearch = 'SCIENTIFIC_RESEARCH',
  Str = 'STR',
  Student = 'STUDENT',
  TechnicalAssistance = 'TECHNICAL_ASSISTANCE',
  Tourist = 'TOURIST',
  Visitor = 'VISITOR',
  Work = 'WORK'
}

export type VoluntaryCancellationOptionsRetrievementRequest = {
  bookingId: Scalars['Long']['input'];
  bookingItemId: Scalars['Long']['input'];
};

export type VoluntaryCancellationOptionsRetrievementResponse = {
  __typename?: 'VoluntaryCancellationOptionsRetrievementResponse';
  c4arCashRefund?: Maybe<C4arCashRefundOption>;
  c4arVoucherRefund?: Maybe<C4arVoucherRefundOption>;
  cancellationCashRefund?: Maybe<CancellationCashRefundOption>;
  freeCancellationCashRefund?: Maybe<FreeCancellationCashRefundOption>;
};

export type Voucher = {
  amount: Money;
  isEnabled: Scalars['Boolean']['output'];
};

export type VoucherApplicationConditions = {
  __typename?: 'VoucherApplicationConditions';
  carrierConditions?: Maybe<WalletElementCarrierConditions>;
  productTypeConditions?: Maybe<WalletElementProductTypeConditions>;
  purchaseAmountConditions?: Maybe<WalletElementPurchaseAmountConditions>;
  usageDateConditions?: Maybe<UsageDateConditions>;
};

export enum VoucherCodeType {
  Error = 'ERROR',
  VoucherAlreadySent = 'VOUCHER_ALREADY_SENT',
  VoucherSent = 'VOUCHER_SENT'
}

export type VoucherDetails = {
  __typename?: 'VoucherDetails';
  amount: Money;
};

export type WalletElementCarrierConditions = {
  __typename?: 'WalletElementCarrierConditions';
  carriers: Array<UserWalletCarrier>;
};

export type WalletElementProductTypeConditions = {
  __typename?: 'WalletElementProductTypeConditions';
  productTypes: Array<UserWalletProductType>;
};

export type WalletElementProductTypeConditionsFilter = {
  productTypes: Array<UserWalletProductType>;
};

export type WalletElementPurchaseAmountCondition = {
  __typename?: 'WalletElementPurchaseAmountCondition';
  maxAmount?: Maybe<Money>;
  minAmount?: Maybe<Money>;
};

export type WalletElementPurchaseAmountConditions = {
  __typename?: 'WalletElementPurchaseAmountConditions';
  purchaseAmounts: Array<WalletElementPurchaseAmountCondition>;
};

export type Website = {
  __typename?: 'Website';
  brand?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
};

export type AccommodationDealsV2QueryVariables = Exact<{
  request: AccommodationDealRequest;
}>;


export type AccommodationDealsV2Query = { __typename?: 'Query', accommodationDealsV2: { __typename?: 'AccommodationDealsResponse', dealsId?: string | null, deals: Array<{ __typename?: 'AccommodationDeal', checkInDate: string, checkOutDate: string, discount: number, dedupId: number, destination: { __typename?: 'City', id?: number | null, name: string, iata?: string | null }, price: { __typename?: 'Money', amount: number, currency: string }, priceNonPrime: { __typename?: 'Money', amount: number, currency: string }, discountAbsolute: { __typename?: 'Money', amount: number, currency: string }, accommodationInfo: { __typename?: 'AccommodationDetailsResponse', accommodationDetail?: { __typename?: 'AccommodationDetail', accommodationDealInformation?: { __typename?: 'AccommodationDealInformation', cityName?: string | null, name: string, cancellationFree: ThreeValuedLogic, stars?: number | null, mainAccommodationImage?: { __typename?: 'AccommodationImage', url?: string | null } | null } | null, accommodationReview?: { __typename?: 'AccommodationReview', rating?: number | null, totalReviews?: number | null } | null } | null } }> } };

export type AccommodationRecommendationQueryVariables = Exact<{
  accommodationRecommendationRequest: AccommodationRecommendationRequest;
}>;


export type AccommodationRecommendationQuery = { __typename?: 'Query', accommodationRecommendation: { __typename?: 'AccommodationRecommendationResponse', accommodationRecommendations: Array<{ __typename?: 'AccommodationRecommendation', checkInDate: string, checkOutDate: string, dedupId: number, accommodationInfo: { __typename?: 'AccommodationDetailsResponse', accommodationDetail?: { __typename?: 'AccommodationDetail', distanceFromCityCenter?: number | null, accommodationDealInformation?: { __typename?: 'AccommodationDealInformation', name: string, stars?: number | null, mainAccommodationImage?: { __typename?: 'AccommodationImage', url?: string | null } | null } | null, accommodationReview?: { __typename?: 'AccommodationReview', rating?: number | null, totalReviews?: number | null } | null } | null }, destination: { __typename?: 'City', name: string, id?: number | null } }> } };

export type AccommodationSearchHistoryQueryVariables = Exact<{
  accommodationSearchHistoryRequest: AccommodationSearchHistoryRequest;
}>;


export type AccommodationSearchHistoryQuery = { __typename?: 'Query', accommodationSearchHistory: { __typename?: 'AccommodationSearchHistoryResponse', accommodationSearchHistories: Array<{ __typename?: 'AccommodationSearchHistory', totalAdults: number, totalChildren?: number | null, date: string, checkIn: string, checkOut: string, name: string, searchId?: number | null, geoAccommodation: { __typename?: 'GeoAccommodation', geoType?: GeoType | null, id: { __typename?: 'GeoId', value: string } }, rooms: Array<{ __typename?: 'RoomRequested', numAdults: number, childrenAges: Array<number> }>, accommodationInfo?: { __typename?: 'AccommodationInfo', cancellationFree: boolean, starsRating?: StarRating | null, currency: string, priceBreakdown: { __typename?: 'PriceBreakdown', price: number, pricePerNightRounded: number, discount: { __typename?: 'Discount', percentage: number } } } | null, accommodationImage?: { __typename?: 'AccommodationImage', thumbnailUrl?: string | null } | null }> } };

export type GetTripsQueryVariables = Exact<{
  filter?: InputMaybe<TripListFilter>;
}>;


export type GetTripsQuery = { __typename?: 'Query', getTrips: { __typename?: 'TripListResponse', trips?: Array<{ __typename?: 'EnrichedTrip', trip: { __typename?: 'Trip', id: string, bookingStatus?: BookingStatus | null, bookingProductStatus?: BookingProductStatus | null, prime: boolean, accommodationBooking?: { __typename?: 'AccommodationBooking', id?: string | null, address: string, city: string, countryName?: string | null } | null, itinerary?: { __typename?: 'TripItinerary', arrivalDate: number, departureDate: number, tripType: TripType, legs: Array<{ __typename?: 'TripLeg', duration: number, sections: Array<{ __typename?: 'TripSection', pnr?: string | null, arrivalDate: number, departureDate: number, arrival: { __typename?: 'Location', cityName: string, countryName: string, id: string } }> }>, origin?: { __typename?: 'Location', iata?: string | null, name?: string | null, countryName: string, id: string, countryCode?: string | null, cityName: string, cityIata?: string | null } | null, destination?: { __typename?: 'Location', iata?: string | null, name?: string | null, countryName: string, id: string, countryCode?: string | null, cityName: string, cityIata?: string | null } | null } | null, travellers: Array<{ __typename?: 'Traveller', travellerType: string, age?: number | null } | null>, buyer: { __typename?: 'Buyer', country?: string | null, zipCode?: string | null, cpf?: string | null, address: string, stateName?: string | null, dateOfBirth?: string | null, name: string, mail: string } } } | null> | null } };

export type UserSegmentQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSegmentQuery = { __typename?: 'Query', userSegment?: { __typename?: 'UserSegmentResponse', segment?: string | null } | null };
